(function() {
  'use strict';

  angular
    .module('isoappClient', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'angular-loading-bar', 'angularUtils.directives.dirPagination']);

})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('KycPassedController', KycPassedController);

    KycPassedController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'KycIdDetails', 'Ids', 'callBackFunction'];

    function KycPassedController(httpService, popupService, modalInstance, rootScope, KycIdDetail, Id, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {


            //  var getLoginUser = angular.fromJson(rootScope.UserData);
            //     vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Kyc_id = KycIdDetail;
            vm.data.Idd = Id;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        //var presave = function () {
        //    var data = {};
        //    data.Kyc_Id = vm.data.Kycid;
        //    data.Status = 'Active';

        //    return data;
        //}

        vm.func.finishIt = function () {

            var alldata = {};
            alldata.Kycid = vm.data.Kyc_id;
            alldata.Status = 'Active';
            httpService.httpCall('api/closureManagement/finishClosure', 'POST', alldata)
            .then(onSuccess, onFail)
        

            var prodata = {};
            prodata.Id = vm.data.Idd;
            prodata.QaStatus = 'Kyc Pass';
            httpService.httpCall('api/proposalMnagement/qaStatusUpdate', 'POST', prodata)
                   .then(onSuccess1, onFail1)

        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Kyc Passed');
            callBack();
        }
        var onSuccess1 = function () {
            //modalInstance.close('OK');
            //popupService.successsm('ISO', 'QA Check Passed');
            //callBack();
        }
        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };
        //var onSuccess1 = function () {
        //    //modalInstance.close('OK');
        //    // popupService.successsm('ISO', 'Certificate Dispatched');
        //    // callBack();
        //}

        var onFail1 = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };


        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('PassClosureController', PassClosureController);

    PassClosureController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'KycIdDetails', 'Ids', 'callBackFunction'];

    function PassClosureController(httpService, popupService, modalInstance, rootScope, KycIdDetail, Id, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {


            //  var getLoginUser = angular.fromJson(rootScope.UserData);
            //     vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Kyc_id = KycIdDetail;
            vm.data.Idd = Id;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        //var presave = function () {
        //    var data = {};
        //    data.Kyc_Id = vm.data.Kycid;
        //    data.Status = 'Active';

        //    return data;
        //}

        vm.func.finishIt = function () {

            var alldata = {};
            alldata.Kycid = vm.data.Kyc_id;
            alldata.Status = 'Active';
            httpService.httpCall('api/closureManagement/finishClosure', 'POST', alldata)
            .then(onSuccess, onFail)
        

            var prodata = {};
            prodata.Id = vm.data.Idd;
            prodata.QaStatus = 'Kyc Approved';            
            httpService.httpCall('api/proposalMnagement/qaStatusUpdate', 'POST', prodata)
                   .then(onSuccess1, onFail1)

        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'QA Check Passed');
            callBack();
        }
        var onSuccess1 = function () {
            //modalInstance.close('OK');
            //popupService.successsm('ISO', 'QA Check Passed');
            //callBack();
        }
        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };
        //var onSuccess1 = function () {
        //    //modalInstance.close('OK');
        //    // popupService.successsm('ISO', 'Certificate Dispatched');
        //    // callBack();
        //}

        var onFail1 = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };


        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('RejectClosureController', RejectClosureController);

    RejectClosureController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'KycIdDetails', 'Ids', 'callBackFunction'];

    function RejectClosureController(httpService, popupService, modalInstance, rootScope, KycIdDetail, Id, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {


            //  var getLoginUser = angular.fromJson(rootScope.UserData);
            //     vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Kyc_id = KycIdDetail;
            vm.data.Idd = Id;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        //var presave = function () {
        //    var data = {};
        //    data.Kyc_Id = vm.data.Kycid;
        //    data.Status = 'Active';

        //    return data;
        //}

        vm.func.finishIt = function () {

            var alldata = {};
            alldata.Kycid = vm.data.Kyc_id;
            alldata.Status = 'Active';
            httpService.httpCall('api/closureManagement/finishClosure', 'POST', alldata)
            .then(onSuccess, onFail)

            var prodata = {};
            prodata.Id = vm.data.Idd;
            prodata.QaStatus = 'Kyc Rejected';
            httpService.httpCall('api/proposalMnagement/qaStatusUpdate', 'POST', prodata)
                   .then(onSuccess1, onFail1)

        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'QA Check Rejected');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };
        var onSuccess1 = function () {
            //modalInstance.close('OK');
            // popupService.successsm('ISO', 'Certificate Dispatched');
            // callBack();
        }

        var onFail1 = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };


        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('KycFailedController', KycFailedController);

    KycFailedController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'KycIdDetails', 'Ids', 'callBackFunction'];

    function KycFailedController(httpService, popupService, modalInstance, rootScope, KycIdDetail, Id, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {


            //  var getLoginUser = angular.fromJson(rootScope.UserData);
            //     vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Kyc_id = KycIdDetail;
            vm.data.Idd = Id;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        //var presave = function () {
        //    var data = {};
        //    data.Kyc_Id = vm.data.Kycid;
        //    data.Status = 'Active';

        //    return data;
        //}

        vm.func.finishIt = function () {

            var alldata = {};
            alldata.Kycid = vm.data.Kyc_id;
            alldata.Status = 'Active';
            httpService.httpCall('api/closureManagement/finishClosure', 'POST', alldata)
            .then(onSuccess, onFail)

            var prodata = {};
            prodata.Id = vm.data.Idd;
            prodata.QaStatus = 'Kyc Fail';
            httpService.httpCall('api/proposalMnagement/qaStatusUpdate', 'POST', prodata)
                   .then(onSuccess1, onFail1)

        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Kyc Failed');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };
        var onSuccess1 = function () {
            //modalInstance.close('OK');
            // popupService.successsm('ISO', 'Certificate Dispatched');
            // callBack();
        }

        var onFail1 = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };


        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('SurvPassedController', SurvPassedController);

    SurvPassedController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'KycIdDetails', 'Ids', 'callBackFunction'];

    function SurvPassedController(httpService, popupService, modalInstance, rootScope, KycIdDetail, Id, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {


            //  var getLoginUser = angular.fromJson(rootScope.UserData);
            //     vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Kyc_id = KycIdDetail;
            vm.data.Idd = Id;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        //var presave = function () {
        //    var data = {};
        //    data.Kyc_Id = vm.data.Kycid;
        //    data.Status = 'Active';

        //    return data;
        //}

        vm.func.finishIt = function () {

            var alldata = {};
            alldata.Kycid = vm.data.Kyc_id;
            alldata.Status = 'Active';
            httpService.httpCall('api/closureManagement/finishClosure', 'POST', alldata)
            .then(onSuccess, onFail)
        

            var prodata = {};
            prodata.Id = vm.data.Idd;
            prodata.ProjectStatus = 'Kyc Pass';
            httpService.httpCall('api/proposalMnagement/projStatusUpdate', 'POST', prodata)
                   .then(onSuccess1, onFail1)

        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Surveillance Passed');
            callBack();
        }
        var onSuccess1 = function () {
            //modalInstance.close('OK');
            //popupService.successsm('ISO', 'QA Check Passed');
            //callBack();
        }
        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };
        //var onSuccess1 = function () {
        //    //modalInstance.close('OK');
        //    // popupService.successsm('ISO', 'Certificate Dispatched');
        //    // callBack();
        //}

        var onFail1 = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };


        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('SurvFailedController', SurvFailedController);

    SurvFailedController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'KycIdDetails', 'Ids', 'callBackFunction'];

    function SurvFailedController(httpService, popupService, modalInstance, rootScope, KycIdDetail, Id, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {


            //  var getLoginUser = angular.fromJson(rootScope.UserData);
            //     vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Kyc_id = KycIdDetail;
            vm.data.Idd = Id;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        //var presave = function () {
        //    var data = {};
        //    data.Kyc_Id = vm.data.Kycid;
        //    data.Status = 'Active';

        //    return data;
        //}

        vm.func.finishIt = function () {

            var alldata = {};
            alldata.Kycid = vm.data.Kyc_id;
            alldata.Status = 'Inactive';
            httpService.httpCall('api/closureManagement/finishClosure', 'POST', alldata)
            .then(onSuccess, onFail)

            //var prodata = {};
            //prodata.Id = vm.data.Idd;
            //prodata.ProjectStatus = 'Kyc Fail';
            //httpService.httpCall('api/proposalMnagement/qaStatusUpdate', 'POST', prodata)
            //       .then(onSuccess1, onFail1)

        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Surveillance Failed');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };
        var onSuccess1 = function () {
            //modalInstance.close('OK');
            // popupService.successsm('ISO', 'Certificate Dispatched');
            // callBack();
        }

        var onFail1 = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };


        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('ViewEnquiryController', ViewEnquiryController)

    ViewEnquiryController.$inject = ['$uibModalInstance', 'detailsOfSingleEnquiry', 'popupService', 'callBackFunction'];

    function ViewEnquiryController(modalInstance, detailsOfSingleEnquiry, popupService, callBack) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.Enquiryname = detailsOfSingleEnquiry.Enquiryname;
            vm.data.Companyname = detailsOfSingleEnquiry.Companyname;
            vm.data.Enquiryphone = detailsOfSingleEnquiry.Enquiryphone;
            vm.data.Enquiryemail = detailsOfSingleEnquiry.Enquiryemail;
            vm.data.Country = detailsOfSingleEnquiry.Country;
            vm.data.Enquirycity = detailsOfSingleEnquiry.Enquirycity;
            vm.data.ISOStandard = detailsOfSingleEnquiry.EnquiryStandard;
            vm.data.Companysize = detailsOfSingleEnquiry.Companysize;
            vm.data.LeadType = detailsOfSingleEnquiry.Leadtype;
            vm.data.Enquirytype = detailsOfSingleEnquiry.Enquirytype;
            vm.data.NatureofBusiness = detailsOfSingleEnquiry.Companytype;
            vm.data.Enq_Date = detailsOfSingleEnquiry.Enquirydate;
          

        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }
        vm.func.updateEnquiryetails = function () {
            modalInstance.close('OK');
            popupService.editEnquiry(detailsOfSingleEnquiry, callBack);
        }

        init();
    }
})();
(function () {
    'use strict'

    angular
    .module('isoappClient')
    .controller('EditProposalReportController', EditProposalReportController)

    EditProposalReportController.$inject = ['$uibModalInstance', 'httpService', 'popupService', 'callBackFunction', 'proposalDataUpdate', '$filter'];

    function EditProposalReportController(modalInstance, httpService, popupService, callBack, proposalData, $filter) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            vm.data.isFormSubmit = false;
            vm.data.requiredValidity = false;
            vm.data.requiredSource = false;
            vm.data.requiredType = false;
            //   vm.data.requiredProjectStatus = false;
            //   vm.data.requiredPaymentStatus = false;
            var currentdate = new Date();
            vm.data.ClosureDate = currentdate;

            vm.data.ClosureSource = [
                { value: 'Select' },
                { value: 'Associate' },
                { value: 'Fresh' },
                { value: 'Reference ' },
                { value: 'Renewal' },
                { value: 'Surveillance 1' },
                { value: 'Surveillance 2' },
                { value: 'Upsale' }
            ];

            vm.data.ClosureType = [
                { value: 'Select' },
                { value: 'Remote' },
                { value: 'Online' },
                { value: 'Onsite' }
            ];

            //vm.data.ClosureProjectStatus = [
            //    { value: 'Select' },
            //    { value: 'Completed' },
            //    { value: 'Under Progress' }
            //];

            //vm.data.ClosurePaymentStatus = [
            //    { value: 'Select' },
            //    { value: 'Full Payment' },
            //    { value: 'Part Payment' }
            //];

            vm.data.suggestCBAB = ["UR-EAJAS", "LMS-DAC", "LMS-IAS", "QEC-UKAS", "SNR-UKAS"];

            vm.data.Validity = [
                { value: 'Select' },
                { value: '1 Year' },
                { value: '3 Years' },
                { value: '1 & 3 Years' }

            ];

            vm.data.selectedClosureSource = vm.data.ClosureSource[0];
            vm.data.selectedClosureType = vm.data.ClosureType[0];
            //  vm.data.selectedClosureProjectStatus = vm.data.ClosureProjectStatus[0];
            //   vm.data.selectedClosurePaymentStatus = vm.data.ClosurePaymentStatus[0];
            vm.data.selectedValidity = vm.data.Validity[0];

            httpService.httpCall('api/enquiryManagement/suggestassignto', 'GET', null)
            .then(function (response) {
                vm.data.suggestSalesAgent = response;
                vm.data.suggestDeliveryAgent = response;
                vm.data.suggestSalesAgentData = angular.copy(vm.data.suggestSalesAgent);
                vm.data.suggestDeliveryAgentData = angular.copy(vm.data.suggestDeliveryAgent);
            });

            httpService.httpCall('api/enquiryManagement/suggestIsoCertificationType', 'GET', null)
            .then(function (response) {
                vm.data.suggestIsoStandards = response;
                vm.data.suggestIsoStandardsData = angular.copy(vm.data.suggestIsoStandards);
            });

            if (typeof (proposalData) != 'undefined' && parseInt(proposalData) > 0) {
                httpService.httpCall('api/proposalMnagement/getsingleProposalDetails?Id=' + proposalData, 'GET', null)
                .then(function (singleProposalDetailsResponse) {
                    debugger;

                    singleProposalDetailsResponse = JSON.parse(JSON.stringify(singleProposalDetailsResponse[0]));

                    vm.data.Id = singleProposalDetailsResponse.Id;
                    vm.data.Client = singleProposalDetailsResponse.client;
                    vm.data.kycidfk = singleProposalDetailsResponse.kyc_id_fk;
                    //vm.data.itemclosuredate = singleProposalDetailsResponse.closure_date;
                    //vm.data.ClosureDate = $filter('date')(vm.data.itemclosuredate, "MM/dd/yyyy");
                    vm.data.ClosureDate = new Date(singleProposalDetailsResponse.closure_date);
                    angular.forEach(vm.data.ClosureSource, function (item, index) {
                        if (item.value == singleProposalDetailsResponse.source) {
                            vm.data.selectedClosureSource = vm.data.ClosureSource[index];
                        }
                    })
                    angular.forEach(vm.data.ClosureType, function (item, index) {
                        if (item.value == singleProposalDetailsResponse.type) {
                            vm.data.selectedClosureType = vm.data.ClosureType[index];
                        }
                    })
                    //angular.forEach(vm.data.ClosureProjectStatus, function (item, index) {
                    //    if (item.value == singleProposalDetailsResponse.project_status) {
                    //        vm.data.selectedClosureProjectStatus = vm.data.ClosureProjectStatus[index];
                    //    }
                    //})
                    //angular.forEach(vm.data.ClosurePaymentStatus, function (item, index) {
                    //    if (item.value == singleProposalDetailsResponse.payment_status) {
                    //        vm.data.selectedClosurePaymentStatus = vm.data.ClosurePaymentStatus[index];
                    //    }
                    //})
                    angular.forEach(vm.data.Validity, function (item, index) {
                        if (item.value == singleProposalDetailsResponse.validity) {
                            vm.data.selectedValidity = vm.data.Validity[index];
                        }
                    })
                    vm.data.selectedIsoStandards = singleProposalDetailsResponse.standards;
                    vm.data.Location = singleProposalDetailsResponse.location;
                    vm.data.Region = singleProposalDetailsResponse.region;
                    vm.data.CB = singleProposalDetailsResponse.CB;
                    vm.data.AccredBody = singleProposalDetailsResponse.accred_body;
                    vm.data.PaymentExpectedDate = singleProposalDetailsResponse.payment_expected_date;
                    vm.data.selectedSalesAgent = singleProposalDetailsResponse.sales_agent;
                    vm.data.selectedDeliveryAgent = singleProposalDetailsResponse.delivery_agent;
                    vm.data.PaymentStatus = singleProposalDetailsResponse.payment_status;
                    vm.data.Remarks = singleProposalDetailsResponse.remarks;
                    vm.data.CertificationBody = vm.data.CB + "-" + vm.data.AccredBody;
                    vm.data.selectedCurrentAgent = singleProposalDetailsResponse.current_sales_agent;
                })
            }

        }

        vm.func.hideRequiredValidity = function () {
            if (vm.data.selectedValidity != 'Select') {
                vm.data.requiredValidity = false;
            }
        };

        vm.func.hideRequiredSource = function () {
            if (vm.data.selectedClosureSource != 'Select') {
                vm.data.requiredSource = false;
            }
        };

        vm.func.hideRequiredType = function () {
            if (vm.data.selectedClosureType != 'Select') {
                vm.data.requiredType = false;
            }
        };

        //vm.func.hideRequiredProjectStatus = function () {
        //    if (vm.data.selectedClosureProjectStatus != 'Select') {
        //        vm.data.requiredProjectStatus = false;
        //    }
        //};

        //vm.func.hideRequiredPaymentStatus = function () {
        //    if (vm.data.selectedClosurePaymentStatus != 'Select') {
        //        vm.data.requiredPaymentStatus = false;
        //    }
        //}

        vm.func.ok = function () {
            modalInstance.dismiss('cancel');
        }

        vm.func.updateProposal = function (isValid) {
            vm.data.isFormSubmit = true;
            if (vm.data.selectedValidity.value == 'Select') {
                vm.data.requiredValidity = true;
                isValid = false;
            }
            if (vm.data.selectedClosureSource.value == 'Select') {
                vm.data.requiredSource = true;
                isValid = false;
            }
            if (vm.data.selectedClosureType.value == 'Select') {
                vm.data.requiredType = true;
                isValid = false;
            }
            //if (vm.data.selectedClosureProjectStatus.value == 'Select') {
            //    vm.data.requiredProjectStatus = true;
            //    isValid = false;
            //}
            //if (vm.data.selectedClosurePaymentStatus.value == 'Select') {
            //    vm.data.requiredPaymentStatus = true;
            //    isValid = false;
            //}
            if (isValid == true) {
                var updatedProposalValue = {};
                updatedProposalValue.Id = vm.data.Id;
                updatedProposalValue.client = vm.data.Client;
                updatedProposalValue.Kycidfk = vm.data.kycidfk;
                //updatedProposalValue.ClosureDate = vm.data.ClosureDate;
                updatedProposalValue.ClosureDate = $filter('date')(vm.data.ClosureDate, "MM/dd/yyyy");
                updatedProposalValue.Standards = vm.data.selectedIsoStandards;
                updatedProposalValue.Location = vm.data.Location;
                updatedProposalValue.Region = vm.data.Region;
                updatedProposalValue.Remarks = vm.data.Remarks;
                updatedProposalValue.CB = vm.data.CertificationBody;
                updatedProposalValue.SalesAgent = vm.data.selectedSalesAgent;
                updatedProposalValue.DeliveryAgent = vm.data.selectedDeliveryAgent;
                updatedProposalValue.Validity = vm.data.selectedValidity.value;
                updatedProposalValue.Source = vm.data.selectedClosureSource.value;
                updatedProposalValue.Type = vm.data.selectedClosureType.value;
                updatedProposalValue.CurrentSalesAgent = vm.data.selectedCurrentAgent;
                //   updatedProposalValue.ProjectStatus = vm.data.selectedClosureProjectStatus.value;
                //   updatedProposalValue.PaymentStatus = vm.data.selectedClosurePaymentStatus.value;


                httpService.httpCall('api/proposalMnagement/updateProposalDetails', 'POST', updatedProposalValue)
                .then(onSuccess, onFail)
            }
        }
        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Update Successful!');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        init();
    }
})();
(function () {
    'use strict',

        angular
            .module('isoappClient')
            .controller('SuccesssmController', SuccesssmController);

    SuccesssmController.$inject = ['$uibModalInstance', 'title', 'message', '$window'];

    function SuccesssmController(modalInstance, title, message, $window) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.title = title;
            vm.data.message = message;
        }

        vm.func.ok = function () {
            modalInstance.close('OK');
            $window.location.reload();
        };

        vm.data.cancel = function () {
            modalInstance.dismiss('cancel');
        };

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('ShowSearchedController', ShowSearchedController)

    ShowSearchedController.$inject = ['httpService', '$uibModalInstance', 'detailsOfSearchedCerts', 'popupService', 'callBackFunction'];

    function ShowSearchedController(httpService, modalInstance, detailsOfSearchedCerts, popupService, callBack) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            debugger;
            vm.data.CompanyName = detailsOfSearchedCerts.CertificationCompanyName;
            vm.data.CertiNumber = detailsOfSearchedCerts.CertificationNumber;
            vm.data.Certi_Scope = detailsOfSearchedCerts.CertificationScope;
            vm.data.CertiAddress = detailsOfSearchedCerts.CertificationAddress;
            vm.data.IssueDate = detailsOfSearchedCerts.RecertifiedDate;
            vm.data.ExpiryDate = detailsOfSearchedCerts.CertificationExpiryDate;
            vm.data.CertiBody = detailsOfSearchedCerts.CertificationBody;
            vm.data.CertiAccred = detailsOfSearchedCerts.CertificationUnderAccred;
            vm.data.CertiStandard = detailsOfSearchedCerts.CertificationIsoStandard;

        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }
        //vm.func.updateEnquiryetails = function () {
        //    modalInstance.close('OK');
        //    popupService.editEnquiry(detailsOfSingleEnquiry, callBack);
        //}

        init();
    }
})();
(function () {
    'use strict';

    angular
        .module('isoappClient')
        .controller('EditProposalPaymentController', EditProposalPaymentController)

    EditProposalPaymentController.$inject = ['$stateParams', '$uibModalInstance', '$filter', 'httpService', 'popupService', 'proposalPaymentDataUpdate', 'callBackFunction', '$rootScope', '$scope'];

    function EditProposalPaymentController(stateParams, modalInstance, $filter, httpService, popupService, proposalPaymentData, callBack, rootScope, $scope) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.isFormSubmit = false;
            //vm.data.requiredProjectStatus = false;
            vm.data.valGrossandTotal = false;
            vm.data.requiredPaymentStatus = false;
            vm.data.reqPartPaySts = false;
            vm.data.requiredPaymentStatus1 = false;
            vm.data.requiredsalesGm = false;
            vm.data.requiredDelisGM = false;
            $scope.ShowUpdate = true;
            $scope.ShowRecon = false;
            var currentdate = new Date();
            vm.data.PaymentExpected = currentdate;

          vm.data.CertificationCost = 0;
          vm.data.BankCharges = 0;
          vm.data.CourierExpenses = 0;
            vm.data.ConsultationCost = 0;
            vm.data.TaxAmount = 0;
            vm.data.AccommodationCost = 0;
            vm.data.VisaCost = 0;
            vm.data.PerDM = 0;
            vm.data.Commission = 0;
            vm.data.ConsultantFee = 0;
            vm.data.OtherCost = 0;

            vm.data.TravelCost = 0;
            vm.data.VisaCost = 0;
            vm.data.PerDM = 0;
            vm.data.Commission = 0;




            var UserData = angular.fromJson(rootScope.UserData);
            vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
            //vm.data.ClosureProjectStatus = [
            //   { value: 'Fresh' },
            //   { value: 'Hold' },
            //   { value: 'Go Ahead' }
            //  // { value: 'Dispatched' }

            //];

            //vm.data.ClosurePaymentStatus = [
            //    { value: 'Fresh' },
            //    { value: 'Part Payment' },
            //     { value: 'Full Payment' },
            //     {value:'Pending Payment'}
            //     // { value: 'Reconcile' }
            //];

            vm.data.ClosureProjectStatus = [
                { value: 'Select', id: 0 },
                { value: 'Fresh', id: 1 },
                { value: 'Hold', id: 2 },
                { value: 'Go Ahead', id: 3 },
                // { value: 'Fresh', prid: 4 },
                { value: 'Hold', id: 4 },
                { value: 'Go Ahead', id: 4 }
                // { value: 'Dispatched' }

            ];

            vm.data.ClosurePaymentStatus = [
                // {value:'Select',id:0},
                { value: 'Fresh', id: 1 },
                { value: 'Part Payment', id: 2 },
                { value: 'Initial Payment', id: 9 },
                { value: 'Pending Payment', id: 4 },
                { value: 'Full Payment', id: 3 },
                { value: 'Cancelled', id: 5 },
                { value: 'Disputed', id: 6 },
                { value: 'Written Off', id: 7 },
                { value: 'Reconciled', id: 8 }

                // { value: 'Reconcile' }
            ];
            //---------------------------------IMP-Start-CertiStatus-----------------------------------------//
            //vm.func.updateProjStatus = function () {
            //    // vm.data.selectedClosureProjectStatus = [];
            //    vm.data.availableStatus = [];
            //    angular.forEach(vm.data.ClosureProjectStatus, function (value) {
            //        if (value.id == vm.data.selectedClosurePaymentStatus.id) {
            //            //vm.data.ClosureProjectStatus.push(value);
            //            vm.data.availableStatus.push(value);
            //        }
            //    });
            //}
            //---------------------------------IMP-End-CertiStatus-----------------------------------------//


            vm.data.selectedClosureProjectStatus = vm.data.ClosureProjectStatus[0];
            //vm.data.availableStatus = vm.data.ClosureProjectStatus[0];
            vm.data.selectedClosurePaymentStatus = vm.data.ClosurePaymentStatus[0];

            if (typeof (proposalPaymentData) != 'undefined' && parseInt(proposalPaymentData) > 0) {
                httpService.httpCall('api/proposalMnagement/getsingleProposalDetails?Id=' + proposalPaymentData, 'GET', null)
                    .then(function (singleProposalPaymentDetailsResponse) {



                        singleProposalPaymentDetailsResponse = JSON.parse(JSON.stringify(singleProposalPaymentDetailsResponse[0]));
                        debugger;
                        vm.data.Id = singleProposalPaymentDetailsResponse.Id;
                        vm.data.GrossMargin = singleProposalPaymentDetailsResponse.gross_margin;
                        vm.data.TotalClosure = singleProposalPaymentDetailsResponse.total_closure;
                        vm.data.PendingAmount = singleProposalPaymentDetailsResponse.pending_amount;
                        vm.data.ActualExpenses = singleProposalPaymentDetailsResponse.actual_expenses;
                        vm.data.PaymentRecived = singleProposalPaymentDetailsResponse.payment_recived;
                        vm.data.SurveillanceCharges = singleProposalPaymentDetailsResponse.surveillance_charges;
                        vm.data.ConsultationCost = singleProposalPaymentDetailsResponse.consultation_cost;
                      vm.data.CertificationCost = singleProposalPaymentDetailsResponse.certification_cost;
                      vm.data.BankCharges = singleProposalPaymentDetailsResponse.Bank_Charges;
                      vm.data.CourierExpenses = singleProposalPaymentDetailsResponse.Courier_Expenses;
                      vm.data.CurrencyType = singleProposalPaymentDetailsResponse.currency_type;
                        vm.data.TrainingCost = singleProposalPaymentDetailsResponse.training_cost;
                        vm.data.TravelCost = singleProposalPaymentDetailsResponse.travel_cost;
                        vm.data.OtherCost = singleProposalPaymentDetailsResponse.other_cost;
                        vm.data.OtherCostRemarks = singleProposalPaymentDetailsResponse.other_cost_remarks;
                        vm.data.ManDays = singleProposalPaymentDetailsResponse.man_days;
                        vm.data.CostInOtherCurrency = singleProposalPaymentDetailsResponse.total_cost_in_other_currency;
                        vm.data.Remarks = singleProposalPaymentDetailsResponse.remarks;
                        //vm.data.PaymentExpecteddup = singleProposalPaymentDetailsResponse.payment_expected_date;
                        //vm.data.PaymentExpected = $filter('date')(vm.data.PaymentExpecteddup);
                        //vm.data.item_date = singleProposalPaymentDetailsResponse.payment_expected_date;
                        //vm.data.ClosureDate = $filter('date')(vm.data.item_date, "MM/dd/yyyy");
                        vm.data.PaymentExpected = new Date(singleProposalPaymentDetailsResponse.payment_expected_date);
                        vm.data.CurrQaStatus = singleProposalPaymentDetailsResponse.qa_status;
                        vm.data.CurrProjStatus = singleProposalPaymentDetailsResponse.project_status;
                        vm.data.CurrPayStatus = singleProposalPaymentDetailsResponse.payment_status;
                        if (vm.data.CurrPayStatus == 'Full Payment' || vm.data.CurrPayStatus == 'Reconciled') {
                            $scope.ShowPayRecDate = true;
                        } else if (vm.data.CurrPayStatus != 'Full Payment' || vm.data.CurrPayStatus != 'Reconciled') {
                            $scope.ShowPayRecDate = false;
                        }
                        vm.data.Closure_kyc_fk = singleProposalPaymentDetailsResponse.kyc_id_fk;
                        vm.data.SaleGM = singleProposalPaymentDetailsResponse.SaleGM;
                        vm.data.ImpType = singleProposalPaymentDetailsResponse.type;
                        vm.data.DeliGM = singleProposalPaymentDetailsResponse.DeliGM;
                        vm.data.TaxAmount = singleProposalPaymentDetailsResponse.Service_Tax;
                        vm.data.TravelCost = singleProposalPaymentDetailsResponse.travel_cost;
                        vm.data.AccommodationCost = singleProposalPaymentDetailsResponse.accomodation_cost;
                        vm.data.VisaCost = singleProposalPaymentDetailsResponse.visa_cost;
                        vm.data.PerDM = singleProposalPaymentDetailsResponse.per_dm_cost;
                        vm.data.Commission = singleProposalPaymentDetailsResponse.commission;
                        vm.data.ConsultantFee = singleProposalPaymentDetailsResponse.consultation_cost;
                        vm.data.tds = singleProposalPaymentDetailsResponse.tds > 0 ? singleProposalPaymentDetailsResponse.tds : 0;

                        vm.data.SalePerShare = singleProposalPaymentDetailsResponse.sale_percentage;

                        if (vm.data.SalePerShare == '' || vm.data.SalePerShare == null) {
                            vm.data.SalePerShare = Math.round((vm.data.SaleGM / vm.data.GrossMargin) * 100);
                        }



                        angular.forEach(vm.data.ClosurePaymentStatus, function (item, index) {
                            if (item.value == singleProposalPaymentDetailsResponse.payment_status) {
                                vm.data.selectedClosurePaymentStatus = vm.data.ClosurePaymentStatus[index];
                            }
                        })

                        // vm.func.updateProjStatus();
                        //angular.forEach(vm.data.ClosureProjectStatus, function (item, index) {
                        //    if (item.value == singleProposalPaymentDetailsResponse.project_status) {
                        //        vm.data.selectedClosureProjectStatus = vm.data.ClosureProjectStatus[index];

                        //    }
                        //})
                        //angular.forEach(vm.data.ClosureProjectStatus, function (item, index) {
                        //    if (item.value == singleProposalPaymentDetailsResponse.project_status) {
                        //        vm.data.selectedClosureProjectStatus = vm.data.ClosureProjectStatus[index];
                        //        //   vm.data.availableStatus = vm.data.ClosureProjectStatus[index];
                        //    }
                        //})

                        //angular.forEach(vm.data.availableStatus, function (item, index) {
                        //    if (item.value == singleProposalPaymentDetailsResponse.project_status) {
                        //        vm.data.selectedClosureProjectStatus = vm.data.availableStatus[index];
                        //    }
                        //})
                        //vm.data.PaymentExpected = singleProposalPaymentDetailsResponse.payment_expected_date;
                        //vm.data.ProjectStatus = singleProposalPaymentDetailsResponse.project_status;
                        //vm.data.PaymentStatus = singleProposalPaymentDetailsResponse.payment_status;
                    });
            }
        }

        vm.func.FinishClosure = function () {
            var ProjectStatus = localStorage.getItem('ProjectStatus');
            var QaStatus = localStorage.getItem('QaStatus');

            if (ProjectStatus != null) {
                if (ProjectStatus == 'Fresh' || ProjectStatus == 'Hold' || ProjectStatus == 'Go Ahead') {
                    vm.data.tempStatus = 1;
                }

              if (ProjectStatus == 'Dispatched' || ProjectStatus == 'Soft Copy Sent' || ProjectStatus == 'Hard Copy Sent') {
                    vm.data.tempStatus = 2;
                }
                if (QaStatus != null) {
                    if (QaStatus == 'Fresh' || QaStatus == 'Qualified') {
                        vm.data.tempqaStatus = 1;
                    }

                    if (QaStatus == 'Kyc Fail' || QaStatus == 'Kyc Pass' || QaStatus == 'Project Pass' || QaStatus == 'Project Fail') {
                        vm.data.tempqaStatus = 2;
                    }
                }
                else {
                    vm.data.tempqaStatus = 1;
                }
                var statusId = vm.data.tempStatus;
                var qaStatusId = vm.data.tempqaStatus;
                var currqastatus = QaStatus;
                var currprojstatus = ProjectStatus;
                var Kyc_idfk = localStorage.getItem('kyc_id_fk');
                popupService.finishClsDetails((stateParams.Id), statusId, qaStatusId, currqastatus, currprojstatus, Kyc_idfk, refresh);
            }
        }
        //================Starts Validte Closure Status=========================//
        //vm.func.hideRequiredProjectStatus = function () {
        //    if (vm.data.selectedClosureProjectStatus != 'Fresh' ) {
        //        vm.data.requiredProjectStatus = false;
        //    }
        //};
        //================Ends Validte Closure Status=========================//

        var refresh = function () {
            init();
        }

        vm.func.valSaleDeli = function () {
            //    vm.data.SalePerShare = Math.round((vm.data.SaleGM / vm.data.GrossMargin) * 100);
            vm.data.SaleGM = (vm.data.SalePerShare / 100) * vm.data.GrossMargin;
            vm.data.DeliGM = vm.data.GrossMargin - vm.data.SaleGM;
            //vm.data.countperlen = vm.data.SalePerShare.c
        }
        vm.func.valSaleShares = function () {
            //  vm.data.SalePerShare = Math.round((vm.data.SaleGM / vm.data.GrossMargin) * 100);
            //    vm.data.SalePerShare = Math.round((vm.data.SaleGM / vm.data.GrossMargin) * 100);
            vm.data.DeliGM = vm.data.GrossMargin - vm.data.SaleGM;
        }

        vm.func.valSaleSharesOnDeli = function () {
            vm.data.SalePerShare = 100 - Math.round((vm.data.DeliGM / vm.data.GrossMargin) * 100);
            vm.data.SaleGM = vm.data.GrossMargin - vm.data.DeliGM;
        }
        vm.func.valGM = function () {
            //   vm.data.SalePerShare = 100 - Math.round((vm.data.DeliGM / vm.data.GrossMargin) * 100);
            //   vm.data.SalePerShare = Math.round((vm.data.SaleGM / vm.data.GrossMargin) * 100);
            vm.data.SaleGM = vm.data.GrossMargin;
            vm.data.DeliGM = vm.data.GrossMargin - vm.data.SaleGM;
        }
        //vm.func.valSaleDeli = function () {
        //    // vm.data.SalePerShare = Math.round((vm.data.SaleGM / vm.data.GrossMargin) * 100);
        //    // init();
        //    vm.data.SaleGM = (vm.data.SalePerShare / 100) * vm.data.GrossMargin;
        //    vm.data.DeliGM = vm.data.GrossMargin - vm.data.SaleGM;
        //    vm.data.SalePerShare = Math.round((vm.data.SaleGM / vm.data.GrossMargin) * 100);
        //}

        vm.func.valReqGrossAndTotal = function () {
            if (vm.data.GrossMargin > vm.data.TotalClosure) {
                vm.data.valGrossandTotal = true;
            }
        };
        vm.func.hideRequiredPaymentStatus = function () {
            if (vm.data.selectedClosurePaymentStatus != 'Fresh') {
                vm.data.requiredPaymentStatus = false;
            }
        };

        vm.func.calActualExpenses = function () {
            //vm.data.TaxAmount;
            //   vm.data.AccommodationCost;
            // vm.data.VisaCost;
            //   vm.data.PerDM;
            //   vm.data.Commission;


            //if (vm.data.CertificationCost != null && vm.data.ConsultationCost != null) {
            //var certCost = vm.data.CertificationCost;
            ////var constCost = vm.data.ConsultationCost;
            //var TaxAmount = vm.data.TaxAmount;
            //var AccommodationCost = vm.data.AccommodationCost;
            //var VisaCost = vm.data.VisaCost;
            //var PerDM = vm.data.PerDM;
            //var Commission = vm.data.Commission;
            //var consultationCost = vm.data.ConsultantFee;
            //var misc = vm.data.OtherCost;

          vm.data.ActualExpenses = vm.data.TravelCost + vm.data.OtherCost + vm.data.ConsultantFee + vm.data.Commission + vm.data.CertificationCost + vm.data.TaxAmount + vm.data.AccommodationCost + vm.data.VisaCost + vm.data.PerDM + vm.data.BankCharges + vm.data.CourierExpenses;

            // vm.data.ActualExpenses = parseInt(certCost) + parseInt(TaxAmount) + parseInt(AccommodationCost) + parseInt(VisaCost) + parseInt(PerDM) + parseInt(Commission);

            if (vm.data.ActualExpenses != null && typeof vm.data.ActualExpenses != 'undefined' && isNaN(vm.data.ActualExpenses) == false) {
                var totalCost = vm.data.TotalClosure;
                var actExpeenses = vm.data.ActualExpenses;
                vm.data.GrossMargin = parseInt(totalCost) - parseInt(actExpeenses);
                vm.func.valReqGrossAndTotal();
                vm.func.valGM();
                vm.func.valSaleSharesOnDeli();
                vm.func.valSaleShares();
                vm.func.valSaleDeli();
            }


        }
        vm.func.PendPay = function () {
            if (vm.data.PaymentRecived != null) {
                var totalCost = vm.data.TotalClosure;
                var payRecv = vm.data.PaymentRecived;
                vm.data.PendingAmount = parseInt(totalCost) - parseInt(payRecv);

                if (vm.data.PendingAmount <= '0' && vm.data.selectedClosurePaymentStatus.value == 'Full Payment') {
                    $scope.ShowUpdate = true;
                    $scope.ShowRecon = false;
                    $scope.ShowPayRecDate = true;
                }
                else if (vm.data.PendingAmount > '0' && (vm.data.selectedClosurePaymentStatus.value == 'Full Payment' || vm.data.selectedClosurePaymentStatus.value == 'Reconciled')) {
                    $scope.ShowUpdate = false;
                    $scope.ShowRecon = false;
                    $scope.ShowPayRecDate = false;
                }
                else if (vm.data.PendingAmount >= '0' && (vm.data.selectedClosurePaymentStatus.value != 'Full Payment' || vm.data.selectedClosurePaymentStatus.value != 'Reconciled')) {
                    $scope.ShowUpdate = true;
                    $scope.ShowRecon = false;
                    $scope.ShowPayRecDate = false;
                }
                if (vm.data.PendingAmount <= '0' && vm.data.selectedClosurePaymentStatus.value == 'Reconciled') {
                    $scope.ShowRecon = true;
                    $scope.ShowUpdate = false;
                    $scope.ShowPayRecDate = true;
                }
            }
        }



        vm.func.updateProposalPayementDetails = function (isValid) {
            vm.data.isFormSubmit = true;
            //========================================Starts ValidReqFor Proj Status==============================
            //if (vm.data.selectedClosureProjectStatus.value == 'Fresh' || vm.data.selectedClosureProjectStatus.value == '' || vm.data.selectedClosureProjectStatus.value == 'Select' || vm.data.selectedClosureProjectStatus.value == null ) {
            //    vm.data.requiredProjectStatus = true;
            //    isValid = false;
            //}else if (vm.data.selectedClosureProjectStatus.value != 'Fresh') {
            //    if (vm.data.CurrProjStatus == 'Dispatched') {
            //        vm.data.PostProjStatus = 'Dispatched';
            //    } else if (vm.data.CurrProjStatus == 'Soft Copy Sent') {
            //        vm.data.PostProjStatus = 'Soft Copy Sent';
            //    }

            //    else {
            //        vm.data.PostProjStatus = vm.data.selectedClosureProjectStatus.value;
            //    }
            //}
            //========================================End ValidReqFor Proj Status==============================
            var salesGm = vm.data.SaleGM;
            var DelisGM = vm.data.DeliGM;

           
            if (vm.data.PaymentRecived != null) {
                var totalCost = vm.data.TotalClosure;
                var payRecv = vm.data.PaymentRecived;
                vm.data.PendingAmount = parseInt(totalCost) - parseInt(payRecv);
            }

            if (vm.data.ImpType == 'Onsite') {
                if (vm.data.GrossMargin != (parseInt(salesGm) + parseInt(DelisGM))) {
                    alert("Please Verify Gross Margin, Sale GM and Delivery GM  ");
                    vm.data.requiredsalesGm = true;
                    vm.data.requiredDelisGM = true;
                    isValid = false;
                }
            }


            if (vm.data.GrossMargin > vm.data.TotalClosure) {
                vm.data.requiredPaymentStatus1 = true;
                isValid = false;
            }

            if (vm.data.selectedClosurePaymentStatus.value == 'Fresh') {
                vm.data.requiredPaymentStatus = true;
                isValid = false;

            }
            else if ((vm.data.selectedClosurePaymentStatus.value != 'Fresh' && vm.data.selectedClosurePaymentStatus.value == 'Part Payment') && (vm.data.CurrProjStatus == 'Dispatched' || vm.data.CurrProjStatus == 'Soft Copy Sent' || vm.data.CurrProjStatus == 'Hard Copy Sent')) {
                vm.data.requiredPaymentStatus = true;
                vm.data.reqPartPaySts = true;
                isValid = false;
            }
            else if ((vm.data.selectedClosurePaymentStatus.value != 'Fresh' && vm.data.selectedClosurePaymentStatus.value == 'Part Payment') && (vm.data.CurrProjStatus == null || vm.data.CurrProjStatus == '' || vm.data.CurrProjStatus != 'Dispatched' || vm.data.CurrProjStatus != 'Soft Copy Sent' || vm.data.CurrProjStatus != 'Hard Copy Sent')) {
                vm.data.PostProjStatus = 'Hold';
            }
            else if ((vm.data.selectedClosurePaymentStatus.value != 'Fresh' && (vm.data.selectedClosurePaymentStatus.value == 'Pending Payment' || vm.data.selectedClosurePaymentStatus.value == 'Full Payment')) && (vm.data.CurrProjStatus == null || vm.data.CurrProjStatus == '' || vm.data.CurrProjStatus == 'Fresh' || vm.data.CurrProjStatus == 'Hold' || vm.data.CurrProjStatus == 'Go Ahead')) {
                //vm.data.PostProjStatus = 'Go Ahead';
                //(vm.data.CurrProjStatus != 'Fresh' && vm.data.CurrProjStatus != 'Dispatched' && vm.data.CurrProjStatus != 'Soft Copy Sent' && vm.data.CurrProjStatus != 'Hard Copy Sent')
            }
            else if ((vm.data.selectedClosurePaymentStatus.value != 'Fresh' && (vm.data.selectedClosurePaymentStatus.value == 'Pending Payment' || vm.data.selectedClosurePaymentStatus.value == 'Full Payment')) && (vm.data.CurrProjStatus != 'Fresh' || vm.data.CurrProjStatus != 'Hold' || vm.data.CurrProjStatus != 'Go Ahead')) {
                vm.data.PostProjStatus = vm.data.CurrProjStatus;
                //(vm.data.CurrProjStatus != 'Fresh' && vm.data.CurrProjStatus != 'Dispatched' && vm.data.CurrProjStatus != 'Soft Copy Sent' && vm.data.CurrProjStatus != 'Hard Copy Sent')
            }

            else if (vm.data.selectedClosurePaymentStatus.value != 'Fresh' && (vm.data.selectedClosurePaymentStatus.value == 'Written Off' || vm.data.selectedClosurePaymentStatus.value == 'Cancelled' || vm.data.selectedClosurePaymentStatus.value == 'Disputed') && vm.data.CurrProjStatus != 'Go Ahead') {
                vm.data.PostProjStatus = vm.data.CurrProjStatus;
            }
            else if (vm.data.selectedClosurePaymentStatus.value != 'Fresh' && (vm.data.selectedClosurePaymentStatus.value == 'Written Off' || vm.data.selectedClosurePaymentStatus.value == 'Cancelled' || vm.data.selectedClosurePaymentStatus.value == 'Disputed') && vm.data.CurrProjStatus == 'Go Ahead') {
                vm.data.PostProjStatus = 'Hold';
            }
            else if (vm.data.selectedClosurePaymentStatus.value != 'Fresh' && (vm.data.selectedClosurePaymentStatus.value == 'Reconciled') && (vm.data.CurrProjStatus == null || vm.data.CurrProjStatus == '' || vm.data.CurrProjStatus == 'Fresh' || vm.data.CurrProjStatus == 'Hold' || vm.data.CurrProjStatus == 'Go Ahead')) {
                vm.data.PostProjStatus = 'Go Ahead';
            }
            else if (vm.data.selectedClosurePaymentStatus.value != 'Fresh' && (vm.data.selectedClosurePaymentStatus.value == 'Reconciled') && (vm.data.CurrProjStatus == null || vm.data.CurrProjStatus == '' || vm.data.CurrProjStatus != 'Fresh' || vm.data.CurrProjStatus != 'Hold' || vm.data.CurrProjStatus != 'Go Ahead')) {
                //vm.data.PostProjStatus = vm.data.CurrProjStatus;
              vm.data.PostProjStatus = 'Go Ahead'; //trial for now to check null proj sts update
            }

            if (vm.data.CurrQaStatus == 'Fresh') {
                vm.data.qaStatus = 'Qualified';
                //vm.data.selectedClosurePaymentStatus.value != 'Fresh' &&
            }
            else {
                vm.data.qaStatus = vm.data.CurrQaStatus;
            }

            if (vm.data.PostProjStatus == undefined || vm.data.PostProjStatus == null) {
                vm.data.PostProjStatus = vm.data.CurrProjStatus;
            }
            if (isValid == true) {
                var updatedProposalPaymentValue = {};
                updatedProposalPaymentValue.Id = vm.data.Id;
                updatedProposalPaymentValue.TotalClosure = vm.data.TotalClosure;
                updatedProposalPaymentValue.GrossMargin = vm.data.GrossMargin;
                updatedProposalPaymentValue.PendingAmount = vm.data.PendingAmount;
                updatedProposalPaymentValue.ActualExpenses = vm.data.ActualExpenses;
                updatedProposalPaymentValue.PaymentRecived = vm.data.PaymentRecived;
                updatedProposalPaymentValue.SurveillanceCharges = vm.data.SurveillanceCharges;
                updatedProposalPaymentValue.ConsultationCost = vm.data.ConsultantFee;
              updatedProposalPaymentValue.CertificationCost = vm.data.CertificationCost;
              updatedProposalPaymentValue.BankCharges = vm.data.BankCharges;
              updatedProposalPaymentValue.CurrencyType = vm.data.CurrencyType;
              updatedProposalPaymentValue.CourierExpenses = vm.data.CourierExpenses;
                updatedProposalPaymentValue.TrainingCost = vm.data.TrainingCost;
                updatedProposalPaymentValue.TravelCost = vm.data.TravelCost;
                updatedProposalPaymentValue.OtherCost = vm.data.OtherCost;
                updatedProposalPaymentValue.OtherCostRemarks = vm.data.OtherCostRemarks;
                updatedProposalPaymentValue.ManDays = vm.data.ManDays;
                updatedProposalPaymentValue.TotalCostInOtherCurrency = vm.data.CostInOtherCurrency;
                updatedProposalPaymentValue.Remarks = vm.data.Remarks;
                updatedProposalPaymentValue.PaymentExpectedDate = $filter('date')(vm.data.PaymentExpected, "MM/dd/yyyy");
                //updatedProposalPaymentValue.PaymentExpectedDate = vm.data.PaymentExpected;
                updatedProposalPaymentValue.ProjectStatus = vm.data.PostProjStatus;
                updatedProposalPaymentValue.PaymentStatus = vm.data.selectedClosurePaymentStatus.value;
                updatedProposalPaymentValue.QaStatus = vm.data.qaStatus;
                updatedProposalPaymentValue.SalesGM = vm.data.SaleGM;
                updatedProposalPaymentValue.DeliveryGM = vm.data.DeliGM;
                updatedProposalPaymentValue.SaleShare = vm.data.SalePerShare;
                updatedProposalPaymentValue.TaxAmount = vm.data.TaxAmount;
                updatedProposalPaymentValue.AccommodationCost = vm.data.AccommodationCost;
                updatedProposalPaymentValue.VisaCost = vm.data.VisaCost;
                updatedProposalPaymentValue.PerDM = vm.data.PerDM;
                updatedProposalPaymentValue.Commission = vm.data.Commission;
                updatedProposalPaymentValue.tds = vm.data.tds;

                httpService.httpCall('api/proposalMnagement/updateProposalPaymentDetails', 'POST', updatedProposalPaymentValue)
                    .then(onSuccess, onFail)

                var updateProposalHistory = {};
                updateProposalHistory.kyc_id_fk = vm.data.Closure_kyc_fk;
                //updateProposalHistory.comment = vm.data.selectedClosurePaymentStatus.value + " verified. Certi Status " + vm.data.PostProjStatus;
                updateProposalHistory.comment = "Payment Status -  " + vm.data.selectedClosurePaymentStatus.value + " done. ";
                updateProposalHistory.activity_user = vm.data.LogedInUserId;
                updateProposalHistory.staus = '1';

                httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
                // .then(onSuccess, onFail)
            }
        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Update Successful!');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        vm.func.ok = function () {
            modalInstance.dismiss('cancel');
        }

        //vm.func.fullPmt = function () {
        //    if (PendingAmount != null && vm.data.ClosurePaymentStatus == 'Full Payment') {
        //     alert("Payment Pending cannot be 0, Please make sure Total Closure is equal to Payment Recieved")   
        //    }
        //}

        //vm.func.onReconsile () {
        //    if ( vm.data.ClosurePaymentStatus == 'Full Payment') {

        //    }
        //}

        //vm.func.payv = function () {
        //    if (vm.data.PendingAmount = '0') {
        //        //$(vm.data.ClosurePaymentStatus = [{ value: 'Full Payment', id: 3 }]).hide();
        //        alert("Payment Pending cannot be 0, Please make sure Total Closure is equal to Payment Recieved");
        //    }
        //}

        vm.func.FullPaymentPend = function () {
            if (vm.data.PendingAmount <= '0' && vm.data.selectedClosurePaymentStatus.value == 'Full Payment') {
                $scope.ShowUpdate = true;
                $scope.ShowRecon = false;
                $scope.ShowPayRecDate = true;
            }
            else if (vm.data.PendingAmount > '0' && (vm.data.selectedClosurePaymentStatus.value == 'Full Payment' || vm.data.selectedClosurePaymentStatus.value == 'Reconciled')) {
                $scope.ShowUpdate = false;
                $scope.ShowRecon = false;
                $scope.ShowPayRecDate = false;
            }
            else if (vm.data.PendingAmount >= '0' && (vm.data.selectedClosurePaymentStatus.value != 'Full Payment' || vm.data.selectedClosurePaymentStatus.value != 'Reconciled')) {
                $scope.ShowUpdate = true;
                $scope.ShowRecon = false;
                $scope.ShowPayRecDate = false;
            }
            if (vm.data.PendingAmount <= '0' && vm.data.selectedClosurePaymentStatus.value == 'Reconciled') {
                $scope.ShowRecon = true;
                $scope.ShowUpdate = false;
                $scope.ShowPayRecDate = true;
            }
        }

        init();
    }

})();

(function () {
    'use strict';

    angular
        .module('isoappClient')
        .controller('FinishClsDetailsController', FinishClsDetailsController);

    FinishClsDetailsController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'IdDetails', 'statusIds', 'qaStatusIds', 'currqastatuss', 'currprojstatuss', 'kycidfk', 'callBackFunction'];

    function FinishClsDetailsController(httpService, popupService, modalInstance, rootScope, IdDetail, statusId, qaStatusId, currqastatus, currprojstatus, Kycid, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {


            //  var getLoginUser = angular.fromJson(rootScope.UserData);
            //     vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            var UserData = angular.fromJson(rootScope.UserData);
            vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
            vm.data.Id = IdDetail;
            vm.data.projId = statusId;
            vm.data.qastsId = qaStatusId;
            vm.data.currqastat = currqastatus;
            vm.data.curprojsts = currprojstatus;
            vm.data.kyc_id_fk = Kycid;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        //var presave = function () {
        //    var data = {};
        //    data.Kyc_Id = vm.data.Kycid;
        //    data.Status = 'Active';

        //    return data;
        //}



      vm.func.finish = function () {
            var statusdata = {};
            if (vm.data.qastsId == 1) {
                if (vm.data.projId == 1) {

                  statusdata.Id = vm.data.Id;
                    //statusdata.ProjectStatus = 'Go Ahead';
                    statusdata.PaymentStatus = 'Reconciled';
                    statusdata.QaStatus = "Qualified";
                    httpService.httpCall('api/proposalMnagement/finishClsDetails', 'POST', statusdata)
                        .then(onSuccess, onFail)
                    updateHistory();

                }

                else {

                    statusdata.Id = vm.data.Id;
                    statusdata.ProjectStatus = vm.data.curprojsts;
                    statusdata.PaymentStatus = 'Reconciled';
                    statusdata.QaStatus = "Qualified";
                    httpService.httpCall('api/proposalMnagement/finishClsDetails', 'POST', statusdata)
                        .then(onSuccess, onFail)
                    updateHistory();
                }
            }
            else {

                if (vm.data.projId == 1) {

                  statusdata.Id = vm.data.Id;
                    //statusdata.ProjectStatus = 'Go Ahead';
                    statusdata.PaymentStatus = 'Reconciled';
                    statusdata.QaStatus = vm.data.currqastat;
                    httpService.httpCall('api/proposalMnagement/finishClsDetails', 'POST', statusdata)
                        .then(onSuccess, onFail)
                    updateHistory();
                }

                else {
                    statusdata.Id = vm.data.Id;
                    statusdata.ProjectStatus = vm.data.curprojsts;
                    statusdata.PaymentStatus = 'Reconciled';
                    statusdata.QaStatus = vm.data.currqastat;
                    httpService.httpCall('api/proposalMnagement/finishClsDetails', 'POST', statusdata)
                        .then(onSuccess, onFail)
                    updateHistory();
                }
            }
        }
        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Reconciled');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        var updateHistory = function () {
            var updateProposalHistory = {};
            updateProposalHistory.kyc_id_fk = vm.data.kyc_id_fk;
            //updateProposalHistory.comment = vm.data.selectedClosurePaymentStatus.value + " verified. Certi Status " + vm.data.PostProjStatus;
            updateProposalHistory.comment = "Payment Status - Reconciled done.";
            updateProposalHistory.activity_user = vm.data.LogedInUserId;
            updateProposalHistory.staus = '1';

            httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
            //.then(onSuccess, onFail)
        }
        init();
    }

})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('FinishClosureController', FinishClosureController);

    FinishClosureController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'KycIdDetails','Ids', 'callBackFunction'];

    function FinishClosureController(httpService, popupService, modalInstance, rootScope, KycIdDetail,Id, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
         

          //  var getLoginUser = angular.fromJson(rootScope.UserData);
       //     vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Kyc_id = KycIdDetail;
            vm.data.Idd = Id;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        //var presave = function () {
        //    var data = {};
        //    data.Kyc_Id = vm.data.Kycid;
        //    data.Status = 'Active';
          
        //    return data;
        //}

        vm.func.finishIt = function () {
                  
            var alldata = {};
                alldata.Kycid = vm.data.Kyc_id;
                alldata.Status = 'Active';
                httpService.httpCall('api/closureManagement/finishClosure', 'POST', alldata)
                .then(onSuccess, onFail)

                var prodata = {};
                prodata.Id = vm.data.Idd;
                prodata.ProjectStatus = 'Dispatched';
            httpService.httpCall('api/proposalMnagement/projectStatusUpdate', 'POST', prodata)
                   .then(onSuccess1, onFail1)
            
        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Certificate Dispatched & Closed');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };
        var onSuccess1 = function () {
            //modalInstance.close('OK');
           // popupService.successsm('ISO', 'Certificate Dispatched');
           // callBack();
        }

        var onFail1 = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };


        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('ErrorsmController', ErrorsmController);

    ErrorsmController.$inject = ['$uibModalInstance', 'title', 'message'];

    function ErrorsmController(modalInstance, title, message) {
        var vm = this;

        vm.data = [];
        vm.func = [];

        vm.func.ok = function () {
            modalInstance.close('OK');
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        var init = function () {
            vm.data.title = title;
            vm.data.message = message;
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('EditInvalidEnquiryController', EditInvalidEnquiryController)

    EditInvalidEnquiryController.$inject = ['$uibModalInstance', '$rootScope', 'httpService', 'popupService', 'singleEnqID', 'callBackFunction'];

    function EditInvalidEnquiryController(modalInstance, rootScope, httpService, popupService, updateInvalidEnquiry, callBack) {


        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            //vm.data.isFormSubmit = false;


            var getLoginUser = angular.fromJson(rootScope.UserData);
            vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Enq_Id = updateInvalidEnquiry;
            vm.data.EnquirID = updateInvalidEnquiry.Enquiryid;
            

            //vm.data.DumpData = [
              
            //    { name: 'Lost',id:'1' },
            //    { name: 'Invalid',id:'2' }
            //];


            vm.data.ReasonData = [
                
                { value: 'Training'},
                { value: 'Not Responding' },
                { value: 'Request out of Portfolio' },
                { value: 'Not Interested(Cost)' },
                { value: 'Not Interested(Certification Body)' },
                { value: 'Not Interested(Needs Local Rep)' },
                { value: 'Test Entry' },
                { value: 'SPAM' },
                { value: 'Incorrect Info' },
                { value: 'Duplicate' }
              
            ];

           
            vm.func.SelectDumpData =   vm.data.ReasonData[0];
        }

            //var presave = function () {
            //    var data = {};
            //  //  data.Enquiryid = vm.data.Enq_Id;// To Save Enquiry Id in EnquiryHistory Table.
            //    data.Enquirycomment = vm.data.CommentEnquiryInvalid;//
            //    //data.Status_Id = vm.data.selectDumpData;
            //    data.ReasonEnqInvalid = vm.data.SelectDumpData.name;
            //    data.Enq_Agent = vm.data.CommentBy;

            //    return data;
            //}

            vm.func.saveEnqInvalidComment = function () {
             

              
                var alldata = {};
                alldata.Enquiryid = vm.data.EnquirID;
                alldata.Enquirycomment = vm.data.CommentEnquiryInvalid;
                alldata.ReasonEnqInvalid = vm.data.SelectDumpData.value;
                alldata.Enq_Agent = vm.data.CommentBy;
                  
                    httpService.httpCall('api/enquiryManagement/saveInvalidEnquiryReason', 'POST', alldata)
                    .then(onSuccess, onFail)

                    var allData1 = {};
                    allData1.enq_id_fk = vm.data.EnquirID;
                    allData1.enq_comment = vm.data.CommentEnquiryInvalid;
                    allData1.ReasonEnqInvalid = vm.data.SelectDumpData.value;
                    allData1.enq_user = vm.data.CommentBy;
                    allData1.enq_comment_status = '1';
                    allData1.status_id_fk = '3';

                httpService.httpCall('api/enquiryManagement/saveInvalidEnquiryHist', 'POST', allData1)
                      .then(onSuccess1, onFail1)
                
                }
            

            var onSuccess = function () {
                modalInstance.close('OK');
                popupService.successsm('ISO', 'Thanks for comment !');
                callBack();
            }

            //var onSuccess1 = function () {
            //    modalInstance.close('OK');
            //    popupService.successsm('ISO', 'Thanks for comment2 !');
            //    callBack();
            //}

            var onFail = function () {
                popupService.errorsm('ISO', 'Server Problem!');
            };
            //var onFail1 = function () {
            //    popupService.errorsm('ISO', 'Server Problem2!');
            //};



            vm.func.cancel = function () {
                modalInstance.dismiss('cancel');
            }


            init();
        

    }

})();




(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('EditEnquiryController', EditEnquiryController)

    EditEnquiryController.$inject = ['$uibModalInstance', 'httpService', 'popupService', 'updateEnquiry', 'callBackFunction'];

    function EditEnquiryController(modalInstance, httpService, popupService, updateEnquiryDetails, callBack) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.isFormSubmit = false;
            vm.data.requiredAgent = false;
            vm.data.requiredReason = false;
            //vm.data.requiredLeadSource = false;

            //vm.data.CompanyType = [
            //    { value: 'Select' },
            //    { value: 'Proprietorship' },
            //    { value: 'Pvt. Ltd.' },
            //    { value: 'Public Ltd.' },
            //    { value: 'Trust/Co-op/Association' },
            //    { value: 'Government' },
            //    { value: 'Other' }
            //];

            //vm.data.LeadType = [
            //    { value: 'Select' },
            //    { value: 'HOT' },
            //    { value: 'WARM' },
            //    { value: 'COLD' }
            //];

            vm.data.LeadSourceType = [
            { value: 'Select' },
            { value: 'Top Certifier' },
            { value: 'Livserv' },
            { value: 'Phone' },
            { value: 'Veave' },
            { value: 'Region Site' }
            ];


            vm.data.ReasonData = [
               { value: 'Select' },
               { value: 'Training' },
               { value: 'Request out of Portfolio' },
               { value: 'Test Entry' },
               { value: 'SPAM' },
               { value: 'Incorrect Info' },
               { value: 'Duplicate' }
                  //   { value: 'Not Responding' },
                  //  { value: 'Not Interested(Cost)' },
             //  { value: 'Not Interested(Certification Body)' },
             //  { value: 'Not Interested(Needs Local Rep)' },

            ];

            vm.data.SelectDumpData = vm.data.ReasonData[0];

            //vm.data.selectedCompanyType = vm.data.CompanyType[0];
            //vm.data.selectedLeadType = vm.data.LeadType[0];
            vm.data.LeadSource = vm.data.LeadSourceType[0];


            vm.data.Agent = [
                {value:'Select'},
               { value: 'Ajay Mohan' },
 { value: 'Anand N' },
{ value: 'Anoop' },
{ value: 'Anoop Ramesh' },
{ value: 'AssociateManager' },
{ value: 'Basil N Sunny' },
{ value: 'Bharath Bhushan' },
{ value: 'Gurutej' },
{ value: 'Mohammed Haneef Ayaz' },
{ value: 'Mones Faizal' },
{ value: 'Naval Chand' },
{ value: 'Naveen' },
{ value: 'Navya' },
{ value: 'Overseas' },
{ value: 'Pavana' },
{ value: 'Prashant' },
{ value: 'Puneeth BR' },
{ value: 'Rajesh' },
{ value: 'Ria' },
{ value: 'Rinku' },
{ value: 'Sahadev' },
{ value: 'Shruthi' },
{ value: 'Sneha' },
{ value: 'Subhash' },
{ value: 'Syed Nadeem' },
{ value: 'Vandana' },
{ value: 'Vijay' },
{ value: 'Vikyath.G.D' },
{ value: 'Vinay' }



            ];

            vm.data.SelectAgent = vm.data.Agent[0];

            httpService.httpCall('api/enquiryManagement/suggestCountryName', 'GET', null)//From Country Table
            .then(function (response) {
                vm.data.suggestCountry = response;
                vm.data.suggestCountryData = angular.copy(vm.data.suggestCountry);
            });

            httpService.httpCall('api/enquiryManagement/suggestassignto', 'GET', null)//Retrieving From TPAContact Table.
            .then(function (response) {
                vm.data.suggestAssignTo = response;
                vm.data.suggestAssignToData = angular.copy(vm.data.suggestAssignTo);
            });

            httpService.httpCall('api/enquiryManagement/suggestIsoCertificationType', 'GET', null)//From Standards Table.
            .then(function (response) {
                vm.data.suggestIsoRequiredType = response;
                vm.data.suggestIsoRequiredTypeData = angular.copy(vm.data.suggestIsoRequiredType);
            });

            vm.data.Enquiryid = updateEnquiryDetails.Enquiryid;
            vm.data.aff_id_fk = '1';
            vm.data.enq_enquiry = "NULL";
            vm.data.cust_email_status = '0';
           
            
            vm.data.EnquiryName = updateEnquiryDetails.Enquiryname;
            vm.data.CompanyName = updateEnquiryDetails.Companyname;
            vm.data.EnquiryPhone = updateEnquiryDetails.Enquiryphone;
            vm.data.EnquiryEmail = updateEnquiryDetails.Enquiryemail;
            vm.data.selectedCountryname = updateEnquiryDetails.Country;
            vm.data.CompanySize = updateEnquiryDetails.Companysize;
            vm.data.selectedAssignto = updateEnquiryDetails.Enquiryassignto;
            vm.data.selectedIsoRequired = updateEnquiryDetails.EnquiryStandard;
            vm.data.priority_id_fk = 3;
            vm.data.City = updateEnquiryDetails.Enquirycity;
            vm.data.commentBy=updateEnquiryDetails
            //angular.forEach(vm.data.CompanyType, function (item, index) {
            //    if (item.value == updateEnquiryDetails.Companytype) {
            //        vm.data.selectedCompanyType = vm.data.CompanyType[index];
            //    }   
            //})s
            //angular.forEach(vm.data.LeadType, function (item, index) {
            //    if (item.value == updateEnquiryDetails.Leadtype) {
            //        vm.data.selectedLeadType = vm.data.LeadType[index];
            //    }
            //})
            
            vm.data.Remarks = updateEnquiryDetails.Enquirycomment;
            vm.data.NatureofBusiness = updateEnquiryDetails.Companytype;


            angular.forEach(vm.data.LeadSourceType, function (item, index) {
                if (item.value == updateEnquiryDetails.Enquirytype) {
                    vm.data.LeadSource = vm.data.LeadSourceType[index];
                }
            })
           
        }


        //vm.func.hideRequiredLeadSource = function () {
        //    if (vm.data.LeadSource != 'Select') {
        //        vm.data.requiredLeadSource = false;
        //    }
        //};
      //  =================================================================
        //vm.func.hideRequiredCompanyType = function () {
        //    if (vm.data.selectedCompanyType != 'Select') {
        //        vm.data.requiredCompanyType = false;
        //    }
        //};

        //vm.func.hideRequiredLeadType = function () {
        //    if (vm.data.selectedLeadType != 'Select') {
        //        vm.data.requiredLeadType = false;
        //    }
        //};

        //vm.func.hideRequiredEnquirySource = function () {
        //    if (vm.data.selectedEnquirySource != 'Select') {
        //        vm.data.requiredEnquirySource = false;
        //    }
        //};

        vm.func.updateEnquiryetails = function (isValid) {
            vm.data.isFormSubmit = true;
            //if (vm.data.selectedCompanyType.value == 'Select') {
            //    vm.data.requiredCompanyType = true;
            //    isValid = false;
            //}
         //   vm.data.isFormSubmit = true;
            if (vm.data.SelectAgent.value == 'Select') {
                vm.data.requiredAgent = true;
                isValid = false;
            }
            //if (vm.data.selectedLeadType.value == 'Select') {
            //    vm.data.requiredLeadType = true;
            //    isValid = false;
            //}
            //if (vm.data.LeadSource.value == 'Select') {
            //    vm.data.requiredLeadSource = true;
            //    isValid = false;
            //}
            if (isValid == true) {
                var updatedEnquiryDetails = {};
                updatedEnquiryDetails.Enquiryid = vm.data.Enquiryid;
                updatedEnquiryDetails.Enquiryname = vm.data.EnquiryName;
                updatedEnquiryDetails.Companyname = vm.data.CompanyName;
                updatedEnquiryDetails.Enquiryphone = vm.data.EnquiryPhone;
                updatedEnquiryDetails.Enquiryemail = vm.data.EnquiryEmail + "$" + vm.data.selectedIsoRequired;
                updatedEnquiryDetails.Enquirycity = vm.data.City;
                updatedEnquiryDetails.Country = vm.data.selectedCountryname;
                //updatedEnquiryDetails.Companytype = vm.data.selectedCompanyType.value;
                //updatedEnquiryDetails.Leadtype = vm.data.selectedLeadType.value;
                updatedEnquiryDetails.Companytype = vm.data.NatureofBusiness;
                updatedEnquiryDetails.Companysize = vm.data.CompanySize;
                updatedEnquiryDetails.Enquiryassignto = vm.data.SelectAgent.value;
                updatedEnquiryDetails.EnquiryStandard = "";
                updatedEnquiryDetails.Enquirycomment = vm.data.Remarks;
                updatedEnquiryDetails.Enquirytype = vm.data.LeadSource.value;
                httpService.httpCall('api/enquiryManagement/updateEnquiryData', 'POST', updatedEnquiryDetails)
                .then(onSuccess, onFail)

               var smsData = {};

               smsData.enqid = vm.data.Enquiryid;
               smsData.agentname = vm.data.SelectAgent.value;
                httpService.httpCall('api/enquiryManagement/smsEnquiryData', 'POST', smsData)
                .then(onSuccess2,onFail2)
            }
        }

        vm.func.saveEnqInvalidComment = function (isValid) {
            vm.data.isFormSubmit = true;

            if (vm.data.SelectDumpData.value == 'Select') {
                vm.data.requiredReason = true;
                isValid = false;
            }
            if (isValid == true) {
            var alldata = {};
            alldata.Enquiryid = vm.data.Enquiryid;
            //alldata.Enquirycomment = vm.data.CommentEnquiryInvalid;
            alldata.ReasonEnqInvalid = vm.data.SelectDumpData.value;
          //  alldata.Enq_Agent = vm.data.CommentBy;

            httpService.httpCall('api/enquiryManagement/saveInvalidEnquiryReason', 'POST', alldata)
            .then(onSuccess1, onFail1)
            }
        }
        var onSuccess1 = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Reason for Invalid, Submitted');
            callBack();
        }

        
        var onFail1 = function () {
            popupService.errorsm('ISO', 'Server Problem!');
        };

        var onSuccess2 = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'SMS has been Delivered Successfully');
            callBack();
        }


        var onFail2 = function () {
            popupService.errorsm('ISO', 'Server Problem at EditEnquiry!');
        };

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Successfully Updated & Assigned Enquiry!');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        vm.func.ok = function () {
            modalInstance.close('OK');
        }
        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('AddProposalController', AddProposalController)

    AddProposalController.$inject = ['$uibModalInstance', 'httpService', 'popupService', 'callBackFunction'];

    function AddProposalController(modalInstance, httpService, popupService, callBack) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.isFormSubmit = false;
            vm.data.requiredValidity = false;
            vm.data.requiredSource = false;
            vm.data.requiredType = false;
            vm.data.requiredProjectStatus = false;
            vm.data.requiredPaymentStatus = false;

            vm.data.ClosureSource = [
                { value: 'Select' },
                { value: 'Associate' },
                { value: 'Fresh' },
                { value: 'Reference ' },
                { value: 'Renewal' },
                { value: 'Surveillance 1' },
                { value: 'Surveillance 2' },
                {value: 'Upsale'}
            ];

            vm.data.ClosureType = [
                { value: 'Select' },
                { value: 'Remote' },
                { value: 'Onsite' }
            ];

            vm.data.ClosureProjectStatus = [
                { value: 'Select' },
                { value: 'Completed' },
                { value: 'Under Progress' }
            ];

            vm.data.ClosurePaymentStatus = [
                { value: 'Select' },
                { value: 'Full Payment' },
                { value: 'Part Payment' }
            ];

            vm.data.Validity = [
                { value: 'Select' },
                { value: '1 Year' },
                { value: '3 Years' }
            ];

            vm.data.selectedClosureSource = vm.data.ClosureSource[0];
            vm.data.selectedClosureType = vm.data.ClosureType[0];
            vm.data.selectedClosureProjectStatus = vm.data.ClosureProjectStatus[0];
            vm.data.selectedClosurePaymentStatus = vm.data.ClosurePaymentStatus[0];
            vm.data.selectedValidity = vm.data.Validity[0];
            
            httpService.httpCall('api/closureManagement/suggistCompanyForClosure', 'GET', null)
            .then(function (response) {
                vm.data.getCompany = response;
            });

            httpService.httpCall('api/enquiryManagement/suggestassignto', 'GET', null)
            .then(function (response) {
                vm.data.suggestSalesAgent = response;
                vm.data.suggestDeliveryAgent = response;
                vm.data.suggestSalesAgentData = angular.copy(vm.data.suggestSalesAgent);
                vm.data.suggestDeliveryAgentData = angular.copy(vm.data.suggestDeliveryAgent);
            });

            httpService.httpCall('api/enquiryManagement/suggestIsoCertificationType', 'GET', null)
            .then(function (response) {
                vm.data.suggestIsoStandards = response;
                vm.data.suggestIsoStandardsData = angular.copy(vm.data.suggestIsoStandards);
            });

        }

        vm.func.ok = function () {
            modalInstance.close('OK');
        }
        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        vm.func.hideRequiredValidity = function () {
            if (vm.data.selectedValidity != 'Select') {
                vm.data.requiredValidity = false;
            }
        };

        vm.func.hideRequiredSource = function () {
            if (vm.data.selectedClosureSource != 'Select') {
                vm.data.requiredSource = false;
            }
        };

        vm.func.hideRequiredType = function () {
            if (vm.data.selectedClosureType != 'Select') {
                vm.data.requiredType = false;
            }
        };

        //vm.func.hideRequiredProjectStatus = function () {
        //    if (vm.data.selectedClosureProjectStatus != 'Select') {
        //        vm.data.requiredProjectStatus = false;
        //    }
        //};

        //vm.func.hideRequiredPaymentStatus = function () {
        //    if (vm.data.selectedClosurePaymentStatus != 'Select') {
        //        vm.data.requiredPaymentStatus = false;
        //    }
        //}

        var preSaveProposal = function () {
            var data = {};
            data.client = vm.data.Client;
            data.standards = vm.data.selectedIsoStandards;
            data.region = vm.data.selectedRegion;
            data.CB = vm.data.CertificationBody;
            data.location = vm.data.Location;
            data.sales_agent = vm.data.selectedSalesAgent;
            data.delivery_agent = vm.data.selectedDeliveryAgent;
            data.validity = vm.data.selectedValidity.value;
            data.source = vm.data.selectedClosureSource.value;
            data.type = vm.data.selectedClosureType.value;
            data.project_status = "Dispatched";
            data.payment_status = "Reconciled";
            data.qa_status = "Qualified";
            //data.project_status = vm.data.selectedClosureProjectStatus.value;
            //data.payment_status = vm.data.selectedClosurePaymentStatus.value;
            data.payment_expected_date = vm.data.PaymentExpectedDate;
            data.gross_margin = vm.data.GrossMargin;
            data.total_closure = vm.data.TotalClosure;
            data.pending_amount = vm.data.PendingAmount;
            data.actual_expenses = vm.data.ActualExpenses;
            data.surveillance_charges = vm.data.SurveillanceCharges;
            data.payment_recived = vm.data.PaymentRecived;
            //data.consultation_cost = vm.data.ConsultationCost;
            data.certification_cost = vm.data.CertificationCost;
            //data.training_cost = vm.data.TrainingCost;
          //  data.travel_cost = vm.data.TravelCost;
        //    data.other_cost = vm.data.OtherCost;
        //    data.other_cost_remarks = vm.data.OtherCostRemarks;
         //   data.man_days = vm.data.ManDays;
          //  data.total_cost_in_other_currency = vm.data.CostInOtherCurrency;
           // data.project_team_size = vm.data.TeamSize;
            data.remarks = vm.data.Remarks;
            
            return data;
        }

        vm.func.saveProposal = function (isValid) {
            vm.data.isFormSubmit = true;
            if (vm.data.selectedValidity.value == 'Select') {
                vm.data.requiredValidity = true;
                isValid = false;
            }
            if (vm.data.selectedClosureSource.value == 'Select') {
                vm.data.requiredSource = true;
                isValid = false;
            }
            if (vm.data.selectedClosureType.value == 'Select') {
                vm.data.requiredType = true;
                isValid = false;
            }
            //if (vm.data.selectedClosureProjectStatus.value == 'Select') {
            //    vm.data.requiredProjectStatus = true;
            //    isValid = false;
            //}
            //if (vm.data.selectedClosurePaymentStatus.value == 'Select') {
            //    vm.data.requiredPaymentStatus = true;
            //    isValid = false;
            //}
            if (isValid == true) {
                var addProposal = preSaveProposal();
                httpService.httpCall('api/proposalMnagement/saveNewProposal', 'POST', addProposal)
                .then(onSuccess, onFail)
            }
        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Successfull save new closure !');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        init();
    }

})();
(function () {
  'use strict';

  angular
    .module('isoappClient')
    .controller('UpdateCertificationController', UpdateCertificationController);

  UpdateCertificationController.$inject = ['$uibModalInstance', '$filter', 'httpService', 'popupService', 'updateCertificate', 'callBackFunction'];

  function UpdateCertificationController(modalInstance, $filter, httpService, popupService, updateCertificate, callBack) {
    var vm = this;

    vm.data = {};
    vm.func = {};

    vm.func.ok = function () {
      modalInstance.close('OK');
    }

    vm.func.cancel = function () {
      modalInstance.dismiss('cancel');
    }

    var init = function () {
      vm.data.isFormSubmit = false;
      vm.data.requiredCertificationType = false;
      //vm.data.requiredCertificationStatus = false;
      vm.data.CertificationIssueType = false;
      vm.data.requiredCertificationValidity = false;
      var currentdate = new Date();
      vm.data.IssueDate = currentdate;
      vm.data.ExpiryDate = currentdate;
      vm.data.AuditRenewalDate = currentdate;

      vm.data.CertificationType = [
        { value: 'Select' },
        { value: 'Online' },
        { value: 'Onsite' },
        { value: 'Remote' },
        { value: 'Not Applicable' }
      ];

      //vm.data.CertificationStatus = [
      //    { value: 'Select' },
      //    { value: 'Active' },
      //    { value: 'Inactive' }
      //];

      vm.data.Validity = [
        { value: 'Select' },
        { value: '3 Months' },
        { value: '6 Months' },
        { value: '1 Year' },
        { value: '2 Years' },
        { value: '3 Years' }
      ];

      vm.data.CertificateIssueType = [
          { value: 'Select' },
          { value: 'Initial' },
          { value: 'Surveillance1' },
          { value: 'Surveillance2' },
          { value: 'Recertification' },
          { value: 'Auditing' }
        ];


      vm.data.SelectedCertIssueType = vm.data.CertificateIssueType[0];
      vm.data.selectedCertificationType = vm.data.CertificationType[0];
      //vm.data.selectedCertificationStatus = vm.data.CertificationStatus[0];
      vm.data.selectedCertificationValidity = vm.data.Validity[0];

      vm.data.CertificationId = updateCertificate.CertificationId;
      vm.data.CertificationNumber = updateCertificate.CertificationNumber;
      vm.data.CompanyName = updateCertificate.CertificationCompanyName;
      //vm.data.item_date = updateCertificate.CertificationIssueDate;
      //vm.data.item_date = updateCertificate.RecertifiedDate;
      // vm.data.IssueDate = updateCertificate.CertificationIssueDate;
      //vm.data.IssueDate = $filter('date')(vm.data.item_date, "MM/dd/yyyy");
      //vm.data.ExpiryDate = updateCertificate.CertificationExpiryDate;
      //vm.data.itemexpiry_date = updateCertificate.CertificationExpiryDate;
      //vm.data.ExpiryDate = $filter('date')(vm.data.itemexpiry_date, "MM/dd/yyyy");
      vm.data.ExpiryDate = new Date(updateCertificate.CertificationExpiryDate);
      vm.data.AuditRenewalDate = new Date(updateCertificate.AuditRenewalDate);
      //vm.data.IssueDate = $filter('date')(updateCertificate.RecertifiedDate, "MM/dd/yyyy");
      vm.data.IssueDate = new Date(updateCertificate.RecertifiedDate);
      vm.data.Scope = updateCertificate.CertificationScope;
      vm.data.Standard = updateCertificate.CertificationIsoStandard;
      vm.data.CertificationAddress = updateCertificate.CertificationAddress;
      vm.data.UnderAccreditation = updateCertificate.CertificationUnderAccred;
      vm.data.Body = updateCertificate.CertificationBody;
      vm.data.Country = updateCertificate.Country;
      vm.data.State = updateCertificate.State;
      vm.data.City = updateCertificate.City;
      vm.data.EnquiryNumber = updateCertificate.EnquiryNumber;
      vm.data.CertAssign = updateCertificate.CertAssign;
      vm.data.AgentReqStatus = updateCertificate.AgentReqStatus;

      angular.forEach(vm.data.CertificationType, function (item, index) {
        if (item.value == updateCertificate.CertificationType) {
          vm.data.selectedCertificationType = vm.data.CertificationType[index];
        }
      })

      //angular.forEach(vm.data.CertificationStatus, function (item, index) {
      //    if (item.value == updateCertificate.CertificationStatus) {
      //        vm.data.selectedCertificationStatus = vm.data.CertificationStatus[index];
      //    }
      //})

      angular.forEach(vm.data.CertificateIssueType, function (item, index) {
        if (item.value == updateCertificate.CertIssueType) {
          vm.data.SelectedCertIssueType = vm.data.CertificateIssueType[index];
        }
      })

      angular.forEach(vm.data.Validity, function (item, index) {
        if (item.value == updateCertificate.CertificationValidity) {
          vm.data.selectedCertificationValidity = vm.data.Validity[index];
        }
      })
      vm.data.getSingleKycid = updateCertificate.CertificationClosurKycID;

      //httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + stateParams.Kycid, 'GET', null)
      //  .then(function (response) {
      //    vm.data.CompanyReg = response.Company_Reg_Files;
      //    alert(vm.data.CompanyReg);
      //  });
    }

    vm.func.hideRequiredCertificationType = function () {
      if (vm.data.selectedCertificationType != 'Select') {
        vm.data.requiredCertificationType = false;
      }
    };

    vm.data.hideRequiredCertificationValidity = function () {
      if (vm.data.selectedCertificationValidity != 'Select') {
        vm.data.requiredCertificationValidity = false;
      }
    };

    //vm.func.hideRequiredCertificationStatus = function () {
    //    if (vm.data.selectedCertificationStatus != 'Select') {
    //        vm.data.requiredCertificationStatus = false;
    //    }
    //};

    vm.func.hideRequiredCertIssueType = function () {
      if (vm.data.SelectedCertIssueType != 'Select') {
        vm.data.CertificationIssueType = false;
      }
    };
    vm.func.hideRequiredDateValid = function () {
      //   var m= vm.data.ExpiryDate.getFullY
      // var nosofdays = 0;

      //vm.data.IssueDateadded = vm.data.IssueDate.setDate(vm.data.IssueDate.getDate() + nosofdays);
      //vm.data.ExpiryDateadded = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() + nosofdays);

      //vm.data.IssueDateformate = $filter('date')(vm.data.IssueDateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
      //vm.data.ExpiryDateformate = $filter('date')(vm.data.ExpiryDateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000


      var dateOutIssueDate = $filter('date')(vm.data.IssueDate, "MM/dd/yyyy"); // it will work if date1 is in ISO format
      var dateOutExpiryDate = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");

      if (dateOutExpiryDate > dateOutIssueDate) {

        var timeDiff = Math.abs(dateOutExpiryDate.getTime() - dateOutIssueDate.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        //alert(diffDays);

        if (diffDays < 364) {
          onFailDate();
          vm.data.ExpiryDate = "";
        }

      }
      else {
        onFailDate();
        vm.data.ExpiryDate = "";
      }


    }

    vm.func.hideRequiredCertificationValidity = function () {
      if (vm.data.selectedCertificationValidity != 'Select') {
        vm.data.requiredCertificationValidity = false;

        // ----------------------------------Gopal------------------------------------------------------------------------------------------------
        var val = (vm.data.selectedCertificationValidity.value).split(' ');

        if (val[1] == 'Months') {
          vm.data.ExpiryDate = vm.data.IssueDate.setMonth(vm.data.IssueDate.getMonth() + parseInt(val[0]));
          vm.data.ExpiryDateformat = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");
          var datass = vm.data.IssueDate.setMonth(vm.data.IssueDate.getMonth() - val[0]);
          vm.data.IssueDate = $filter('date')(datass, "MM/dd/yyyy");
          vm.data.IssueDate = new Date(vm.data.IssueDate);
          var expdate = $filter('date')(vm.data.ExpiryDateformat, "MM/dd/yyyy");
          var newexpdate = new Date(expdate);
          vm.data.ExpiryDate = newexpdate;

          vm.data.ExpiryDate = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() - 1);
          vm.data.ExpiryDateformat = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");
          var expdatee = $filter('date')(vm.data.ExpiryDateformat, "MM/dd/yyyy");
          var newexpdatee = new Date(expdatee);
          vm.data.ExpiryDate = newexpdatee;
          //vm.data.AuditRenewalDate = newexpdatee;
        }
        else if (val[1] == 'Year' || val[1] == 'Years') {
          var mon = val[0] * 12;
          vm.data.ExpiryDate = vm.data.IssueDate.setMonth(vm.data.IssueDate.getMonth() + parseInt(mon));
          vm.data.ExpiryDateformat = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");

          var datass = vm.data.IssueDate.setMonth(vm.data.IssueDate.getMonth() - mon);
          vm.data.IssueDate = $filter('date')(datass, "MM/dd/yyyy");
          vm.data.IssueDate = new Date(vm.data.IssueDate);

          var expdate = $filter('date')(vm.data.ExpiryDateformat, "MM/dd/yyyy");
          var newexpdate = new Date(expdate);
          vm.data.ExpiryDate = newexpdate;

          vm.data.ExpiryDate = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() - 1);
          vm.data.ExpiryDateformat = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");
          var expdatee = $filter('date')(vm.data.ExpiryDateformat, "MM/dd/yyyy");
          var newexpdatee = new Date(expdatee);
          vm.data.ExpiryDate = newexpdatee;
          //vm.data.AuditRenewalDate = newexpdatee; 
        }
        else {
          vm.data.ExpiryDate = vm.data.IssueDate;
          //vm.data.AuditRenewalDate = vm.data.IssueDate; 
        }

        // ----------------------------------Gopal------------------------------------------------------------------------------------------------

        //---------------------------------------------Nithin-----------------------------------------------------

        // Assuming the value from vm.data.Validity is vm.data.selectedCertificationValidity
        //alert(vm.data.selectedCertificationValidity.value);
        //if (vm.data.selectedCertificationValidity.value === '3 Months') {
        //  vm.data.AuditRenewalDate = new Date();
        //  vm.data.AuditRenewalDate.setMonth(vm.data.AuditRenewalDate.getMonth() + 3);
        //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
        //} else if (vm.data.selectedCertificationValidity.value === '6 Months') {
        //  vm.data.AuditRenewalDate = new Date();
        //  vm.data.AuditRenewalDate.setMonth(vm.data.AuditRenewalDate.getMonth() + 6);
        //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
        //} else if (vm.data.selectedCertificationValidity.value === '1 Year') {
        //  vm.data.AuditRenewalDate = new Date();
        //  vm.data.AuditRenewalDate.setFullYear(vm.data.AuditRenewalDate.getFullYear() + 1);
        //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
        //} else if (vm.data.selectedCertificationValidity.value === '2 Years') {
        //  vm.data.AuditRenewalDate = new Date();
        //  vm.data.AuditRenewalDate.setFullYear(vm.data.AuditRenewalDate.getFullYear() + 2);
        //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
        //} else if (vm.data.selectedCertificationValidity.value === '3 Years') {
        //  vm.data.AuditRenewalDate = new Date();
        //  vm.data.AuditRenewalDate.setFullYear(vm.data.AuditRenewalDate.getFullYear() + 3);
        //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
        //}


        //---------------------------------------------------Nithin------------------------------------------
      }
      if (vm.data.selectedCertificationValidity.value != vm.data.BillingCycle) {
        onFailValidity();
      }
    };

    vm.func.updateCertificateDetails = function (isValid) {
      vm.data.isFormSubmit = true;
      //alert(vm.data.AgentReqStatus);
      //if (vm.data.AgentReqStatus != 'Certificate Requested') {
      //  alert("In order to Update Certificate, Please make sure the Certificate is requested from the Agent");
      //} else {
        if (vm.data.selectedCertificationType.value == 'Select') {
          vm.data.requiredCertificationType = true;
          isValid = false;
        }
        if (vm.data.SelectedCertIssueType.value == 'Select') {
          vm.data.CertificationIssueType = true;
          isValid = false;
        }
        if (vm.data.selectedCertificationValidity.value == 'Select') {
          vm.data.requiredCertificationValidity = true;
          isValid = false;
        }
        //if (vm.data.selectedCertificationStatus.value == 'Select') {
        //    vm.data.requiredCertificationStatus = true;
        //    isValid = false;
        //}

        var dateOutIssueDate = $filter('date')(vm.data.IssueDate, "MM/dd/yyyy"); // it will work if date1 is in ISO format
        var dateOutExpiryDate = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");
        var currdatetime = new Date();


        var issueDate = vm.data.IssueDate.getTime();
      var expiryDate = vm.data.AuditRenewalDate.getTime();
        var Currentdate = currdatetime.getTime();

        if (expiryDate > issueDate) {

          var timeDiff = Math.abs(expiryDate - issueDate);
          var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

          var expDiff = (expiryDate - Currentdate);
          var expDays = Math.ceil(expDiff / (1000 * 3600 * 24));

          //alert(expDays);
          if (expDays < 90) {
            vm.data.CertStatus = 'Needs Action';
          } else {
            vm.data.CertStatus = 'Active';
          }

          //if (expDays < 0) {
          //  popupService.errorsm('ISO', 'Expiry Date Must Be Greater Than Current Date');
          //  isValid = false;
          //}

          //if (diffDays < 364) {
          //onFailDate();
          //isValid = false;
          // vm.data.ExpiryDate = "";
          //}

        }
        else {
          onFailDate();
          isValid = false;
          // vm.data.ExpiryDate = "";
        }


        if (isValid) {
          var certificateDetails = {};
          certificateDetails.CertificationId = vm.data.CertificationId;
          certificateDetails.CertificationNumber = vm.data.CertificationNumber;
          certificateDetails.CertificationCompanyName = vm.data.CompanyName;
          //certificateDetails.CertificationIssueDate = vm.data.IssueDate;
          certificateDetails.RecertifiedDate = $filter('date')(vm.data.IssueDate, "MM/dd/yyyy");
          certificateDetails.CertificationExpiryDate = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");
          certificateDetails.AuditRenewalDate = $filter('date')(vm.data.AuditRenewalDate, "MM/dd/yyyy");
          //certificateDetails.CertificationExpiryDate = vm.data.ExpiryDate;
          certificateDetails.CertificationScope = vm.data.Scope;
          certificateDetails.CertificationIsoStandard = vm.data.Standard;
          certificateDetails.Country = vm.data.Country;
          certificateDetails.State = vm.data.State;
          certificateDetails.City = vm.data.City;
          certificateDetails.CertificationAddress = vm.data.CertificationAddress;
          certificateDetails.CertificationBody = vm.data.Body;
          certificateDetails.CertificationUnderAccred = vm.data.UnderAccreditation;
          certificateDetails.CertificationCancelDate = vm.data.ExpiryDate
          certificateDetails.CertificationType = vm.data.selectedCertificationType.value;
          certificateDetails.CertificationValidity = vm.data.selectedCertificationValidity.value;
          certificateDetails.CertificationClosurKycID = vm.data.getSingleKycid;
          certificateDetails.CertificationStatus = vm.data.CertStatus;//vm.data.selectedCertificationStatus.value
          certificateDetails.EnquiryNumber = vm.data.EnquiryNumber;
          certificateDetails.CertAssign = vm.data.CertAssign;
          certificateDetails.CertIssueType = vm.data.SelectedCertIssueType.value;
          certificateDetails.CertSaleStatus = 'Do Not Know';

          httpService.httpCall('api/certificationDetails/editCertificateDetails', 'POST', certificateDetails)
            .then(function (response) {
              if (response) {
                popupService.successsm('ISO Application', 'Successfully edit certificate details');
              }
              else {
                popupService.errorsm('ISO Aplication', 'Server Problem');
              }
              modalInstance.close('OK');
              callBack();
            }, function () {
              popupService.errorsm('ISO Aplication', 'Server Problem');
              modalInstance.close('OK');
            });
        }
      //}
    }

    vm.func.replace = function () {
      // debugger;
      var certID = {};
      certID.CertificationId = vm.data.CertificationId;
      httpService.httpCall('api/certificationDetails/replaceCertificate', 'POST', certID)
        .then(function (response) {
          if (response) {
            popupService.successsm('ISO Application', 'Successfully Replaced Old Certificate');

          }
          else {
            popupService.errorsm('ISO Aplication', 'Server Problem');
          }
        })
      modalInstance.close('OK');
    }

    var onFailDate = function () {
      popupService.errorsm('ISO', 'Expiry Date Must Be Greater Than Issue Date');
    };


    init();
  }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('AddNewEnquiryController', AddNewEnquiryController)

    AddNewEnquiryController.$inject = ['$uibModalInstance', 'httpService', 'popupService', 'callBackFunction'];

    function AddNewEnquiryController(modalInstance, httpService, popupService, callBack) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.isFormSubmit = false;
            vm.data.requiredCompanyType = false;
            vm.data.requiredLeadType = false;
            vm.data.requiredEnquirySource = false;

            vm.data.CompanyType = [
                { value: 'Select' },
                { value: 'Proprietorship' },
                { value: 'Pvt. Ltd.' },
                { value: 'Public Ltd.' },
                { value: 'Trust/Co-op/Association' },
                { value: 'Government' },
                { value: 'Other' }
            ];

            vm.data.LeadType = [
                { value: 'Select' },
                { value: 'HOT' },
                { value: 'WARM' },
                { value: 'COLD' }
            ];

            vm.data.EnquirySource = [
                { value: 'Select' },
                { value: 'Self' },
                { value: 'Internal' }
            ];

            vm.data.selectedCompanyType = vm.data.CompanyType[0];
            vm.data.selectedLeadType = vm.data.LeadType[0];
            vm.data.selectedEnquirySource = vm.data.EnquirySource[0];

            httpService.httpCall('api/enquiryManagement/suggestCountryName', 'GET', null)
            .then(function (response) {
                vm.data.suggestCountry = response;
                vm.data.suggestCountryData = angular.copy(vm.data.suggestCountry);
            });

            httpService.httpCall('api/enquiryManagement/suggestIsoCertificationType', 'GET', null)
            .then(function (response) {
                vm.data.suggestIsoRequiredType = response;
                vm.data.suggestIsoRequiredTypeData = angular.copy(vm.data.suggestIsoRequiredType);
            });

        }

        vm.func.hideRequiredCompanyType = function () {
            if (vm.data.selectedCompanyType != 'Select') {
                vm.data.requiredCompanyType = false;
            }
        };

        vm.func.hideRequiredLeadType = function () {
            if (vm.data.selectedLeadType != 'Select') {
                vm.data.requiredLeadType = false;
            }
        };

        vm.func.hideRequiredEnquirySource = function () {
            if (vm.data.selectedEnquirySource != 'Select') {
                vm.data.requiredEnquirySource = false;
            }
        }

        var preSaveData = function () {
            var data = {};
            
            data.enq_name = vm.data.EnquiryName;
            data.comp_name = vm.data.CompanyName;
            data.enq_phone = vm.data.EnquiryPhone;
            data.enq_email = vm.data.EnquiryEmail +"$"+ vm.data.selectedIsoRequired;
            data.country_id_fk = vm.data.selectedCompanyname;
            data.enq_Standard = "";
            data.priority_id_fk = 3;
            data.aff_id_fk = '1';
            data.enq_enquiry = "NULL";
            data.cust_email_status = '0';
            data.enq_city = vm.data.City;
            data.comp_type = vm.data.selectedCompanyType.value;
            data.lead_type = vm.data.selectedLeadType.value;
            data.comp_size = vm.data.CompanySize;
            data.enq_type = vm.data.selectedEnquirySource.value;
            return data;
        }

        vm.func.saveEnquiryetails = function (isValid) {
            vm.data.isFormSubmit = true;
            if (vm.data.selectedCompanyType.value == 'Select') {
                vm.data.requiredCompanyType = true;
                isValid = false;
            }
            if (vm.data.selectedLeadType.value == 'Select') {
                vm.data.requiredLeadType = true;
                isValid = false;
            }
            if (vm.data.selectedEnquirySource.value == 'Select') {
                vm.data.requiredEnquirySource = true;
                isValid = false;
            }
            if (isValid == true) {
                var addEnquiryDetails;
                addEnquiryDetails = preSaveData();
                httpService.httpCall('api/enquiryManagement/saveEnquiryData', 'POST', addEnquiryDetails)
                .then(onSuccess, onFail)
            }
        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Successfull save new Certification !');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        vm.func.ok = function () {
            modalInstance.close('OK');
        }
        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }



        init();
    }

})();
(function () {
    'use strict';

    angular
        .module('isoappClient')
        .controller('AddPaymentHistoryForClosureController', AddPaymentHistoryForClosureController);

    AddPaymentHistoryForClosureController.$inject = ['httpService', '$state', '$window', 'popupService', '$uibModalInstance', '$rootScope', 'PMIDDetails', 'PHIDDetails', 'callBackFunction', '$filter', '$scope'];

    function AddPaymentHistoryForClosureController(httpService, state, $window, popupService, modalInstance, rootScope, PMID, PHID, callBack, $filter, $scope) {

        var vm = this;

        vm.data = {};
        vm.func = {};
        var PP = 0;
        var PR = 0;
      var GST = 0;
      var TDS = 0;
        var temptax = 0;

        var init = function () {
            vm.data.isFormSubmit = false;
            vm.data.requiredCertificationStatus = false;

            var currentdate = new Date();
            vm.data.PaymentRecivedDate = currentdate;

            var getLoginUser = angular.fromJson(rootScope.UserData);
            vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.PMID = PMID;
            //vm.data.PendingAmount = localStorage.getItem('PendingAmount');

            if (PMID == 0) {
                $scope.verifypayment = true;
                $scope.addpayment = false;
                $scope.ShowVerify = true;
                $scope.ShowStatus = true;
                $scope.ShowDelete = true;
                $scope.ShowReject = true;
                httpService.httpCall('api/closureManagement/getpaymenthistory?PHID=' + PHID, 'GET', null)
                    .then(function (SinglePaymentClosureHistory) {
                        SinglePaymentClosureHistory = JSON.parse(JSON.stringify(SinglePaymentClosureHistory[0]));

                        vm.data.PaymentRecived = SinglePaymentClosureHistory.payment_recived;
                        vm.data.GSTAmount = SinglePaymentClosureHistory.GST_Amount;
                        vm.data.TDSAmount = SinglePaymentClosureHistory.TDS_Amount;
                        vm.data.PendingAmount = SinglePaymentClosureHistory.pending_amount;
                      vm.data.TaxableValue = SinglePaymentClosureHistory.Taxable_Amount;  
                        PP = SinglePaymentClosureHistory.pending_amount;
                        vm.data.PaymentRecivedDate = new Date(SinglePaymentClosureHistory.payment_recevied_date);
                      vm.data.PaymentRemarks = SinglePaymentClosureHistory.comments;
                      vm.data.BankDescription = SinglePaymentClosureHistory.Bank_Description;

                        angular.forEach(vm.data.currencytype, function (item, index) {
                            if (item.value == SinglePaymentClosureHistory.currency_type) {
                                vm.data.selectedcurrencytype = vm.data.currencytype[index];
                            }
                        });

                        angular.forEach(vm.data.BankType, function (item, index) {
                            if (item.value == SinglePaymentClosureHistory.bank_type) {
                                vm.data.selectedBankType = vm.data.BankType[index];
                            }
                        });

                      angular.forEach(vm.data.TDSType, function (item, index) {
                        if (vm.data.TDSAmount != 0) {
                          vm.data.selectedTDS = vm.data.TDSType[1];
                        } else
                          vm.data.selectedTDS = vm.data.TDSType[2];
                      });

                        angular.forEach(vm.data.PaymentType, function (item, index) {
                            if (item.value == SinglePaymentClosureHistory.payment_type) {
                                vm.data.selectedPaymentType = vm.data.PaymentType[index];
                            }
                        });

                        angular.forEach(vm.data.PaymentStatus, function (item, index) {
                            if (item.value == SinglePaymentClosureHistory.payment_status) {
                                vm.data.selectedPaymentStatus = vm.data.PaymentStatus[index];
                            }
                        });
                    });
            }
            else {
                httpService.httpCall('api/closureManagement/getpaymentpending?PMID=' + PMID, 'GET', null)
                   .then(function (SinglePaymentClosureHistory) {

                       PP = SinglePaymentClosureHistory;
                       vm.data.PendingAmount = SinglePaymentClosureHistory;

                   });
                $scope.verifypayment = false;
                $scope.addpayment = true
                $scope.ShowStatus = true;
                $scope.ShowAdd = true;
                $scope.ShowDelete = false;
                $scope.ShowReject = false;
            }
        }

        vm.data.currencytype = [
            { value: '-- Select --' },
            { value: 'AUD' },
            { value: 'AED' },
            { value: 'BD' },
            { value: 'INR' },
            { value: 'KWD' },
            { value: 'OMR' },
            { value: 'QAR' },
            { value: 'SAR' },
            { value: 'USD' },
            { value: 'ZAR' },
            { value: 'EUR' },
            { value: 'CAD' },
            { value: 'SGD' },
            { value: 'NGN' },
            { value: 'PHP' },
            { value: 'LBP' },
            { value: 'IQD' },
            { value: 'JOD' },
            { value: 'GBP' },
            { value: 'AOA' },
            { value: 'KES' },

        ];
        vm.data.selectedcurrencytype = vm.data.currencytype[0];

        vm.data.BankType = [
            { value: '-- Select --' },
          { value: 'Veave-India' },
          { value: 'Veave-UAE' },
          { value: 'Veave-Qatar' },
          { value: 'Veave-South Africa' },
          { value: 'Veave-Australia' },
          { value: 'Veave-Singapore' },
          { value: 'Al Fiyafi-Oman' },
          { value: '21Search-Nigeria' },
          { value: 'M&G-Nigeria' },
          { value: 'Nigeria' },
          { value: 'Infinity-Saudi Arabia' },
          { value: 'Veave-Bahrain' },
          { value: 'Veave-Kuwait' },
          { value: 'Veave-Phillippines' },
          { value: 'Veave-Kenya' },
          { value: 'Veave - UK(Muktha Ltd)' },
          { value: 'Fera Academy-Angola' },
            { value: 'Others' }
        ];
        vm.data.selectedBankType = vm.data.BankType[0];

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        vm.data.PaymentType = [
            { value: '-- Select --' },
            { value: 'Cash' },
            { value: 'Cheque' },
            { value: 'Wire Transfer' },
            { value: 'Paypal' },
            { value: 'Others' }
        ];
        vm.data.selectedPaymentType = vm.data.PaymentType[0];

        //vm.data.TDSType = [
        //  { value: '-- Select --', id: 0 },
        //  { value: 'Yes', id: 1 },
        //  { value: 'No', id: 2 }
        //    ];

        //vm.data.selectedTDS = vm.data.TDSType[0];

        vm.data.PaymentStatus = [
            { value: '-- Select --' },
            { value: 'Fresh' },
            //{ value: 'Part Payment' },
            { value: 'Part Payment' },
            //{ value: 'Pending Payment' },
            { value: 'Full Payment' },
            //{ value: 'Cancelled' },
            //{ value: 'Disputed' },
            //{ value: 'Written Off' },
            //{ value: 'Reconciled' }
        ];
        vm.data.selectedPaymentStatus = vm.data.PaymentStatus[0];

        vm.func.changePR = function () {

            PR = vm.data.PaymentRecived;
            GST = PR * 18 / 108
            TDS = PR * 10 / 108

            vm.data.PendingAmount = PP - PR;
            vm.data.GSTAmount = GST;
            vm.data.TDSAmount = TDS;
            vm.data.TaxableValue = parseFloat(PR) + parseFloat(TDS) - parseFloat(GST);

            if (PR == 0 || PR == "" || PR == null || PR == undefined) {
                vm.data.PendingAmount = PP;
            }

        }

        //onchange code for Displaying Taxable Value along with TDS
        //vm.func.onchangeTDS = function () {
        //    if (vm.data.selectedTDS.value == 'Yes') {
        //        temptax = vm.data.PaymentRecived;
        //      vm.data.TDSAmount = (parseFloat(10) * parseFloat(vm.data.PaymentRecived) / 108).toFixed(2);
        //      vm.data.TaxableValue = parseFloat(PR) + parseFloat(vm.data.TDSAmount) - parseFloat(GST);
        //    }
        //    else if (vm.data.selectedTDS.value == 'No') {
        //        temptax = vm.data.PaymentRecived;
        //      vm.data.TDSAmount = 0;
        //        vm.data.TaxableValue = temptax - GST;
        //    }
        //}

      vm.func.onchangeTDS = function () {
        if (vm.data.TDSAmount == 0) {
          PR = vm.data.PaymentRecived;
          GST = PR * 18 / 108
          TDS = PR * 10 / 108
          vm.data.TaxableValue = parseFloat(PR) - parseFloat(GST);
        }
        else if (vm.data.TDSAmount != 0) {
          GST = PR * 18 / 108
          TDS = vm.data.TDSAmount
          vm.data.TaxableValue = parseFloat(PR) + parseFloat(TDS) - parseFloat(GST);
        }
      }
        
        vm.func.addpayment = function () {
            var data = {};

            data.propasalkyc_fk = PMID;
            data.comments = vm.data.PaymentRemarks;
          data.Bank_Description = vm.data.BankDescription;
            data.pending_amount = vm.data.PendingAmount;
            data.payment_recived = vm.data.PaymentRecived;
            data.GST_Amount = vm.data.GSTAmount;
            data.Taxable_Amount = vm.data.TaxableValue;
            data.TDS_Amount = vm.data.TDSAmount;
            data.bank_type = vm.data.selectedBankType.value;
            data.payment_type = vm.data.selectedPaymentType.value;
            data.payment_recevied_date = $filter('date')(vm.data.PaymentRecivedDate, "MM/dd/yyyy");
            data.payment_status = vm.data.selectedPaymentStatus.value;
            data.activity_user = vm.data.CommentBy;
            data.currency_type = vm.data.selectedcurrencytype.value;

            if (vm.data.selectedBankType.value == "-- Select --" || vm.data.selectedPaymentType.value == "-- Select --" || vm.data.selectedcurrencytype.value == "-- Select --" || (vm.data.PaymentRecived == undefined || vm.data.PaymentRecived == "") || vm.data.PaymentRecivedDate == "" || vm.data.selectedPaymentStatus.value == "-- Select --") {
                alert("Kindly fill all the required fields !");
                return false;
            }

            //if (isValid == true) {
            var alldata
            alldata = data;
            httpService.httpCall('api/closureManagement/savepaymenthistory', 'POST', alldata)
                .then(onSuccess, onFail)
            //}
        }

        vm.func.VerifyPayment = function () {

            var data = {};
            data.p_id = PHID;
            data.payment_status = vm.data.selectedPaymentStatus.value;
          data.comments = vm.data.PaymentRemarks;
          data.Bank_Description = vm.data.BankDescription;
            data.bank_type = vm.data.selectedBankType.value;
            data.currency_type = vm.data.selectedcurrencytype.value;
            data.payment_type = vm.data.selectedPaymentType.value;
            data.pending_amount = vm.data.PendingAmount;
            data.payment_recived = vm.data.PaymentRecived;
            data.GST_Amount = vm.data.GSTAmount;
            data.Taxable_Amount = vm.data.TaxableValue;
            data.TDS_Amount = vm.data.TDSAmount;
            data.Verification_status = 1;
            data.activity_user = vm.data.CommentBy;
            data.payment_recevied_date = $filter('date')(vm.data.PaymentRecivedDate, "MM/dd/yyyy");

            if (vm.data.selectedPaymentStatus.value == "-- Select --") {
                alert("Please Select Payment Status");
                return false;
            }

            if (vm.data.selectedBankType.value == "-- Select --") {
                alert("Please Select Bank type");
                return false;
            }

            if (vm.data.selectedcurrencytype.value == "-- Select --") {
                alert("Please Select Currency type");
                return false;
            }

            if (vm.data.selectedPaymentType.value == "-- Select --") {
                alert("Please Select Payment Type");
                return false;
            }

            if (vm.data.PaymentRemarks == "" || vm.data.PaymentRemarks == undefined) {
                alert("Please Enter Remarks");
                return false;
            }

            var alldata
            alldata = data;
            httpService.httpCall('api/closureManagement/savepaymenthistory', 'POST', alldata)
                .then(onVerSuccess, onFail)

        }

        vm.func.DeletePayment = function () {

            var data = {};
            data.p_id = PHID;
            data.Verification_status = 2;
            data.activity_user = vm.data.CommentBy;

            var alldata
            alldata = data;
            httpService.httpCall('api/closureManagement/deletepaymenthistory', 'POST', alldata)
                .then(onDelSuccess, onFail)

        }

      vm.func.RejectPayment = function () {

          var data = {};
          data.p_id = PHID;
          data.Verification_status = 9;
          data.activity_user = vm.data.CommentBy;

          var alldata
          alldata = data;
          httpService.httpCall('api/closureManagement/rejectpaymenthistory', 'POST', alldata)
            .then(OnRejSuccess, onFail)

        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Payment Added Successfully !');

            // var url = state.href('singleProposal', { Kycidfk: PMID });
            // $window.open(url);

            //$window.location.reload();

            callBack();
        }

        var onVerSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Payment Verified Successfully !');
            callBack();
        }

        var onDelSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Payment Deleted Successfully !');
            callBack();
        }

        var OnRejSuccess = function () {
        modalInstance.close('OK');
        popupService.successsm('ISO', 'Payment Rejected Successfully !');
        callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        //***********************To make payment recived disabled while editing*********************************//
        //document.getElementById('AddPaymnet').onclick = function () {
        //    document.getElementById('PaymentRecived').removeAttribute('disabled');
        //};

        $("document").ready(function () {
            $("button").trigger('click');
        });

        init();
    }

})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('AddCommentsForClosureController', AddCommentsForClosureController);

    AddCommentsForClosureController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'singleKycIdDetails','CertIdDetails', 'callBackFunction'];

    function AddCommentsForClosureController(httpService, popupService, modalInstance, rootScope, singleKycId,CertId, callBack) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.isFormSubmit = false;
            vm.data.requiredCertificationStatus = false;

            if(parseInt(CertId) > 0  ){
                vm.data.hideStatus = false;
            }
            else{
                vm.data.hideStatus = true;
            }
          

            var getLoginUser = angular.fromJson(rootScope.UserData);
            vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.Kycid = singleKycId;
            vm.data.CertId=CertId;
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }
        
        vm.data.CertificationStatus = [

            { value: 'Select' },
            { value: 'Request Info Change' },
            { value: 'Company Closed' },
            { value: 'Deal Closed' },
            { value: 'Not Responding' },
            { value: 'Do Not Know' },
            { value: 'Deal Under Progress' },
            { value: 'Not Interested' },
            { value: 'Interested' },
            { value: 'Not Reachable' },
            { value: 'Certified By Others' }

        ];
        vm.data.selectedCertificationStatus = vm.data.CertificationStatus[0];

        
        vm.func.hideRequiredCertificationStatus = function () {
           if (vm.data.selectedCertificationStatus != 'Select') {
               vm.data.requiredCertificationStatus = false;
           }
        };

        var presave = function () {
            debugger;
            var data = {};
            data.kyc_id_fk = vm.data.Kycid;
            data.certId=vm.data.CertId;
           
       
            if (vm.data.CommentBy == 'Reshma') {
                data.comment = "CertTeam - " + vm.data.Comments;
            }
            else {
                data.comment=vm.data.Comments;
            }
                data.activity_user = vm.data.CommentBy;
                data.status = vm.data.selectedCertificationStatus.value;
            
            return data;
        }

        vm.func.saveComment = function (isValid) {
            vm.data.isFormSubmit = true;

            if (vm.data.selectedCertificationStatus.value == 'Reshma') {

                if (vm.data.CommentBy == 'Reshma') {
                    vm.data.requiredCertificationStatus = true;
                    isValid = false;
                } else {
                    vm.data.requiredCertificationStatus = false;
                    isValid = true;
                }
   
}

            if (isValid == true) {
                var alldata
                alldata = presave();
                
                httpService.httpCall('api/closureManagement/saveCommentForClosure', 'POST', alldata)
                .then(onSuccess, onFail)
            }
        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Thanks for comment !');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };



        init();
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('AddDispatchDetailsController', AddDispatchDetailsController)

    AddDispatchDetailsController.$inject = ['$uibModalInstance', 'httpService', 'popupService', 'callBackFunction', 'IdDetail','$rootScope'];

    function AddDispatchDetailsController(modalInstance, httpService, popupService, callBack,Id,rootScope) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            //vm.data.isFormSubmit = false;
            //vm.data.requiredCourierService = false;
            //vm.data.requiredLocation = false;
            //vm.data.requiredTrackerID = false;
            vm.data.requiredRemarks = false;
            vm.data.Id = Id;
            
        }

        vm.data.CourierOffice = [
            'Aramex' ,
            'FedEx' ,
              'DHL' ,
             'DTDC' ,
            'Professional'
             // { value: 'Reconcile' }
        ];

        var UserData = angular.fromJson(rootScope.UserData);
        vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
        //vm.func.hideRequiredCourierService = function () {
        //    if (vm.data.CourierService != '') {
        //        vm.data.requiredCourierService = false;
        //    }
        //};

        //vm.func.hideRequiredLocation = function () {
        //    if (vm.data.Location != '') {
        //        vm.data.requiredLocation = false;
        //    }
        //};

        //vm.func.hideRequiredTrackerID = function () {
        //    if (vm.data.TrackerID != '') {
        //        vm.data.requiredTrackerID = false;
        //    }
        //}

        var preSaveData = function () {
            var data = {};
            data.Id = vm.data.Id;
            data.CourierName = vm.data.CourierService;
            data.DispatchLocation = vm.data.Location;
            data.TrackerID = vm.data.TrackerID;
            data.DispatchRemarks = vm.data.Remarks;
            data.LogedInUserId = vm.data.LogedInUserId;
            //data.Kycidfk=vm.data.
            return data;
        }

        vm.func.savedispatchDetails = function (isValid) {
           // isValid = true;
            vm.data.isFormSubmit = true;
            if (vm.data.CourierService == '') {
                //vm.data.requiredCourierService = true;
                isValid = false;
            }
            if (vm.data.Location == '') {
               // vm.data.requiredLocation = true;
                isValid = false;
            }
            if (vm.data.TrackerID == '') {
               // vm.data.requiredTrackerID = true;
                isValid = false;
            }

            if (isValid == true) {
                var addDispatchDetails;
                addDispatchDetails = preSaveData();
                httpService.httpCall('api/ProposalMnagement/saveDispatchDetails', 'POST', addDispatchDetails)
                .then(onSuccess, onFail)
            }
        }

        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Dispatch Details Saved!');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        vm.func.ok = function () {
            modalInstance.close('OK');
        }
        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }



        init();
    }

})();
(function () {
  'use strict';

  angular
    .module('isoappClient')
    .controller('addCommentsInRejectRequestController', addCommentsInRejectRequestController);

  addCommentsInRejectRequestController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'singleKycIdDetails', 'Ids', 'callBackFunction'];

  function addCommentsInRejectRequestController(httpService, popupService, modalInstance, rootScope, singleKycId, Id, callBack) {

    var vm = this;

    vm.data = {};
    vm.func = {};

    var init = function () {
      vm.data.isFormSubmit = false;
      vm.data.requiredCertificationStatus = false;

      //if (parseInt(CertId) > 0) {
      //  vm.data.hideStatus = false;
      //}
      //else {
      //  vm.data.hideStatus = true;
      //}


      var getLoginUser = angular.fromJson(rootScope.UserData);
      vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
      vm.data.Kycid = singleKycId;
      //vm.data.CertId = CertId;
    }

    vm.func.cancel = function () {
      modalInstance.dismiss('cancel');
    }

    vm.data.CertificationStatus = [

      { value: 'Select' },
      { value: 'Request Info Change' },
      { value: 'Company Closed' },
      { value: 'Deal Closed' },
      { value: 'Not Responding' },
      { value: 'Do Not Know' },
      { value: 'Deal Under Progress' },
      { value: 'Not Interested' },
      { value: 'Interested' },
      { value: 'Not Reachable' },
      { value: 'Certified By Others' }

    ];
    vm.data.selectedCertificationStatus = vm.data.CertificationStatus[0];


    vm.func.hideRequiredCertificationStatus = function () {
      if (vm.data.selectedCertificationStatus != 'Select') {
        vm.data.requiredCertificationStatus = false;
      }
    };

    var presave = function () {
      debugger;
      var data = {};
      data.kyc_id_fk = vm.data.Kycid;
      //data.certId = vm.data.CertId;


      if (vm.data.CommentBy == 'Reshma') {
        data.comment = "CertTeam - " + vm.data.Comments;
      }
      else {
        data.comment = vm.data.Comments;
      }
      data.activity_user = vm.data.CommentBy;
      data.status = vm.data.selectedCertificationStatus.value;

      return data;
    }

    vm.func.saveComment = function (isValid) {
      vm.data.isFormSubmit = true;

      if (vm.data.selectedCertificationStatus.value == 'Reshma') {

        if (vm.data.CommentBy == 'Reshma') {
          vm.data.requiredCertificationStatus = true;
          isValid = false;
        } else {
          vm.data.requiredCertificationStatus = false;
          isValid = true;
        }
        
      }

      if (isValid == true) {
        var alldata
        alldata = presave();

        httpService.httpCall('api/closureManagement/saveCommentForClosure', 'POST', alldata)
          .then(onSuccess, onFail)

        var prodata = {};
        
        prodata.Id = Id;
        //alert(prodata.Id)
        prodata.AgentRequestStatus = 'Request Rejected';
        httpService.httpCall('api/proposalMnagement/RejectStatusUpdate', 'POST', prodata)
          .then(onSuccessRejectReq, onFail1);
      }
    }

    var onSuccess = function () {
      modalInstance.close('OK');
      popupService.successsm('ISO', 'Thanks for comment !');
      callBack();
    }

    var onFail = function () {
      popupService.errorsm('ISO', 'Server Problem !');
    };



    init();
  }

})();

(function () {
  'use strict';

  angular
    .module('isoappClient')
    .controller('addCommentsInNACController', addCommentsInNACController);

  addCommentsInNACController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'singleKycIdDetails', 'Ids', 'callBackFunction'];

  function addCommentsInNACController(httpService, popupService, modalInstance, rootScope, singleKycId, Id, callBack) {

    var vm = this;

    vm.data = {};
    vm.func = {};

    var init = function () {
      vm.data.isFormSubmit = false;
      vm.data.requiredCertificationStatus = false;

      var getLoginUser = angular.fromJson(rootScope.UserData);
      vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
      vm.data.Kycid = singleKycId;
    }

    vm.func.cancel = function () {
      modalInstance.dismiss('cancel');
    }

    vm.data.CertificationStatus = [

      { value: 'Select' },
      { value: 'Request Info Change' },
      { value: 'Company Closed' },
      { value: 'Deal Closed' },
      { value: 'Not Responding' },
      { value: 'Do Not Know' },
      { value: 'Deal Under Progress' },
      { value: 'Not Interested' },
      { value: 'Interested' },
      { value: 'Not Reachable' },
      { value: 'Certified By Others' }

    ];
    vm.data.selectedCertificationStatus = vm.data.CertificationStatus[0];


    vm.func.hideRequiredCertificationStatus = function () {
      if (vm.data.selectedCertificationStatus != 'Select') {
        vm.data.requiredCertificationStatus = false;
      }
    };

    var presave = function () {
      debugger;
      var data = {};
      data.kyc_id_fk = vm.data.Kycid;


      if (vm.data.CommentBy == 'Reshma') {
        data.comment = "CertTeam - " + vm.data.Comments;
      }
      else {
        data.comment = vm.data.Comments;
      }
      data.activity_user = vm.data.CommentBy;
      data.status = vm.data.selectedCertificationStatus.value;

      return data;
    }

    vm.func.saveComment = function (isValid) {
      vm.data.isFormSubmit = true;

      if (vm.data.selectedCertificationStatus.value == 'Reshma') {

        if (vm.data.CommentBy == 'Reshma') {
          vm.data.requiredCertificationStatus = true;
          isValid = false;
        } else {
          vm.data.requiredCertificationStatus = false;
          isValid = true;
        }

      }

      if (isValid == true) {
        var alldata
        alldata = presave();

        httpService.httpCall('api/closureManagement/saveCommentForClosure', 'POST', alldata)
          .then(onSuccess, onFail)

        var prodata = {};

        prodata.Id = Id;
        //alert(prodata.Id)
        prodata.ProjectStatus = 'Not Applicable';
        httpService.httpCall('api/proposalMnagement/CertAbortUpdate', 'POST', prodata)
          .then(onSuccessRejectReq, onFail1);
      }
    }

    var onSuccess = function () {
      modalInstance.close('OK');
      popupService.successsm('ISO', 'Thanks for comment !');
      callBack();
    }

    var onFail = function () {
      popupService.errorsm('ISO', 'Server Problem !');
    };



    init();
  }

})();

(function () {
  'use strict';

  angular
    .module('isoappClient')
    .controller('addCommentsInAbortedController', addCommentsInAbortedController);

  addCommentsInAbortedController.$inject = ['httpService', 'popupService', '$uibModalInstance', '$rootScope', 'singleKycIdDetails', 'Ids', 'callBackFunction'];

  function addCommentsInAbortedController(httpService, popupService, modalInstance, rootScope, singleKycId, Id, callBack) {

    var vm = this;

    vm.data = {};
    vm.func = {};

    var init = function () {
      vm.data.isFormSubmit = false;
      vm.data.requiredCertificationStatus = false;

      var getLoginUser = angular.fromJson(rootScope.UserData);
      vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
      vm.data.Kycid = singleKycId;
    }

    vm.func.cancel = function () {
      modalInstance.dismiss('cancel');
    }

    vm.data.CertificationStatus = [

      { value: 'Select' },
      { value: 'Request Info Change' },
      { value: 'Company Closed' },
      { value: 'Deal Closed' },
      { value: 'Not Responding' },
      { value: 'Do Not Know' },
      { value: 'Deal Under Progress' },
      { value: 'Not Interested' },
      { value: 'Interested' },
      { value: 'Not Reachable' },
      { value: 'Certified By Others' }

    ];
    vm.data.selectedCertificationStatus = vm.data.CertificationStatus[0];


    vm.func.hideRequiredCertificationStatus = function () {
      if (vm.data.selectedCertificationStatus != 'Select') {
        vm.data.requiredCertificationStatus = false;
      }
    };

    var presave = function () {
      debugger;
      var data = {};
      data.kyc_id_fk = vm.data.Kycid;


      if (vm.data.CommentBy == 'Reshma') {
        data.comment = "CertTeam - " + vm.data.Comments;
      }
      else {
        data.comment = vm.data.Comments;
      }
      data.activity_user = vm.data.CommentBy;
      data.status = vm.data.selectedCertificationStatus.value;

      return data;
    }

    vm.func.saveComment = function (isValid) {
      vm.data.isFormSubmit = true;

      if (vm.data.selectedCertificationStatus.value == 'Reshma') {

        if (vm.data.CommentBy == 'Reshma') {
          vm.data.requiredCertificationStatus = true;
          isValid = false;
        } else {
          vm.data.requiredCertificationStatus = false;
          isValid = true;
        }

      }

      if (isValid == true) {
        var alldata
        alldata = presave();

        httpService.httpCall('api/closureManagement/saveCommentForClosure', 'POST', alldata)
          .then(onSuccess, onFail)

        var prodata = {};

        prodata.Id = Id;
        //alert(prodata.Id)
        prodata.ProjectStatus = 'Aborted';
        httpService.httpCall('api/proposalMnagement/CertAbortUpdate', 'POST', prodata)
          .then(onSuccessRejectReq, onFail1);
      }
    }

    var onSuccess = function () {
      modalInstance.close('OK');
      popupService.successsm('ISO', 'Thanks for comment !');
      callBack();
    }

    var onFail = function () {
      popupService.errorsm('ISO', 'Server Problem !');
    };



    init();
  }

})();

(function () {
    'use strict'

    angular
    .module('isoappClient')
    .controller('kycUpdatePopUpController', kycUpdatePopUpController)

    kycUpdatePopUpController.$inject = ['$uibModalInstance', 'httpService', 'popupService', 'callBackFunction', 'kycDetails','$rootScope'];

    function kycUpdatePopUpController(modalInstance, httpService, popupService, callBack, Kycid,rootScope) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            vm.data.isFormSubmit = false;
            vm.data.requiredValidity = false;
            vm.data.requiredStatus = false;
            vm.data.requiredType = false;
            vm.data.requiredCompSize = false;
          
            var UserData = angular.fromJson(rootScope.UserData);
            vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
         //   vm.data.requiredProjectStatus = false;
         //   vm.data.requiredPaymentStatus = false;

            vm.data.ClosureSource = [
                { value: 'Select' },
                { value: 'Associate' },
                { value: 'Fresh' },
                { value: 'Reference ' },
                { value: 'Renewal' },
                { value: 'Surveillance 1' },
                { value: 'Surveillance 2' },
                { value: 'Upsale' }
            ];

            vm.data.ClosureType = [
                { value: 'Select' },
                { value: 'Remote' },
                { value: 'Onsite' }
            ];

            //vm.data.ClosureProjectStatus = [
            //    { value: 'Select' },
            //    { value: 'Completed' },
            //    { value: 'Under Progress' }
            //];

            vm.data.Status = [
                { value: 'Select' },
                  { value: 'Needs Action' },
                { value: 'Active' },
                 { value: 'Suspended' },
                   { value: 'Withdrawn' },
                     { value: 'Inactive' }

            ];

            vm.data.suggestCBAB = ["UR-EAJAS", "LMS-DAC", "LMS-IAS", "QEC-UKAS", "SNR-UKAS"];
            
            vm.data.Validity = [
                { value: 'Select' },
                { value: '1 Year' },
                { value: '3 Years' },
                { value: '1 & 3 Years' }

            ];
            vm.data.CompSize = [
               { value: 'Select' },
               { value: '1 Year' },
          { value: '3 Years' }


            ];
            vm.data.selectedCompSize = vm.data.CompSize[0];
            vm.data.selectedClosureType = vm.data.ClosureType[0];
          //  vm.data.selectedClosureProjectStatus = vm.data.ClosureProjectStatus[0];
            vm.data.selectedStatus = vm.data.Status[0];
            vm.data.selectedValidity = vm.data.Validity[0];

            httpService.httpCall('api/enquiryManagement/suggestassignto', 'GET', null)
            .then(function (response) {
                vm.data.suggestSalesAgent = response;
                vm.data.suggestDeliveryAgent = response;
                vm.data.suggestSalesAgentData = angular.copy(vm.data.suggestSalesAgent);
                vm.data.suggestDeliveryAgentData = angular.copy(vm.data.suggestDeliveryAgent);
            });

          

            if (typeof (Kycid) != 'undefined' && parseInt(Kycid) > 0) {
                httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + Kycid, 'GET', null)
                .then(function (response) {
                     vm.data.Kycid = response.Kyc_id;
                    vm.data.CreatedDate = response.Created_Date;
                    vm.data.Client = response.Company_name;
                    vm.data.Agent = response.Account_Manager;
                    vm.data.ContactName = response.Contact_Name;
                    vm.data.Designation = response.Designation;
                    vm.data.ContactNumber = response.Contact_Num;
                    vm.data.ContactEmail = response.Contact_Email;
                    vm.data.AltContactName = response.AltContact_Name;
                    vm.data.AlternateDesignation = response.AltDesignation;
                    vm.data.AltContactNumber = response.AltContact_Number;
                    vm.data.AltContactEmail = response.AltContact_Email;
                    vm.data.NatureofBusiness = response.Nature_of_Business;
                    vm.data.CompanyCountry = response.Company_Country;
                    vm.data.CompanyState = response.Company_State;
                    vm.data.CompanyCity = response.Company_City;
                    vm.data.firstsaleby = response.First_Sale_By;
                 //   vm.data.ZoneType = response.Zone;
                    angular.forEach(vm.data.Validity, function (item, index) {
                        if (item.value == response.Billing_Cycle) {
                            vm.data.selectedValidity = vm.data.Validity[index];
                        }
                    });
                    angular.forEach(vm.data.ClosureType, function (item, index) {
                        if (item.value == response.Implementation_type) {
                            vm.data.selectedClosureType = vm.data.ClosureType[index];
                        }
                    });
                    angular.forEach(vm.data.Status, function (item, index) {
                        if (item.value == response.Status) {
                            vm.data.selectedStatus = vm.data.Status[index];
                        }
                    });
                    angular.forEach(vm.data.CompSize, function (item, index) {
                        if (item.value == response.Account_Size) {
                            vm.data.selectedCompSize  = vm.data.CompSize[index];
                        }
                    });
                    vm.data.EmpStrength = response.Employee_Strength;
                    vm.data.Locations = response.Locations;
                    vm.data.Yearsinbusiness = response.Years_in_Business;
                    vm.data.Turnover = response.Turnover;
                    vm.data.Website = response.URL;
                    vm.data.Landline = response.Landline;
                    //vm.data.NatureofBusiness = response.Nature_of_Business;
                    vm.data.PostalAddress = response.PostalAddress;
                   
                })
            }

        }

        vm.func.hideRequiredValidity = function () {
            if (vm.data.selectedValidity != 'Select') {
                vm.data.requiredValidity = false;
            }
        };

        //vm.func.hideRequiredSource = function () {
        //    if (vm.data.selectedClosureSource != 'Select') {
        //        vm.data.requiredSource = false;
        //    }
        //};

        vm.func.hideRequiredType = function () {
            if (vm.data.selectedClosureType != 'Select') {
                vm.data.requiredType = false;
            }
        };

        vm.func.hideRequiredCompSize = function () {
            if (vm.data.selectedCompSize != 'Select') {
                vm.data.requiredCompSize = false;
            }
        }

        //vm.func.hideRequiredProjectStatus = function () {
        //    if (vm.data.selectedClosureProjectStatus != 'Select') {
        //        vm.data.requiredProjectStatus = false;
        //    }
        //};

        //vm.func.hideRequiredPaymentStatus = function () {
        //    if (vm.data.selectedClosurePaymentStatus != 'Select') {
        //        vm.data.requiredPaymentStatus = false;
        //    }
        //}

        vm.func.ok = function () {
            modalInstance.dismiss('cancel');
        }

        vm.func.updateProposal = function (isValid) {
            vm.data.isFormSubmit = true;
            if (vm.data.selectedValidity.value == 'Select') {
                vm.data.requiredValidity = true;
                isValid = false;
            }
            //if (vm.data.selectedClosureSource.value == 'Select') {
            //    vm.data.requiredSource = true;
            //    isValid = false;
            //}
            if (vm.data.selectedClosureType.value == 'Select') {
                vm.data.requiredType = true;
                isValid = false;
            }
            //if (vm.data.selectedClosureProjectStatus.value == 'Select') {
            //    vm.data.requiredProjectStatus = true;
            //    isValid = false;
            //}
            //if (vm.data.selectedClosurePaymentStatus.value == 'Select') {
            //    vm.data.requiredPaymentStatus = true;
            //    isValid = false;
            //}
            if (isValid == true) {
                var data = {};
                data.Kycid = vm.data.Kycid;
          
                data.Companyname = vm.data.Client;
                data.ClientName = vm.data.ContactName;
                data.ContactNumber = vm.data.ContactNumber;
                data.ContactEmail = vm.data.ContactEmail;
                data.AltContactName = vm.data.AltContactName;
                data.AltContactNumber = vm.data.AltContactNumber;
                data.AltContactEmail = vm.data.AltContactEmail;
                data.Status = vm.data.selectedStatus.value;
                data.Acc_Size = vm.data.selectedCompSize.value;
                data.ImpType = vm.data.selectedClosureType.value;
                data.BillingCycle = vm.data.selectedValidity.value;
                data.AcountManager = vm.data.Agent;
                data.EmployeeStrength = vm.data.EmpStrength;
                data.NatureofBusiness = vm.data.NatureofBusiness;
                data.Landline = vm.data.Landline;
                data.URL = vm.data.Website;
                data.Designation = vm.data.Designation;
                data.LogedInUserId = vm.data.LogedInUserId;
             //   updatedProposalValue.ProjectStatus = vm.data.selectedClosureProjectStatus.value;
             //   updatedProposalValue.PaymentStatus = vm.data.selectedClosurePaymentStatus.value;

                httpService.httpCall('api/ClosureManagement/updateClosureKyc', 'POST', data)
                .then(onSuccess, onFail)
            }
        }
        var onSuccess = function () {
            modalInstance.close('OK');
            popupService.successsm('ISO', 'Update Successful!');
            callBack();
        }

        var onFail = function () {
            popupService.errorsm('ISO', 'Server Problem !');
        };

        init();
    }
})();
(function () {
    'use strict';

    angular
        .module('isoappClient')
        .controller('GenerateTaxInvoiceController', GenerateTaxInvoiceController);

    GenerateTaxInvoiceController.$inject = ['httpService', '$state', '$window', 'popupService', '$uibModalInstance', '$rootScope', 'PMIDDetails', 'PHIDDetails', 'callBackFunction', '$filter', '$scope'];

    function GenerateTaxInvoiceController(httpService, state, $window, popupService, modalInstance, rootScope, PMID, PHID, callBack, $filter, $scope) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var flag = 0;
        var tempTaxVal1 = 0;

        var init = function () {

            vm.data.isFormSubmit = false;
            vm.data.requiredCertificationStatus = false;


            var currentdate = new Date();
            vm.data.InvoiceDate = currentdate;

            //vm.data.TDSType = [
            //    { value: '-- Select --' },
            //    { value: 'Yes' },
            //    { value: 'No' }
            //];

            //vm.data.selectedTDS = vm.data.TDSType[0];
            var getLoginUser = angular.fromJson(rootScope.UserData);
            vm.data.CommentBy = angular.fromJson(getLoginUser).UserName;
            vm.data.PMID = PMID;
            vm.data.PendingAmount = localStorage.getItem('PendingAmount');

            if (PMID == 0) {
                $scope.ShowVerify = true;
                $scope.ShowStatus = true;

                var data = {};
                data.PHID = PHID;

                httpService.httpCall('api/closureManagement/GetClosureInvoiceDetails', 'POST', data)
                    .then(function (ClosureTaxDetails) {
                        ClosureTaxDetails = JSON.parse(JSON.stringify(ClosureTaxDetails[0]));

                        vm.data.ClientName = ClosureTaxDetails.ClientName;
                        vm.data.PostalAddress = ClosureTaxDetails.PostalAddress;
                        vm.data.State = ClosureTaxDetails.CompanyState;
                        vm.data.Country = ClosureTaxDetails.CompanyCountry;
                        vm.data.TaxableValueOne = ClosureTaxDetails.Closure_Value;
                        vm.data.ClosureValue = ClosureTaxDetails.Closure_Value;
                        vm.data.ProjectValue = ClosureTaxDetails.Project_Value;
                        vm.data.GSTAmount = ClosureTaxDetails.GST_Amount;
                        vm.data.TDSAmount = ClosureTaxDetails.TDS_Amount;
                        vm.data.TaxableAmount = ClosureTaxDetails.Taxable_Amount;
                        vm.data.DescriptionOne = ClosureTaxDetails.Description;
                      vm.data.InvRefNoStatic = ClosureTaxDetails.InvoiceReference;
                      vm.data.GSTIN = ClosureTaxDetails.GSTIN;
                        //vm.data.InvoiceReference = ClosureTaxDetails.InvoiceReference;
                        //vm.data.TDSValue = ClosureTaxDetails.TDS;
                    });
            }
            else {
                $scope.ShowStatus = true;
                $scope.ShowAdd = true;
            }
        }

        vm.func.keyup = function () {
            if (flag == 1) {
              $('#ClientName,#GSTIN,#State,#Code,#Country,#Address,#DescriptionOne,#TaxableValueOne,#TDSAmount,#GSTAmount,#InvRefNoStatic,#TaxableAmount,#TotProjectValue,#InvSequence').each(function () {
                    if ($.trim($(this).val()) == '' || $.trim($(this).val()) == undefined) {
                        $(this).css({
                            "border": "1px solid red"
                        });
                    }
                    else {
                        $(this).css({
                            "border": ""
                        });
                    }
                });
                if (vm.data.InvoiceDate == undefined || vm.data.InvoiceDate == "" || vm.data.InvoiceDate == "undefined") {
                    $('#InvoiceDate').css({
                        "border": "1px solid red"
                    });
                }
                else {
                    $('#InvoiceDate').css({
                        "border": ""
                    });
                }
            }
        }

        vm.func.generateinvoice = function () {
          $('#ClientName,#GSTIN,#State,#Code,#Country,#Address,#DescriptionOne,#TaxableValueOne,#TDSAmount,#GSTAmount,#InvRefNoStatic,#TaxableAmount,#TotProjectValue,#InvSequence').each(function () {
                if ($.trim($(this).val()) == '' || $.trim($(this).val()) == undefined) {
                    $(this).css({
                        "border": "1px solid red"
                    });
                }
                else {
                    $(this).css({
                        "border": ""
                    });
                }
            });

            if (vm.data.InvoiceDate == undefined || vm.data.InvoiceDate == "" || vm.data.InvoiceDate == "undefined") {
                $('#InvoiceDate').css({
                    "border": "1px solid red"
                });
            }
            else {
                $('#InvoiceDate').css({
                    "border": ""
                });
            }

            flag = 1;

          if (vm.data.ClientName == undefined || vm.data.PostalAddress == undefined || vm.data.GSTIN == undefined || vm.data.State == undefined || vm.data.Country == undefined || vm.data.DescriptionOne == undefined || vm.data.TDSAmount == undefined || vm.data.GSTAmount == undefined || vm.data.TaxableAmount == undefined || vm.data.TaxableValueOne == undefined || vm.data.InvRefNoStatic == undefined || vm.data.InvSequence == undefined || vm.data.ProjectValue == undefined) {
                alert("Kindly entry all the manditory field");
                return false;
            }

            if (vm.data.DescriptionTwo == undefined) {
                vm.data.DescriptionTwo = "";
            }
            if (vm.data.TaxableValueTwo == undefined) {
                vm.data.TaxableValueTwo = "";
            }

          if (vm.data.GSTIN == undefined || vm.data.GSTIN == "") {
            vm.data.Code = "";
          }
          else {
            vm.data.Code = vm.data.GSTIN.slice(0, 2);
          }

            $window.open('TaxInvoice?ClientName=' + vm.data.ClientName +
              '&Address=' + vm.data.PostalAddress +
                '&GSTIN=' + vm.data.GSTIN +
                '&State=' + vm.data.State +
                '&Code=' + vm.data.Code +
                //'&TDS=' + vm.data.TDSValue +
                '&TDS=' + vm.data.TDSAmount +
                '&ClosureValue=' + vm.data.ClosureValue +
                '&ProjectValue=' + vm.data.ProjectValue +
                '&InvoiceSequence=' + vm.data.InvSequence +
                '&GSTAmount=' + vm.data.GSTAmount +
                '&TaxableAmount=' + vm.data.TaxableAmount +
                '&Country=' + vm.data.Country +
                '&Description1=' + vm.data.DescriptionOne +
                '&TaxableValue1=' + vm.data.TaxableValueOne +
                '&Description2=' + vm.data.DescriptionTwo +
                '&TaxableValue2=' + vm.data.TaxableValueTwo +
                '&InvRefNoStatic=' + vm.data.InvRefNoStatic
                /*'&InvoiceReference=' + vm.data.InvoiceReference*/
                , "_self");

        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }

        

        //code to get State name from GSTIN

        //vm.func.gstcodename = function () {
        //    if (vm.data.code = vm.data.GSTIN.slice(0, 2));

        //    httpService.httpCall('api/closureManagement/GetGstStateCodeDetails', 'GET', data)
        //        .then(function (GstStateCodedetails) {
        //            GstStateCodedetails = JSON.parse(JSON.stringify(GstStateCodedetails[0]));

        //            vm.data.GST_Code = GstStateCodedetails.GST_Code;
        //            vm.data.State_Name = GstStateCodedetails.State_Name;
        //        });
        //}

        //onchange code for Displaying Taxable Value along with TDS
        //vm.func.onchangeTDS = function () {
        //    if (vm.data.selectedTDS.value == 'Yes') {
        //        tempTaxVal1 = vm.data.TaxableValueOne;
        //        vm.data.TDSValue = (parseFloat(0.1) * parseFloat(vm.data.TaxableValueOne/1.18)).toFixed(2);
        //        vm.data.TaxableValueOne += parseFloat(vm.data.TDSValue);
        //    }
        //    else if (vm.data.selectedTDS.value == 'No') {
        //        vm.data.TDSValue = 0;
        //        vm.data.TaxableValueOne = tempTaxVal1;
        //    }
        //}

        //vm.func.refreshpage = function () {
        //    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        //        this.router.navigate(['singleproposal.controller.js']);
        //    });
        //}

        //var onSuccess = function () {
        //    modalInstance.close('OK');
        //    popupService.successsm('ISO', 'Invoice Added Successfully !');
        //    callBack();
        //}

        //var onFail = function () {
        //    popupService.errorsm('ISO', 'Server Problem !');
        //};

        init();
    }

})();

(function() {
  'use strict';

  angular
      .module('isoappClient')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

/// <reference path="../services/popupService.js" />
(function () {
    'use strict';

    angular
        .module('isoappClient')
        .directive('acmeNavbar', acmeNavbar);
    // .controller('NavbarController', NavbarController)

    /** @ngInject */
    function acmeNavbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
                creationDate: '='
            },
            controller: NavbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        NavbarController.$inject = ['$location', 'localstorageService', 'authService', 'httpService', '$filter', '$rootScope']

        function NavbarController($location, localstorageService, authService, httpService, $filter, rootScope) {
            var vm = this;

            vm.data = [];
            vm.func = [];
            vm.data.totalItems = 0;
            vm.data.hidetab = false;
            //var loginData ;
            //loginData = stateParams.loginInfo;
            //var loginUser = loginData;
            // vm.data.loginUser = authService.
            var UserData = angular.fromJson(rootScope.UserData);

            //vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
            //if (vm.data.LogedInUserId == 'Ramya K A') {
            //    vm.data.hideClosureDetails = true;
            //    vm.data.hidesearchCertificates = true;
            //    vm.data.hideQaChecker = true;
            //    vm.data.hideUpdateKyc = true;
            //    vm.data.hideCertification = false;
            //    vm.data.hideIssuedCerts = false;
            //}
            vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
            if (vm.data.LogedInUserId == 'Cert') {
                vm.data.hideClosureDetails = true;
                vm.data.hidesearchCertificates = true;
                vm.data.hideQaChecker = true;
                vm.data.hideUpdateKyc = true;
                vm.data.hideCertification = false;
                vm.data.hideIssuedCerts = false;
                vm.data.hideSoftCopySent = false;
                vm.data.hideHardCopySent = false;
                vm.data.hideKycFail = true;
                vm.data.hideKycPass = true;
                vm.data.hideKycApproved = true;
                vm.data.hideKycRejected = true;
                vm.data.hideNewClo = true;
                vm.data.hidePaymentHistory = true;
                vm.data.hideFresh = true;
                vm.data.hideInitial = true;
                vm.data.hidePayPending = true;
                vm.data.hideFullPay = true;
                vm.data.hideReconciled = true;
                vm.data.hiderenewal = true;
                vm.data.hideDelayedProjects = true;
                vm.data.hideExpiredCertificate = true;
              vm.data.hideTaxInvoiceHistory = true;
              vm.data.hideMonthPaymentHistory = true;
            }
            if (vm.data.LogedInUserId == 'kavya') {
              vm.data.hideagentrequest = true;
              vm.data.hideCertsPending = true;
                vm.data.hideSoftCopySent = true;
                vm.data.hideHardCopySent = true;
                vm.data.hideDispatched = true;
                vm.data.hidePending = true;
                vm.data.hideNewClo = true;
                vm.data.hideFresh = true;
                vm.data.hideInitial = true;
                vm.data.hideFullPay = true;
                vm.data.hideReconciled = true;
                vm.data.hidePaymentHistory = true;
                vm.data.hideQaChecker = true;
                vm.data.hideKycFail = true;
                vm.data.hideKycPass = true;
                vm.data.hideKycApproved = true;
                vm.data.hideKycRejected = true;
                vm.data.hideTaxInvoiceHistory = true;
            }
            if (vm.data.LogedInUserId == 'Kruthika ') {
                vm.data.hideClosureDetails = true;
                vm.data.hidesearchCertificates = true;
                vm.data.hideQaChecker = true;
                vm.data.hideCertification = false;
                vm.data.hideUpdateKyc = false;
                vm.data.hidePending = true;
                vm.data.hideDispatched = true;
                vm.data.hiderenewal = true;
                vm.data.hideDelayedProjects = true;
                vm.data.hideExpiredCertificate = true;
                vm.data.hideTaxInvoiceHistory = true;
            }
            if (vm.data.LogedInUserId == 'Accounts1') {
                //vm.data.hideagentrequest = true
                vm.data.hidePending = true;
                vm.data.hideQaChecker = true;
                vm.data.hidesearchCertificates = true;
                vm.data.hideCertification = true;
                vm.data.hideClosureDetails = true;
              vm.data.hideagentrequest = true;
              vm.data.hideCertsPending = true;
                vm.data.hideUpdateKyc = true;
                vm.data.hideDispatched = true;
                vm.data.hideIssuedCerts = true;
                vm.data.hideKycFail = true;
                vm.data.hideKycPass = true;
                vm.data.hideKycApproved = true;
                vm.data.hideKycRejected = true;
                vm.data.hideSoftCopySent = true;
                vm.data.hideHardCopySent = true;
                vm.data.hiderenewal = true;
                vm.data.hideDelayedProjects = true;
                vm.data.hideExpiredCertificate = true;
                //vm.data.hideTaxInvoice = true;
            }
            if (vm.data.LogedInUserId == 'Accounts2') {
                //vm.data.hideagentrequest = true
                vm.data.hidePending = true;
                vm.data.hideQaChecker = true;
                vm.data.hidesearchCertificates = true;
                vm.data.hideCertification = true;
                vm.data.hideUpdateKyc = true;
                vm.data.hideDispatched = true;
                vm.data.hideIssuedCerts = true;
                vm.data.hiderenewal = true;
                vm.data.hideDelayedProjects = true;
                vm.data.hideExpiredCertificate = true;
                vm.data.hideTaxInvoiceHistory = true;
            }
            if (vm.data.LogedInUserId == 'Ops') {
                vm.data.hideClosureDetails = true;
                vm.data.hidePending = false;
                vm.data.hideCertification = false;
                vm.data.hidesearchCertificates = false;
                vm.data.hideUpdateKyc = false;
                vm.data.hideDispatched = false;
                vm.data.hideKycFail = false;
                vm.data.hideKycPass = false;
                vm.data.hideKycApproved = false;
                vm.data.hideKycRejected = false;
                vm.data.hideSoftCopySent = false;
                vm.data.hideHardCopySent = true;
                vm.data.hideNewClo = true;
                vm.data.hidePaymentHistory = true;
                vm.data.hideFresh = true;
                vm.data.hideInitial = true;
                vm.data.hidePayPending = true;
                vm.data.hideFullPay = true;
                vm.data.hideReconciled = true;
                vm.data.hiderenewal = true;
                vm.data.hideDelayedProjects = true;
                vm.data.hideExpiredCertificate = true;
              vm.data.hideTaxInvoiceHistory = true;
              vm.data.hideMonthPaymentHistory = true;
            }
            if (vm.data.LogedInUserId == 'Vijay B') {
                vm.data.hideClosureDetails = false;
                vm.data.hidePending = false;
                vm.data.hidesearchCertificates = false;
                vm.data.hideQaChecker = false;
                vm.data.hideKycFail = true;
                vm.data.hideKycPass = true;
                vm.data.hideKycApproved = true;
                vm.data.hideKycRejected = true;
                vm.data.hideNewClo = true;
                vm.data.hidePaymentHistory = true;
                vm.data.hideFresh = true;
                vm.data.hideInitial = true;
                vm.data.hidePayPending = true;
                vm.data.hideFullPay = true;
                vm.data.hideReconciled = true;
                vm.data.hideSoftCopySent = true;
                vm.data.hideHardCopySent = true;
                //vm.data.hideUpdateKyc = false;
                vm.data.hiderenewal = true;
                vm.data.hideDelayedProjects = true;
                vm.data.hideExpiredCertificate = true;
                vm.data.hideTaxInvoiceHistory = true;
            }
            if (vm.data.LogedInUserId == 'Ria') {
                vm.data.hideClosureDetails = false;
                vm.data.hidePending = false;
                vm.data.hidesearchCertificates = false;
                vm.data.hideQaChecker = false;
                vm.data.hideKycFail = true;
                vm.data.hideKycPass = true;
                vm.data.hideKycApproved = true;
                vm.data.hideKycRejected = true;
                vm.data.hideNewClo = true;
                vm.data.hidePaymentHistory = true;
                vm.data.hideFresh = true;
                vm.data.hideInitial = true;
                vm.data.hidePayPending = true;
                vm.data.hideFullPay = true;
                vm.data.hideReconciled = true;
                vm.data.hideSoftCopySent = true;
                vm.data.hideHardCopySent = true;
                //vm.data.hideUpdateKyc = false;
                vm.data.hiderenewal = true;
                vm.data.hideDelayedProjects = true;
                vm.data.hideExpiredCertificate = true;
                vm.data.hideTaxInvoiceHistory = true;
            }
            if (vm.data.LogedInUserId == 'varun') {
                vm.data.hideClosureDetails = false;
                vm.data.hidePending = false;
                vm.data.hideQaChecker = false;
                vm.data.hidesearchCertificates = false;
                vm.data.hideCertification = false;
                //vm.data.hideUpdateKyc = false;
            }
            vm.func.activateClass = function (url) {
                return ($location.path().indexOf(url) > -1);
            }

            httpService.httpCall('api/certificationDetails/GetNavbarheadercounts', 'GET', null)
                .then(function (response) {
                    //   var data = response;
                    debugger;
                    vm.data.newclosure = response[0]['NewClosureCount'];
                  vm.data.PayHistDetail = response[0]['PayHistCount'];
                  vm.data.MonthPayDetails = response[0]['MonthPayCount'];
                    vm.data.totalFreshProp = response[0]['CountFreshProposalDetail'];
                    vm.data.totalAgentRequests = response[0]['CountAgentRequest'];
                    vm.data.totalCertsPending = response[0]['CountCertPending'];
                    vm.data.totalProp = response[0]['CountGoAhead'];
                    vm.data.countofcerts = response[0]['CountIssuedCerts'];
                    vm.data.totalToBeVerified = response[0]['CountToBeVerified'];
                    vm.data.PendingRec = response[0]['CountPendingDetails'];
                    vm.data.Softcopy = response[0]['CountSoftcopyDetails'];
                    vm.data.HardCopy = response[0]['CountHardDetails'];
                    vm.data.InitialPaymentDetails = response[0]['InitialPaymentDetails'];
                    vm.data.FullPaymentDetails = response[0]['FullPaymentDetails'];
                    vm.data.PendingPaymentDetails = response[0]['PendingPaymentDetails'];
                    vm.data.ReconciledDetail = response[0]['ReconciledDetails'];
                    vm.data.KycPassDetail = response[0]['KycpassDetails'];
                    vm.data.KycFailDetail = response[0]['KycfailDetails'];
                    vm.data.KycApprovedDetail = response[0]['KycApprovedDetails'];
                    vm.data.KycRejectedDetail = response[0]['KycRejectedDetails'];
                    vm.data.renewals = response[0]['RenewalCount'];
                    vm.data.DelayedProjects = response[0]['DelayedProjectsCount'];
                    vm.data.Expired = response[0]['ExpiredCertificateCount'];
                    vm.data.TaxInvoiceHist = response[0]['TaxInvoiceHist'];
                });

            vm.func.logout = function () {
                authService.logout();
            }

            vm.func.applymobilemenu = function () {
                angular.element('body, .mobile-nav-block').toggleClass('open-mobile-nav');
            }
        }
        return directive;
    }

})();

(function () {
    'use strict';

    angular
      .module('isoappClient')
      .controller('NavbrController', NavbrController);

    NavbrController.$inject = ['httpService', '$state','$stateParams']

    function NavbrController(httpService, state, stateParams) {

        var vm = this;

        vm.data = [];
        vm.func = [];

        if (typeof (stateParams.usernme) != 'undefined') {

            //var user = stateParams.usernme;
            //if (user == 'Varun') {
            //    vm.data.hidetab = true;
            //}
            //vm.data.hidetab = false;
        }

        //var init = function () {

        //}

        //init();
    }

})();
(function() {
  'use strict';

  angular
    .module('isoappClient')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('isoappClient')
        .service('popupService', popupService);

    popupService.$inject = ['$uibModal'];

    function popupService($uibModal) {

        this.errorsm = function (title, message) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'sm',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/errorpopups/errorsmpopup.html',
                controller: 'ErrorsmController',
                controllerAs: 'vm',
                resolve: {
                    title: function () {
                        return angular.copy(title);
                    },
                    message: function () {
                        return angular.copy(message);
                    }
                }
            });
            return modalInstance;
        }

        this.errordialog = function (title, message) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'dialog',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/errorpopups/errorsmpopup.html',
                controller: 'ErrorsmController',
                controllerAs: 'vm',
                resolve: {
                    title: function () {
                        return angular.copy(title);
                    },
                    message: function () {
                        return angular.copy(message);
                    }
                }
            });
            return modalInstance;
        }

        this.successsm = function (title, message) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'sm',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/successpopups/successpopup.html',
                controller: 'SuccesssmController',
                controllerAs: 'vm',
                resolve: {
                    title: function () {
                        return angular.copy(title);
                    },
                    message: function () {
                        return angular.copy(message);
                    }
                }
            });
            return modalInstance;
        }

        this.editCertificate = function (updateCertificate, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/certificateupdate/updatecertificate.html',
                controller: 'UpdateCertificationController',
                controllerAs: 'vm',
                resolve: {
                    updateCertificate: function () {
                    return angular.copy(updateCertificate);
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.addNewEnquiry = function (callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/addenquiry/addnewenquiry.html',
                controller: 'AddNewEnquiryController',
                controllerAs: 'vm',
                resolve: {
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.viewEnquiryDetails = function (detailsOfSingleEnquiry, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'dialog',
                backdrop: 'static',
                templateUrl: 'app/popups/viewenquiry/viewenquiry.html',
                controller: 'ViewEnquiryController',
                controllerAs: 'vm',
                resolve: {
                    detailsOfSingleEnquiry: function () {
                        return angular.copy(detailsOfSingleEnquiry);
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }


        this.viewCertDetails = function (detailsOfSearchedCerts, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                templateUrl: 'app/popups/showSearchedCertificates/showSearchedCerts.html',
                controller: 'ShowSearchedController',
                controllerAs: 'vm',
                resolve: {
                    detailsOfSearchedCerts: function () {
                        return angular.copy(detailsOfSearchedCerts);
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }


        this.viewPropDetails = function (detailsOfSingleProp, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'dialog',
                backdrop: 'static',
                templateUrl: 'app/proposalmanagement/viewPropDetails.html',
                controller: 'ViewPropDetailsController',
                controllerAs: 'vm',
                resolve: {
                    detailsOfSingleProp: function () {
                        return angular.copy(detailsOfSingleProp);
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.editEnquiry = function (updateEnquiryDetails, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                templateUrl: 'app/popups/editenquiry/editenquirydetails.html',
                controller: 'EditEnquiryController',
                controllerAs: 'vm',
                resolve: {
                    updateEnquiry: function () {
                        return angular.copy(updateEnquiryDetails)
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.editinvalidEnquiry = function (updateInvalidEnquiry, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/editinvalidEnquiry/editinvalidEnquiry.html',
                controller: 'EditInvalidEnquiryController',
                controllerAs: 'vm',
                resolve: {
                    singleEnqID: function () {
                        return updateInvalidEnquiry;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }

                }
            });
            return modalInstance;
        }

        this.finishClosure = function (KycIdDetail, Id, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/finishClosure/finishClosure.html',
                controller: 'FinishClosureController',
                controllerAs: 'vm',
                resolve: {
                    KycIdDetails: function () {
                        return KycIdDetail;
                    },
                    Ids: function () {
                        return Id;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.finishClsDetails = function (IdDetail, statusId, qaStatusId, currqastatus, currprojstatus, Kyc_idfk, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/finishClsDetails/finishClsDetails.html',
                controller: 'FinishClsDetailsController',
                controllerAs: 'vm',
                resolve: {
                    IdDetails: function () {
                        return IdDetail;
                    },
                    statusIds: function () {
                        return statusId;
                    },
                    qaStatusIds: function () {
                        return qaStatusId;
                    },
                    currqastatuss: function () {
                        return currqastatus;
                    },
                    currprojstatuss: function () {
                        return currprojstatus;
                    },
                    kycidfk: function () {
                        return Kyc_idfk;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }

                }
            });
            return modalInstance;
        }
        this.rejectClosure = function (KycIdDetail, Id, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/qaChecker/RejectIt/rejectIt.html',
                controller: 'RejectClosureController',
                controllerAs: 'vm',
                resolve: {
                    KycIdDetails: function () {
                        return KycIdDetail;
                    },
                    Ids: function () {
                        return Id;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }
        this.passClosure = function (KycIdDetail, Id, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/qaChecker/passIt/passIt.html',
                controller: 'PassClosureController',
                controllerAs: 'vm',
                resolve: {
                    KycIdDetails: function () {
                        return KycIdDetail;
                    },
                    Ids: function () {
                        return Id;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }
        this.kycfailed = function (KycIdDetail, Id, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/qaChecker/KycFailed/kycfailed.html',
                controller: 'KycFailedController',
                controllerAs: 'vm',
                resolve: {
                    KycIdDetails: function () {
                        return KycIdDetail;
                    },
                    Ids: function () {
                        return Id;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }
        this.survFail = function (KycIdDetail, Id, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/SurveillanceFailPass/SurvFailed/survfailed.html',
                controller: 'SurvFailedController',
                controllerAs: 'vm',
                resolve: {
                    KycIdDetails: function () {
                        return KycIdDetail;
                    },
                    Ids: function () {
                        return Id;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }
        this.survPass = function (KycIdDetail, Id, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/SurveillanceFailPass/SurvPassed/survpassed.html',
                controller: 'SurvPassedController',
                controllerAs: 'vm',
                resolve: {
                    KycIdDetails: function () {
                        return KycIdDetail;
                    },
                    Ids: function () {
                        return Id;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }
        this.kycpassed = function (KycIdDetail, Id, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/qaChecker/KycPassed/kycpassed.html',
                controller: 'KycPassedController',
                controllerAs: 'vm',
                resolve: {
                    KycIdDetails: function () {
                        return KycIdDetail;
                    },
                    Ids: function () {
                        return Id;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }
        //this.finishClsDetails = function (IdDetail, callBack) {
        //    var modalInstance = $uibModal.open({
        //        windowClass: 'center-modal',
        //        size: 'md',
        //        backdrop: 'static',
        //        templateUrl: 'app/popups/finishClsDetails/finishClsDetails.html',
        //        controller: 'FinishClsDetailsController',
        //        controllerAs: 'vm',
        //        resolve: {
        //            IdDetails: function () {
        //                return IdDetail;
        //            },
        //            callBackFunction: function () {
        //                return callBack;
        //            }
        //        }
        //    });
        //    return modalInstance;
        //}


        this.addCommentsInClosure = function (singleKycId, CertId, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/popups/addcommentsforclosure/addcommentsforclosure.html',
                controller: 'AddCommentsForClosureController',
                controllerAs: 'vm',
                resolve: {
                    singleKycIdDetails: function () {
                        return singleKycId;
                    },
                    CertIdDetails: function () {
                        return CertId;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

      this.addCommentsInRejectRequest = function (singleKycId, Id, callBack) {
        var modalInstance = $uibModal.open({
          windowClass: 'center-modal',
          size: 'md',
          backdrop: 'static',
          templateUrl: 'app/popups/addCommentsInRejectRequest/addCommentsInRejectRequest.html',
          controller: 'addCommentsInRejectRequestController',
          controllerAs: 'vm',
          resolve: {
            singleKycIdDetails: function () {
              return singleKycId;
            },
            Ids: function () {
              return Id;
            },
            callBackFunction: function () {
              return callBack;
            }
          }
        });
        return modalInstance;
      }

      this.addCommentsInAborted = function (singleKycId, Id, callBack) {
        var modalInstance = $uibModal.open({
          windowClass: 'center-modal',
          size: 'md',
          backdrop: 'static',
          templateUrl: 'app/popups/addCommentsInAborted/addCommentsInAborted.html',
          controller: 'addCommentsInAbortedController',
          controllerAs: 'vm',
          resolve: {
            singleKycIdDetails: function () {
              return singleKycId;
            },
            Ids: function () {
              return Id;
            },
            callBackFunction: function () {
              return callBack;
            }
          }
        });
        return modalInstance;
      }

      this.addCommentsInNAC = function (singleKycId, Id, callBack) {
        var modalInstance = $uibModal.open({
          windowClass: 'center-modal',
          size: 'md',
          backdrop: 'static',
          templateUrl: 'app/popups/addCommentsInNAC/addCommentsInNAC.html',
          controller: 'addCommentsInNACController',
          controllerAs: 'vm',
          resolve: {
            singleKycIdDetails: function () {
              return singleKycId;
            },
            Ids: function () {
              return Id;
            },
            callBackFunction: function () {
              return callBack;
            }
          }
        });
        return modalInstance;
      }

        this.AddPaymentHistoryInClosure = function (PMID, PHID, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                templateUrl: 'app/popups/addpaymenthistoryforclosure/addpaymenthistoryforclosure.html',
                controller: 'AddPaymentHistoryForClosureController',
                controllerAs: 'vm',
                resolve: {
                    PMIDDetails: function () {
                        return PMID;
                    },
                    PHIDDetails: function () {
                        return PHID;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.GenerateTaxInvoice = function (PMID, PHID, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                templateUrl: 'app/popups/GenerateTaxInvoice/GenerateTaxInvoice.html',
                controller: 'GenerateTaxInvoiceController',
                controllerAs: 'vm',
                resolve: {
                    PMIDDetails: function () {
                        return PMID;
                    },
                    PHIDDetails: function () {
                        return PHID;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.addProposal = function (callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/addproposal/addproposal.html',
                controller: 'AddProposalController',
                controllerAs: 'vm',
                resolve: {
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.updateProposalReport = function (proposalData, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/updateproposal/updateproposalReport.html',
                controller: 'EditProposalReportController',
                controllerAs: 'vm',
                resolve: {
                    proposalDataUpdate: function () {
                        return angular.copy(proposalData);
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.updatePaymentProposalReport = function (proposalPaymentData, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/proposalpaymentupdate/proposalpaymentupdate.html',
                controller: 'EditProposalPaymentController',
                controllerAs: 'vm',
                resolve: {
                    proposalPaymentDataUpdate: function () {
                        return angular.copy(proposalPaymentData);
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

        this.addDispatchDetails = function (Id, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'md',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/addDispatchDetails/addDispatchDetails.html',
                controller: 'AddDispatchDetailsController',
                controllerAs: 'vm',
                resolve: {


                    IdDetail: function () {
                        return Id;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }
        this.kycUpdatePage = function (Kycid, callBack) {
            var modalInstance = $uibModal.open({
                windowClass: 'center-modal',
                size: 'lg',
                backdrop: 'static',
                placement: 'top',
                templateUrl: 'app/popups/KycUpdate/kycUpdatePopUp.html',
                controller: 'kycUpdatePopUpController',
                controllerAs: 'vm',
                resolve: {
                    kycDetails: function () {
                        return Kycid;
                    },
                    callBackFunction: function () {
                        return callBack;
                    }
                }
            });
            return modalInstance;
        }

    }

})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .service('localstorageService', localstorageService);

    localstorageService.$inject = ['$window'];

    function localstorageService($window) {
        this.getObject = function (key) {
            return angular.toJson($window.localStorage[key] || {});
        }

        this.setObject = function (key, value) {
            $window.localStorage[key] = angular.toJson(value);
        }

        this.clearStorage = function () {
            $window.localStorage.clear();
        }
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .service('httpService', httpService);

    function httpService($http, $q, serviceUrl) {

        this.httpCall = function (url, method, data) {
            
            url = serviceUrl + url;

            var deferred = $q.defer();
            $http({
                method: method,
                url: url,
                data: data 
            })

            .success(function (data) {
                deferred.resolve(data);
            })
            .error(function (data) {
                deferred.reject(data);
            })

            return deferred.promise;
        }
    }

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .service('authService', authService);

    authService.$inject = ['httpService', 'localstorageService', 'popupService', '$rootScope', '$state'];

    function authService(httpService, localstorageService, popupService, rootScope, state) {

        var authentication = function (loginInfo) {
            httpService.httpCall('api/user/authentication', 'Post', loginInfo)
            .then(function (response) {
                rootScope.UserData = response;
                localstorageService.setObject('user', rootScope.UserData);
                state.go('home');
                //var usernme = rootScope.UserData;
                //state.go('navbar', { usernme: usernme });
                return;
            },
            function () {
                popupService.errorsm('ISO', 'Your Username/Email Or Password is invalid! or You may dont have access ');
                return false;
            });
        }

        var logout = function () {
            rootScope.UserData = {};
            localstorageService.clearStorage();
            state.go('login')
        }
        return {
            authentication: authentication,
            logout: logout
        }
    }

})();
(function() {
  'use strict';

  angular
    .module('isoappClient')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function () {
	'use strict';

	angular
	.module('isoappClient')
	.directive('acmeFooter', acmeFooter);

	function acmeFooter() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/footer/footer.html'
		};

		return directive;
	}

})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('QaSingleKycController', QaSingleKycController);

    QaSingleKycController.$inject = ['$stateParams', 'httpService', '$state', 'popupService','$rootScope'];

    function QaSingleKycController(stateParams, httpService, state, popupService, rootScope) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            var UserData = angular.fromJson(rootScope.UserData);
            vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
            vm.data.noShowDetails = true;
            vm.data.hideDetails = false;
            vm.data.itemsPerPage = 5;
            vm.data.totalItems = 0;
            vm.data.totalItemsofClosure = 0;
            vm.data.totalItemsofComment = 0;
            vm.data.pagination = {
                current: 1
            };
            vm.data.paginationofClosure = {
                current: 1
            };
            vm.data.paginationofComment = {
                current: 1
            };
            if (typeof (stateParams.Id) != 'undefined' && parseInt(stateParams.Id) > 0) {
                vm.data.Id = stateParams.Id;
            }

            if (typeof (stateParams.Kycid) != 'undefined' && parseInt(stateParams.Kycid) > 0) {
                httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + stateParams.Kycid, 'GET', null)
                .then(function (response) {
                    vm.data.Kycid = response.Kyc_id;
                    vm.data.ClientName = response.Contact_Name;
                    vm.data.ContactNumber = response.Contact_Num;
                    vm.data.ContactEmail = response.Contact_Email;
                    vm.data.Designation = response.Designation;
                    vm.data.AltContactName = response.AltContact_Name;
                    vm.data.AltContactNumber = response.AltContact_Number;
                    vm.data.AltContactEmail = response.AltContact_Email;
                    vm.data.AltDesignation = response.AltDesignation
                    vm.data.CompanyName = response.Company_name;
                    vm.data.CompanyType = response.Company_Type;
                    vm.data.CompanyCity = response.Company_City;
                    vm.data.CompanyCountry = response.Company_Country;
                    vm.data.CompanyState = response.Company_State;
                    vm.data.NatureofBusiness = response.Nature_of_Business
                    vm.data.CompanyType = response.Company_Type;
                    vm.data.Turnover = response.Turnover;
                    vm.data.URL = response.URL;
                    vm.data.Landline = response.Landline;
                    vm.data.EmployeeStrength = response.Employee_Strength;
                    vm.data.Associate = response.Associate;

                });
            }

            httpService.httpCall('api/closureManagement/getCertificationDetailsForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
            .then(getCertificationDetailsForSingleKyc)

            httpService.httpCall('api/closureManagement/getCommentForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
            .then(getCommentForSingleKyc)

            httpService.httpCall('api/closureManagement/getProposalDetailsForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
            .then(getProposalDetailsForSingleKyc)
            

            if (vm.data.LogedInUserId == 'Ops') {
                vm.data.hideProjFailbutton = true;
                vm.data.hideProjPassbutton = true;
                //alert(vm.data.LogedInUserId);
            }

          //  vm.func.saveUserActivity();
       //     httpService.httpCall('api/closureManagement/getLatestCertificationDetails?Kycid=' + stateParams.Kycid, 'GET', null)
       //.then(latestCertificates)
        }
      

        //vm.func.saveUserActivity = function () {
          
        //    vm.data.userName = vm.data.LogedInUserId;
        //    vm.data.visitPage = 'QaSingleKyc';
        //    vm.data.id = (stateParams.Kycid);

        //    var userData = {};
        //    userData.user_visitpage = vm.data.visitPage;
        //    userData.row_id_fk = vm.data.id;
        //    userData.userName = vm.data.userName;

        //    httpService.httpCall('api/user/saveUserActivity', 'POST', userData)
        //}

        //var latestCertificates = function (response) {
        //    vm.data.latestCerts = response;
        //    vm.data.CertsLatest = angular.copy(vm.data.latestCerts);

        //}

        var getCertificationDetailsForSingleKyc = function (response) {
            vm.data.certificationDetailsForSinglekyc = response;
            // vm.data.latestCert = response.RecertifiedDate;
            vm.data.certificationDetailsForSingleKycData = angular.copy(vm.data.certificationDetailsForSinglekyc);
            getPages();
        }



        vm.data.editProposal = function (Id) {
            state.go('singleProposal', { Id: Id });
        }

        var getCommentForSingleKyc = function (responseForComments) {
            vm.data.commentDetailsForKyc = responseForComments;
            vm.data.commentDetailsForKycData = angular.copy(vm.data.commentDetailsForKyc);
            getPagesforComment();
        }

        var getProposalDetailsForSingleKyc = function (response) {
            vm.data.proposalDetailsForSingleKyc = response;
            vm.data.proposalDetailsForSingleKycData = angular.copy(vm.data.proposalDetailsForSingleKyc);
            getPagesforProposal();
        }

        var getPages = function () {
            vm.data.totalItems = vm.data.certificationDetailsForSinglekyc.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        var getPagesforProposal = function () {
            vm.data.totalItemsofClosure = vm.data.proposalDetailsForSingleKyc.length;
            vm.data.paginationofClosure = {
                current: 1
            }
            vm.data.startofClosure = vm.data.paginationofClosure.current;
            vm.data.endofClosure = vm.data.startofClosure * vm.data.itemsPerPage;
            if (vm.data.totalItemsofClosure < vm.data.itemsPerPage) {
                vm.data.endofClosure = vm.data.totalItemsofClosure;
            }
        };

        var getPagesforComment = function () {
            vm.data.totalItemsofComment = vm.data.commentDetailsForKyc.length;
            vm.data.paginationofComment = {
                current: 1
            }
            vm.data.startofComment = vm.data.paginationofComment.current;
            vm.data.endofComment = vm.data.startofComment * vm.data.itemsPerPage;
            if (vm.data.totalItemsofComment < vm.data.itemsPerPage) {
                vm.data.endofComment = vm.data.totalItemsofComment;
            }
        };

        vm.func.pageChangeofComment = function () {
            var startofComment = ((vm.data.paginationofComment.current - 1) * vm.data.itemsPerPage)
            , endofComment = startofComment + vm.data.itemsPerPage;

            vm.data.startofComment = startofComment + 1;
            vm.data.endofComment = (vm.data.totalItemsofComment > endofComment ? endofComment : vm.data.totalItemsofComment);

            vm.data.commentDetailsForKycData = vm.data.commentDetailsForKyc.slice(startofComment, endofComment);
        };

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.certificationDetailsForSingleKycData = vm.data.certificationDetailsForSinglekyc.slice(start, end);
        };

        vm.func.pageChangeofClosure = function () {
            var startofClosure = ((vm.data.paginationofClosure.current - 1) * vm.data.itemsPerPage)
            , endofClosure = startofClosure + vm.data.itemsPerPage;

            vm.data.startofClosure = startofClosure + 1;
            vm.data.endofClosure = (vm.data.totalItemsofClosure > endofClosure) ? endofClosure : vm.data.totalItemsofClosure;

            vm.data.proposalDetailsForSingleKycData = vm.data.proposalDetailsForSingleKyc.slice(startofClosure, endofClosure);
        };



        vm.data.goAddNewCertificationPage = function (Kycid) {
            state.go('addnewcertification', { Kycid: Kycid })
        };
        var Prid = 0;
        vm.data.editClosureKYCDetails = function (Kycid) {
            state.go('editKycByQaChecker', { Kycid: Kycid }, { Prid: Prid })
        };

        vm.func.editCertificationDetails = function (row) {
            popupService.editCertificate(row, refresh);
        }
        vm.data.closureReportUpdate = function (Id) {
            popupService.updateProposalReport((Id), refresh);
        }

        vm.func.giveComment = function (Kycid) {
            popupService.addCommentsInClosure(Kycid, refresh);
        }
        
        vm.func.ProjFail  = function (Kycid, Id) {
            popupService.rejectClosure(Kycid, Id, refresh);
            var updateProposalHistory = {};

            updateProposalHistory.kyc_id_fk = vm.data.Kycid;
            updateProposalHistory.comment = "Certification Status - Kyc Rejected";
            updateProposalHistory.activity_user = vm.data.LogedInUserId;
            updateProposalHistory.staus = '1';
            httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
            .then(onSuccess, onFail)
            init();
            //if (vm.data.certificationDetailsForSingleKycData.length != 0) {

            //    if (vm.data.CertsLatest.length != 0) {

            //        if ((vm.data.Associate != null && vm.data.Associate != '')) {

            //            popupService.rejectClosure(Kycid, Id, refresh);
            //        }
            //        else {
            //            onFail();
            //        }
            //    }
            //    else {
            //        onFail1();
            //    }

            //}
            //else {
            //    onFail();
            //}


        }
        //alert(vm.data.LogedInUserId);
        vm.func.ProjPass = function (Kycid, Id) {

      //      httpService.httpCall('api/closureManagement/getLatestCertificationDetails?Kycid=' + stateParams.Kycid, 'GET', null)
      //.then(function (response) {
      //    vm.data.latestCerts = response;
      //    vm.data.CertsLatest = angular.copy(vm.data.latestCerts);
      //})
           
            //if (vm.data.certificationDetailsForSingleKycData.length != 0) {

            //    if (vm.data.CertsLatest.length != 0) {


            //httpService.httpCall('api/closureManagement/getPropBySingleKycId?Kycid=' + stateParams.Kycid, 'GET', null)
            //    .then(function (response) {
            //        vm.data.BillingCycle = response.validity;
            //        vm.data.ImpType = response.type;
            //        vm.data.CertiType = response.certification_type;
            //    });

            
                    if ((vm.data.Associate != null && vm.data.Associate != '')) {

                        popupService.passClosure(Kycid, Id, refresh);

                        var updateProposalHistory = {};

                        updateProposalHistory.kyc_id_fk = vm.data.Kycid;
                        updateProposalHistory.comment = "Certification Status - Kyc Approved";
                        updateProposalHistory.activity_user = vm.data.LogedInUserId;
                        updateProposalHistory.staus = '1';
                        httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
                        .then(onSuccess, onFail)
                        init();
                        
                    }
                    else {
                        onFail();
                    }
            //    }
            //    else {
            //        onFail1();
            //    }

            //}
            ////else {
            //    onFail();
            //}


        }
           vm.func.KycFail  = function (Kycid, Id) {
            popupService.kycfailed(Kycid, Id, refresh);
          

        }
        vm.func.KycPass = function (Kycid, Id) {

      //      httpService.httpCall('api/closureManagement/getLatestCertificationDetails?Kycid=' + stateParams.Kycid, 'GET', null)
      //.then(function (response) {
      //    vm.data.latestCerts = response;
      //    vm.data.CertsLatest = angular.copy(vm.data.latestCerts);
      //})
           
            //if (vm.data.certificationDetailsForSingleKycData.length != 0) {

            //    if (vm.data.CertsLatest.length != 0) {

                    if ((vm.data.Associate != null && vm.data.Associate != '')) {

                        popupService.kycpassed(Kycid, Id, refresh);
                    }
                    else {
                        onFail();
                    }
            //    }
            //    else {
            //        onFail1();
            //    }

            //}
            ////else {
            //    onFail();
            //}


        }

        vm.func.activenoShowDetails = function () {
            vm.data.noShowDetails = false;
            vm.data.hideDetails = true;
        }
        var onFail = function () {
            popupService.errorsm('ISO', 'Update Details of KYC!');
        };
        //var onFail1 = function () {
        //    popupService.errorsm('ISO', 'Certificate Too Old to Dispatch!\n\n (Older than 6 Months From Now)');
        //};
        var refresh = function () {
            init();
        }

        init();
    }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('QaCheckerController', QaCheckerController)

    QaCheckerController.$inject = ['httpService', '$filter', '$state', '$window'];//'popupService'$window

    function QaCheckerController(httpService, $filter, $state, $window) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];

            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };
            vm.data.selectStatus = [
            { value: 'Select', id: 0 },
             { value: 'Fresh', id: 1 },
            { value: 'Qualified', id: 1 },
            { value: 'Kyc Fail', id: 1 },
            { value: 'Kyc Pass', id: 1 },
            { value: 'Project Fail', id: 1 },
            { value: 'Project Pass', id: 1 },
            { value: 'Hold', id: 2 },
             { value: 'Go Ahead', id: 2 },
              { value: 'Soft Copy Sent', id: 2 },
              { value: 'Dispatched', id: 2 },
              { value: 'Part Payment', id: 3 },
               { value: 'Pending Payment', id: 3 },
                { value: 'Full Payment', id: 3 },
                { value: 'Reconciled', id: 3 }
              

            ];
            vm.data.QaStatus = vm.data.selectStatus[0];
            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforQaStatus', 'GET', null)
          .then(function (response) {
              vm.data.SuggestedQaStatus = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function(response){
                vm.data.getallCompanyName=response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

           // httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
          //  .then(getAllProposal)
            httpService.httpCall('api/proposalMnagement/getToBeVerified', 'GET', null)
            .then(getToBeVerified)
        }
        vm.func.getSingleKycDetails = function (Kycid,Id) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('qasinglekyc', { Kycid: Kycid, Id: Id });
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getToBeVerified = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            vm.func.pageChange();
            getPages();
        }

        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
            // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);
           
        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();s
        //}
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}
       
        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.QaStatus = vm.data.QaStatus.value;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            if (vm.data.QaStatus.id == 1) {
                httpService.httpCall('api/proposalMnagement/searchbySortQaStatus', 'POST', sortData)
          .then(successSearchsorted)

            }
            else if (vm.data.QaStatus.id == 2) {
                sortData.Dispatch = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchbyProjStatus', 'POST', sortData)
           .then(successSearchsorted)
            }
            else {
                sortData.PaymentStatus = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
           .then(successSearchsorted)
            }

          
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('KycRejectedController', KycRejectedController)

    KycRejectedController.$inject = ['httpService', '$filter', '$state', '$window'];//'popupService'$window

    function KycRejectedController(httpService, $filter, $state, $window) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' vm.data.CompanyName
            //    { value: 'March' qaKycRejected
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];

            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };
            vm.data.selectStatus = [
            { value: 'Select', id: 0 },
             { value: 'Fresh', id: 1 },
            { value: 'Qualified', id: 1 },
            { value: 'Kyc Fail', id: 1 },
            { value: 'Kyc Pass', id: 1 },
            { value: 'Project Fail', id: 1 },
            { value: 'Project Pass', id: 1 },
            { value: 'Hold', id: 2 },
             { value: 'Go Ahead', id: 2 },
              { value: 'Soft Copy Sent', id: 2 },
              { value: 'Dispatched', id: 2 },
              { value: 'Part Payment', id: 3 },
               { value: 'Pending Payment', id: 3 },
                { value: 'Full Payment', id: 3 },
                { value: 'Reconciled', id: 3 }


            ];
            vm.data.QaStatus = vm.data.selectStatus[0];
            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforQaStatus', 'GET', null)
          .then(function (response) {
              vm.data.SuggestedQaStatus = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            // httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
            //  .then(getAllProposal)
            httpService.httpCall('api/proposalMnagement/KycRejected', 'GET', null)
            .then(getToBeVerified)
        }
        vm.func.getSingleKycDetails = function (Kycid, Id) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('qasinglekyc', { Kycid: Kycid, Id: Id });
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getToBeVerified = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            vm.func.pageChange();
            getPages();
        }

        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
        // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);

        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();s
        //}
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}

        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.QaStatus = vm.data.QaStatus.value;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            if (vm.data.QaStatus.id == 1) {
                httpService.httpCall('api/proposalMnagement/searchbySortQaStatus', 'POST', sortData)
          .then(successSearchsorted)

            }
            else if (vm.data.QaStatus.id == 2) {
                sortData.Dispatch = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchbyProjStatus', 'POST', sortData)
           .then(successSearchsorted)
            }
            else {
                sortData.PaymentStatus = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
           .then(successSearchsorted)
            }


        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('KycPassController', KycPassController)

    KycPassController.$inject = ['httpService', '$filter', '$state', '$window'];//'popupService'$window

    function KycPassController(httpService, $filter, $state, $window) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];

            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };
            vm.data.selectStatus = [
            { value: 'Select', id: 0 },
             { value: 'Fresh', id: 1 },
            { value: 'Qualified', id: 1 },
            { value: 'Kyc Fail', id: 1 },
            { value: 'Kyc Pass', id: 1 },
            { value: 'Project Fail', id: 1 },
            { value: 'Project Pass', id: 1 },
            { value: 'Hold', id: 2 },
             { value: 'Go Ahead', id: 2 },
              { value: 'Soft Copy Sent', id: 2 },
              { value: 'Dispatched', id: 2 },
              { value: 'Part Payment', id: 3 },
               { value: 'Pending Payment', id: 3 },
                { value: 'Full Payment', id: 3 },
                { value: 'Reconciled', id: 3 }


            ];
            vm.data.QaStatus = vm.data.selectStatus[0];
            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforQaStatus', 'GET', null)
          .then(function (response) {
              vm.data.SuggestedQaStatus = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            // httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
            //  .then(getAllProposal)
            httpService.httpCall('api/proposalMnagement/KycPass', 'GET', null)
            .then(getToBeVerified)
        }
        vm.func.getSingleKycDetails = function (Kycid, Id) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('qasinglekyc', { Kycid: Kycid, Id: Id });
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getToBeVerified = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            vm.func.pageChange();
            getPages();
        }

        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
        // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);

        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();s
        //}
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}

        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.QaStatus = vm.data.QaStatus.value;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            if (vm.data.QaStatus.id == 1) {
                httpService.httpCall('api/proposalMnagement/searchbySortQaStatus', 'POST', sortData)
          .then(successSearchsorted)

            }
            else if (vm.data.QaStatus.id == 2) {
                sortData.Dispatch = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchbyProjStatus', 'POST', sortData)
           .then(successSearchsorted)
            }
            else {
                sortData.PaymentStatus = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
           .then(successSearchsorted)
            }


        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('KycFailController', KycFailController)

    KycFailController.$inject = ['httpService', '$filter', '$state', '$window'];//'popupService'$window

    function KycFailController(httpService, $filter, $state, $window) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];

            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };
            vm.data.selectStatus = [
            { value: 'Select', id: 0 },
             { value: 'Fresh', id: 1 },
            { value: 'Qualified', id: 1 },
            { value: 'Kyc Fail', id: 1 },
            { value: 'Kyc Pass', id: 1 },
            { value: 'Project Fail', id: 1 },
            { value: 'Project Pass', id: 1 },
            { value: 'Hold', id: 2 },
             { value: 'Go Ahead', id: 2 },
              { value: 'Soft Copy Sent', id: 2 },
              { value: 'Dispatched', id: 2 },
              { value: 'Part Payment', id: 3 },
               { value: 'Pending Payment', id: 3 },
                { value: 'Full Payment', id: 3 },
                { value: 'Reconciled', id: 3 }


            ];
            vm.data.QaStatus = vm.data.selectStatus[0];
            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforQaStatus', 'GET', null)
          .then(function (response) {
              vm.data.SuggestedQaStatus = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            // httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
            //  .then(getAllProposal)
            httpService.httpCall('api/proposalMnagement/KycFail', 'GET', null)
            .then(getToBeVerified)
        }
        vm.func.getSingleKycDetails = function (Kycid, Id) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('qasinglekyc', { Kycid: Kycid, Id: Id });
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getToBeVerified = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            vm.func.pageChange();
            getPages();
        }

        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
        // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);

        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();s
        //}
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}

        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.QaStatus = vm.data.QaStatus.value;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            if (vm.data.QaStatus.id == 1) {
                httpService.httpCall('api/proposalMnagement/searchbySortQaStatus', 'POST', sortData)
          .then(successSearchsorted)

            }
            else if (vm.data.QaStatus.id == 2) {
                sortData.Dispatch = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchbyProjStatus', 'POST', sortData)
           .then(successSearchsorted)
            }
            else {
                sortData.PaymentStatus = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
           .then(successSearchsorted)
            }


        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('KycApprovedController', KycApprovedController)

    KycApprovedController.$inject = ['httpService', '$filter', '$state', '$window'];//'popupService'$window

    function KycApprovedController(httpService, $filter, $state, $window) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];

            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };
            vm.data.selectStatus = [
            { value: 'Select', id: 0 },
             { value: 'Fresh', id: 1 },
            { value: 'Qualified', id: 1 },
            { value: 'Kyc Fail', id: 1 },
            { value: 'Kyc Pass', id: 1 },
            { value: 'Project Fail', id: 1 },
            { value: 'Project Pass', id: 1 },
            { value: 'Hold', id: 2 },
             { value: 'Go Ahead', id: 2 },
              { value: 'Soft Copy Sent', id: 2 },
              { value: 'Dispatched', id: 2 },
              { value: 'Part Payment', id: 3 },
               { value: 'Pending Payment', id: 3 },
                { value: 'Full Payment', id: 3 },
                { value: 'Reconciled', id: 3 }


            ];
            vm.data.QaStatus = vm.data.selectStatus[0];
            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforQaStatus', 'GET', null)
          .then(function (response) {
              vm.data.SuggestedQaStatus = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            // httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
            //  .then(getAllProposal)
            httpService.httpCall('api/proposalMnagement/KycApproved', 'GET', null)
            .then(getToBeVerified)
        }
        vm.func.getSingleKycDetails = function (Kycid, Id) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('qasinglekyc', { Kycid: Kycid, Id: Id });
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getToBeVerified = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            vm.func.pageChange();
            getPages();
        }

        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
        // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);

        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();s
        //}
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}

        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.QaStatus = vm.data.QaStatus.value;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            if (vm.data.QaStatus.id == 1) {
                httpService.httpCall('api/proposalMnagement/searchbySortQaStatus', 'POST', sortData)
          .then(successSearchsorted)

            }
            else if (vm.data.QaStatus.id == 2) {
                sortData.Dispatch = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchbyProjStatus', 'POST', sortData)
           .then(successSearchsorted)
            }
            else {
                sortData.PaymentStatus = vm.data.QaStatus.value;
                httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
           .then(successSearchsorted)
            }


        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
    'user strict';

    angular
    .module('isoappClient')
    .controller('EditKycByQaCheckerController', EditKycByQaCheckerController);

    EditKycByQaCheckerController.$inject = ['$state', '$stateParams', 'httpService', 'popupService'];

    function EditKycByQaCheckerController(state, stateParams, httpService, popupService) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            vm.data.isFormSubmit = false;
            vm.data.addMoreCompany = false;
            vm.data.addAlternateContact = false;
            vm.data.requiredCompanyType = false;
            vm.data.requiredAssociate = false;
            vm.data.requiredStateName = false;
            vm.data.requiredZoneType = false;
            vm.data.ifWantAddAlternateContact = true;
            vm.data.ifDontWantAddAlternateContact = false;
            vm.data.ifWantAddMoreCompany = true;
            vm.data.ifDontWantAddMoreCompany = false;
            vm.data.ComType = [
                    { value: 'Select' },
                    { value: 'Proprietorship' },
                    { value: 'Private Ltd.' },
                    { value: 'Public Ltd.' },
                    { value: 'Trust/Co-op/Association' },
                    { value: 'Government' },
                    { value: 'Other' }
            ];

           
            vm.data.ZoneType = [
                  { value: 'Select' },
                  { value: 'India' },
                  { value: 'ROI' },
                  { value: 'Oman' },
                  { value: 'UAE' },
                  { value: 'Saudi Arabia' },
                  { value: 'Kuwait' },
                  { value: 'Qatar' },
                  { value: 'South Africa' },
                  { value: 'Bahrain' },
                  { value: 'Rest of World' }
            ];
            vm.data.Associate = [
                { value: 'Select' },
                { value: 'Yes' },
                { value: 'No' }
            ];

            httpService.httpCall('api/enquiryManagement/suggestassignto', 'GET', null)
            .then(function (response) {
                vm.data.suggestAgentName = response;
                vm.data.suggestAgentNameData = angular.copy(vm.data.suggestAgentName);
            });

            httpService.httpCall('api/enquiryManagement/suggestCountryName', 'GET', null)
            .then(function (response) {
                vm.data.suggestCountry = response;
                vm.data.suggestCountryData = angular.copy(vm.data.suggestCountry);
            });

            vm.data.selectedCompanyType = vm.data.ComType[0];
            vm.data.selectedAssociate = vm.data.Associate[0];
            vm.data.selectedZoneType = vm.data.ZoneType[0];


            if (typeof (stateParams.Prid) != 'undefined' && parseInt(stateParams.Prid) > 0) {
                vm.data.propid = stateParams.Prid;
            }
            else {
                vm.data.propid = 0;
            }

            if (typeof (stateParams.Kycid) != 'undefined' && parseInt(stateParams.Kycid) > 0) {
                httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + stateParams.Kycid, 'GET', null)
                .then(function (response) {
                    vm.data.Kycid = response.Kyc_id;
                    vm.data.CreatedDate = response.Created_Date;
                    vm.data.CompanyName = response.Company_name;
                    vm.data.AgentName = response.Account_Manager;
                    vm.data.ContactPerson = response.Contact_Name;
                    vm.data.Designation = response.Designation;
                    vm.data.ContactNumber = response.Contact_Num;
                    vm.data.ContactEmail = response.Contact_Email;
                    vm.data.AlternateContactPerson = response.AltContact_Name;
                    vm.data.AlternateDesignation = response.AltDesignation;
                    vm.data.AlternateNumber = response.AltContact_Number;
                    vm.data.AlternateEmail = response.AltContact_Email;
                    vm.data.Natureofbusiness = response.Nature_of_Business;
                    vm.data.CompanyCountry = response.Company_Country;
                    vm.data.CompanyState = response.Company_State;
                    vm.data.CompanyCity = response.Company_City;
                    vm.data.firstsaleby = response.First_Sale_By;
                    //   vm.data.ZoneType = response.Zone;
                    angular.forEach(vm.data.ZoneType, function (item, index) {
                        if (item.value == response.Zone) {
                            vm.data.selectedZoneType = vm.data.ZoneType[index];
                        }
                    });
                    angular.forEach(vm.data.ComType, function (item, index) {
                        if (item.value == response.Company_Type) {
                            vm.data.selectedCompanyType = vm.data.ComType[index];
                        }
                    });
                    angular.forEach(vm.data.Associate, function (item, index) {
                        if (item.value == response.Associate) {
                            vm.data.selectedAssociate = vm.data.Associate[index];
                        }
                    });
                    vm.data.EmployeeStrength = response.Employee_Strength;
                    vm.data.Locations = response.Locations;
                    vm.data.Yearsinbusiness = response.Years_in_Business;
                    vm.data.Turnover = response.Turnover;
                    vm.data.URL = response.URL;
                    vm.data.LandlineNumber = response.Landline;
                    vm.data.PostalAddress = response.PostalAddress;
                    vm.data.Status = response.Status;
                });
            }

        }

        vm.func.activeAddAlternateContact = function () {
            vm.data.addAlternateContact = true;
            vm.data.ifWantAddAlternateContact = false;
            vm.data.ifDontWantAddAlternateContact = true;
        };

        vm.func.deactiveAddAlternateContact = function () {
            vm.data.addAlternateContact = false;
            vm.data.ifWantAddAlternateContact = true;
            vm.data.ifDontWantAddAlternateContact = false;
        };

        vm.func.activeAddMoreCompany = function () {
            vm.data.addMoreCompany = true;
            vm.data.ifWantAddMoreCompany = false;
            vm.data.ifDontWantAddMoreCompany = true;
        };

        vm.func.deactiveAddMoreCompany = function () {
            vm.data.addMoreCompany = false;
            vm.data.ifWantAddMoreCompany = true;
            vm.data.ifDontWantAddMoreCompany = false;
        };

        vm.func.hideRequiredCompanyType = function () {
            if (vm.data.selectedCompanyType != 'Select') {
                vm.data.requiredCompanyType = false;
            }
        };

        vm.func.hideRequiredZoneType = function () {
            if (vm.data.selectedZoneType != 'Select') {
                vm.data.requiredZoneType = false;
            }
        };
        vm.func.hideRequiredAssociate = function () {
            if (vm.data.selectedAssociate != 'Select') {
                vm.data.requiredAssociate = false;
            }
        };
        vm.func.hideRequiredState = function () {
            if (vm.data.CompanyCountry == 'India' || vm.data.CompanyCountry == 'INDIA') {
                if (vm.data.CompanyState != '' || vm.data.CompanyState != null) {
                    vm.data.requiredStateName = false;

                }
            }
        };

        vm.func.updateSingleKycDetails = function (isValid) {
            vm.data.isFormSubmit = true;
            isValid = true;
            if (vm.data.selectedCompanyType.value == 'Select') {
                vm.data.requiredCompanyType = true;
                isValid = false;
            }
            if (vm.data.selectedZoneType.value == 'Select') {
                vm.data.requiredZoneType = true;
                isValid = false;
            }
            if (vm.data.selectedAssociate.value == 'Select') {
                vm.data.requiredAssociate = true;
                isValid = false;
            }
            if (vm.data.CompanyCountry == 'India' || vm.data.CompanyCountry == 'INDIA') {
                if (vm.data.CompanyState == '' || vm.data.CompanyState == null) {
                    vm.data.requiredStateName = true;
                    isValid = false;
                }
            }
            if (isValid) {
                var data = {};
                data.CreatedDate = vm.data.CreatedDate;
                data.Companyname = vm.data.CompanyName;
                data.Associate = vm.data.selectedAssociate.value;
                // data.AcountManager = vm.data.AgentName;
                data.ClientName = vm.data.ContactPerson;
                data.Designation = vm.data.Designation;
                data.ContactNumber = vm.data.ContactNumber;
                data.ContactEmail = vm.data.ContactEmail;
                data.AltContactName = vm.data.AlternateContactPerson;
                data.AltDesignation = vm.data.AlternateDesignation;
                data.AltContactNumber = vm.data.AlternateNumber;
                data.AltContactEmail = vm.data.AlternateEmail;
                data.NatureofBusiness = vm.data.Natureofbusiness;
                data.CompanyCountry = vm.data.CompanyCountry;
                data.CompanyCity = vm.data.CompanyCity;
                data.CompanyState = vm.data.CompanyState;
                data.CompanyType = vm.data.selectedCompanyType.value;
                data.EmployeeStrength = vm.data.EmployeeStrength;
                data.Locations = vm.data.Locations;
                data.YearsinBusiness = vm.data.Yearsinbusiness;
                data.Turnover = vm.data.Turnover;
                data.URL = vm.data.URL;
                data.Landline = vm.data.LandlineNumber;
                data.PostalAddress = vm.data.PostalAddress;
                // data.FirstSaleBy = vm.data.firstsaleby;
                data.ClientZone = vm.data.selectedZoneType.value;
                data.Status = vm.data.Status;

                if (typeof (vm.data.Kycid) != 'undefined' && parseInt(vm.data.Kycid) != null) {
                    data.Kycid = vm.data.Kycid;
                    httpService.httpCall('api/closureManagement/editSingleClosureKyc', 'POST', data)
                    .then(onSuccess, onFail)

                }
            }
        }
        //var onSuccess = function () {
        //    if (typeof (stateParams.Id) != 'undefined' && parseInt(stateParams.Id) != null) {
        //        var Id = stateParams.Id;
        //        popupService.successsm('ISO Application', 'Successful Update of KYC Details');
        //        state.go('singleProposal', { Id: Id });
        //    }
        //    else
        //    {
        //        popupService.successsm('ISO Application', 'Successful Update of KYC Details');
        //        state.go('singleclosurekyc', { Kycid: vm.data.Kycid });
        //    }
        //};

        var onSuccess = function () {
            var Id;
            Id = vm.data.propid;
            if (vm.data.propid == 0) {
                popupService.successsm('ISO Application', 'Successful Update of KYC Details');
                // state.go('singleclosurekyc', { Kycid: vm.data.Kycid });
            }
            else {
                var kycidfk = vm.data.Kycid;
                popupService.successsm('ISO Application', 'Successful Update of KYC Detail');
                state.go('singleProposal', { Id: Id }, { kycidfk: kycidfk });
            }
        };

        var onFail = function () {
            popupService.errorsm('ISO Aplication', 'Server Problem');
        };

        //vm.func.goToBack = function () {
        //    state.go('qasinglekyc', { Kycid: vm.data.Kycid });
        //}


        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('ViewPropDetailsController', ViewPropDetailsController)

    ViewPropDetailsController.$inject = ['$uibModalInstance', 'httpService','$filter','detailsOfSingleProp', 'popupService', 'callBackFunction'];

    function ViewPropDetailsController(modalInstance, httpService, $filter, detailsOfSingleProp, popupService, callBack) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {


            if (typeof (detailsOfSingleProp) != 'undefined' && parseInt(detailsOfSingleProp) > 0) {
                httpService.httpCall('api/proposalMnagement/getsingleProposalDetails?Id=' + detailsOfSingleProp, 'GET', null)
                .then(function (singleProposalDetailsResponse) {

                    singleProposalDetailsResponse = JSON.parse(JSON.stringify(singleProposalDetailsResponse[0]));

                    debugger;
                    vm.data.Id = singleProposalDetailsResponse.Id;
                    vm.data.Client = singleProposalDetailsResponse.client;
                    vm.data.kycidfk = singleProposalDetailsResponse.kyc_id_fk;
                    vm.data.itemclosuredate = singleProposalDetailsResponse.closure_date;
                    vm.data.ClosureDate = $filter('date')(vm.data.itemclosuredate,"dd/MM/yyyy");


                    vm.data.SalesAgent = singleProposalDetailsResponse.sales_agent;
                    vm.data.Type = singleProposalDetailsResponse.type;
                    vm.data.Validity = singleProposalDetailsResponse.validity;
                    vm.data.IsoStandard = singleProposalDetailsResponse.standards;
                    vm.data.CB = singleProposalDetailsResponse.CB;
                    vm.data.AB = singleProposalDetailsResponse.accred_body;
                  //  vm.data.ClosureDate = singleProposalDetailsResponse.ClosureDate;
                    // vm.data.ISOStandard = detailsOfSingleProp.EnquiryStandard;
                    vm.data.Source = singleProposalDetailsResponse.source;
                    vm.data.DeliveryAgent = singleProposalDetailsResponse.delivery_agent;
                    vm.data.PaymentStatus = singleProposalDetailsResponse.payment_status;
                    vm.data.ProjectStatus = singleProposalDetailsResponse.project_status;
                  vm.data.IssueType = singleProposalDetailsResponse.certification_type;
                  vm.data.AuditType = singleProposalDetailsResponse.Audit_Type;

                  //  vm.data.Client = singleProposalDetailsResponse.Client;
          
                })
                }
        }

        vm.func.cancel = function () {
            modalInstance.dismiss('cancel');
        }
        vm.func.updateEnquiryetails = function () {
            modalInstance.close('OK');
            popupService.editEnquiry(detailsOfSingleProp, callBack);
        }

        init();
    }
})();

(function () {
  'use strict';

  angular
    .module('isoappClient')
    .controller('SingleProposalController', SingleProposalController)

  SingleProposalController.$inject = ['$stateParams', '$state', 'httpService', 'popupService', '$filter', '$window', '$rootScope'];

  function SingleProposalController(stateParams, state, httpService, popupService, $filter, $window, rootScope) {
    var vm = this;

    vm.data = {};
    vm.func = {};

    var CLDate;

    var init = function () {
      var UserData = angular.fromJson(rootScope.UserData);
      vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
      vm.data.noShowDetails = true;
      vm.data.hideDetails = false;
      vm.data.modalEnable = true;
      vm.data.itemsPerPage = 5;
      vm.data.totalItems = 0;
      vm.data.totalItemsofClosure = 0;
      vm.data.totalItemsofPayHistory = 0;
      vm.data.totalItemsofInvHistory = 0;
      vm.data.totalItemsofComment = 0;
      vm.data.HideUpdatePymt = false;
      vm.data.pagination = {
        current: 1
      };
      vm.data.paginationofClosure = {
        current: 1
      };
      vm.data.paginationofPayHistory = {
        current: 1
      };
      vm.data.paginationofInvHistory = {
        current: 1
      };
      vm.data.paginationofComment = {
        current: 1
      };

      vm.data.noShowDetails = true;
      if (typeof (stateParams.Id) != 'undefined' && parseInt(stateParams.Id) > 0) {
        vm.data.Prid = stateParams.Id;
      }

      //vm.$parent.getCommentForSingleKyc();

      if (typeof (stateParams.Id) != 'undefined' && parseInt(stateParams.Id) > 0) {
        httpService.httpCall('api/proposalMnagement/getsingleProposalDetails?Id=' + stateParams.Id, 'GET', null)
          .then(function (singleProposaResponse) {
            debugger;
            //singleProposaResponse = JSON.stringify(singleProposaResponse);
            singleProposaResponse = JSON.parse(JSON.stringify(singleProposaResponse[0]));
            //  var kyc_idd = singleProposaResponse[0]['kyc_id_fk'];
            httpService.httpCall('api/closureManagement/getCommentForSingleKyc?Kycid=' + singleProposaResponse.kyc_id_fk, 'GET', null)
              .then(getCommentForSingleKyc)

            httpService.httpCall('api/closureManagement/getPaymentHistoryForSingleKyc?Kycid=' + stateParams.Id, 'GET', null)
              .then(getPaymentHistoryForSingleKyc)

            httpService.httpCall('api/proposalMnagement/TaxInvoiceHistory?PropID=' + stateParams.Id, 'GET', null)
              .then(getAllTaxInvoice)

            if (singleProposaResponse.kyc_id_fk != null) {
              httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + singleProposaResponse.kyc_id_fk, 'GET', null)
                .then(function (response) {
                  vm.data.Kycid = response.Kyc_id;
                  vm.data.ClientName = response.Contact_Name;
                  vm.data.ContactNumber = response.Contact_Num;
                  vm.data.ContactEmail = response.Contact_Email;
                  vm.data.Designation = response.Designation;
                  vm.data.AltContactName = response.AltContact_Name;
                  vm.data.AltContactNumber = response.AltContact_Number;
                  vm.data.AltContactEmail = response.AltContact_Email;
                  vm.data.AltDesignation = response.AltDesignation
                  vm.data.CompanyName = response.Company_name;
                  vm.data.CompanyType = response.Company_Type;
                  vm.data.CompanyCity = response.Company_City;
                  vm.data.CompanyCountry = (response.Company_Country).toLowerCase();
                  vm.data.CompanyState = response.Company_State;
                  vm.data.NatureofBusiness = response.Nature_of_Business
                  vm.data.CompanyType = response.Company_Type;
                  vm.data.Turnover = response.Turnover;
                  vm.data.URL = response.URL;
                  vm.data.Landline = response.Landline;

                  // INVOICE001 - Invice btn is visible only for Indian Closures [if not comment below set of code]
                  if (vm.data.CompanyCountry == 'india') {
                    vm.data.HideInvoice = false;
                    checkCLDate();
                  } else {
                    vm.data.HideInvoice = true;
                  }
                  ////*****Update Payment Details button is visible only when Pending Amount is 0*****
                  //if (vm.data.PendingAmount == '0') {
                  //    vm.data.HideUpdatePymt = false;
                  //} else {
                  //    vm.data.HideUpdatePymt = true;
                  //}
                })
            }
            //  vm.data.Id = singleProposalResponse.Id;
            vm.data.Client = singleProposaResponse.client;
            vm.data.kycidfk = singleProposaResponse.kyc_id_fk;
            vm.data.itemclosuredate = singleProposaResponse.closure_date;
            vm.data.ClosureDate = $filter('date')(vm.data.itemclosuredate, "dd/MM/yyyy");
            vm.data.Source = singleProposaResponse.source;
            vm.data.Type = singleProposaResponse.type;
            vm.data.Validity = singleProposaResponse.validity;
            vm.data.SalesAgent = singleProposaResponse.sales_agent;
            vm.data.DeliveryAgent = singleProposaResponse.delivery_agent;
            vm.data.QaStatus = singleProposaResponse.qa_status;
            //vm.data.DeliveryAgent = angular.forEach(singleProposaResponse.delivery_agent, function (item) {
            //    if (item.delivery_agent == null || item.delivery_agent == '') {
            //        item.delivery_agent == 'NA';
            //    } else {
            //        item.delivery_agent = singleProposaResponse.delivery_agent;
            //    }
            //});
            //if (singleProposaResponse.delivery_agent == null) {
            //      vm.data.DeliveryAgent =='NA';
            //}
            //else {
            //      vm.data.DeliveryAgent = singleProposaResponse.delivery_agent;

            //}
            vm.data.IsoStandard = singleProposaResponse.standards;
            vm.data.ProjectStatus = singleProposaResponse.project_status;
            vm.data.CB = singleProposaResponse.CB;
            vm.data.AB = singleProposaResponse.accred_body;
            vm.data.PaymentStatus = singleProposaResponse.payment_status;

            //if (singleProposaResponse.payment_status== "Fresh") {
            //      vm.data.PaymentStatus =="To Be Verified";
            //}
            //else {
            //      vm.data.PaymentStatus = singleProposaResponse.payment_status;

            //}
            //vm.data.PaymentStatusAlter = angular.copy(vm.data.PaymentStatusAlter1);
            vm.data.GrossMargin = singleProposaResponse.gross_margin;
            vm.data.TotalClosure = singleProposaResponse.total_closure;
            vm.data.PendingAmount = singleProposaResponse.pending_amount;
            vm.data.ActualExpenses = singleProposaResponse.actual_expenses;
            vm.data.PaymentRecived = singleProposaResponse.payment_recived;
            vm.data.ConsultationCost = singleProposaResponse.consultation_cost;
            vm.data.CourierExpenses = singleProposaResponse.Courier_Expenses;
            vm.data.CertificationCost = singleProposaResponse.certification_cost;
            vm.data.BankCharges = singleProposaResponse.Bank_Charges;
            vm.data.CurrencyType = singleProposaResponse.currency_type;
            vm.data.TrainingCost = singleProposaResponse.training_cost;
            vm.data.TravelCost = singleProposaResponse.travel_cost;
            vm.data.OtherCost = singleProposaResponse.other_cost;
            vm.data.Surveillance = singleProposaResponse.surveillance_charges;
            vm.data.PaymentExpecteddup = singleProposaResponse.payment_expected_date;
            //  vm.data.PaymentExpecteddup = singleProposalPaymentDetailsResponse.payment_expected_date;
            vm.data.PaymentExpected = $filter('date')(vm.data.PaymentExpecteddup, "MM/dd/yyyy");
            vm.data.TotalCostinOther = singleProposaResponse.total_cost_in_other_currency;
            vm.data.Remarks = singleProposaResponse.remarks;
            vm.data.TaxAmount = singleProposaResponse.Service_Tax;
            vm.data.Accomodation = singleProposaResponse.accomodation_cost;
            vm.data.VisaCost = singleProposaResponse.visa_cost;
            vm.data.PerDmCost = singleProposaResponse.per_dm_cost;
            vm.data.Commission = singleProposaResponse.commission;
            vm.data.Miscellaneous = singleProposaResponse.other_cost;
            vm.data.SaleGM = singleProposaResponse.SaleGM;
            vm.data.DeliGM = singleProposaResponse.DeliGM;
            //vm.data.tds = singleProposaResponse.tds > 0 ? singleProposaResponse.tds : "0";
            vm.data.tds = singleProposaResponse.tds;

            // Setting session values
            localStorage.setItem('ProjectStatus', vm.data.ProjectStatus);
            localStorage.setItem('QaStatus', singleProposaResponse.qa_status);
            localStorage.setItem('kyc_id_fk', singleProposaResponse.kyc_id_fk);
            localStorage.setItem('PendingAmount', singleProposaResponse.pending_amount);

            CLDate = new Date($filter('date')(vm.data.itemclosuredate, "yyyy/MM/dd"));


          });
      }


      var getPagesforInvHistory = function () {
        vm.data.totalItemsofInvHistory = vm.data.allProposal.length;
        vm.data.paginationofInvHistory = {
          current: 1
        }
        vm.data.startofInvHistory = vm.data.paginationofInvHistory.current;
        vm.data.endofInvHistory = vm.data.startofInvHistory * vm.data.itemsPerPage;
        if (vm.data.totalItemsofInvHistory < vm.data.itemsPerPage) {
          vm.data.endofInvHistory = vm.data.totalItemsofInvHistory;
        }
      };

      var getAllTaxInvoice = function (responseForInvHistory) {
        vm.data.allProposal = responseForInvHistory;
        vm.data.allProposalData = angular.copy(vm.data.allProposal);
        getPagesforInvHistory();
      }

      // HideButtons
      if (vm.data.LogedInUserId != "Accounts1") {
        vm.data.HideButtons = true;
        vm.data.HideUpdatePymt = true;
      }


      vm.func.pageChangeofInvHistory = function () {
        var startofInvHistory = ((vm.data.paginationofInvHistory.current - 1) * vm.data.itemsPerPage)
          , endofInvHistory = startofInvHistory + vm.data.itemsPerPage;

        vm.data.startofInvHistory = startofInvHistory + 1;
        vm.data.endofInvHistory = (vm.data.totalItemsofInvHistory > endofInvHistory ? endofInvHistory : vm.data.totalItemsofInvHistory);

        vm.data.allProposalData = vm.data.allProposal.slice(startofInvHistory, endofInvHistory);
      };



    }

    var checkCLDate = function () {
      // We have given static date because PaymentClosureHistory has implemented on 2021/10/01 so....
      var StaticDate = new Date("2021/10/01");
      if (CLDate >= StaticDate) {
        vm.data.HideInvoice = false;
      } else {
        vm.data.HideInvoice = true;
      }
    }

    vm.func.activenoShowDetails = function () {
      vm.data.noShowDetails = false;
      vm.data.hideDetails = true
    }
    vm.data.editClosureKYCDetails = function (Kycid, Prid) {
      state.go('editClosureKycDetais', { Kycid: Kycid }, { Prid: Prid });
    };
    vm.data.closureReportUpdate = function () {
      popupService.updateProposalReport((stateParams.Id), refresh);
    }

    vm.data.PaymentProposalReportUpdate = function () {
      setTimeout(popUpdatePayment, 500);

      function popUpdatePayment() {
        if (vm.data.HideUpdatePymt == false) {
          popupService.updatePaymentProposalReport((stateParams.Id), refresh);
        }

      }
    }

    var refresh = function () {
      init();
    }
    vm.func.giveComment = function (Kycid) {
      popupService.addCommentsInClosure(Kycid, refresh);
    }
    vm.func.addpayment = function () {
      popupService.AddPaymentHistoryInClosure(stateParams.Id, refresh);
    }


    var getPagesforComment = function () {
      vm.data.totalItemsofComment = vm.data.commentDetailsForKyc.length;
      vm.data.paginationofComment = {
        current: 1
      }
      vm.data.startofComment = vm.data.paginationofComment.current;
      vm.data.endofComment = vm.data.startofComment * vm.data.itemsPerPage;
      if (vm.data.totalItemsofComment < vm.data.itemsPerPage) {
        vm.data.endofComment = vm.data.totalItemsofComment;
      }
    };

    var getPagesforPayHistory = function () {
      vm.data.totalItemsofPayHistory = vm.data.PaymentHistoryForKyc.length;
      vm.data.paginationofPayHistory = {
        current: 1
      }
      vm.data.startofPayHistory = vm.data.paginationofPayHistory.current;
      vm.data.endofPayHistory = vm.data.startofPayHistory * vm.data.itemsPerPage;
      if (vm.data.totalItemsofPayHistory < vm.data.itemsPerPage) {
        vm.data.endofPayHistory = vm.data.totalItemsofPayHistory;
      }
    };

    var getCommentForSingleKyc = function (responseForComments) {
      debugger;
      vm.data.commentDetailsForKyc = responseForComments;
      vm.data.commentDetailsForKycData = angular.copy(vm.data.commentDetailsForKyc);
      getPagesforComment();
    }

    var getPaymentHistoryForSingleKyc = function (responseForPayHistory) {
      debugger;

      var flag = 0;
      var i = 0;
      //alert(responseForPayHistory);
      if (responseForPayHistory != null) {
        if (responseForPayHistory.length == 0) {
          vm.data.HideUpdatePymt = true;

        } else {
          for (i = 0; i < responseForPayHistory.length; i++) {
            if (responseForPayHistory[i].VerificationStatus == "Not Verified") {
              flag = 1;
              vm.data.HideUpdatePymt = true;

            }
          }
        }
      }
      if (flag == 0 && vm.data.LogedInUserId != "Accounts1") {
        vm.data.HideUpdatePymt = false;
      }
      vm.data.PaymentHistoryForKyc = responseForPayHistory;
      vm.data.PaymentHistoryForKycData = angular.copy(vm.data.PaymentHistoryForKyc);
      getPagesforPayHistory();
    }

    vm.func.pageChangeofComment = function () {
      var startofComment = ((vm.data.paginationofComment.current - 1) * vm.data.itemsPerPage)
        , endofComment = startofComment + vm.data.itemsPerPage;

      vm.data.startofComment = startofComment + 1;
      vm.data.endofComment = (vm.data.totalItemsofComment > endofComment ? endofComment : vm.data.totalItemsofComment);

      vm.data.commentDetailsForKycData = vm.data.commentDetailsForKyc.slice(startofComment, endofComment);
    };

    vm.func.pageChangeofPayHistory = function () {
      var startofPayHistory = ((vm.data.paginationofPayHistory.current - 1) * vm.data.itemsPerPage)
        , endofPayHistory = startofPayHistory + vm.data.itemsPerPage;

      vm.data.startofPayHistory = startofPayHistory + 1;
      vm.data.endofPayHistory = (vm.data.totalItemsofPayHistory > endofPayHistory ? endofPayHistory : vm.data.totalItemsofPayHistory);

      vm.data.PaymentHistoryForKycData = vm.data.PaymentHistoryForKyc.slice(startofPayHistory, endofPayHistory);
    };

    vm.data.getSinglePaymentDetails = function (PHID) {
      if (vm.data.LogedInUserId == "Accounts1") {
        var PMID = 0;
        popupService.AddPaymentHistoryInClosure(PMID, PHID, refresh);
      }
    }

    vm.func.GenerateInvoive = function () {
      var id = "";
      $("input:checked").each(function () {
        id += $(this).attr("id") + ",";
      });

      if (id != "" && id != undefined) {
        sessionStorage.setItem('PHID', id);
        sessionStorage.setItem('PMID', stateParams.Id);
        var url = state.href('TaxInvoice');
        $window.open(url);
      }
      else {
        alert("Atleast click on one CheckBox!");
      }

     
    }
    init();
  }

})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('AllProposalController', AllProposalController)

    AllProposalController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

    function AllProposalController(httpService, $filter, state, $window, popupService) {//, popupService
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
           // vm.data.pendingzero = 0;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };
            
            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforPaymentStatus', 'GET', null)
         .then(function (response) {
             vm.data.getPaymentStatus = response;
         })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function(response){
                vm.data.getallCompanyName=response;
            })



            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            //httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
           // .then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/GetAllFreshProposalDetail', 'GET', null)
            .then(getAllFreshProposal)

            httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET',null)
                .then(function (response) {
                    vm.data.pendingid = response.Id;
                    if (vm.data.pendingid > 0) {
                        vm.data.pendingzero = 1;
                    }
                    else {
                        vm.data.pendingzero = 0;
                    }

                })
            
               
            
          
        }
      //  var orderbyComp = $filter('orderby')(vm.data.getallCompanyName, getCompanyOnly);
        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    getPages();
        //}
       
        //var getAllFreshProposal = function (response) {
        //    vm.data.allProposal = response;
          
        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    getPages();
        //}
        var getAllFreshProposal = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }
      

        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };
       

        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            sortData.PaymentStatus = vm.data.PayStatus;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


           // sortData.Fromdate = vm.data.FromDate;
        //    sortData.Todate = vm.data.ToDate;

            httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        vm.data.getSingleProposalDetails = function (Id, Kycidfk) {
            //state.go('singleProposal', { Id: Id });

            var url = state.href('singleProposal', { Id: Id }, { Kycidfk: Kycidfk });
            $window.open(url);
        }

        vm.func.addNewProposal = function () {
            popupService.addProposal();
        }

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.PayStatus = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
	'use strict';

	angular
    .module('isoappClient')
    .controller('ReconciledDetailController', ReconciledDetailController)

	ReconciledDetailController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

	function ReconciledDetailController(httpService, $filter, state, $window, popupService) {//, popupService
		var vm = this;

		vm.data = {};
		vm.func = {};

		var init = function () {

			//vm.data.selectMonth = [
			//    { value: 'Select' },
			//    { value: 'January' },
			//    { value: 'February' },
			//    { value: 'March' },
			//    { value: 'April' },
			//    { value: 'May' },
			//    { value: 'June' },
			//    { value: 'July' },
			//    { value: 'August' },
			//    { value: 'September' },
			//    { value: 'October' },
			//    { value: 'November' },
			//    { value: 'December' }
			//];

			//vm.data.selectYear = [
			//{ value: 'Select' },
			//{ value: '2013' },
			//{ value: '2014' },
			//{ value: '2015' },
			//{ value: '2016' },
			//{ value: '2017' },

			//];
			//vm.data.Zonedata = [
			//    { value: 'Select' },
			//    { value: 'BMC' },
			//    { value: 'OMUAE' },
			//    { value: 'Rest of India' },
			//    { value: 'Rest of World' }
			//];
			// vm.data.pendingzero = 0;
			vm.data.searchProposal = false;
			vm.data.itemsPerPage = 10;
			vm.data.totalItems = 0;
			vm.data.pagination = {
				current: 1
			};

			//vm.data.selectedYear = vm.data.selectYear[0];
			//vm.data.selectedMonth = vm.data.selectMonth[0];

			//vm.data.Zone = vm.data.Zonedata;

			httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
            	vm.data.getAgentName = response;
            })

			//httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
			//.then(function (response) {
			//    vm.data.getZoneData = response;
			//})
			httpService.httpCall('api/proposalMnagement/suggestforPaymentStatus', 'GET', null)
         .then(function (response) {
         	vm.data.getPaymentStatus = response;
         })

			httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
            	vm.data.getallCompanyName = response;
            })



			//httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
			//.then(getAllProposal)

			//httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
			// .then(getAllProposal)

			httpService.httpCall('api/proposalMnagement/ReconciledDetail', 'GET', null)
            .then(getAllFreshProposal)

			httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET', null)
                .then(function (response) {
                	vm.data.pendingid = response.Id;
                	if (vm.data.pendingid > 0) {
                		vm.data.pendingzero = 1;
                	}
                	else {
                		vm.data.pendingzero = 0;
                	}

                })




		}
		//  var orderbyComp = $filter('orderby')(vm.data.getallCompanyName, getCompanyOnly);
		//var getAllProposal = function (response) {
		//    vm.data.allProposal = response;
		//    vm.data.allProposalData = angular.copy(vm.data.allProposal);
		//    getPages();
		//}

		//var getAllFreshProposal = function (response) {
		//    vm.data.allProposal = response;

		//    vm.data.allProposalData = angular.copy(vm.data.allProposal);
		//    getPages();
		//}
		var getAllFreshProposal = function (response) {
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}


		var getPages = function () {
			vm.data.totalItems = vm.data.allProposal.length;
			vm.data.pagination = {
				current: 1
			}
			vm.data.start = vm.data.pagination.current;
			vm.data.end = vm.data.start * vm.data.itemsPerPage;
			if (vm.data.totalItems < vm.data.itemsPerPage) {
				vm.data.end = vm.data.totalItems;
			}
		};


		//vm.func.sortByMonthYear = function () {
		//    var sortdata = {};
		//    sortdata.year = vm.data.selectedYear;
		//    sortdata.month = vm.data.selectedMonth;

		//    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
		//    .then(successSearch)
		//}


		vm.func.searchby = function () {
			var sortData = {};
			//sortData.Zone = vm.data.Zonedata;
			sortData.Agent = vm.data.AgentName;
			sortData.PaymentStatus = vm.data.PayStatus;
			var nosofdays = 0;

			//vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
			//vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

			//vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
			//vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

			//sortData.Fromdate = vm.data.fromDateformate;
			//sortData.Todate = vm.data.toDateformate;


			if (vm.data.FromDate != null && vm.data.ToDate != null) {
				vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
				vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

				vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
				vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

				sortData.Fromdate = vm.data.fromDateformate;
				sortData.Todate = vm.data.toDateformate;

			}
			else {
				sortData.Fromdate = vm.data.FromDate;
				sortData.Todate = vm.data.ToDate;
			}


			// sortData.Fromdate = vm.data.FromDate;
			//    sortData.Todate = vm.data.ToDate;

			httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
            .then(successSearchsorted)
		}

		var successSearchsorted = function (response) {
			vm.data.searchProposal = true;
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}


		vm.func.pageChange = function () {
			var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

			vm.data.start = start + 1;
			vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

			vm.data.allProposalData = vm.data.allProposal.slice(start, end);
		};

		vm.data.getSingleProposalDetails = function (Id, Kycidfk) {
			//state.go('singleProposal', { Id: Id });

			var url = state.href('singleProposal', { Id: Id }, { Kycidfk: Kycidfk });
			$window.open(url);
		}

		vm.func.addNewProposal = function () {
			popupService.addProposal();
		}

		vm.func.searchProposalData = function () {

		    var format = /&/;

		    if (format.test(vm.data.CompanyName)) {

		        var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

		    } else {

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

		    }

		}

		var successSearch = function (response) {
			vm.data.searchProposal = true;
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}

		vm.func.refresh = function () {
			vm.data.CompanyName = '';
			vm.data.PayStatus = '';
			vm.data.AgentName = '';
			vm.data.Fromdate = '';
			vm.data.Todate = '';
			init();
		}

		init();
	}
})();
(function () {
	'use strict';

	angular
    .module('isoappClient')
    .controller('PendingPropsalDetailController', PendingPropsalDetailController)

	PendingPropsalDetailController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

	function PendingPropsalDetailController(httpService, $filter, state, $window, popupService) {//, popupService
		var vm = this;

		vm.data = {};
		vm.func = {};

		var init = function () {

			//vm.data.selectMonth = [
			//    { value: 'Select' },
			//    { value: 'January' },
			//    { value: 'February' },
			//    { value: 'March' },
			//    { value: 'April' },
			//    { value: 'May' },
			//    { value: 'June' },
			//    { value: 'July' },
			//    { value: 'August' },
			//    { value: 'September' },
			//    { value: 'October' },
			//    { value: 'November' },
			//    { value: 'December' }
			//];

			//vm.data.selectYear = [
			//{ value: 'Select' },
			//{ value: '2013' },
			//{ value: '2014' },
			//{ value: '2015' },
			//{ value: '2016' },
			//{ value: '2017' },

			//];
			//vm.data.Zonedata = [
			//    { value: 'Select' },
			//    { value: 'BMC' },
			//    { value: 'OMUAE' },
			//    { value: 'Rest of India' },
			//    { value: 'Rest of World' }
			//];
			// vm.data.pendingzero = 0;
			vm.data.searchProposal = false;
			vm.data.itemsPerPage = 10;
			vm.data.totalItems = 0;
			vm.data.pagination = {
				current: 1
			};

			//vm.data.selectedYear = vm.data.selectYear[0];
			//vm.data.selectedMonth = vm.data.selectMonth[0];

			//vm.data.Zone = vm.data.Zonedata;

			httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
            	vm.data.getAgentName = response;
            })

			//httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
			//.then(function (response) {
			//    vm.data.getZoneData = response;
			//})
			httpService.httpCall('api/proposalMnagement/suggestforPaymentStatus', 'GET', null)
         .then(function (response) {
         	vm.data.getPaymentStatus = response;
         })

			httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
            	vm.data.getallCompanyName = response;
            })



			//httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
			//.then(getAllProposal)

			//httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
			// .then(getAllProposal)

			httpService.httpCall('api/proposalMnagement/PendingPropsalDetail', 'GET', null)
            .then(getAllFreshProposal)

			httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET', null)
                .then(function (response) {
                	vm.data.pendingid = response.Id;
                	if (vm.data.pendingid > 0) {
                		vm.data.pendingzero = 1;
                	}
                	else {
                		vm.data.pendingzero = 0;
                	}

                })




		}
		//  var orderbyComp = $filter('orderby')(vm.data.getallCompanyName, getCompanyOnly);
		//var getAllProposal = function (response) {
		//    vm.data.allProposal = response;
		//    vm.data.allProposalData = angular.copy(vm.data.allProposal);
		//    getPages();
		//}

		//var getAllFreshProposal = function (response) {
		//    vm.data.allProposal = response;

		//    vm.data.allProposalData = angular.copy(vm.data.allProposal);
		//    getPages();
		//}
		var getAllFreshProposal = function (response) {
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}


		var getPages = function () {
			vm.data.totalItems = vm.data.allProposal.length;
			vm.data.pagination = {
				current: 1
			}
			vm.data.start = vm.data.pagination.current;
			vm.data.end = vm.data.start * vm.data.itemsPerPage;
			if (vm.data.totalItems < vm.data.itemsPerPage) {
				vm.data.end = vm.data.totalItems;
			}
		};


		//vm.func.sortByMonthYear = function () {
		//    var sortdata = {};
		//    sortdata.year = vm.data.selectedYear;
		//    sortdata.month = vm.data.selectedMonth;

		//    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
		//    .then(successSearch)
		//}


		vm.func.searchby = function () {
			var sortData = {};
			//sortData.Zone = vm.data.Zonedata;
			sortData.Agent = vm.data.AgentName;
			sortData.PaymentStatus = vm.data.PayStatus;
			var nosofdays = 0;

			//vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
			//vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

			//vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
			//vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

			//sortData.Fromdate = vm.data.fromDateformate;
			//sortData.Todate = vm.data.toDateformate;


			if (vm.data.FromDate != null && vm.data.ToDate != null) {
				vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
				vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

				vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
				vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

				sortData.Fromdate = vm.data.fromDateformate;
				sortData.Todate = vm.data.toDateformate;

			}
			else {
				sortData.Fromdate = vm.data.FromDate;
				sortData.Todate = vm.data.ToDate;
			}


			// sortData.Fromdate = vm.data.FromDate;
			//    sortData.Todate = vm.data.ToDate;

			httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
            .then(successSearchsorted)
		}

		var successSearchsorted = function (response) {
			vm.data.searchProposal = true;
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}


		vm.func.pageChange = function () {
			var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

			vm.data.start = start + 1;
			vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

			vm.data.allProposalData = vm.data.allProposal.slice(start, end);
		};

		vm.data.getSingleProposalDetails = function (Id, Kycidfk) {
			//state.go('singleProposal', { Id: Id });

			var url = state.href('singleProposal', { Id: Id }, { Kycidfk: Kycidfk });
			$window.open(url);
		}

		vm.func.addNewProposal = function () {
			popupService.addProposal();
		}

		vm.func.searchProposalData = function () {

		    var format = /&/;

		    if (format.test(vm.data.CompanyName)) {

		        var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

		    } else {

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

		    }

		}

		var successSearch = function (response) {
			vm.data.searchProposal = true;
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}

		vm.func.refresh = function () {
			vm.data.CompanyName = '';
			vm.data.PayStatus = '';
			vm.data.AgentName = '';
			vm.data.Fromdate = '';
			vm.data.Todate = '';
			init();
		}

		init();
	}
})();
(function () {
    'use strict';

    angular
        .module('isoappClient')
        .controller('PaymentHistoryController', PaymentHistoryController)

    PaymentHistoryController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

    function PaymentHistoryController(httpService, $filter, state, $window, popupService) {//, popupService
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
                .then(function (response) {
                    vm.data.getAgentName = response;
                })

            var Status = ["Verified", "Not Verified"];
            vm.data.getPaymentStatus = Status;

            var BkTy = ["India", "UAE", "Oman", "Qatar", "Bahrain", "South Africa", "Nigeria", "Others"];
            vm.data.getBankType = BkTy;

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
                .then(function (response) {
                    vm.data.getallCompanyName = response;
                })

            httpService.httpCall('api/proposalMnagement/PaymentHistory?SortByAddedDate=No', 'GET', null)
                .then(getAllNewClosures)

            httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET', null)
                .then(function (response) {
                    vm.data.pendingid = response.Id;
                    if (vm.data.pendingid > 0) {
                        vm.data.pendingzero = 1;
                    }
                    else {
                        vm.data.pendingzero = 0;
                    }

                })




        }

        var getAllNewClosures = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        vm.func.searchby = function () {
            var sortData = {};
            sortData.AgentName = vm.data.AgentName;
            sortData.PaymentStatus = vm.data.PayStatus;
            sortData.IsCompSearch = "NO";
            sortData.BankType = vm.data.BankType;
            sortData.CompanyName = "NoSearch";

            var nosofdays = 0;

            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.FromDate = vm.data.fromDateformate;
                sortData.ToDate = vm.data.toDateformate;

            }
            else {
                sortData.FromDate = vm.data.FromDate;
                sortData.ToDate = vm.data.ToDate;
            }
            // alert(sortData.AgentName);
            // alert(sortData.PaymentStatus);
            // alert(sortData.CompanyName);
            // alert(sortData.BankType);
            // alert(sortData.FromDate);;
            // alert(sortData.ToDate);

            httpService.httpCall('api/proposalMnagement/SearchPaymentHistory', 'POST', sortData)
                .then(successSearchsorted);
        }

        vm.func.SortByAddedDate = function(){
            httpService.httpCall('api/proposalMnagement/PaymentHistory?SortByAddedDate=Yes', 'GET', null)
                .then(getAllNewClosures)
        }

        vm.func.SortByReceivedDate = function(){
            httpService.httpCall('api/proposalMnagement/PaymentHistory?SortByAddedDate=No', 'GET', null)
                .then(getAllNewClosures)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        var OnFail = function () {
            alert("Fail");
        }

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
                , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        vm.func.addNewProposal = function () {
            popupService.addProposal();
        }

        vm.func.searchProposalData = function () {

            var data = {};
            data.CompanyName = vm.data.CompanyName;
            data.IsCompSearch = "YES";

            if (data.CompanyName == undefined) {
                data.CompanyName = "";
            }

            var Params = data;
            httpService.httpCall('api/proposalMnagement/SearchPaymentHistory', 'POST', Params)
                .then(successSearch);
        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.PayStatus = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            vm.data.BankType = '';
            init();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('NewClosureController', NewClosureController)

    NewClosureController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

    function NewClosureController(httpService, $filter, state, $window, popupService) {//, popupService
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
            // vm.data.pendingzero = 0;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforPaymentStatus', 'GET', null)
         .then(function (response) {
             vm.data.getPaymentStatus = response;
         })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })



            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            //httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
            // .then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/NewClosureDetails', 'GET', null)
            .then(getAllNewClosures)

            httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET', null)
                .then(function (response) {
                    vm.data.pendingid = response.Id;
                    if (vm.data.pendingid > 0) {
                        vm.data.pendingzero = 1;
                    }
                    else {
                        vm.data.pendingzero = 0;
                    }

                })




        }
        //  var orderbyComp = $filter('orderby')(vm.data.getallCompanyName, getCompanyOnly);
        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    getPages();
        //}

        var getAllNewClosures = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            sortData.PaymentStatus = vm.data.PayStatus;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        vm.data.getSingleProposalDetails = function (Id, Kycidfk) {
            //state.go('singleProposal', { Id: Id });

            var url = state.href('singleProposal', { Id: Id }, { Kycidfk: Kycidfk });
            $window.open(url);
        }

        vm.func.addNewProposal = function () {
            popupService.addProposal();
        }

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.PayStatus = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();

(function () {
	'use strict';

	angular
    .module('isoappClient')
    .controller('InitialPropsalDetailController', InitialPropsalDetailController)

	InitialPropsalDetailController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

	function InitialPropsalDetailController(httpService, $filter, state, $window, popupService) {//, popupService
		var vm = this;

		vm.data = {};
		vm.func = {};

		var init = function () {

			//vm.data.selectMonth = [
			//    { value: 'Select' },
			//    { value: 'January' },
			//    { value: 'February' },
			//    { value: 'March' },
			//    { value: 'April' },
			//    { value: 'May' },
			//    { value: 'June' },
			//    { value: 'July' },
			//    { value: 'August' },
			//    { value: 'September' },
			//    { value: 'October' },
			//    { value: 'November' },
			//    { value: 'December' }
			//];

			//vm.data.selectYear = [
			//{ value: 'Select' },
			//{ value: '2013' },
			//{ value: '2014' },
			//{ value: '2015' },
			//{ value: '2016' },
			//{ value: '2017' },

			//];
			//vm.data.Zonedata = [
			//    { value: 'Select' },
			//    { value: 'BMC' },
			//    { value: 'OMUAE' },
			//    { value: 'Rest of India' },
			//    { value: 'Rest of World' }
			//];
			// vm.data.pendingzero = 0;
			vm.data.searchProposal = false;
			vm.data.itemsPerPage = 10;
			vm.data.totalItems = 0;
			vm.data.pagination = {
				current: 1
			};

			//vm.data.selectedYear = vm.data.selectYear[0];
			//vm.data.selectedMonth = vm.data.selectMonth[0];

			//vm.data.Zone = vm.data.Zonedata;

			httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
            	vm.data.getAgentName = response;
            })

			//httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
			//.then(function (response) {
			//    vm.data.getZoneData = response;
			//})
			httpService.httpCall('api/proposalMnagement/suggestforPaymentStatus', 'GET', null)
         .then(function (response) {
         	vm.data.getPaymentStatus = response;
         })

			httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
            	vm.data.getallCompanyName = response;
            })



			//httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
			//.then(getAllProposal)

			//httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
			// .then(getAllProposal)

			httpService.httpCall('api/proposalMnagement/InitialPropsalDetail', 'GET', null)
            .then(getAllFreshProposal)

			httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET', null)
                .then(function (response) {
                	vm.data.pendingid = response.Id;
                	if (vm.data.pendingid > 0) {
                		vm.data.pendingzero = 1;
                	}
                	else {
                		vm.data.pendingzero = 0;
                	}

                })




		}
		//  var orderbyComp = $filter('orderby')(vm.data.getallCompanyName, getCompanyOnly);
		//var getAllProposal = function (response) {
		//    vm.data.allProposal = response;
		//    vm.data.allProposalData = angular.copy(vm.data.allProposal);
		//    getPages();
		//}

		//var getAllFreshProposal = function (response) {
		//    vm.data.allProposal = response;

		//    vm.data.allProposalData = angular.copy(vm.data.allProposal);
		//    getPages();
		//}
		var getAllFreshProposal = function (response) {
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}


		var getPages = function () {
			vm.data.totalItems = vm.data.allProposal.length;
			vm.data.pagination = {
				current: 1
			}
			vm.data.start = vm.data.pagination.current;
			vm.data.end = vm.data.start * vm.data.itemsPerPage;
			if (vm.data.totalItems < vm.data.itemsPerPage) {
				vm.data.end = vm.data.totalItems;
			}
		};


		//vm.func.sortByMonthYear = function () {
		//    var sortdata = {};
		//    sortdata.year = vm.data.selectedYear;
		//    sortdata.month = vm.data.selectedMonth;

		//    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
		//    .then(successSearch)
		//}


		vm.func.searchby = function () {
			var sortData = {};
			//sortData.Zone = vm.data.Zonedata;
			sortData.Agent = vm.data.AgentName;
			sortData.PaymentStatus = vm.data.PayStatus;
			var nosofdays = 0;

			//vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
			//vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

			//vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
			//vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

			//sortData.Fromdate = vm.data.fromDateformate;
			//sortData.Todate = vm.data.toDateformate;


			if (vm.data.FromDate != null && vm.data.ToDate != null) {
				vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
				vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

				vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
				vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

				sortData.Fromdate = vm.data.fromDateformate;
				sortData.Todate = vm.data.toDateformate;

			}
			else {
				sortData.Fromdate = vm.data.FromDate;
				sortData.Todate = vm.data.ToDate;
			}


			// sortData.Fromdate = vm.data.FromDate;
			//    sortData.Todate = vm.data.ToDate;

			httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
            .then(successSearchsorted)
		}

		var successSearchsorted = function (response) {
			vm.data.searchProposal = true;
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}


		vm.func.pageChange = function () {
			var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

			vm.data.start = start + 1;
			vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

			vm.data.allProposalData = vm.data.allProposal.slice(start, end);
		};

		vm.data.getSingleProposalDetails = function (Id, Kycidfk) {
			//state.go('singleProposal', { Id: Id });

			var url = state.href('singleProposal', { Id: Id }, { Kycidfk: Kycidfk });
			$window.open(url);
		}

		vm.func.addNewProposal = function () {
			popupService.addProposal();
		}

		vm.func.searchProposalData = function () {

		    var format = /&/;

		    if (format.test(vm.data.CompanyName)) {

		        var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

		    } else {

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

		    }

		}
		var successSearch = function (response) {
			vm.data.searchProposal = true;
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}

		vm.func.refresh = function () {
			vm.data.CompanyName = '';
			vm.data.PayStatus = '';
			vm.data.AgentName = '';
			vm.data.Fromdate = '';
			vm.data.Todate = '';
			init();
		}

		init();
	}
})();
(function () {
	'use strict';

	angular
    .module('isoappClient')
    .controller('PayedPropsalDetailController', PayedPropsalDetailController)

	PayedPropsalDetailController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

	function PayedPropsalDetailController(httpService, $filter, state, $window, popupService) {//, popupService
		var vm = this;

		vm.data = {};
		vm.func = {};

		var init = function () {

			//vm.data.selectMonth = [
			//    { value: 'Select' },
			//    { value: 'January' },
			//    { value: 'February' },
			//    { value: 'March' },
			//    { value: 'April' },
			//    { value: 'May' },
			//    { value: 'June' },
			//    { value: 'July' },
			//    { value: 'August' },
			//    { value: 'September' },
			//    { value: 'October' },
			//    { value: 'November' },
			//    { value: 'December' }
			//];

			//vm.data.selectYear = [
			//{ value: 'Select' },
			//{ value: '2013' },
			//{ value: '2014' },
			//{ value: '2015' },
			//{ value: '2016' },
			//{ value: '2017' },

			//];
			//vm.data.Zonedata = [
			//    { value: 'Select' },
			//    { value: 'BMC' },
			//    { value: 'OMUAE' },
			//    { value: 'Rest of India' },
			//    { value: 'Rest of World' }
			//];
			// vm.data.pendingzero = 0;
			vm.data.searchProposal = false;
			vm.data.itemsPerPage = 10;
			vm.data.totalItems = 0;
			vm.data.pagination = {
				current: 1
			};

			//vm.data.selectedYear = vm.data.selectYear[0];
			//vm.data.selectedMonth = vm.data.selectMonth[0];

			//vm.data.Zone = vm.data.Zonedata;

			httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
            	vm.data.getAgentName = response;
            })

			//httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
			//.then(function (response) {
			//    vm.data.getZoneData = response;
			//})
			httpService.httpCall('api/proposalMnagement/suggestforPaymentStatus', 'GET', null)
         .then(function (response) {
         	vm.data.getPaymentStatus = response;
         })

			httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
            	vm.data.getallCompanyName = response;
            })



			//httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
			//.then(getAllProposal)

			//httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
			// .then(getAllProposal)

			httpService.httpCall('api/proposalMnagement/PayedPropsalDetail', 'GET', null)
            .then(getAllFreshProposal)

			httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET', null)
                .then(function (response) {
                	vm.data.pendingid = response.Id;
                	if (vm.data.pendingid > 0) {
                		vm.data.pendingzero = 1;
                	}
                	else {
                		vm.data.pendingzero = 0;
                	}

                })




		}
		//  var orderbyComp = $filter('orderby')(vm.data.getallCompanyName, getCompanyOnly);
		//var getAllProposal = function (response) {
		//    vm.data.allProposal = response;
		//    vm.data.allProposalData = angular.copy(vm.data.allProposal);
		//    getPages();
		//}

		//var getAllFreshProposal = function (response) {
		//    vm.data.allProposal = response;

		//    vm.data.allProposalData = angular.copy(vm.data.allProposal);
		//    getPages();
		//}
		var getAllFreshProposal = function (response) {
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}


		var getPages = function () {
			vm.data.totalItems = vm.data.allProposal.length;
			vm.data.pagination = {
				current: 1
			}
			vm.data.start = vm.data.pagination.current;
			vm.data.end = vm.data.start * vm.data.itemsPerPage;
			if (vm.data.totalItems < vm.data.itemsPerPage) {
				vm.data.end = vm.data.totalItems;
			}
		};


		//vm.func.sortByMonthYear = function () {
		//    var sortdata = {};
		//    sortdata.year = vm.data.selectedYear;
		//    sortdata.month = vm.data.selectedMonth;

		//    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
		//    .then(successSearch)
		//}


		vm.func.searchby = function () {
			var sortData = {};
			//sortData.Zone = vm.data.Zonedata;
			sortData.Agent = vm.data.AgentName;
			sortData.PaymentStatus = vm.data.PayStatus;
			var nosofdays = 0;

			//vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
			//vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

			//vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
			//vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

			//sortData.Fromdate = vm.data.fromDateformate;
			//sortData.Todate = vm.data.toDateformate;


			if (vm.data.FromDate != null && vm.data.ToDate != null) {
				vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
				vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

				vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
				vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

				sortData.Fromdate = vm.data.fromDateformate;
				sortData.Todate = vm.data.toDateformate;

			}
			else {
				sortData.Fromdate = vm.data.FromDate;
				sortData.Todate = vm.data.ToDate;
			}


			// sortData.Fromdate = vm.data.FromDate;
			//    sortData.Todate = vm.data.ToDate;

			httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
            .then(successSearchsorted)
		}

		var successSearchsorted = function (response) {
			vm.data.searchProposal = true;
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}


		vm.func.pageChange = function () {
			var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

			vm.data.start = start + 1;
			vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

			vm.data.allProposalData = vm.data.allProposal.slice(start, end);
		};

		vm.data.getSingleProposalDetails = function (Id, Kycidfk) {
			//state.go('singleProposal', { Id: Id });

			var url = state.href('singleProposal', { Id: Id }, { Kycidfk: Kycidfk });
			$window.open(url);
		}

		vm.func.addNewProposal = function () {
			popupService.addProposal();
		}

		vm.func.searchProposalData = function () {

		    var format = /&/;

		    if (format.test(vm.data.CompanyName)) {

		        var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

		    } else {

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

		    }

		}

		var successSearch = function (response) {
			vm.data.searchProposal = true;
			vm.data.allProposal = response;
			vm.data.allProposalData = angular.copy(vm.data.allProposal);
			getPages();
		}

		vm.func.refresh = function () {
			vm.data.CompanyName = '';
			vm.data.PayStatus = '';
			vm.data.AgentName = '';
			vm.data.Fromdate = '';
			vm.data.Todate = '';
			init();
		}

		init();
	}
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('FreshProposalController', FreshProposalController)

    FreshProposalController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

    function FreshProposalController(httpService, $filter, state, $window, popupService) {//, popupService
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
            // vm.data.pendingzero = 0;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforPaymentStatus', 'GET', null)
         .then(function (response) {
             vm.data.getPaymentStatus = response;
         })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })



            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            //httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
            // .then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/FreshProposalDetail', 'GET', null)
            .then(getAllFreshProposal)

            httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET', null)
                .then(function (response) {
                    vm.data.pendingid = response.Id;
                    if (vm.data.pendingid > 0) {
                        vm.data.pendingzero = 1;
                    }
                    else {
                        vm.data.pendingzero = 0;
                    }

                })




        }
        //  var orderbyComp = $filter('orderby')(vm.data.getallCompanyName, getCompanyOnly);
        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    getPages();
        //}

        //var getAllFreshProposal = function (response) {
        //    vm.data.allProposal = response;

        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    getPages();
        //}
        var getAllFreshProposal = function (response) {
            //alert(response.PaymentDate);
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            sortData.PaymentStatus = vm.data.PayStatus;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        vm.data.getSingleProposalDetails = function (Id, Kycidfk) {
            //state.go('singleProposal', { Id: Id });

            var url = state.href('singleProposal', { Id: Id }, { Kycidfk: Kycidfk });
            $window.open(url);
        }

        vm.func.addNewProposal = function () {
            popupService.addProposal();
        }

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.PayStatus = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('DelayedProjectsController', DelayedProjectsController)

    DelayedProjectsController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

    function DelayedProjectsController(httpService, $filter, state, $window, popupService) {//, popupService
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
            // vm.data.pendingzero = 0;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforPaymentStatus', 'GET', null)
         .then(function (response) {
             vm.data.getPaymentStatus = response;
         })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })



            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            //httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
            // .then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/GetDelayedProject', 'GET', null)
            .then(GetDelayedProject)

            httpService.httpCall('api/proposalMnagement/GetPendingList', 'GET', null)
                .then(function (response) {
                    vm.data.pendingid = response.Id;
                    if (vm.data.pendingid > 0) {
                        vm.data.pendingzero = 1;
                    }
                    else {
                        vm.data.pendingzero = 0;
                    }

                })




        }
        //  var orderbyComp = $filter('orderby')(vm.data.getallCompanyName, getCompanyOnly);
        //var getAllProposal = function (response) {
        //    vm.data.allProposal = response;
        //    vm.data.allProposalData = angular.copy(vm.data.allProposal);
        //    getPages();
        //}

        var GetDelayedProject = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            sortData.PaymentStatus = vm.data.PayStatus;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            httpService.httpCall('api/proposalMnagement/searchby', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        vm.data.getSingleProposalDetails = function (Id, Kycidfk) {
            //state.go('singleProposal', { Id: Id });

            var url = state.href('singleProposal', { Id: Id }, { Kycidfk: Kycidfk });
            $window.open(url);
        }

        vm.func.addNewProposal = function () {
            popupService.addProposal();
        }

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.PayStatus = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function() {
  'use strict';

  angular
    .module('isoappClient')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['httpService', '$state', '$rootScope', 'localstorageService', 'authService']

  function LoginController(httpService, state, rootScope, localstorageService, authService) {

      var vm = this;

      vm.data = [];
      vm.func = [];

      vm.func.login = function (valid) {
          if (valid) {
              var loginInfo = {};
              loginInfo.Username = vm.data.username;
              loginInfo.Password = vm.data.password;
              authService.authentication(loginInfo);
           //   state.go('NavbarController', { loginInfo: loginInfo });
          }
      }

      var init = function () {

      }

      init();
  }

})();

(function () {
    'use strict';

    angular
        .module('isoappClient')
        .controller('TaxInvoiceHistoryController', TaxInvoiceHistoryController)

    TaxInvoiceHistoryController.$inject = ['httpService', '$filter', '$state', '$window', 'popupService'];//'popupService'

    function TaxInvoiceHistoryController(httpService, $filter, state, $window, popupService) {//, popupService
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            httpService.httpCall('api/proposalMnagement/InvoiceRef', 'GET', null)
                .then(function (response) {
                    vm.data.getallInvoiceReference = response;
                })
           
            httpService.httpCall('api/proposalMnagement/ClientNameLstForSRH', 'GET', null)
                .then(function (response) {
                    vm.data.getallCompanyName = response;
                })

            httpService.httpCall('api/proposalMnagement/TaxInvoiceHistory?PropID=0', 'GET', null)
                .then(getAllTaxInvoice)

        }

        var getAllTaxInvoice = function (response) {
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        vm.func.searchby = function () {
            var sortData = {};
            sortData.Reference = vm.data.Reference;
            sortData.IsCompSearch = "NO";
            sortData.CompanyName = "NoSearch";

            var nosofdays = 0;

            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.FromDate = vm.data.fromDateformate;
                sortData.ToDate = vm.data.toDateformate;

            }
            else {
                sortData.FromDate = vm.data.FromDate;
                sortData.ToDate = vm.data.ToDate;
            }

            httpService.httpCall('api/proposalMnagement/SearchTaxInvoiceHistory', 'POST', sortData)
                .then(successSearchsorted);
        }

        // vm.func.SortByAddedDate = function(){
        //     httpService.httpCall('api/proposalMnagement/PaymentHistory?SortByAddedDate=Yes', 'GET', null)
        //         .then(getAllTaxInvoice)
        // }

        // vm.func.SortByReceivedDate = function(){
        //     httpService.httpCall('api/proposalMnagement/PaymentHistory?SortByAddedDate=No', 'GET', null)
        //         .then(getAllTaxInvoice)
        // }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        var OnFail = function () {
            alert("Fail");
        }

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
                , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        vm.func.addNewProposal = function () {
            popupService.addProposal();
        }

        vm.func.searchProposalData = function () {

            var data = {};
            data.CompanyName = vm.data.CompanyName;
            data.IsCompSearch = "YES";

            if (data.CompanyName == undefined) {
                data.CompanyName = "";
            }

            var Params = data;
            httpService.httpCall('api/proposalMnagement/SearchTaxInvoiceHistory', 'POST', Params)
                .then(successSearch);
        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Reference = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
        .module('isoappClient')
        .controller('TaxInvoiceController', TaxInvoiceController)


    TaxInvoiceController.$inject = ['$stateParams', 'httpService', '$filter', '$state', '$window', 'popupService', '$scope'];//'popupService'

    function TaxInvoiceController(stateParams, httpService, $filter, state, $window, popupService, $scope) {//, popupService
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            var PHID = sessionStorage.getItem("PHID");
            var PMID = sessionStorage.getItem("PMID");

            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams != "") {
                vm.data.ClientName = urlParams.get('ClientName');
                vm.data.Address = urlParams.get('Address');
                vm.data.Country = urlParams.get('Country');
                vm.data.State = urlParams.get('State');
                vm.data.GSTIN = urlParams.get('GSTIN');
                vm.data.Code = urlParams.get('Code');
                vm.data.TDSVal = urlParams.get('TDS');
                vm.data.ClosureValue = urlParams.get('ClosureValue');
                vm.data.ProjectValue = urlParams.get('ProjectValue');
                vm.data.InvoiceSequence = urlParams.get('InvoiceSequence');
                vm.data.GSTAmount = urlParams.get('GSTAmount');
                vm.data.TaxableAmount = urlParams.get('TaxableAmount');
                vm.data.DescriptionOne = urlParams.get('Description1');
                vm.data.AmountOne = urlParams.get('TaxableValue1');
                vm.data.DescriptionTwo = urlParams.get('Description2');
                vm.data.AmountTwo = urlParams.get('TaxableValue2');
                //vm.data.InvoiceRef = urlParams.get('InvoiceReference');
                vm.data.InvRefNoStatic = urlParams.get('InvRefNoStatic');

                if (vm.data.AmountTwo == "" || vm.data.AmountTwo == undefined) {
                    vm.data.AmountTwo = 0;
                }

                vm.data.AmountOne = parseFloat(vm.data.AmountOne).toFixed(2);
                vm.data.Amount = Math.round(vm.data.AmountOne).toLocaleString("en-IN", { minimumFractionDigits: 2 });
                vm.data.AmountTwo = parseFloat(vm.data.AmountTwo).toFixed(2);
                vm.data.TDSVal = parseFloat(vm.data.TDSVal).toFixed(2);
                vm.data.ClosureValue = Math.round(vm.data.ClosureValue).toLocaleString("en-IN", { minimumFractionDigits: 2 });
                vm.data.ProjectValue = Math.round(vm.data.ProjectValue).toLocaleString("en-IN", { minimumFractionDigits: 2 });

                if (vm.data.TDSVal == 0) {
                    
                  var TaxValOne = parseFloat(vm.data.TaxableAmount).toFixed(2);
                  vm.data.TaxableValueOne = Math.round(TaxValOne).toLocaleString("en-IN", { minimumFractionDigits: 2 }); //Taxable Value


                  var SGST1 = (parseFloat(vm.data.GSTAmount) / 2).toFixed(2);
                  var CGST1 = (parseFloat(vm.data.GSTAmount) / 2).toFixed(2);//SGST (9%) Value
                  vm.data.SGSTOne = Math.round(SGST1).toLocaleString("en-IN", { minimumFractionDigits: 2 });


                  vm.data.CGSTOne = vm.data.SGSTOne; //CGST (9%) Value
                  vm.data.TotalCGST = vm.data.CGSTOne;
                  vm.data.TotalSGST = vm.data.SGSTOne;

                  //TOTALS
                  vm.data.TotalValue = Math.round(TaxValOne).toLocaleString("en-IN", { minimumFractionDigits: 2 });

                  vm.data.TotalClosure = (parseFloat(vm.data.AmountOne) + parseFloat(vm.data.AmountTwo)).toFixed(2); //TOTAL

                  var TotClos = vm.data.TotalClosure;
                  
                  vm.data.TotalClosure = Math.round(TotClos).toLocaleString("en-IN", { minimumFractionDigits: 2 });

                  vm.data.TotalInWords = inWords(parseFloat(TotClos)).toUpperCase();
                }
                else if (vm.data.TDSVal != 0) {  
                  
                  var TaxValOne = parseFloat(vm.data.TaxableAmount).toFixed(2);
                  vm.data.TaxableValueOne = Math.round(TaxValOne).toLocaleString("en-IN", { minimumFractionDigits: 2 }); //Taxable Value


                  var SGST1 = (parseFloat(vm.data.GSTAmount) / 2).toFixed(2);
                  var CGST1 = (parseFloat(vm.data.GSTAmount) / 2).toFixed(2);//SGST (9%) Value
                  vm.data.SGSTOne = Math.round(SGST1).toLocaleString("en-IN", { minimumFractionDigits: 2 });
                  

                  vm.data.CGSTOne = vm.data.SGSTOne; //CGST (9%) Value
                  vm.data.TotalCGST = vm.data.CGSTOne;
                  vm.data.TotalSGST = vm.data.SGSTOne;
                 
                    
                  //TOTALS
                  vm.data.TotalValue = Math.round(TaxValOne).toLocaleString("en-IN", { minimumFractionDigits: 2 });

                  vm.data.TotalClosure = (parseFloat(vm.data.AmountOne) + parseFloat(vm.data.AmountTwo)).toFixed(2); //TOTAL

                  var TotClos = vm.data.TotalClosure;

                  vm.data.TotalClosure = Math.round(TotClos).toLocaleString("en-IN", { minimumFractionDigits: 2 });

                  vm.data.TotalInWords = inWords(parseFloat(TotClos)).toUpperCase();
                }

                if (vm.data.State.toLowerCase() == "karnataka") {
                    vm.data.ifNotKarnataka = true;
                    
                }
                else {
                    vm.data.ifKarnataka = true;
                    
                  vm.data.IGSTOne = (parseFloat(CGST1) + parseFloat(SGST1)).toLocaleString("en-IN", { minimumFractionDigits: 2 }); //SGST (9%) Value
                    //vm.data.IGSTTwo = (parseFloat(vm.data.SGSTTwo) + parseFloat(vm.data.CGSTTwo)).toFixed(2); //SGST (9%) Value
                  //alert(vm.data.IGSTOne);
                  vm.data.TotalIGST = vm.data.IGSTOne;
                }


                //vm.data.InvoiceRef = "INR-0099-0921";
                vm.data.InvoiceDate = new Date();
                vm.data.StaticPANNumber = "AADCV8103B";
                vm.data.StaticGSTIN = "29AADCV8103B1ZK";
                vm.data.StaticStateCode = "Karnataka - 29";
                vm.data.StaticSACode = "998346";

                // Insert TaxInvoice into Database   

                var data = {};

                data.InvRefNo_Static = vm.data.InvRefNoStatic;
                data.Invoice_sequence = vm.data.InvoiceSequence;
                //data.Invoice_Ref = vm.data.InvoiceRef;
                data.Invoice_Date = vm.data.InvoiceDate;
                data.Client_Name = vm.data.ClientName;
                data.Client_GSTIN = vm.data.GSTIN;
                data.Client_State = vm.data.State;
                data.Client_Code = vm.data.Code;
                data.TDS = vm.data.TDSVal;
                data.Client_Country = vm.data.Country;
                data.Client_Address = vm.data.Address;
                data.PAN_Number = vm.data.StaticPANNumber;
                data.GSTIN = vm.data.StaticGSTIN;
                data.State_Code = vm.data.StaticStateCode;
                data.SA_Code = vm.data.StaticSACode;
                data.Total_Taxable_Value = vm.data.TotalValue;
                data.Total_CGST = vm.data.TotalCGST;
                data.Total_SGST = vm.data.TotalSGST;
                data.Total_Amount = vm.data.TotalClosure;
                data.Total_Amount_InWords = vm.data.TotalInWords;

                // TaxInviceItem
                data.Item_Description_One = vm.data.DescriptionOne;
                data.Item_Taxable_Value_One = vm.data.TaxableValueOne;
                data.Item_CGST_One = vm.data.CGSTOne;
                data.Item_SGST_One = vm.data.SGSTOne;
                data.Item_Amount_One = vm.data.AmountOne;

                data.Item_Description_Two = vm.data.DescriptionTwo;
                data.Item_Taxable_Value_Two = vm.data.TaxableValueTwo;
                data.Item_CGST_Two = vm.data.CGSTTwo;
                data.Item_SGST_Two = vm.data.SGSTTwo;
                data.Item_Amount_Two = vm.data.AmountTwo;
                data.PMID = PMID;
                data.PHID = PHID;

                httpService.httpCall('api/closureManagement/SaveTaxInvoice', 'POST', data)
                    .then(OnSuccess, OnFail);

                vm.data.GenInvBtn = true;
            }

            if (vm.data.DescriptionTwo != undefined && vm.data.DescriptionTwo != "") {
                vm.data.hidesecond = false;
            }
            else {
                vm.data.hidesecond = true;
            }

            if ((PHID != "" || PHID != undefined) && urlParams == "") {
                popupService.GenerateTaxInvoice(0, PHID, refresh);
            }
        }

        var OnSuccess = function () {
            //alert("Success");
        }
        var OnFail = function () {
            //alert("Success");
        }

        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        function inWords(num) {
            if ((num = num.toString()).length > 9) return 'overflow';
            var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
            if (!n) return; var str = '';
            str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
            str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
            str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
            str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
          /*str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';*/
            str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
            str += 'only ';
            return str;
        }

        vm.func.invoice = function () {
            window.location.replace('TaxInvoice');
        }

        var refresh = function () {
            init();
        }

        vm.func.Download = function () {

            // html2canvas(vm.data.pdf, {
            //     onrendered: function(canvas) {
            //         $("#previewImage").append(canvas);
            //         getCanvas = canvas;
            //     }
            // });

            // window.print(vm.data.pdf);

            html2canvas($("#payslip")[0], {
                scale: 10,
                onrendered: function (canvas) {
                    var data = canvas.toDataURL();
                    var docDefinition = {
                        content: [{
                            image: data,
                            width: 500
                        }],
                    };
                  pdfMake.createPdf(docDefinition).download(vm.data.InvRefNoStatic + ".pdf"); //change name based on inv ref code static or dynamic
                }
            });


            //$('#c-invoice').modal('show');
            // setTimeout(function () {
            //     html2canvas($(".row")[0]).then(canvas => {
            //         //$("#previewBeforeDownload").html(canvas);
            //         var imgData = canvas.toDataURL("image/jpeg", 1);
            //         var pdf = new jsPDF("p", "mm", "a4");
            //         var pageWidth = pdf.internal.pageSize.getWidth();
            //         var pageHeight = pdf.internal.pageSize.getHeight();
            //         var imageWidth = canvas.width;
            //         var imageHeight = canvas.height;

            //         var ratio = imageWidth / imageHeight >= pageWidth / pageHeight ? pageWidth / imageWidth : pageHeight / imageHeight;
            //         pdf.addImage(imgData, 'JPEG', 0, 0, imageWidth * ratio, imageHeight * ratio);
            //         pdf.save("invoice.pdf");
            //     });
            // }, 500);

            // var HTML_Width = $("#payslip").width();
            // var HTML_Height = $("#payslip").height();
            // var top_left_margin = 15;
            // var PDF_Width = HTML_Width + (top_left_margin * 2);
            // var PDF_Height = (PDF_Width * 1.5) + (top_left_margin * 2);
            // var canvas_image_width = HTML_Width;
            // var canvas_image_height = HTML_Height;

            // var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

            // html2canvas($("#payslip")[0]).then(function (canvas) {
            //     var imgData = canvas.toDataURL("image/jpeg", 1.0);
            //     var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
            //     pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);
            //     for (var i = 1; i <= totalPDFPages; i++) {
            //         pdf.addPage(PDF_Width, PDF_Height);
            //         pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height * i) + (top_left_margin * 4), canvas_image_width, canvas_image_height);
            //     }
            //     pdf.save("Your_PDF_Name.pdf");
            // });

        }

        init();
    }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('kycUpdateDetailsController', kycUpdateDetailsController)

    kycUpdateDetailsController.$inject = ['httpService', '$filter', 'popupService'];

    function kycUpdateDetailsController(httpService, $filter, popupService) {
        var vm=this;
       
        vm.data={};
        vm.func={};


        var init =function()  {
            vm.data.afterSearch=false;
            vm.data.totalItems=0;
            vm.data.itemsPerPage=10;
            vm.data.Pagination={
                current:1
            };
            vm.data.ChkPryCnt = false;
            vm.data.ChkCertDetails = false;
         
            vm.data.PrimaryContact = [
                { id: 'Select', value: 'Null' },
                { id: 'Yes', value: 'True' },
                { id: 'No', value: 'False' },
                { id: 'All', value: 'All' }
            ];
            vm.data.selectedPrimaryContact = vm.data.PrimaryContact[0];
            
            vm.data.SalesStatus = [
                { value: 'Select' },
                { value: 'Not Reachable' },
                { value: 'Not Responding' },
                { value: 'Do Not Know' }
            ];
            vm.data.selectedSalesStatus = vm.data.SalesStatus[0];


            vm.data.CertDetails = [
             { id: 'Select', value: 'Null' },
                { id: 'Yes', value: 'True' },
                { id: 'No', value: 'False' },
                { id: 'All', value: 'All' }
            ];
            vm.data.selectedCertDetails = vm.data.CertDetails[0];
            //$('#datepicker').Datepicker({
            //               dateFormat: 'dd-mm-yy'
            //           });
           
           // httpService.httpCall('api/certificationDetails/suggestforZone', 'GET', null)
           //.then(function (response) {
           //    vm.data.getZoneData = response;
           //})

          //  httpService.httpCall('api/ClosureManagement/suggestforAgent', 'GET', null)
          //.then(function (response) {
          //    vm.data.getAgentName = response;
          //})

            //httpService.httpCall('api/ClosureManagement/suggestforSize', 'GET', null)
            //.then(function (response) {
            //    vm.data.getSizeData = response;
            //})

            //httpService.httpCall('api/ClosureManagement/suggestforValidity', 'GET', null)
            //.then(function (response) {
            //    vm.data.getValidityData = response;
            //})

            //httpService.httpCall('api/ClosureManagement/suggestforStatus', 'GET', null)
            //.then(function (response) {
            //    vm.data.getStatusData = response;
            //})

            httpService.httpCall('api/ClosureManagement/suggestForCertStatus', 'GET', null)
            .then(function (response) {
                vm.data.getCertStatus = response;
            })

            httpService.httpCall('api/ClosureManagement/getKycForUpdate', 'GET', null)
                .then(getAllCertificates)

            httpService.httpCall('api/ClosureManagement/suggistCompanyForClosure', 'GET', null)
            .then(function(response){
                vm.data.getAllCompanyNames = response;
            })


            //vm.func.dateOptions = function(){
            //         dateFormat: "dd-MM-yyyy"
            //};

            //vm.data.valueofdate = new Date(vm.data.valueofdate);
           
            

            //vm.data.FromDate = $filter('date')(vm.data.valueofdate, "dd/MM/yyyy");
            //vm.data.ToDate = $filter('date')(vm.data.ToDate, "dd/MM/yyyy");



            //vm.func.searchby = function () {
            //    var sortData = {};
            //    sortData.Zone = vm.data.Zonedata;
            //    sortData.Agent = vm.data.AgentName;
            //    sortData.FromDate = vm.data.FromDate;
            //    sortData.ToDate = vm.data.ToDate;

            //    httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
            //    .then(successSearchsorted)
            //}
        }

       

        vm.func.searchby = function () {
            var sortData = {};
            
            //vm.data.ChkCertDetails = vm.data.selectedCertDetails.value;
            //vm.data.ChkPryCont = vm.data.selectedPrimaryContact.value;
            sortData.ChkPryCont = vm.data.ChkPryCnt;
            sortData.ChkCrtDetails = vm.data.ChkCertDetails;
            sortData.CertStatus = vm.data.CertStatus;
           // sortData.SalesStatus = vm.data.SalesStatus;
               // sortData.Zone = vm.data.Zonedata;
               //sortData.Agent = vm.data.AgentName;
               //sortData.CompanySize = vm.data.Size;
               //sortData.Validity = vm.data.SrchValidity;
               //sortData.EmailStatus = vm.data.SrchStatus;
           // var nosofdays = 0;

           //   if (vm.data.FromDate != null && vm.data.ToDate != null) {
           // vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
           // vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

           // vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
           // vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

           // sortData.Fromdate = vm.data.fromDateformate;
           // sortData.Todate = vm.data.toDateformate;

           //  }
           //else {
           //   sortData.Fromdate = vm.data.FromDate;
           //     sortData.Todate = vm.data.ToDate;
           // }

              //if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
              //    if (vm.data.CompanyState == '' || vm.data.CompanyState == null) {
              //        vm.data.StateName = true;
              //     //   isValid = false;
              //    }
                 
              //}
         //   sortData.FromDate = vm.data.FromDate;
           // sortData.ToDate = vm.data.ToDate;

            httpService.httpCall('api/ClosureManagement/getSortedKycForUpdated', 'POST', sortData)
               .then(successSearchsorted)

               //httpService.httpCall('api/ClosureManagement/getKycForUpdate', 'GET', null)
               //   .then(response) 
                     
               //       var selectedZoneRecords = response.ClientZone;
                  

               //       if (selectedZoneRecords == sortData.Zone) {
               //           return response;
               //       }
                     
                      
                    
                     
                


        }
        var successSearchsorted = function (response) {
            vm.data.afterSearch = true;
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        var getAllCertificates = function (response) {
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }
        
        var successsearch = function (response) {
            vm.data.afterSearch = true;
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }



        var getPages = function () {
            vm.data.totalItems = vm.data.getAllCertification.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.getAllCertificationData = vm.data.getAllCertification.slice(start, end);
        };

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
           
            init();
        }
        vm.func.getSingleKycDetails = function (Kycid) {
            popupService.kycUpdatePage(Kycid, refresh);
        }
        var refresh = function () {
            init();
        }
        init();
    }

    



})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('HomeController', HomeController);

    HomeController.$inject = ['$rootScope'];

    function HomeController(rootScope) {
        var vm = this;

        vm.data = [];
        vm.func = [];

        var init = function () {
            var UserData = angular.fromJson(rootScope.UserData);

            vm.data.LogedInUserId = angular.fromJson(UserData).UserName;
        }

        init();
    }
})();
(function () {
  'use strict';

  angular
    .module('isoappClient')
    .controller('SingleKycDetailsController', SingleKycDetailsController);

  SingleKycDetailsController.$inject = ['$stateParams', 'httpService', '$state', 'popupService', '$rootScope'];

  function SingleKycDetailsController(stateParams, httpService, state, popupService, rootScope) {

    var vm = this;

    vm.data = {};
    vm.func = {};

    var init = function () {
      vm.data.noShowDetails = true;
      vm.data.hideDetails = false;
      vm.data.modalEnable = true;
      vm.data.itemsPerPage = 5;
      vm.data.totalItems = 0;
      vm.data.totalItemsofClosure = 0;
      vm.data.totalItemsofComment = 0;
      vm.data.pagination = {
        current: 1
      };
      vm.data.paginationofClosure = {
        current: 1
      };
      vm.data.paginationofComment = {
        current: 1
      };
      var UserData = angular.fromJson(rootScope.UserData);
      vm.data.LogedInUserId = angular.fromJson(UserData).UserName;

      if (typeof (stateParams.Id) != 'undefined' && parseInt(stateParams.Id) > 0) {
        vm.data.Id = stateParams.Id;
        httpService.httpCall('api/ProposalMnagement/getsingleProposalDetails?Id=' + stateParams.Id, 'GET', null)
          .then(function (response) {

            if (response[0].agent_request_status == 'Certificate Requested') {
              vm.data.hideAcceptButton = false;
              vm.data.alreadyAcceptButton = true;
              vm.data.hidesoftcopyButton = true;
              vm.data.alreadysoftcopyButton = false;
              vm.data.hidehardcopyButton = true;
              vm.data.alreadyhardcopyButton = false;
              vm.data.hideDispatchButton = true;
              vm.data.alreadyDispatch = false;
              vm.data.hideabort = true;
              vm.data.alreadyhideabort = false;
              vm.data.hidenotAapplicable = true;
              vm.data.alreadynotAapplicable = false;
              vm.data.hideCourier = true;
              vm.data.alreadyCourier = false;
            
            } else {
              vm.data.hideAcceptButton = true;
              vm.data.alreadyAcceptButton = false;
              vm.data.hideCourier = false;
              vm.data.alreadyCourier = true;

              if (response[0].project_status == 'Soft Copy Sent') {
                vm.data.hidesoftcopyButton = true;
                vm.data.alreadysoftcopyButton = false;
              } else {
                vm.data.hidesoftcopyButton = false;
                vm.data.alreadysoftcopyButton = true;
              }
              if (response[0].project_status == 'Hard Copy Sent') {
                vm.data.hidehardcopyButton = true;
                vm.data.alreadyhardcopyButton = false;
              } else {
                vm.data.hidehardcopyButton = false;
                vm.data.alreadyhardcopyButton = true;
              }
              if (response[0].certification_type != 'Initial') {
                vm.data.alreadyDispatch = true;
                vm.data.hideDispatchButton = false;
                
              } else {
                vm.data.alreadyDispatch = true;
                vm.data.hideDispatchButton = false;
         
              }
              if (response[0].project_status == 'Aborted') {
                vm.data.hideabort = true;
                vm.data.alreadyhideabort = false;
              } else {
                vm.data.hideabort = false;
                vm.data.alreadyhideabort = true;
              }
              if (response[0].project_status == 'Not Applicable') {
                vm.data.hidenotAapplicable = true;
                vm.data.alreadynotAapplicable = false;

              } else {
                vm.data.hidenotAapplicable = false;
                vm.data.alreadynotAapplicable = true;
              }
            }
            
            if (response[0].agent_request_status == 'Request Rejected') {
              vm.data.hiderejectButton = true;
              vm.data.alreadyRejectButton = false;
              vm.data.hideAcceptButton = true;
              vm.data.alreadyAcceptButton = false;
              vm.data.hidesoftcopyButton = true;
              vm.data.alreadysoftcopyButton = false;
              vm.data.hidehardcopyButton = true;
              vm.data.alreadyhardcopyButton = false;
              vm.data.hideDispatchButton = true;
              vm.data.alreadyDispatch = false;
              vm.data.hideabort = true;
              vm.data.alreadyhideabort = false;
              vm.data.hidenotAapplicable = true;
              vm.data.alreadynotAapplicable = false;
              vm.data.hideCourier = true;
              vm.data.alreadyCourier = false;
            } else {
              vm.data.hiderejectButton = false;
              vm.data.alreadyRejectButton = true;
            }
           
           
            

           
            vm.data.PaymentStatus = response[0].payment_status;
            vm.data.AgentReqStatus = response[0].agent_request_status;

            //alert(response[0].agent_request_status);
          })
      }

      if (typeof (stateParams.Kycid) != 'undefined' && parseInt(stateParams.Kycid) > 0) {
        httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + stateParams.Kycid, 'GET', null)
          .then(function (response) {
            vm.data.Kycid = response.Kyc_id;
            vm.data.ClientName = response.Contact_Name;
            vm.data.ContactNumber = response.Contact_Num;
            vm.data.ContactEmail = response.Contact_Email;
            vm.data.Designation = response.Designation;
            vm.data.AltContactName = response.AltContact_Name;
            vm.data.AltContactNumber = response.AltContact_Number;
            vm.data.AltContactEmail = response.AltContact_Email;
            vm.data.AltDesignation = response.AltDesignation;
            vm.data.CompanyName = response.Company_name;
            vm.data.CompanyType = response.Company_Type;
            vm.data.CompanyCity = response.Company_City;
            vm.data.CompanyReg = response.Company_Reg_Files;
            vm.data.CompanyCountry = response.Company_Country;
            vm.data.CompanyState = response.Company_State;
            vm.data.NatureofBusiness = response.Nature_of_Business;
            vm.data.CompanyType = response.Company_Type;
            vm.data.Turnover = response.Turnover;
            vm.data.URL = response.URL;
            vm.data.Landline = response.Landline;
            vm.data.EmployeeStrength = response.Employee_Strength;
            vm.data.Associate = response.Associate;
            vm.data.PostalAddresss = response.PostalAddress;
           
          });
      }


      httpService.httpCall('api/closureManagement/getCertificationDetailsForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
        .then(getCertificationDetailsForSingleKyc)

      httpService.httpCall('api/closureManagement/getCommentForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
        .then(getCommentForSingleKyc)

      httpService.httpCall('api/closureManagement/getProposalDetailsForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
        .then(getProposalDetailsForSingleKyc)


      //  vm.func.saveUserActivity();
      //     httpService.httpCall('api/closureManagement/getLatestCertificationDetails?Kycid=' + stateParams.Kycid, 'GET', null)
      //.then(latestCertificates)
    }

    //vm.func.saveUserActivity = function () {

    //    vm.data.userName = vm.data.LogedInUserId;
    //    vm.data.visitPage = 'SingleKycDetails';
    //    vm.data.id = (stateParams.Kycid);

    //    var userData = {};
    //    userData.user_visitpage = vm.data.visitPage;
    //    userData.row_id_fk = vm.data.id;
    //    userData.userName = vm.data.userName;

    //    httpService.httpCall('api/user/saveUserActivity', 'POST', userData)
    //}

    //var latestCertificates = function (response) {
    //    vm.data.latestCerts = response;
    //    vm.data.CertsLatest = angular.copy(vm.data.latestCerts);

    //}

    var getCertificationDetailsForSingleKyc = function (response) {
      vm.data.certificationDetailsForSinglekyc = response;
      // vm.data.latestCert = response.RecertifiedDate;
      vm.data.certificationDetailsForSingleKycData = angular.copy(vm.data.certificationDetailsForSinglekyc);
      getPages();
    }

    vm.data.viewPropDetails = function (row) {
      popupService.viewPropDetails(row, refresh);
    }

    //vm.data.editProposal = function (Id) {
    //    state.go('singleProposal', { Id: Id });
    //}

    var getCommentForSingleKyc = function (responseForComments) {
      debugger;
      vm.data.commentDetailsForKyc = responseForComments;
      vm.data.commentDetailsForKycData = angular.copy(vm.data.commentDetailsForKyc);
      getPagesforComment();
    }

    var getProposalDetailsForSingleKyc = function (response) {
      vm.data.proposalDetailsForSingleKyc = response;
      // 
      vm.data.proposalDetailsForSingleKycData = angular.copy(vm.data.proposalDetailsForSingleKyc);
      getPagesforProposal();
    }

    var getPages = function () {
      vm.data.totalItems = vm.data.certificationDetailsForSinglekyc.length;
      vm.data.pagination = {
        current: 1
      }
      vm.data.start = vm.data.pagination.current;
      vm.data.end = vm.data.start * vm.data.itemsPerPage;
      if (vm.data.totalItems < vm.data.itemsPerPage) {
        vm.data.end = vm.data.totalItems;
      }
    };

    var getPagesforProposal = function () {
      vm.data.totalItemsofClosure = vm.data.proposalDetailsForSingleKyc.length;
      vm.data.paginationofClosure = {
        current: 1
      }
      vm.data.startofClosure = vm.data.paginationofClosure.current;
      vm.data.endofClosure = vm.data.startofClosure * vm.data.itemsPerPage;
      if (vm.data.totalItemsofClosure < vm.data.itemsPerPage) {
        vm.data.endofClosure = vm.data.totalItemsofClosure;
      }
    };

    var getPagesforComment = function () {
      vm.data.totalItemsofComment = vm.data.commentDetailsForKyc.length;
      vm.data.paginationofComment = {
        current: 1
      }
      vm.data.startofComment = vm.data.paginationofComment.current;
      vm.data.endofComment = vm.data.startofComment * vm.data.itemsPerPage;
      if (vm.data.totalItemsofComment < vm.data.itemsPerPage) {
        vm.data.endofComment = vm.data.totalItemsofComment;
      }
    };

    vm.func.pageChangeofComment = function () {
      var startofComment = ((vm.data.paginationofComment.current - 1) * vm.data.itemsPerPage)
        , endofComment = startofComment + vm.data.itemsPerPage;

      vm.data.startofComment = startofComment + 1;
      vm.data.endofComment = (vm.data.totalItemsofComment > endofComment ? endofComment : vm.data.totalItemsofComment);

      vm.data.commentDetailsForKycData = vm.data.commentDetailsForKyc.slice(startofComment, endofComment);
    };

    vm.func.pageChange = function () {
      var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
        , end = start + vm.data.itemsPerPage;

      vm.data.start = start + 1;
      vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

      vm.data.certificationDetailsForSingleKycData = vm.data.certificationDetailsForSinglekyc.slice(start, end);
    };

    vm.func.pageChangeofClosure = function () {
      var startofClosure = ((vm.data.paginationofClosure.current - 1) * vm.data.itemsPerPage)
        , endofClosure = startofClosure + vm.data.itemsPerPage;

      vm.data.startofClosure = startofClosure + 1;
      vm.data.endofClosure = (vm.data.totalItemsofClosure > endofClosure) ? endofClosure : vm.data.totalItemsofClosure;

      vm.data.proposalDetailsForSingleKycData = vm.data.proposalDetailsForSingleKyc.slice(startofClosure, endofClosure);
    };



    vm.data.goAddNewCertificationPage = function (Kycid, Id) {
      //alert(vm.data.AgentReqStatus);
      //if (vm.data.AgentReqStatus != 'Certificate Requested') {
      //  alert("In order to add New Certificate, Please make sure the Certificate is requested from the Agent");
      //} else {
        state.go('addnewcertification', { Kycid: Kycid, Id: Id })
      //}
    };

    vm.data.goAddNewTrainingCert = function (Kycid, Id) {
      //if (vm.data.AgentReqStatus != 'Certificate Requested') {
      //  alert("In order to add New Certificate, Please make sure the Certificate is requested from the Agent");
      //} else {
        state.go('addnewTrainingcert', { Kycid: Kycid, Id: Id })
      //}
    };

    var Prid = 0;
    vm.data.editClosureKYCDetails = function (Kycid) {
      state.go('editClosureKycDetais', { Kycid: Kycid }, { Prid: Prid })
    };

    vm.func.editCertificationDetails = function (row) {
      row.AgentReqStatus = vm.data.AgentReqStatus;
      popupService.editCertificate(row, refresh);
    }

    vm.func.giveComment = function (Kycid) {
      popupService.addCommentsInClosure(Kycid, refresh);
    }

    vm.func.RejectRequest = function (Kycid, Id) {
      popupService.addCommentsInRejectRequest(Kycid, Id, refresh);
    }

    vm.func.AcceptRequest = function (Kycid, Id) {
      var prodata = {};
      prodata.Id = Id;
      prodata.AgentRequestStatus = 'Request Accepted';
      httpService.httpCall('api/proposalMnagement/projectStatusUpdate', 'POST', prodata)
        .then(onSuccessAccept, onFail);

      var updateProposalHistory = {};

      updateProposalHistory.kyc_id_fk = vm.data.Kycid;
      updateProposalHistory.comment = "Certificate Request - Accepted";
      updateProposalHistory.activity_user = vm.data.LogedInUserId;
      updateProposalHistory.staus = '1';

      httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
        .then(onSuccess, onFail)
      init();
    }

    
    vm.func.SoftCopySent = function (Kycid, Id) {
      vm.data.certificationDetailsForSingleKycData.length = 1;

      if (vm.data.certificationDetailsForSingleKycData.length != 0) {
        //popupService.finishClosure(Kycid, Id, refresh);
        var prodata = {};
        prodata.Id = Id;
        prodata.ProjectStatus = 'Soft Copy Sent';
        httpService.httpCall('api/proposalMnagement/projectStatusUpdate', 'POST', prodata)
          .then(onSuccessSoftCopy, onFail1);



        var updateProposalHistory = {};

        updateProposalHistory.kyc_id_fk = vm.data.Kycid;
        updateProposalHistory.comment = "Certification Status - Soft Copy Sent.";
        updateProposalHistory.activity_user = vm.data.LogedInUserId;
        updateProposalHistory.staus = '1';

        httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
          .then(onSuccess, onFail)
        init();

      }
      else {
        onFail();
      }

    }
    vm.func.HardCopySent = function (Kycid, Id) {
      vm.data.certificationDetailsForSingleKycData.length = 1;
      if (vm.data.certificationDetailsForSingleKycData.length != 0) {

        //popupService.finishClosure(Kycid, Id, refresh);
        var prodata = {};
        prodata.Id = Id;
        prodata.ProjectStatus = 'Hard Copy Sent';
        httpService.httpCall('api/proposalMnagement/projectStatusUpdate', 'POST', prodata)
          .then(onSuccessHardCopy, onFail1);

        var certdata = {};
        certdata.Kyc_id = Kycid;
        certdata.ProjectStatus = 'Hard Copy Sent';
        //httpService.httpCall('api/closureManagement/agentRequestUpdate', 'POST', certdata)
        //  .then(onSuccess, onFail1);

        var updateProposalHistory = {};

        updateProposalHistory.kyc_id_fk = vm.data.Kycid;
        updateProposalHistory.comment = "Certification Status - Hard Copy Sent.";
        updateProposalHistory.activity_user = vm.data.LogedInUserId;
        updateProposalHistory.staus = '1';

        httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
          .then(onSuccess, onFail)

        init();

      }
      else {
        onFail();
      }

    }
    vm.func.SurveillanceFail = function (Kycid, Id) {
      popupService.survFail(Kycid, Id, refresh);
    }
    vm.func.SurveillancePass = function (Kycid, Id) {
      popupService.survPass(Kycid, Id, refresh);
    }

    vm.func.Abort = function (Kycid, Id) {
      popupService.addCommentsInAborted(Kycid, Id, refresh);
      // vm.data.certificationDetailsForSingleKycData.length = 1;

      //popupService.finishClosure(Kycid, Id, refresh);

      //var updateProposalHistory = {};

      //updateProposalHistory.kyc_id_fk = vm.data.Kycid;

      //updateProposalHistory.comment = "Certification Status - Aborted";
      //updateProposalHistory.activity_user = vm.data.LogedInUserId;
      //updateProposalHistory.status = '1';

      //httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)

      //var prodata = {};
      //prodata.Id = Id;
      //prodata.ProjectStatus = 'Aborted';
      //httpService.httpCall('api/proposalMnagement/projectStatusUpdate', 'POST', prodata)
      //  .then(onSuccessAbort, onFail);
      //refresh();
    }

    vm.func.NotApplicable = function (Kycid, Id) {
      popupService.addCommentsInNAC(Kycid, Id, refresh);
      // vm.data.certificationDetailsForSingleKycData.length = 1;

      //popupService.finishClosure(Kycid, Id, refresh);

    //  var updateProposalHistory = {};

    //  updateProposalHistory.kyc_id_fk = vm.data.Kycid;

    //  updateProposalHistory.comment = "Certification Status - Not Applicable";
    //  updateProposalHistory.activity_user = vm.data.LogedInUserId;
    //  updateProposalHistory.status = '1';

    //  httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)

    //  var prodata = {};
    //  prodata.Id = Id;
    //  prodata.ProjectStatus = 'Not Applicable';
    //  httpService.httpCall('api/proposalMnagement/projectStatusUpdate', 'POST', prodata)
    //    .then(onSuccessNA, onFail);
    //  refresh();
    }
    vm.func.CloseandFinish = function (Kycid, Id) {

      //      ---------------------------------------------------------------------------------------------------------
      //Checks KYC UPDATE Info
      //  ------------------------------------------------------------------------------------------------------
      //      httpService.httpCall('api/closureManagement/getLatestCertificationDetails?Kycid=' + stateParams.Kycid, 'GET', null)
      //.then(function(response){
      //      //var latestCertificates = function (response) {
      //          vm.data.latestCerts = response;
      //          vm.data.CertsLatest = angular.copy(vm.data.latestCerts);

      //      })
      //      ---------------------------------------------------------------------------------------------------------
      //  ------------------------------------------------------------------------------------------------------
      //vm.data.date = new Date();
      // var nosofdays = 30;
      // vm.data.presentAdded = vm.data.date.setDate(vm.data.date.getDate() - nosofdays);
      //vm.data.lastrecert = getCertificationDetailsForSingleKyc.RecertifiedDate;
      // vm.data.Dateformate = $filter('date')(vm.data.presentAdded, 'yyyy-MM-dd HH:mm:ss Z');
      //if (vm.data.CertsLatest.length <= 0) {
      //    onFail1();
      //}
      //if (vm.data.proposalDetailsForSingleKycData.length <= 0) {
      //    onFail();
      //}
      vm.data.certificationDetailsForSingleKycData.length = 1;

      if (vm.data.certificationDetailsForSingleKycData.length != 0) {

        //if (vm.data.CertsLatest.length != 0) {

        //if ((vm.data.PostalAddresss != null && vm.data.PostalAddresss != '')) {
        //popupService.addDispatchDetails(Id,refresh);
        popupService.finishClosure(Kycid, Id, refresh);

        var updateProposalHistory = {};

        updateProposalHistory.kyc_id_fk = vm.data.Kycid;
        //   updateProposalHistory.comment = vm.data.PaymentStatus + " verified. Certi Status Dispatched";
        updateProposalHistory.comment = "Certification Status - Dispatched";
        updateProposalHistory.activity_user = vm.data.LogedInUserId;
        updateProposalHistory.status = '1';

        httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
          .then(onSuccess, onFail)
        //}
        //else {
        //    onFail();
        //}
        //}
        //else {
        //    onFail1();
        //}

      }
      else {
        onFail();
      }
      //  addDispatchDetails

    }
    vm.func.DispatchDetails = function (Kycid, Id) {

      popupService.addDispatchDetails(Id, refresh);

    }

    vm.func.activenoShowDetails = function () {
      vm.data.noShowDetails = false;
      vm.data.hideDetails = true;
    }
    var onFail = function () {
      popupService.errorsm('ISO', 'Server Problem');
    };
    var onFail1 = function () {
      popupService.errorsm('ISO', 'Certificate Too Old to Dispatch!\n\n (Older than 6 months From Now)');
    };
    var onSuccessRejectReq = function () {

      popupService.successsm('ISO', 'Certificate Rejected Successfully');

    }
    var onSuccessSoftCopy = function () {

      popupService.successsm('ISO', 'Certificate Soft Copy Sent');

    }
    var onSuccessAccept = function () {

      popupService.successsm('ISO', 'Certificate Request Accepted');

    }
    
    var onSuccessHardCopy = function () {

      popupService.successsm('ISO', 'Certificate Hard Copy Sent');

    }
    var onSuccessAbort = function () {

      popupService.successsm('ISO', 'Certificate Aborted Successfully');

    }
    //var onSuccessAbort = function () {
    //    modalInstance.close('OK');
    //    popupService.successsm('ISO', 'Certificate Dispatched & Closed');
    //    callBack();
    //}
    var onSuccessNA = function () {

      popupService.successsm('ISO', 'Certificate Not Applicable');

    }
    var refresh = function () {
      init();
    }

    init();
  }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('SearchClosureKycController', SearchClosureKycController)

    SearchClosureKycController.$inject = ['$stateParams', '$filter', 'httpService', 'popupService', '$rootScope', '$state', '$window'];

    function SearchClosureKycController(stateParams, $filter, httpService, popupService, rootScope, state, $window) {

        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.afterSearch = false;
            vm.data.totalItems = 0;
            vm.data.itemsPerPage = 10;
            vm.data.pagination = {
                current: 1
            };

            vm.func.searchby = function () {
                var sortData = {};
                sortData.Zone = vm.data.Zonedata;
                sortData.Agent = vm.data.AgentName;
                var nosofdays = 0;



                //if (vm.data.FromDate != null) {
                //    vm.data.FromDate1 = vm.data.FromDate;//Wed Apr 01 2015 00:00:00 GMT+0530 (India Standard Time)
                //}
                //else {
                //    vm.data.FromDate1 = Date([2017], [12], [10], [12], [30], [10], [100]);//Tue Apr 15 1000 00:00:00 GMT+0530 (India Standard Time)
                //    vm.data.FromDate1 = $filter('date')(vm.data.FromDate, 'yyyy-MM-dd HH:mm:ss Z');
                //}
                //if (vm.data.ToDate != null) {
                //    vm.data.ToDate1 = vm.data.FromDate;
                //}
                //else {
                //    vm.data.ToDate1 = Date([2000], 12, [10], [12], [30], [10], [100]);//Tue Apr 15 1000 00:00:00 GMT+0530 (India Standard Time)
                //    vm.data.ToDate1 = $filter('date')(vm.data.ToDate, 'yyyy-MM-dd HH:mm:ss Z');
                //}
                if (vm.data.FromDate != null && vm.data.ToDate != null){
                    vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                   vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                   vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                   vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

              sortData.Fromdate = vm.data.fromDateformate;
              sortData.Todate = vm.data.toDateformate;

                }
                else {
                    sortData.Fromdate = vm.data.FromDate;
                    sortData.Todate = vm.data.ToDate;
                }
             // sortData.Fromdate = vm.data.FromDate;
             // sortData.Todate = vm.data.ToDate;

                //  $scope.mydate = new Date("2015-07-08T15:10:10.530Z");
              //  var numberOfDaysToAdd = 2;
                //$scope.newdate = $scope.mydate.setDate($scope.mydate.getDate() + numberOfDaysToAdd);

                httpService.httpCall('api/closureManagement/searchby', 'POST', sortData)
                .then(successSearchsorted)
            }


            httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            .then(function (response) {
                vm.data.getZoneData = response;
            })

            httpService.httpCall('api/closureManagement/suggestforAgent', 'GET', null)
          .then(function (response) {
              vm.data.getAgentName = response;
          })


            httpService.httpCall('api/closureManagement/suggistCompanyForClosure', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })

            //httpService.httpCall('api/closureManagement/getAllClosurekyc', 'GET', null)
            //.then(getClosureManagementData)

            httpService.httpCall('api/closureManagement/getAllNewClosurekyc', 'GET', null)
            .then(getClosureManagementData)
            vm.data.NumCert = getClosureManagementData.leng;

           

         //   httpService.httpCall('api/closureManagement/getCertificationDetailsForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
         //.then(getCertificationDetailsForSingleKyc)

        }
        //var getCertificationDetailsForSingleKyc = function (response) {
        //    vm.data.certificationDetailsForSinglekyc = response;
        //    vm.data.certificationDetailsForSingleKycData = angular.copy(vm.data.certificationDetailsForSinglekyc);
            //getPages();
      //  }
        //vm.func.getSingleKycDetails = function (Kycid) {
        // //   state.go('singleclosurekyc', { Kycid: Kycid });

        //    var url = state.href('singleclosurekyc', { Kycid: Kycid });
        //    $window.open(url);

        //}

        var getClosureManagementData = function (response) {
            vm.data.allClosureManagement = response;
            vm.data.allClosureManagementData = angular.copy(vm.data.allClosureManagement);
            getPages();
        }

        //vm.data.NumCert = getClosureManagementData.

        var getPages = function () {
            vm.data.totalItems = vm.data.allClosureManagement.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allClosureManagementData = vm.data.allClosureManagement.slice(start, end);
        };

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.afterSearch = true;
            vm.data.allClosureManagement = response;
            vm.data.allClosureManagementData = angular.copy(vm.data.allClosureManagement);
            getPages(); 
        }

        var successSearchsorted = function (response) {
            vm.data.afterSearch = true;
            vm.data.allClosureManagement = response;
            vm.data.allClosureManagementData = angular.copy(vm.data.allClosureManagement);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Zonedata = '';
            vm.data.AgentName = '';
            init();
        }

        init();
    }
})();
(function () {
    'user strict';

    angular
    .module('isoappClient')
    .controller('EditClosureKYCDetailsController', EditClosureKYCDetailsController);

    EditClosureKYCDetailsController.$inject = ['$state','$stateParams', 'httpService', 'popupService' ];

    function EditClosureKYCDetailsController(state, stateParams, httpService, popupService) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            vm.data.isFormSubmit = false;
            vm.data.addMoreCompany = false;
            vm.data.addAlternateContact = false;
            vm.data.requiredCompanyType = false;
            vm.data.requiredAssociate = false;
            vm.data.requiredStateName = false;
            vm.data.requiredZoneType = false;
            vm.data.ifWantAddAlternateContact = true;
            vm.data.ifDontWantAddAlternateContact = false;
            vm.data.ifWantAddMoreCompany = true;
            vm.data.ifDontWantAddMoreCompany = false;
            vm.data.ComType = [
                    { value: 'Select' },
                    { value: 'Proprietorship' },
                    { value: 'Private Ltd.' },
                    { value: 'Public Ltd.' },
                    { value: 'Trust/Co-op/Association' },
                    { value: 'Government' },
                    { value: 'Other' }
            ];


            vm.data.ZoneType = [
                  { value: 'Select' },
                  { value: 'India' },
                  { value: 'ROI' },
                  { value: 'Oman' },
                  { value: 'UAE' },
                  { value: 'Saudi Arabia' },
                  { value: 'Kuwait' },
                  { value: 'Qatar' },
                  { value: 'South Africa' },
                  { value: 'Bahrain' },
                  { value: 'Rest of World' }
            ];

            vm.data.Associate = [
                { value: 'Select' },
                { value: 'Yes' },
                { value: 'No' }
            ];

            httpService.httpCall('api/enquiryManagement/suggestassignto', 'GET', null)
            .then(function (response) {
                vm.data.suggestAgentName = response;
                vm.data.suggestAgentNameData = angular.copy(vm.data.suggestAgentName);
            });

            httpService.httpCall('api/enquiryManagement/suggestCountryName', 'GET', null)
            .then(function (response) {
                vm.data.suggestCountry = response;
                vm.data.suggestCountryData = angular.copy(vm.data.suggestCountry);
            });

            vm.data.selectedCompanyType = vm.data.ComType[0];
            vm.data.selectedAssociate = vm.data.Associate[0];
            vm.data.selectedZoneType = vm.data.ZoneType[0];


            if (typeof (stateParams.Prid) != 'undefined' && parseInt(stateParams.Prid) > 0) {
                vm.data.propid = stateParams.Prid;
            }
            else {
                vm.data.propid = 0;
            }

            if (typeof (stateParams.Kycid) != 'undefined' && parseInt(stateParams.Kycid) > 0) {
                httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + stateParams.Kycid, 'GET', null)
                .then(function (response) {
                    vm.data.Kycid = response.Kyc_id;
                    vm.data.CreatedDate = response.Created_Date;
                    vm.data.CompanyName = response.Company_name;
                    vm.data.AgentName = response.Account_Manager;
                    vm.data.ContactPerson = response.Contact_Name;
                    vm.data.Designation = response.Designation;
                    vm.data.ContactNumber = response.Contact_Num;
                    vm.data.ContactEmail = response.Contact_Email;
                    vm.data.AlternateContactPerson = response.AltContact_Name;
                    vm.data.AlternateDesignation = response.AltDesignation;
                    vm.data.AlternateNumber = response.AltContact_Number;
                    vm.data.AlternateEmail = response.AltContact_Email;
                    vm.data.Natureofbusiness = response.Nature_of_Business;
                    vm.data.CompanyCountry = response.Company_Country;
                    vm.data.CompanyState = response.Company_State;
                    vm.data.CompanyCity = response.Company_City;
                    vm.data.firstsaleby = response.First_Sale_By;
                 //   vm.data.ZoneType = response.Zone;
                    angular.forEach(vm.data.ZoneType, function (item, index) {
                        if (item.value == response.Zone) {
                            vm.data.selectedZoneType = vm.data.ZoneType[index];
                        }
                    });
                    angular.forEach(vm.data.ComType, function (item, index) {
                        if (item.value == response.Company_Type) {
                            vm.data.selectedCompanyType = vm.data.ComType[index];
                        }
                    });
                    angular.forEach(vm.data.Associate, function (item, index) {
                        if (item.value == response.Associate) {
                            vm.data.selectedAssociate = vm.data.Associate[index];
                        }
                    });
                    vm.data.EmployeeStrength = response.Employee_Strength;
                    vm.data.Locations = response.Locations;
                    vm.data.Yearsinbusiness = response.Years_in_Business;
                    vm.data.Turnover = response.Turnover;
                    vm.data.URL = response.URL;
                    vm.data.LandlineNumber = response.Landline;
                    vm.data.PostalAddress = response.PostalAddress;
                    vm.data.Status = response.Status;
                });
            }

        }

        vm.func.activeAddAlternateContact = function () {
            vm.data.addAlternateContact = true;
            vm.data.ifWantAddAlternateContact = false;
            vm.data.ifDontWantAddAlternateContact = true;
        };

        vm.func.deactiveAddAlternateContact = function () {
            vm.data.addAlternateContact = false;
            vm.data.ifWantAddAlternateContact = true;
            vm.data.ifDontWantAddAlternateContact = false;
        };

        vm.func.activeAddMoreCompany = function () {
            vm.data.addMoreCompany = true;
            vm.data.ifWantAddMoreCompany = false;
            vm.data.ifDontWantAddMoreCompany = true;
        };

        vm.func.deactiveAddMoreCompany = function () {
            vm.data.addMoreCompany = false;
            vm.data.ifWantAddMoreCompany = true;
            vm.data.ifDontWantAddMoreCompany = false;
        };

        vm.func.hideRequiredCompanyType = function () {
            if (vm.data.selectedCompanyType != 'Select') {
                vm.data.requiredCompanyType = false;
            }
        };

        vm.func.hideRequiredZoneType = function () {
            if (vm.data.selectedZoneType != 'Select') {
                vm.data.requiredZoneType = false;
            }
        };
        vm.func.hideRequiredAssociate = function () {
            if (vm.data.selectedAssociate != 'Select') {
                vm.data.requiredAssociate = false;
            }
        };
        vm.func.hideRequiredState = function () {
            if (vm.data.CompanyCountry == 'India' || vm.data.CompanyCountry == 'INDIA') {
                if (vm.data.CompanyState!= '' || vm.data.CompanyState != null) {
                    vm.data.requiredStateName = false;
                 
                }
            }
        };

        vm.func.updateSingleKycDetails = function (isValid) {
            isValid = true;
            vm.data.isFormSubmit = true;
            if (vm.data.selectedCompanyType.value == 'Select') {
                vm.data.requiredCompanyType = true;
                isValid = false;
            }
            if (vm.data.selectedZoneType.value == 'Select') {
                vm.data.requiredZoneType = true;
                isValid = false;
            }
            if (vm.data.selectedAssociate.value == 'Select') {
                vm.data.requiredAssociate = true;
                isValid = false;
            }
            if (vm.data.CompanyCountry == 'India' || vm.data.CompanyCountry == 'INDIA') {
                if (vm.data.CompanyState == '' || vm.data.CompanyState == null) {
                    vm.data.requiredStateName = true;
                    isValid = false;
                }
            }
           
            if (isValid) {
                var data = {};
                data.CreatedDate = vm.data.CreatedDate;
                data.Companyname = vm.data.CompanyName;
                data.Associate = vm.data.selectedAssociate.value;
               // data.AcountManager = vm.data.AgentName;
                data.ClientName = vm.data.ContactPerson;
                data.Designation = vm.data.Designation;
                data.ContactNumber = vm.data.ContactNumber;
                data.ContactEmail = vm.data.ContactEmail;
                data.AltContactName = vm.data.AlternateContactPerson;
                data.AltDesignation = vm.data.AlternateDesignation;
                data.AltContactNumber = vm.data.AlternateNumber;
                data.AltContactEmail = vm.data.AlternateEmail;
                data.NatureofBusiness = vm.data.Natureofbusiness;
                data.CompanyCountry = vm.data.CompanyCountry;
                data.CompanyCity = vm.data.CompanyCity;
                data.CompanyState = vm.data.CompanyState;
                data.CompanyType = vm.data.selectedCompanyType.value;
                data.EmployeeStrength = vm.data.EmployeeStrength;
                data.Locations = vm.data.Locations;
                data.YearsinBusiness = vm.data.Yearsinbusiness;
                data.Turnover = vm.data.Turnover;
                data.URL = vm.data.URL;
                data.Landline = vm.data.LandlineNumber;
                data.PostalAddress = vm.data.PostalAddress;
               // data.FirstSaleBy = vm.data.firstsaleby;
                data.ClientZone = vm.data.selectedZoneType.value;
                data.Status = vm.data.Status;

                if (typeof (vm.data.Kycid) != 'undefined' && parseInt(vm.data.Kycid) != null) {
                    data.Kycid = vm.data.Kycid;
                    httpService.httpCall('api/closureManagement/editSingleClosureKyc', 'POST', data)
                    .then(onSuccess, onFail)
                  
                }
            }
        }
        //var onSuccess = function () {
        //    if (typeof (stateParams.Id) != 'undefined' && parseInt(stateParams.Id) != null) {
        //        var Id = stateParams.Id;
        //        popupService.successsm('ISO Application', 'Successful Update of KYC Details');
        //        state.go('singleProposal', { Id: Id });
        //    }
        //    else
        //    {
        //        popupService.successsm('ISO Application', 'Successful Update of KYC Details');
        //        state.go('singleclosurekyc', { Kycid: vm.data.Kycid });
        //    }
        //};

        var onSuccess = function () {
            var Id;
            Id = vm.data.propid;
            if (vm.data.propid == 0) {
                popupService.successsm('ISO Application', 'Successful Update of KYC Details');
               // state.go('singleclosurekyc', { Kycid: vm.data.Kycid });
            }
            else {
                var kycidfk = vm.data.Kycid;
                popupService.successsm('ISO Application', 'Successful Update of KYC Detail');
                state.go('singleProposal', {Id : Id  }, { kycidfk: kycidfk });
            }
            };

        var onFail = function () {
            popupService.errorsm('ISO Aplication', 'Server Problem');
        };

        vm.func.goToBack = function () {
            state.go('singleclosurekyc', { Kycid: vm.data.Kycid });
        }


        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('AddClosureKycController', AddClosureKycController);

    AddClosureKycController.$inject = ['httpService', '$state', 'popupService'];

    function AddClosureKycController(httpService, state, popupService) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.isFormSubmit = false;
            vm.data.addAlternateContact = false;
            vm.data.requiredCompanyType = false;
            vm.data.requiredAssociate = false;
            vm.data.ifWantAddAlternateContact = true;
            vm.data.ifDontWantAddAlternateContact = false;

            vm.data.CompanyType = [
                { value: 'Select' },
                { value: 'Proprietorship' },
                { value: 'Pvt. Ltd.' },
                { value: 'Public Ltd.' },
                { value: 'Trust/Co-op/Association' },
                { value: 'Government' },
                { value: 'Other' }
            ];

            vm.data.Associate = [
                { value: 'Select' },
                { value: 'Yes' },
                { value: 'No' }
            ];

            vm.data.selectedCompanyType = vm.data.CompanyType[0];
            vm.data.selectedAssociate = vm.data.Associate[0];

            httpService.httpCall('api/enquiryManagement/suggistCompanyForEnquiry', 'GET', null)
             .then(function (response) {
                 if (response != null) {
                     vm.data.getCompany = response;
                 }
             });

            httpService.httpCall('api/enquiryManagement/suggestassignto', 'GET', null)
            .then(function (response) {
                vm.data.suggestAgentName = response;
                vm.data.suggestAgentNameData = angular.copy(vm.data.suggestAgentName);
            });

            httpService.httpCall('api/enquiryManagement/suggestCountryName', 'GET', null)
            .then(function (response) {
                vm.data.suggestCountry = response;
                vm.data.suggestCountryData = angular.copy(vm.data.suggestCountry);
            });

        }
        //vm.data.emailFormat = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;

        vm.func.activeAddAlternateContact = function () {
                vm.data.addAlternateContact = true;
                vm.data.ifWantAddAlternateContact = false;
                vm.data.ifDontWantAddAlternateContact = true;      
        };

        vm.func.deactiveAddAlternateContact = function () {
                vm.data.addAlternateContact = false;
                vm.data.ifWantAddAlternateContact = true;
                vm.data.ifDontWantAddAlternateContact = false;

                vm.data.AlternateContactPerson = '';
                vm.data.AlternateDesignation = '';
                vm.data.AlternateNumber = '';
                vm.data.AlternateEmail = '';
        };

        vm.func.hideRequiredCompanyType = function () {
            if (vm.data.selectedCompanyType != 'Select') {
                vm.data.requiredCompanyType = false;
            }
        };

        vm.func.hideRequiredAssociate = function () {
            if (vm.data.selectedAssociate != 'Select') {
                vm.data.requiredAssociate = false;
            }
        };

        function preSaveNewKyc() {
            var data = {};
            data.Company_name = vm.data.CompanyName;
            data.Associate = vm.data.selectedAssociate.value;
            data.Account_Manager = vm.data.AgentName;
            data.First_Sale_By = vm.data.AgentName;
            data.Contact_Name = vm.data.ContactPerson;
            data.Designation = vm.data.Designation;
            data.Contact_Num = vm.data.ContactNumber;
            data.Contact_Email = vm.data.ContactEmail;
            data.AltContact_Name = vm.data.AlternateContactPerson;
            data.AltDesignation = vm.data.AlternateDesignation;
            data.AltContact_Number = vm.data.AlternateNumber;
            data.AltContact_Email = vm.data.AlternateEmail;
            data.Nature_of_Business = vm.data.Natureofbusiness;
            data.Company_Country = vm.data.CompanyCountry;
            data.Company_City = vm.data.CompanyCity;
            data.Company_State = vm.data.CompanyState;
            data.Company_Type = vm.data.selectedCompanyType.value;
            data.Employee_Strength = vm.data.EmployeeStrength;
            data.Locations = vm.data.Locations;
            data.Years_in_Business = vm.data.Yearsinbusiness;
            data.Turnover = vm.data.Turnover;
            data.URL = vm.data.URL;
            data.Landline = vm.data.LandlineNumber;
            data.PostalAddress = vm.data.PostalAddress;
            return data;
        }

        vm.func.saveNewKyc = function (isValid) {
            vm.data.isFormSubmit = true;
            if (vm.data.selectedCompanyType.value == 'Select') {
                vm.data.requiredCompanyType = true;
                isValid = false;
            }
            if (vm.data.selectedAssociate.value == 'Select') {
                vm.data.requiredAssociate = true;
                isValid = false;
            }
            if (isValid == true) {
                var allNewKycData = preSaveNewKyc();
                if (allNewKycData != null) {
                    httpService.httpCall('api/closureManagement/saveNewClosureKYC', 'POST', allNewKycData)
                    .then(onSuccess, onFail)
                }
            }
        };

        var onSuccess = function () {
            popupService.successsm('ISO Application', 'Successfully add new KYC');
            state.go('searchclosurekyc');
        };

        var onFail = function () {
            popupService.errorsm('ISO Aplication', 'Server Problem');
        };

        vm.func.search = function () {
            var searchData = {};
            searchData.SearchType = (typeof (vm.data.searchKeyDetails) != 'undefined' && vm.data.searchKeyDetails != null && /[isString]/.test(vm.data.searchKeyDetails)) ? 'CompanyName' : 'EnquiryId';
            if (searchData.SearchType == "CompanyName") {
                searchData.searchByComDetails = vm.data.searchKeyDetails;
            }
            else if (searchData.SearchType == "EnquiryId") {
                searchData.searchByEnqId = vm.data.searchKeyDetails;
            }

            httpService.httpCall('api/enquiryManagement/getsearchEnquerydetails', 'POST', searchData)
            .then(function (getResponse) {
                if (getResponse != null) {
                    vm.data.EnquiryId = getResponse.Enquiryid
                    vm.data.CompanyName = getResponse.Companyname;
                    vm.data.AgentName = getResponse.Enquiryassignto;
                    vm.data.ContactPerson = getResponse.Enquiryname;
                    vm.data.ContactNumber = getResponse.Enquiryphone;
                    vm.data.ContactEmail = getResponse.Enquiryemail;
                    vm.data.CompanyCountry = getResponse.Country;
                    vm.data.CompanyCity = getResponse.Enquirycity;
                    vm.data.URL = getResponse.Enquirycompurl;
                    vm.data.EmployeeStrength = getResponse.Companysize;
                    angular.forEach(vm.data.CompanyType, function (item, index) {
                        if (item.value == getResponse.Companytype) {
                            vm.data.selectedCompanyType = vm.data.CompanyType[index];
                        }
                    });
                    
                }
                else {
                    onFail();
                }
            });
        };

        vm.func.goToBack = function () {
            state.go('searchclosurekyc');
        }


        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('SearchEnquiryDetailsController', SearchEnquiryDetailsController)

    SearchEnquiryDetailsController.$inject = ['httpService', 'popupService'];

    function SearchEnquiryDetailsController(httpService, popupService) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.afterSearch = false;
            vm.data.totalItems = 0;
            vm.data.itemsPerPage = 10;
            vm.data.pagination = {
                current: 1
            };


            httpService.httpCall('api/enquiryManagement/suggistCompanyForEnquiry', 'GET', null)
            .then(function (response) {
                if (response != null) {
                    vm.data.getCompany = response;
                }
            });

            //httpService.httpCall('api/enquiryManagement/getAllEnquiryDetails', 'GET', null)
            //.then(getEnquiryDetailsData)

            httpService.httpCall('api/enquiryManagement/getFreshEnquiry', 'GET', null)
            .then(getFreshEnquiryData)

        }

        //var getEnquiryDetailsData = function (response) {
        //    vm.data.allEnquiry = response;
        //    vm.data.allEnquiryData = angular.copy(vm.data.allEnquiry);
        //    getPages();
        //}

        var getFreshEnquiryData = function (response) {
            vm.data.allEnquiry = response;
            vm.data.allEnquiryData = angular.copy(vm.data.allEnquiry);
            getPagesForFreshEnquiry();
        }

        var getPagesForFreshEnquiry = function () {
            vm.data.totalItems = vm.data.allEnquiry.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        var getPages = function () {
            vm.data.totalItems = vm.data.allEnquiry.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allEnquiryData = vm.data.allEnquiry.slice(start, end);
          
        };

        vm.func.searchEnquiryData = function () {
            httpService.httpCall('api/enquiryManagement/getEnquiryDataBySearch?searchKey=' + vm.data.CompanyName, 'GET', null)
            .then(function (response) {
                vm.data.afterSearch = true;
                vm.data.allEnquiry = response;
                vm.data.allEnquiryData = angular.copy(vm.data.allEnquiry);
                getPages();
            })
        }

        vm.func.addNewEnquiry = function () {
            popupService.addNewEnquiry(refresh);
        }

        vm.data.viewEnquiryDetails = function (row) {
            popupService.viewEnquiryDetails(row, refresh);
        }

        vm.func.updateEnquiryAssign = function (row) {
            popupService.editEnquiry(row, refresh);
        }

        vm.func.invalidEnquiry = function (row) {
            popupService.editinvalidEnquiry(row, refresh);
        }

        var refresh = function () {
            vm.data.CompanyName = '';
            init();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            init();
        }

        init();

    }
})();
(function () {
  'use strict';

  angular
    .module('isoappClient')
    .controller('certpendingController', certpendingController)

  certpendingController.$inject = ['httpService', '$filter', '$state', '$window', '$state'];//'popupService'$window

  function certpendingController(httpService, $filter, $state, $window, state) {//, popupService,$window
    var vm = this;

    vm.data = {};
    vm.func = {};

    var init = function () {

      vm.data.hideProposalSearch = false;
      vm.data.hideKycSearch = true;
      vm.data.searchProposal = false;
      vm.data.itemsPerPage = 10;
      vm.data.totalItems = 0;
      vm.data.pagination = {
        current: 1
      };


      httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
        .then(function (response) {
          vm.data.getAgentName = response;
        })

      
      httpService.httpCall('api/proposalMnagement/suggestforCertDispatch', 'GET', null)
        .then(function (response) {
          vm.data.CertDispatch = response;
        })

      httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
        .then(function (response) {
          vm.data.getallCompanyName = response;
        })

           
      httpService.httpCall('api/proposalMnagement/getAllCertsPending', 'GET', null)
        .then(getAllProposal)

    }

    vm.func.getSingleKycDetails = function (Kycid, Id) {
      
      var url = $state.href('singleclosurekyc', { Kycid: Kycid, Id: Id });
      $window.open(url);
    }
    
    var getAllProposal = function (response) {
      vm.data.allProposal = response;
      
      vm.data.allProposalData = angular.copy(vm.data.allProposal);
      
      vm.func.pageChange();
      getPages();
    }
    
    
    var getPages = function () {
      vm.data.totalItems = vm.data.allProposal.length;
      vm.data.pagination = {
        current: 1
      }
      vm.data.start = vm.data.pagination.current;
      vm.data.end = vm.data.start * vm.data.itemsPerPage;
      if (vm.data.totalItems < vm.data.itemsPerPage) {
        vm.data.end = vm.data.totalItems;
      }
    };


    vm.func.searchby = function () {
      var sortData = {};
      sortData.Dispatch = vm.data.Dispatch;
      //sortData.Zone = vm.data.Zonedata;
      sortData.Agent = vm.data.AgentName;
      var nosofdays = 0;

      //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
      //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

      //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
      //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

      //sortData.Fromdate = vm.data.fromDateformate;
      //sortData.Todate = vm.data.toDateformate;


      if (vm.data.FromDate != null && vm.data.ToDate != null) {
        vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
        vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

        vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
        vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

        sortData.Fromdate = vm.data.fromDateformate;
        sortData.Todate = vm.data.toDateformate;

      }
      else {
        sortData.Fromdate = vm.data.FromDate;
        sortData.Todate = vm.data.ToDate;
      }


      // sortData.Fromdate = vm.data.FromDate;
      //    sortData.Todate = vm.data.ToDate;

      httpService.httpCall('api/proposalMnagement/searchbyCPendProjStatus', 'POST', sortData)
        .then(successSearchsorted)
    }

    var successSearchsorted = function (response) {
      vm.data.searchProposal = true;
      vm.data.allProposal = response;
      vm.data.allProposalData = angular.copy(vm.data.allProposal);
      getPages();
    }


    vm.func.pageChange = function () {
      var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
        , end = start + vm.data.itemsPerPage;

      vm.data.start = start + 1;
      vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

      vm.data.allProposalData = vm.data.allProposal.slice(start, end);
    };

    //vm.data.getSingleProposalDetails = function (Id) {
    //    //state.go('singleProposal', { Id: Id });

    //    var url = state.href('singleProposal', { Id: Id });
    //    $window.open(url);
    //}

    //vm.func.addNewProposal = function () {
    //    popupService.addProposal(refresh);
    //}

    vm.func.searchProposalData = function () {

      var format = /&/;

      if (format.test(vm.data.CompanyName)) {

        var str = vm.data.CompanyName;

        httpService.httpCall('api/proposalMnagement/searchCertPendProposalData?SearchKey=' + str, 'Get', null)
          .then(successSearch)

      } else {

        httpService.httpCall('api/proposalMnagement/searchCertPendProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
          .then(successSearch)

      }

    }

    var successSearch = function (response) {
      vm.data.searchProposal = true;
      vm.data.hideProposalSearch = false;
      vm.data.hideKycSearch = true;
      if (response.length == 0) {

        httpService.httpCall('api/closureManagement/searchClosureKYC?SearchKey=' + vm.data.CompanyName, 'GET', null)
          .then(successSearchKyc)
      }
      else {

        vm.data.allProposal = response;
        vm.data.allProposalData = angular.copy(vm.data.allProposal);
        getPages();

      }
    }
    var successSearchKyc = function (response) {
      vm.data.searchProposal = true;
      vm.data.hideKycSearch = false;
      vm.data.hideProposalSearch = true;
      vm.data.allProposal = response;
      vm.data.allProposalData = angular.copy(vm.data.allProposal);
      getPages();

    }
    vm.func.getSingleKycDetailsByKyc = function (Kycid) {
      //   state.go('singleclosurekyc', { Kycid: Kycid });

      var url = state.href('singleclosurekyc', { Kycid: Kycid });
      $window.open(url);

    }

    vm.func.refresh = function () {
      vm.data.CompanyName = '';
      vm.data.Dispatch = '';
      vm.data.AgentName = '';
      vm.data.Fromdate = '';
      vm.data.Todate = '';
      init();
    }

    init();
  }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('CertificatesPendingController', CertificatesPendingController)

    CertificatesPendingController.$inject = ['httpService', '$filter', '$state', '$window','$state'];//'popupService'$window

    function CertificatesPendingController(httpService, $filter, $state, $window,state) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforCertDispatch', 'GET', null)
          .then(function (response) {
              vm.data.CertDispatch = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function(response){
                vm.data.getallCompanyName=response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/getAllNewProposalDetails', 'GET', null)
            .then(getAllProposal)
            
        }
        vm.func.getSingleKycDetails = function (Kycid,Id) {
          // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('singleclosurekyc', { Kycid: Kycid ,Id:Id});
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getAllProposal = function (response) {
            vm.data.allProposal = response;
           // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);
           
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
        ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
            vm.func.pageChange();
            getPages();
        }
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}
       
        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.Dispatch = vm.data.Dispatch;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


           // sortData.Fromdate = vm.data.FromDate;
        //    sortData.Todate = vm.data.ToDate;

          httpService.httpCall('api/proposalMnagement/searchbyCPipeProjStatus', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}
       
        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName;

              httpService.httpCall('api/proposalMnagement/searchCertPipelineProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

              httpService.httpCall('api/proposalMnagement/searchCertPipelineProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            if (response.length == 0) {

                httpService.httpCall('api/closureManagement/searchClosureKYC?SearchKey=' + vm.data.CompanyName, 'GET', null)
                 .then(successSearchKyc)
            }
            else {

            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();

            }
        }
        var successSearchKyc = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideKycSearch = false;
            vm.data.hideProposalSearch = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
                        
        }
        vm.func.getSingleKycDetailsByKyc = function (Kycid) {
         //   state.go('singleclosurekyc', { Kycid: Kycid });

            var url = state.href('singleclosurekyc', { Kycid: Kycid });
            $window.open(url);

        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('agentrequestController', agentrequestController)

    agentrequestController.$inject = ['httpService', '$filter', '$state', '$window', '$state'];//'popupService'$window

    function agentrequestController(httpService, $filter, $state, $window, state) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
          //  httpService.httpCall('api/proposalMnagement/suggestforCertDispatch', 'GET', null)
          //.then(function (response) {
          //    vm.data.CertDispatch = response;
          //})

          httpService.httpCall('api/proposalMnagement/suggestforAgentRequest', 'GET', null)
            .then(function (response) {
              vm.data.AgentRequest = response;
            })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/GetAllAgentRequestDetails', 'GET', null)
            .then(getAllProposal)

        }
        vm.func.getSingleKycDetails = function (Kycid, Id) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('singleclosurekyc', { Kycid: Kycid, Id: Id });
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getAllProposal = function (response) {
            vm.data.allProposal = response;
            // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);

            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
            vm.func.pageChange();
            getPages();
        }
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}

        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


      vm.func.searchby = function () {
            debugger;
        var sortData = {};
            sortData.ReqStatus = vm.data.ReqStatus;
            //sortData.Dispatch = vm.data.Dispatch;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }

        httpService.httpCall('api/proposalMnagement/searchbyARProjStatus', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {
            var format = /&/;

          if (format.test(vm.data.CompanyName)) {

            var str = vm.data.CompanyName;

            httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

            httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            if (response.length == 0) {

                httpService.httpCall('api/closureManagement/searchClosureKYC?SearchKey=' + vm.data.CompanyName, 'GET', null)
                 .then(successSearchKyc)
            }
            else {

                vm.data.allProposal = response;
                vm.data.allProposalData = angular.copy(vm.data.allProposal);
                getPages();

            }
        }
        var successSearchKyc = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideKycSearch = false;
            vm.data.hideProposalSearch = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();

        }
        vm.func.getSingleKycDetailsByKyc = function (Kycid) {
            //   state.go('singleclosurekyc', { Kycid: Kycid });

            var url = state.href('singleclosurekyc', { Kycid: Kycid });
            $window.open(url);

        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            //vm.data.Dispatch = '';
            vm.data.ReqStatus = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('SurvKycDetailsController', SurvKycDetailsController);

    SurvKycDetailsController.$inject = ['$stateParams', 'httpService', '$state', 'popupService', '$rootScope'];

    function SurvKycDetailsController(stateParams, httpService, state, popupService, rootScope) {
        
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.noShowDetails = true;
            vm.data.hideDetails = false;
            vm.data.modalEnable = true;
            vm.data.itemsPerPage = 5;
            vm.data.totalItems = 0;
            vm.data.totalItemsofClosure = 0;
            vm.data.totalItemsofComment = 0;
            vm.data.pagination = {
                current: 1
            };
            vm.data.paginationofClosure = {
                current: 1
            };
            vm.data.paginationofComment = {
                current: 1
            };
            var UserData = angular.fromJson(rootScope.UserData);
            vm.data.LogedInUserId = angular.fromJson(UserData).UserName;

            //if (typeof (stateParams.Id) != 'undefined' && parseInt(stateParams.Id) > 0) {
            //    vm.data.Id = stateParams.Id;
            //    httpService.httpCall('api/ProposalMnagement/getsingleProposalDetails?Id=' + stateParams.Id, 'GET', null)
            //    .then(function (response) {
            //        if (response.project_status == 'Soft Copy Sent') {
            //            vm.data.hidesoftcopyButton = true;
            //            vm.data.alreadysoftcopyButton = false;
            //        } else {
            //            vm.data.hidesoftcopyButton = false;
            //            vm.data.alreadysoftcopyButton = true;
            //        }
            //        if (response.project_status == 'Hard Copy Sent') {
            //            vm.data.hidehardcopyButton = true;
            //            vm.data.alreadyhardcopyButton = false;
            //        } else {
            //            vm.data.hidehardcopyButton = false;
            //            vm.data.alreadyhardcopyButton = true;
            //        }
            //        if (response.certification_type != 'Initial') {
            //            vm.data.hideDispatchButton = false;
            //            vm.data.hideSurvButton = true;
            //        } else {
            //            vm.data.hideDispatchButton = false;
            //            vm.data.hideSurvButton = true;
            //        }
            //        vm.data.PaymentStatus = response.payment_status;
            //    })
            //}

            if (typeof (stateParams.Kycid) != 'undefined' && parseInt(stateParams.Kycid) > 0) {
                httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + stateParams.Kycid, 'GET', null)
                .then(function (response) {
                    debugger;
                    vm.data.Kycid = response.Kyc_id;
                    vm.data.ClientName = response.Contact_Name;
                    vm.data.ContactNumber = response.Contact_Num;
                    vm.data.ContactEmail = response.Contact_Email;
                    vm.data.Designation = response.Designation;
                    vm.data.AltContactName = response.AltContact_Name;
                    vm.data.AltContactNumber = response.AltContact_Number;
                    vm.data.AltContactEmail = response.AltContact_Email;
                    vm.data.AltDesignation = response.AltDesignation
                    vm.data.CompanyName = response.Company_name;
                    vm.data.CompanyType = response.Company_Type;
                    vm.data.CompanyCity = response.Company_City;
                    vm.data.CompanyCountry = response.Company_Country;
                    vm.data.CompanyState = response.Company_State;
                    vm.data.NatureofBusiness = response.Nature_of_Business;
                    vm.data.CompanyType = response.Company_Type;
                    vm.data.Turnover = response.Turnover;
                    vm.data.URL = response.URL;
                    vm.data.Landline = response.Landline;
                    vm.data.EmployeeStrength = response.Employee_Strength;
                    vm.data.Associate = response.Associate;
                    vm.data.PostalAddresss = response.PostalAddress;
                    
                });

                vm.data.certId = stateParams.certId;

                var certId = vm.data.certId
            }
         

            httpService.httpCall('api/closureManagement/getCertificationDetailsForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
            .then(getCertificationDetailsForSingleKyc)

            httpService.httpCall('api/closureManagement/getCommentForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
            .then(getCommentForSingleKyc)

            httpService.httpCall('api/closureManagement/getProposalDetailsForSingleKyc?Kycid=' + stateParams.Kycid, 'GET', null)
            .then(getProposalDetailsForSingleKyc)
            
            //vm.func.saveUserActivity();
       //     httpService.httpCall('api/closureManagement/getLatestCertificationDetails?Kycid=' + stateParams.Kycid, 'GET', null)
       //.then(latestCertificates)
        }

        //vm.func.saveUserActivity = function () {
           
        //    vm.data.userName = vm.data.LogedInUserId;
        //    vm.data.visitPage = 'SurvKycDetails';
        //    vm.data.id = (stateParams.Kycid);

        //    var userData = {};
        //    userData.user_visitpage = vm.data.visitPage;
        //    userData.row_id_fk = vm.data.id;
        //    userData.userName = vm.data.userName;

        //    httpService.httpCall('api/user/saveUserActivity', 'POST', userData)
        //}

        //var latestCertificates = function (response) {
        //    vm.data.latestCerts = response;
        //    vm.data.CertsLatest = angular.copy(vm.data.latestCerts);

        //}

    

        var getCertificationDetailsForSingleKyc = function (response) {
            vm.data.certificationDetailsForSinglekyc = response;
           // vm.data.latestCert = response.RecertifiedDate;
            vm.data.certificationDetailsForSingleKycData = angular.copy(vm.data.certificationDetailsForSinglekyc);
            getPages();
        }

        vm.data.viewPropDetails = function (row) {
            popupService.viewPropDetails(row, refresh);
        }

        //vm.data.editProposal = function (Id) {
        //    state.go('singleProposal', { Id: Id });
        //}

        var getCommentForSingleKyc = function (responseForComments) {
            vm.data.commentDetailsForKyc = responseForComments;
            vm.data.commentDetailsForKycData = angular.copy(vm.data.commentDetailsForKyc);
            getPagesforComment();
        }

        var getProposalDetailsForSingleKyc = function (response) {
            vm.data.proposalDetailsForSingleKyc = response;
          // 
            vm.data.proposalDetailsForSingleKycData = angular.copy(vm.data.proposalDetailsForSingleKyc);
            getPagesforProposal();
        }

        var getPages = function () {
            vm.data.totalItems = vm.data.certificationDetailsForSinglekyc.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        var getPagesforProposal = function () {
            vm.data.totalItemsofClosure = vm.data.proposalDetailsForSingleKyc.length;
            vm.data.paginationofClosure = {
                current: 1
            }
            vm.data.startofClosure = vm.data.paginationofClosure.current;
            vm.data.endofClosure = vm.data.startofClosure * vm.data.itemsPerPage;
            if (vm.data.totalItemsofClosure < vm.data.itemsPerPage) {
                vm.data.endofClosure = vm.data.totalItemsofClosure;
            }
        };

        var getPagesforComment = function () {
            vm.data.totalItemsofComment = vm.data.commentDetailsForKyc.length;
            vm.data.paginationofComment = {
                current: 1
            }
            vm.data.startofComment = vm.data.paginationofComment.current;
            vm.data.endofComment = vm.data.startofComment * vm.data.itemsPerPage;
            if (vm.data.totalItemsofComment < vm.data.itemsPerPage) {
                vm.data.endofComment = vm.data.totalItemsofComment;
            }
        };

        vm.func.pageChangeofComment = function () {
            var startofComment = ((vm.data.paginationofComment.current - 1) * vm.data.itemsPerPage)
            , endofComment = startofComment + vm.data.itemsPerPage;

            vm.data.startofComment = startofComment + 1;
            vm.data.endofComment = (vm.data.totalItemsofComment > endofComment ? endofComment : vm.data.totalItemsofComment);

            vm.data.commentDetailsForKycData = vm.data.commentDetailsForKyc.slice(startofComment, endofComment);
        };

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.certificationDetailsForSingleKycData = vm.data.certificationDetailsForSinglekyc.slice(start, end);
        };
       
        vm.func.pageChangeofClosure = function () {
            var startofClosure = ((vm.data.paginationofClosure.current - 1) * vm.data.itemsPerPage)
            , endofClosure = startofClosure + vm.data.itemsPerPage;

            vm.data.startofClosure = startofClosure + 1;
            vm.data.endofClosure = (vm.data.totalItemsofClosure > endofClosure) ? endofClosure : vm.data.totalItemsofClosure;

            vm.data.proposalDetailsForSingleKycData = vm.data.proposalDetailsForSingleKyc.slice(startofClosure, endofClosure);
        };



        vm.data.goAddNewCertificationPage = function (Kycid, Id) {
            state.go('addnewcertification', { Kycid: Kycid , Id: Id })
        };
        var Prid = 0;
        vm.data.editClosureKYCDetails = function (Kycid) {
            state.go('editClosureKycDetais', { Kycid: Kycid }, { Prid: Prid })
        };

        vm.func.editCertificationDetails = function (row) {
            popupService.editCertificate(row, refresh);
        }


       
        
        vm.func.giveComment = function (Kycid, certId) {
          //  certId = vm.data.certId;
          //  Kycid = stateParams.Kycid
            popupService.addCommentsInClosure(Kycid, certId, refresh);
        }

        vm.func.SoftCopySent = function (Kycid, Id) {
            vm.data.certificationDetailsForSingleKycData.length = 1;
            
            if (vm.data.certificationDetailsForSingleKycData.length != 0) {               
                //popupService.finishClosure(Kycid, Id, refresh);
                var prodata = {};
                prodata.Id = Id;
                prodata.ProjectStatus = 'Soft Copy Sent';
                httpService.httpCall('api/proposalMnagement/projectStatusUpdate', 'POST', prodata)
                       .then(onSuccessSoftCopy, onFail1);

                var updateProposalHistory = {};
               
                updateProposalHistory.kyc_id_fk = vm.data.Kycid;
                updateProposalHistory.comment =  "Certification Status - Soft Copy Sent.";
                updateProposalHistory.activity_user = vm.data.LogedInUserId;
                updateProposalHistory.staus = '1';

                httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
                .then(onSuccess, onFail)
                init();

            }
            else {
                onFail();
            }
            
        }
        vm.func.HardCopySent = function (Kycid, Id) {
            vm.data.certificationDetailsForSingleKycData.length = 1;
            if (vm.data.certificationDetailsForSingleKycData.length != 0) {

                //popupService.finishClosure(Kycid, Id, refresh);
                var prodata = {};
                prodata.Id = Id;
                prodata.ProjectStatus = 'Hard Copy Sent';
                httpService.httpCall('api/proposalMnagement/projectStatusUpdate', 'POST', prodata)
                       .then(onSuccessHardCopy, onFail1);

                var updateProposalHistory = {};

                updateProposalHistory.kyc_id_fk = vm.data.Kycid;
                updateProposalHistory.comment = "Certification Status - Hard Copy Sent.";
                updateProposalHistory.activity_user = vm.data.LogedInUserId;
                updateProposalHistory.staus = '1';

                httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
                .then(onSuccess, onFail)

                init();

            }
            else {
                onFail();
            }

        }
        vm.func.SurveillanceFail = function (Kycid, Id) {
            popupService.survFail(Kycid, Id, refresh);
        }
        vm.func.SurveillancePass = function (Kycid, Id) {
            popupService.survPass(Kycid, Id, refresh);
        }
        
        vm.func.CloseandFinish = function (Kycid, Id) {
            
       //      ---------------------------------------------------------------------------------------------------------
            //Checks KYC UPDATE Info
            //  ------------------------------------------------------------------------------------------------------
      //      httpService.httpCall('api/closureManagement/getLatestCertificationDetails?Kycid=' + stateParams.Kycid, 'GET', null)
      //.then(function(response){
      //      //var latestCertificates = function (response) {
      //          vm.data.latestCerts = response;
      //          vm.data.CertsLatest = angular.copy(vm.data.latestCerts);

      //      })
      //      ---------------------------------------------------------------------------------------------------------
    //  ------------------------------------------------------------------------------------------------------
            //vm.data.date = new Date();
           // var nosofdays = 30;
           // vm.data.presentAdded = vm.data.date.setDate(vm.data.date.getDate() - nosofdays);
            //vm.data.lastrecert = getCertificationDetailsForSingleKyc.RecertifiedDate;
           // vm.data.Dateformate = $filter('date')(vm.data.presentAdded, 'yyyy-MM-dd HH:mm:ss Z');
            //if (vm.data.CertsLatest.length <= 0) {
            //    onFail1();
            //}
            //if (vm.data.proposalDetailsForSingleKycData.length <= 0) {
            //    onFail();
            //}
            vm.data.certificationDetailsForSingleKycData.length = 1;
           
            if (vm.data.certificationDetailsForSingleKycData.length != 0) {
                
              //if (vm.data.CertsLatest.length != 0) {

                  //if ((vm.data.PostalAddresss != null && vm.data.PostalAddresss != '')) {
                      //popupService.addDispatchDetails(Id,refresh);
                      popupService.finishClosure(Kycid, Id, refresh);

                      var updateProposalHistory = {};

                      updateProposalHistory.kyc_id_fk = vm.data.Kycid;
                   //   updateProposalHistory.comment = vm.data.PaymentStatus + " verified. Certi Status Dispatched";
                      updateProposalHistory.comment = "Certification Status - Dispatched";
                      updateProposalHistory.activity_user = vm.data.LogedInUserId;
                      updateProposalHistory.status = '1';

                      httpService.httpCall('api/proposalMnagement/updateProposalHistory', 'POST', updateProposalHistory)
                      .then(onSuccess, onFail)
                    //}
                    //else {
                    //    onFail();
                    //}
                //}
                //else {
                //    onFail1();
                //}

            }
            else {
                onFail();
            }   
          //  addDispatchDetails

        }
      vm.func.DispatchDetails = function (Kycid, Id) {

          popupService.addDispatchDetails(Id, refresh);

        }

        vm.func.activenoShowDetails = function () {
            vm.data.noShowDetails = false;
            vm.data.hideDetails = true;
        }
        var onFail = function () {
            popupService.errorsm('ISO', 'Update Details of KYC!');
        };
        var onFail1 = function () {
            popupService.errorsm('ISO', 'Certificate Too Old to Dispatch!\n\n (Older than 6 months From Now)');
        };
        var onSuccessSoftCopy = function () {
          
            popupService.successsm('ISO', 'Certificate Soft Copy Sent');
          
        }
        var onSuccessHardCopy = function () {

            popupService.successsm('ISO', 'Certificate Hard Copy Sent');

        }
        var refresh = function () {
            init();
        }

        init();
    }
})();
(function () {
	'use strict';

	angular
    .module('isoappClient')
    .controller('searchCertificateController', searchCertificateController)

	searchCertificateController.$inject = ['httpService', '$filter', 'popupService', '$state', '$window'];

	function searchCertificateController(httpService, $filter, popupService, $state, $window) {
		var vm = this;

		vm.data = {};
		vm.func = {};


		var init = function () {
			vm.data.afterSearch = false;
			vm.data.totalItems = 0;
			vm.data.itemsPerPage = 10;
			vm.data.Pagination = {
				current: 1
			};

			httpService.httpCall('api/certificationDetails/suggestCompanyname', 'GET', null)
            .then(function (response) {
            	vm.data.getAllCompanyNames = response;
            })


			vm.func.dateOptions = function () {
				dateFormat: "dd-MM-yyyy"
			};

			vm.data.valueofdate = new Date(vm.data.valueofdate);



			vm.data.FromDate = $filter('date')(vm.data.valueofdate, "dd/MM/yyyy");
			vm.data.ToDate = $filter('date')(vm.data.ToDate, "dd/MM/yyyy");



			vm.func.searchby = function () {
				var sortData = {};
				//sortData.Zone = vm.data.Zonedata;
				sortData.SalesStatus = vm.data.SaleStatus;
				sortData.CertStatus = vm.data.CertStatus;
				sortData.Agent = vm.data.AgentName;
				sortData.FromDate = vm.data.FromDate;
				sortData.ToDate = vm.data.ToDate;

				httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
                .then(successSearchsorted)
			}
		}


		vm.func.searchby = function () {
			var sortData = {};
			sortData.Zone = vm.data.Zonedata;
			sortData.Agent = vm.data.AgentName;
			var nosofdays = 0;

			if (vm.data.FromDate != null && vm.data.ToDate != null) {
				vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
				vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

				vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
				vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

				sortData.Fromdate = vm.data.fromDateformate;
				sortData.Todate = vm.data.toDateformate;

			}
			else {
				sortData.Fromdate = vm.data.FromDate;
				sortData.Todate = vm.data.ToDate;
			}

			//if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
			//    if (vm.data.CompanyState == '' || vm.data.CompanyState == null) {
			//        vm.data.StateName = true;
			//     //   isValid = false;
			//    }

			//}
			//   sortData.FromDate = vm.data.FromDate;
			// sortData.ToDate = vm.data.ToDate;

			httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
               .then(successSearchsorted)

		}
		var successSearchsorted = function (response) {
			vm.data.afterSearch = true;
			vm.data.getAllCertification = response;
			vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
			getPages();
		}

		//var getAllCertificates = function (response) {
		//	vm.data.getAllCertification = response;
		//	vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
		//	getPages();
		//}

		vm.func.searchProposalData = function () {

		    var format = /&/;

		    if (format.test(vm.data.CompanyName)) {

		        var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

		    } else {

		        httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

		    }

		}

		vm.data.viewSearchDetails = function (row) {
		
			popupService.viewCertDetails(row);
		}

		var successsearch = function (response) {
			vm.data.afterSearch = true;
			vm.data.getAllCertification = response;
			vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
			getPages();
		}

		var getPages = function () {
			vm.data.totalItems = vm.data.getAllCertification.length;
			vm.data.pagination = {
				current: 1
			}
			vm.data.start = vm.data.pagination.current;
			vm.data.end = vm.data.start * vm.data.itemsPerPage;
			if (vm.data.totalItems < vm.data.itemsPerPage) {
				vm.data.end = vm.data.totalItems;
			}
		};

		vm.func.pageChange = function () {
			var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

			vm.data.start = start + 1;
			vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

			vm.data.getAllCertificationData = vm.data.getAllCertification.slice(start, end);
		};
		//debugger;
		vm.func.getSurvSingleKycDetails = function (Kycid) {
			// var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });



			var url = $state.href('survclosurekyc', { Kycid: Kycid });
			$window.open(url);

		}

		vm.func.refresh = function () {
			vm.data.CompanyName = '';
			vm.data.SaleStatus = '';
			vm.data.CertStatus = '';
			vm.data.AgentName = '';
			vm.data.FromDate = '';
			vm.data.ToDate = '';

			init();
		}
		init();
	}





})();
(function () {
  'use strict';

  angular
    .module('isoappClient')
    .controller('issuedCertificatesController', issuedCertificatesController)

  issuedCertificatesController.$inject = ['httpService', '$filter', '$state', '$window'];

  function issuedCertificatesController(httpService, $filter, $state, $window) {
    var vm = this;

    vm.data = {};
    vm.func = {};


    var init = function () {
      vm.data.afterSearch = false;
      vm.data.totalItems = 0;
      vm.data.itemsPerPage = 10;
      vm.data.Pagination = {
        current: 1
      };


      var date = new Date();

      var firstDay =
        new Date(date.getFullYear(), date.getMonth(), 1);

      var lastDay =
        new Date(date.getFullYear(), date.getMonth() + 1, 0);

      vm.data.selectDateType = [
        { value: 'Select', id: 0 },
        { value: 'Issue Date on Cert', id: 2 },
        { value: 'Expiry Date on Cert', id: 3 },
        { value: 'New Certificates', id: 1 },
        { value: 'Renewed Certificates', id: 4 },
        { value: 'Modified Certificates', id: 5 },
        
     
      ];

      vm.data.DateType = vm.data.selectDateType[0];
      //$('#datepicker').Datepicker({
      //               dateFormat: 'dd-mm-yy'
      //           });

      // httpService.httpCall('api/certificationDetails/suggestforZone', 'GET', null)
      //.then(function (response) {
      //    vm.data.getZoneData = response;
      //})

      //httpService.httpCall('api/closureManagement/suggestforSaleStatus', 'GET', null)
      //  .then(function (response) {
      //    vm.data.getSaleStatus = response;
      //  })
      httpService.httpCall('api/closureManagement/suggestForCertStatus', 'GET', null)
        .then(function (response) {
          vm.data.getCertStatus = response;
        })
      httpService.httpCall('api/closureManagement/getAccreditationBody', 'GET', null)
        .then(function (response) {
          vm.data.getAccBody = response;
        })
      httpService.httpCall('api/closureManagement/getCertificationBody', 'GET', null)
        .then(function (response) {
          vm.data.getCertBody = response;
        })
      httpService.httpCall('api/certificationDetails/suggestforAgent', 'GET', null)
        .then(function (response) {
          vm.data.getAgentName = response;
        })

      httpService.httpCall('api/certificationDetails/getAllIssuedCertificates', 'GET', null)
        .then(getAllCertificates)

      httpService.httpCall('api/certificationDetails/suggestCompanyname', 'GET', null)
        .then(function (response) {
          vm.data.getAllCompanyNames = response;
        })


      vm.func.dateOptions = function () {
        dateFormat: "dd-MM-yyyy"
      };

      vm.data.valueofdate = new Date(vm.data.valueofdate);



      vm.data.FromDate = $filter('date')(vm.data.valueofdate, "dd/MM/yyyy");
      vm.data.ToDate = $filter('date')(vm.data.ToDate, "dd/MM/yyyy");



      //vm.func.searchby = function () {
      //  var sortData = {};
      //  sortData.DateType = vm.data.DateType.value;
      //  //sortData.Zone = vm.data.Zonedata;
      //  //sortData.SalesStatus = vm.data.SaleStatus;
      //  sortData.CertStatus = vm.data.CertStatus;
      //  sortData.Agent = vm.data.AgentName;
      //  sortData.CertBody = vm.data.CertBody;
      //  sortData.AccBody = vm.data.AccBody;
      //  sortData.FromDate = vm.data.FromDate;
      //  sortData.ToDate = vm.data.ToDate;

      //  httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
      //    .then(successSearchsorted)
      //}
    }


    vm.func.searchby = function () {
      var sortData = {};
      sortData.Zone = vm.data.Zonedata;
      sortData.Agent = vm.data.AgentName;
      sortData.CertBody = vm.data.CertBody;
      sortData.AccBody = vm.data.AccBody;
      sortData.DateType = vm.data.DateType.value;
      //sortData.Zone = vm.data.Zonedata;
      //sortData.SalesStatus = vm.data.SaleStatus;
      sortData.CertStatus = vm.data.CertStatus;
      sortData.Agent = vm.data.AgentName;
      sortData.CertBody = vm.data.CertBody;
      sortData.AccBody = vm.data.AccBody;
      sortData.FromDate = vm.data.FromDate;
      sortData.ToDate = vm.data.ToDate;

      var nosofdays = 0;

      if (vm.data.FromDate != null && vm.data.ToDate != null) {
        vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
        vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

        vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
        vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

        sortData.Fromdate = vm.data.fromDateformate;
        sortData.Todate = vm.data.toDateformate;

      }
      else {
        sortData.Fromdate = vm.data.FromDate;
        sortData.Todate = vm.data.ToDate;
      }

      //if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
      //    if (vm.data.CompanyState == '' || vm.data.CompanyState == null) {
      //        vm.data.StateName = true;
      //     //   isValid = false;
      //    }

      //}
      //   sortData.FromDate = vm.data.FromDate;
      // sortData.ToDate = vm.data.ToDate;

      //httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
      //  .then(successSearchsorted)

      if (vm.data.DateType.id == 1) {
        httpService.httpCall('api/certificationDetails/getCertificationSortedCreated', 'POST', sortData)
          .then(successSearchsorted)

      }
      else if (vm.data.DateType.id == 2) {
        //sortData.Dispatch = vm.data.QaStatus.value;
        httpService.httpCall('api/certificationDetails/getCertificationSortedIssue', 'POST', sortData)
          .then(successSearchsorted)
      }
      else if (vm.data.DateType.id == 3) {
        //sortData.PaymentStatus = vm.data.QaStatus.value;
        httpService.httpCall('api/certificationDetails/getCertificationSortedExpiry', 'POST', sortData)
          .then(successSearchsorted)
      }
      else if (vm.data.DateType.id == 4) {
        //sortData.PaymentStatus = vm.data.QaStatus.value;
        httpService.httpCall('api/certificationDetails/getCertificationSortedRecertify', 'POST', sortData)
          .then(successSearchsorted)
      }
      else if (vm.data.DateType.id == 5) {
        //sortData.PaymentStatus = vm.data.QaStatus.value;
        httpService.httpCall('api/certificationDetails/getCertificationSortedModified', 'POST', sortData)
          .then(successSearchsorted)
      }

    }
    var successSearchsorted = function (response) {
      vm.data.afterSearch = true;
      vm.data.getAllCertification = response;
      vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
      getPages();
    }

    var getAllCertificates = function (response) {
      vm.data.getAllCertification = response;
      vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
      getPages();
    }

    vm.func.searchCertificationData = function () {


      //var format = /&/;
      //alert('Here');
      //if (format.test(vm.data.CompanyName)) {

      //    alert('Here');

      //    var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

      //    httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + str, 'Get', null)
      //    .then(successSearch)

      //} else {

      //    alert('Here');

      //    httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + vm.data.CompanyName, 'Get', null)
      //    .then(successSearch)

      //}



      httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + vm.data.CompanyName, 'GET', null)
        .then(successsearch)


    }


    var successsearch = function (response) {
      vm.data.afterSearch = true;
      vm.data.getAllCertification = response;
      vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
      getPages();
    }

    var getPages = function () {
      vm.data.totalItems = vm.data.getAllCertification.length;
      vm.data.pagination = {
        current: 1
      }
      vm.data.start = vm.data.pagination.current;
      vm.data.end = vm.data.start * vm.data.itemsPerPage;
      if (vm.data.totalItems < vm.data.itemsPerPage) {
        vm.data.end = vm.data.totalItems;
      }
    };

    vm.func.pageChange = function () {
      var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
        , end = start + vm.data.itemsPerPage;

      vm.data.start = start + 1;
      vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

      vm.data.getAllCertificationData = vm.data.getAllCertification.slice(start, end);
    };
    //debugger;
    vm.func.getSurvSingleKycDetails = function (Kycid) {
      // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

      var url = $state.href('survclosurekyc', { Kycid: Kycid });
      $window.open(url);

    }

    vm.func.refresh = function () {
      vm.data.CompanyName = '';
      //vm.data.SaleStatus = '';
      vm.data.CertStatus = '';
      vm.data.AgentName = '';
      vm.data.FromDate = '';
      vm.data.ToDate = '';

      init();
    }
    init();
  }





})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('allCertificationController', allCertificationController)

    allCertificationController.$inject = ['httpService', '$filter', '$state', '$window'];

    function allCertificationController(httpService, $filter, $state, $window) {
        var vm=this;
       
        vm.data={};
        vm.func={};


        var init =function()  {
            vm.data.afterSearch=false;
            vm.data.totalItems=0;
            vm.data.itemsPerPage=10;
            vm.data.Pagination={
                current:1
            };
           
         
            //$('#datepicker').Datepicker({
            //               dateFormat: 'dd-mm-yy'
            //           });
           
           // httpService.httpCall('api/certificationDetails/suggestforZone', 'GET', null)
           //.then(function (response) {
           //    vm.data.getZoneData = response;
           //})

            httpService.httpCall('api/closureManagement/suggestforSaleStatus', 'GET', null)
            .then(function (response) {
                vm.data.getSaleStatus = response;
            })
            httpService.httpCall('api/closureManagement/suggestForCertStatus', 'GET', null)
            .then(function (response) {
                vm.data.getCertStatus = response;
            })
            httpService.httpCall('api/certificationDetails/suggestforAgent', 'GET', null)
          .then(function (response) {
              vm.data.getAgentName = response;
          })

            httpService.httpCall('api/certificationDetails/getAllCertificationDetails', 'GET', null)
                .then(getAllCertificates)

            httpService.httpCall('api/certificationDetails/suggestCompanyname', 'GET', null)
            .then(function(response){
                vm.data.getAllCompanyNames = response;
            })


            vm.func.dateOptions = function(){
                     dateFormat: "dd-MM-yyyy"
            };

            vm.data.valueofdate = new Date(vm.data.valueofdate);
           
            

            vm.data.FromDate = $filter('date')(vm.data.valueofdate, "dd/MM/yyyy");
            vm.data.ToDate = $filter('date')(vm.data.ToDate, "dd/MM/yyyy");



            vm.func.searchby = function () {
                var sortData = {};
                //sortData.Zone = vm.data.Zonedata;
                sortData.SalesStatus = vm.data.SaleStatus;
                sortData.CertStatus = vm.data.CertStatus;
                sortData.Agent = vm.data.AgentName;
                sortData.FromDate = vm.data.FromDate;
                sortData.ToDate = vm.data.ToDate;

                httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
                .then(successSearchsorted)
            }
        }


        vm.func.searchby = function () {
            var sortData = {};
                sortData.Zone = vm.data.Zonedata;
               sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

              if (vm.data.FromDate != null && vm.data.ToDate != null) {
            vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
            vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

            sortData.Fromdate = vm.data.fromDateformate;
            sortData.Todate = vm.data.toDateformate;

             }
           else {
              sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }

              //if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
              //    if (vm.data.CompanyState == '' || vm.data.CompanyState == null) {
              //        vm.data.StateName = true;
              //     //   isValid = false;
              //    }
                 
              //}
         //   sortData.FromDate = vm.data.FromDate;
           // sortData.ToDate = vm.data.ToDate;

            httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
               .then(successSearchsorted)

        }
        var successSearchsorted = function (response) {
            vm.data.afterSearch = true;
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        var getAllCertificates = function (response) {
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        
        var successsearch = function (response) {
            vm.data.afterSearch = true;
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        var getPages = function () {
            vm.data.totalItems = vm.data.getAllCertification.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.getAllCertificationData = vm.data.getAllCertification.slice(start, end);
        };
        //debugger;
        vm.func.getSurvSingleKycDetails = function (Kycid,certId) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('survclosurekyc', { Kycid: Kycid, certId: certId });
            $window.open(url);

        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.SaleStatus = '';
            vm.data.CertStatus = '';
            vm.data.AgentName = '';
            vm.data.FromDate = '';
            vm.data.ToDate = '';
           
            init();
        }
        init();
    }

    



})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('AddCertificationController', AddCertificationController);

    AddCertificationController.$inject = ['$stateParams', '$filter', '$state', 'httpService', 'popupService'];

    function AddCertificationController(stateParams, $filter, state, httpService, popupService) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.isFormSubmit = false;
            vm.data.requiredCertificationType = false;
            vm.data.CertificationIssueType = false;
            //  vm.data.requiredCertificationStatus = false;
            vm.data.requiredCertificationValidity = false;

            vm.data.getSingleKycid = stateParams.Kycid;
            vm.data.getPropId = stateParams.Id;

            if (typeof (stateParams.Kycid) != 'undefined' && parseInt(stateParams.Kycid) > 0) {
                httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + stateParams.Kycid, 'GET', null)
                .then(function (response) {
                    var date = new Date();
                    vm.data.IssueDate = date;

                  vm.data.ExpiryDate = date;
                  vm.data.AuditRenewalDate = date;

                    vm.data.CompanyName = response.Company_name;
                    vm.data.City = response.Company_City;
                    vm.data.Country = response.Company_Country;
                    vm.data.State = response.Company_State;
                    vm.data.assignto = response.Account_Manager;
                    vm.data.Zone = response.Zone;
                    vm.data.Enq_Num = response.Enquiry_Number;
                });
                httpService.httpCall('api/closureManagement/getPropBySingleKycId?Kycid=' + stateParams.Kycid, 'GET', null)
                .then(function (response) {
                    vm.data.BillingCycle = response.validity;
                    vm.data.ImpType = response.type;
                    vm.data.CertiType = response.certification_type;
                });
            }

            vm.data.CertificationType = [
                { value: 'Select' },
                { value: 'Online' },
                { value: 'Onsite' },
                { value: 'Remote' },
                { value: 'Not Applicable' }
            ];

            //vm.data.CertificationStatus = [
            //    { value: 'Select' },
            //    { value: 'Active' },
            //    { value: 'Inactive' }
            //];

            vm.data.Validity = [
                { value: 'Select' },
                { value: '3 Months' },
                { value: '6 Months' },
                { value: '1 Year' },
                { value: '2 Years' },
                { value: '3 Years' }
            ];

            vm.data.CertificateIssueType = [
                 { value: 'Select' },
                { value: 'Initial' },
                { value: 'Surveillance1' },
                { value: 'Surveillance2' },
                { value: 'Recertification' },
                 { value: 'Auditing' }
            ];


            vm.data.SelectedCertIssueType = vm.data.CertificateIssueType[0];
            vm.data.selectedCertificationType = vm.data.CertificationType[0];
            //vm.data.selectedCertificationStatus = vm.data.CertificationStatus[0];
            vm.data.selectedCertificationValidity = vm.data.Validity[0];

        }

        //vm.dateOptions = {
        //    maxDate: new Date(),
        //    dateDisabled: myDisabledDates
        //};

        //function myDisabledDates(dateAndMode) {
        //    alert();
        //    return (dateAndMode.mode === 'day' && (dateAndMode.date.getDay() === -30|| dateAndMode.date.getDay() === 6));
        //}

        //vm.dateChanged = function () {
        //    vm.filteredDate1 = { date: vm.date1, filtered: $filter('date')(vm.date1, "MM/dd/yyyy") };

        //}

        var hideRequiredDateValid = function () {
            //   var m= vm.data.ExpiryDate.getFullY
            var nosofdays = 0;

            vm.data.IssueDateadded = vm.data.IssueDate.setDate(vm.data.IssueDate.getDate() + nosofdays);
            vm.data.ExpiryDateadded = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() + nosofdays);

            vm.data.IssueDateformate = $filter('date')(vm.data.IssueDateadded, "MM/dd/yyyy");//1397586600000
            vm.data.ExpiryDateformate = $filter('date')(vm.data.ExpiryDateadded, "MM/dd/yyyy");//1397673000000


            var dateOutIssueDate = new Date(vm.data.IssueDateformate); // it will work if date1 is in ISO format
            var dateOutExpiryDate = new Date(vm.data.ExpiryDateformate);

            if (dateOutExpiryDate > dateOutIssueDate) {

                //    var timeDiff = Math.abs(dateOutExpiryDate.getTime() - dateOutIssueDate.getTime());
                //    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));


                //    //if (diffDays < 89) {
                //    //    onFailDatefor3();
                //    //    vm.data.ExpiryDate = "";
                //    //}
                //    //else if (diffDays < 179 && diffDays > 91) {
                //    //    onFailDatefor6();
                //    //    vm.data.ExpiryDate = "";
                //    //}
                //    //else if (diffDays < 364 && diffDays > 183) {
                //    //    onFailDate();
                //    //    vm.data.ExpiryDate = "";
                //    //}
                //    //else if (diffDays < 90) {
                //    //    onFailDate1();

                //    //    vm.data.ExpiryDate = "";
                //    //}
                //    //else if (diffDays < 180) {
                //    //    onFailDate();
                //    //    vm.data.ExpiryDate = "";
                //    //}

            }
            else {
                onFailDate();
                vm.data.ExpiryDate = "";
            }


        }

        vm.func.hideRequiredCertificationType = function () {
            if (vm.data.selectedCertificationType != 'Select') {
                vm.data.requiredCertificationType = false;
            }
            if (vm.data.selectedCertificationType.value != vm.data.ImpType) {
                onFailImpType();
            }
        };





        vm.func.hideRequiredCertIssueType = function () {
            if (vm.data.SelectedCertIssueType != 'Select') {
                vm.data.CertificationIssueType = false;
            }
            if (vm.data.SelectedCertIssueType.value != vm.data.CertiType) {
                onFailIssueType();
            }
        };
        vm.func.hideRequiredStateName = function () {
            if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
                if (vm.data.State != '' || vm.data.State != null) {
                    vm.data.requiredStateName = false;

                }
            }
        };
        //vm.func.valDate = function () {
        //    if
        //}
        //vm.func.hideRequiredCertificationStatus = function () {
        //    if (vm.data.selectedCertificationStatus != 'Select') {
        //        vm.data.requiredCertificationStatus = false;
        //    }
        //};

        vm.func.hideRequiredCertificationValidity = function () {
            if (vm.data.selectedCertificationValidity != 'Select') {
                vm.data.requiredCertificationValidity = false;

                // ----------------------------------Gopal------------------------------------------------------------------------------------------------
                var val = (vm.data.selectedCertificationValidity.value).split(' ');

                if (val[1] == 'Months') {
                    vm.data.ExpiryDate = vm.data.IssueDate.setMonth(vm.data.IssueDate.getMonth() + parseInt(val[0]));
                    vm.data.ExpiryDateformat = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");
                    var datass = vm.data.IssueDate.setMonth(vm.data.IssueDate.getMonth() - val[0]);
                    vm.data.IssueDate = $filter('date')(datass, "MM/dd/yyyy");
                    vm.data.IssueDate = new Date(vm.data.IssueDate);
                    var expdate = $filter('date')(vm.data.ExpiryDateformat, "MM/dd/yyyy");
                    var newexpdate = new Date(expdate);
                    vm.data.ExpiryDate = newexpdate;

                    vm.data.ExpiryDate = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() - 1);
                    vm.data.ExpiryDateformat = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");
                    var expdatee = $filter('date')(vm.data.ExpiryDateformat, "MM/dd/yyyy");
                    var newexpdatee = new Date(expdatee);
                  vm.data.ExpiryDate = newexpdatee;
                  //vm.data.AuditRenewalDate = newexpdatee;
                }
                else if (val[1] == 'Year' || val[1] == 'Years') {
                    var mon = val[0] * 12;
                    vm.data.ExpiryDate = vm.data.IssueDate.setMonth(vm.data.IssueDate.getMonth() + parseInt(mon));
                    vm.data.ExpiryDateformat = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");

                    var datass = vm.data.IssueDate.setMonth(vm.data.IssueDate.getMonth() - mon);
                    vm.data.IssueDate = $filter('date')(datass, "MM/dd/yyyy");
                    vm.data.IssueDate = new Date(vm.data.IssueDate);

                    var expdate = $filter('date')(vm.data.ExpiryDateformat, "MM/dd/yyyy"); 
                    var newexpdate = new Date(expdate);
                    vm.data.ExpiryDate = newexpdate;

                    vm.data.ExpiryDate = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() - 1);
                    vm.data.ExpiryDateformat = $filter('date')(vm.data.ExpiryDate, "MM/dd/yyyy");
                    var expdatee = $filter('date')(vm.data.ExpiryDateformat, "MM/dd/yyyy");
                    var newexpdatee = new Date(expdatee);
                  vm.data.ExpiryDate = newexpdatee;
                  //vm.data.AuditRenewalDate = newexpdatee; 
                }
                else {
                  vm.data.ExpiryDate = vm.data.IssueDate;
                  //vm.data.AuditRenewalDate = vm.data.IssueDate; 
                }

                // ----------------------------------Gopal------------------------------------------------------------------------------------------------

              //---------------------------------------------Nithin-----------------------------------------------------

              // Assuming the value from vm.data.Validity is vm.data.selectedCertificationValidity
              //alert(vm.data.selectedCertificationValidity.value);
              //if (vm.data.selectedCertificationValidity.value === '3 Months') {
              //  vm.data.AuditRenewalDate = new Date();
              //  vm.data.AuditRenewalDate.setMonth(vm.data.AuditRenewalDate.getMonth() + 3);
              //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
              //} else if (vm.data.selectedCertificationValidity.value === '6 Months') {
              //  vm.data.AuditRenewalDate = new Date();
              //  vm.data.AuditRenewalDate.setMonth(vm.data.AuditRenewalDate.getMonth() + 6);
              //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
              //} else if (vm.data.selectedCertificationValidity.value === '1 Year') {
              //  vm.data.AuditRenewalDate = new Date();
              //  vm.data.AuditRenewalDate.setFullYear(vm.data.AuditRenewalDate.getFullYear() + 1);
              //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
              //} else if (vm.data.selectedCertificationValidity.value === '2 Years') {
              //  vm.data.AuditRenewalDate = new Date();
              //  vm.data.AuditRenewalDate.setFullYear(vm.data.AuditRenewalDate.getFullYear() + 2);
              //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
              //} else if (vm.data.selectedCertificationValidity.value === '3 Years') {
              //  vm.data.AuditRenewalDate = new Date();
              //  vm.data.AuditRenewalDate.setFullYear(vm.data.AuditRenewalDate.getFullYear() + 3);
              //  vm.data.AuditRenewalDate.setDate(vm.data.AuditRenewalDate.getDate() - 1);
              //}


              //---------------------------------------------------Nithin------------------------------------------
            }
            if (vm.data.selectedCertificationValidity.value != vm.data.BillingCycle) {
                onFailValidity();
            }
        };

        function preSaveCertificationDetails() {

            var data = {};
            debugger;
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            var nosofdays = 0;
            vm.data.IssueDateadded = vm.data.IssueDate.setDate(vm.data.IssueDate.getDate() + nosofdays);
            vm.data.ExpiryDateadded = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() + nosofdays);

            vm.data.IssueDateformate = $filter('date')(vm.data.IssueDateadded, "MM/dd/yyyy");//1397586600000
            vm.data.ExpiryDateformate = $filter('date')(vm.data.ExpiryDateadded, "MM/dd/yyyy");//1397673000000

            vm.data.issueFromdate = vm.data.IssueDateformate;
            vm.data.expiryTodate = vm.data.ExpiryDateformate;

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            data.Certi_Number = vm.data.CertificationNumber;
            data.Company_Name = vm.data.CompanyName;
            // data.Issue_Date = vm.data.IssueDate;
            // data.Recertification_Date = vm.data.IssueDate;
            //data.Lastupdated_Date = DateTime.Now;
            //  data.Expiry_Date = vm.data.ExpiryDate;

            data.Issue_Date = vm.data.issueFromdate;
            data.Recertification_Date = vm.data.issueFromdate;
            //data.Lastupdated_Date = DateTime.Now;
          data.Expiry_Date = vm.data.expiryTodate;
          data.Audit_renewal_date = vm.data.AuditRenewalDate;

            data.Certi_Scope = vm.data.Scope;
            data.Certi_Standard = vm.data.Standard;
            data.Certi_Address = vm.data.CertificationAddress;
            data.Certi_Accred = vm.data.UnderAccreditation;
            data.Certi_Body = vm.data.Body;
            data.Country = vm.data.Country;
            data.State = vm.data.State;
            data.City = vm.data.City;
            data.Certi_Type = vm.data.selectedCertificationType.value;
            data.Status = 'Active';//vm.data.selectedCertificationStatus.value
            data.Certi_Validity = vm.data.selectedCertificationValidity.value;
            data.Closure_Kyc_fk = vm.data.getSingleKycid;
            data.Cancel_Date = vm.data.ExpiryDate;
            data.enq_assignto = vm.data.assignto;
            data.Certi_issue_type = vm.data.SelectedCertIssueType.value;
            data.Zone = vm.data.Zone;
            data.Enquiry_Num_Fk = vm.data.Enq_Num;
            data.Certi_Status = 'Do Not Know';
            return data;
        }

        vm.func.saveCertificationDetails = function (isValid) {

            var selecteddate = vm.data.IssueDate
            var currdate = new Date();
            //dates for comparision purpose
            var currentdate = $filter('date')(currdate, "MM/dd/yyyy");
            var selectdate = $filter('date')(selecteddate, "MM/dd/yyyy");
            //finding diff b/n no of days
            var Sdate = new Date(selecteddate);
            var curdate = new Date(currdate);
            var timeDif = Math.abs(Sdate.getTime() - curdate.getTime());
            var difDay = Math.ceil(timeDif / (1000 * 3600 * 24));

            //if (difDay > 90) {

            //    if (selectdate > currentdate) {
            //        alert("Issue Date is greater than 90 Days from Current Date is not allowed")
            //        vm.data.IssueDate = currdate;
            //    }
            //    else if (selectdate < currentdate) {
            //        alert("Issue Date is lesser than 90 Days from Current Date is not allowed")
            //        vm.data.IssueDate = currdate;
            //    }

            //}
            //else if (difDay < 90) {

            //    if (selectdate > currentdate) {
            //        if (confirm("Issue Date is greater than Current Date, Do you wish to continue?")) {

            //        }
            //        else {
            //            vm.data.IssueDate = currdate;
            //        }

            //    }
            //    else if (selectdate < currentdate) {
            //        if (confirm("Issue Date is lesser than Current Date, Do you wish to continue?")) {

            //        }
            //        else {
            //            vm.data.IssueDate = currdate;

            //        }

            //    }

            //}
            hideRequiredDateValid();
            vm.data.isFormSubmit = true;
            //if ((vm.data.selectedCertificationType.value == 'Select') && (vm.data.selectedCertificationValidity.value == 'Select') &&( vm.data.SelectedCertIssueType.value=='Select')) {//&& vm.data.selectedCertificationStatus.value == 'Select' 
            //    vm.data.requiredCertificationType = true;
            //    vm.data.requiredCertificationIssueType = true;
            //   // vm.data.requiredCertificationStatus = true;
            //    vm.data.requiredCertificationValidity = true;
            //    isValid = false;
            //}
            //vm.data.diff = (vm.data.issueFromdate - vm.data.expiryTodate);
            //if(vm.data.diff<1){
            //    vm.data.requiredExpiry = true;
            //    isValid = false;
            //}

            if (vm.data.selectedCertificationType.value == 'Select') {
                vm.data.requiredCertificationType = true;
                isValid = false;
            }
            if (vm.data.SelectedCertIssueType.value == 'Select') {
                vm.data.CertificationIssueType = true;
                isValid = false;
            }
            if (vm.data.selectedCertificationValidity.value == 'Select') {
                vm.data.requiredCertificationValidity = true;
                isValid = false;
            }
            if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
                if (vm.data.State == '' || vm.data.State == null) {
                    vm.data.requiredStateName = true;
                    isValid = false;
                }
            }

            if (isValid == true) {
                var addCertificationDetails = preSaveCertificationDetails();
                if (addCertificationDetails != null) {
                    httpService.httpCall('api/certificationDetails/saveNewCertificationInfo', 'POST', addCertificationDetails)
                    .then(onSuccess, onFail)

                    //$(function ()  {
                    //        debugger;
                    //        var TD = new Object();
                    //        TD.certifi_CompanyName = $("#CompanyName").val();
                    //        TD.certifi_issueDate = $("#IssueDate").val();
                    //        TD.certifi_ExpiryDate = $("#ExpiryDate").val();
                    //        TD.certifi_Number = $("#CertificationNumber").val();
                    //        TD.certifi_isoStandard = $("#Standard").val();
                    //        TD.certifi_scope = $("#Scope").val();
                    //        TD.certi_type = $("#CertificationIssueType").val();
                    //        TD.certifi_CompLocation = $("#CertificationAddress").val();
                    //        $.post('http://localhost:49955/api/DTransfer/savedata', TD, function (data) {
                    //            alert("true");
                    //        });
                    //    });


                }
            }
        }

        var onSuccess = function () {
            popupService.successsm('ISO', 'Successfully Saved New Certificate !');
            state.go('singleclosurekyc', { Kycid: stateParams.Kycid });
        };



        var onFail = function () {
            popupService.errorsm('ISO', 'Existing Certificate Number!');
        };

        var onFailValidity = function () {
            popupService.errorsm('ISO', 'Miss match of Validity wrt Closure Details.\n\n Please check');
        };
        var onFailIssueType = function () {
            popupService.errorsm('ISO', 'Miss match of Issue Type wrt Closure Details.\n\n Please check');
        };

        var onFailImpType = function () {
            popupService.errorsm('ISO', 'Miss match of Implementation Type wrt Closure Details.\n\n Please check');
        };
        var onFailDate = function () {
            popupService.errorsm('ISO', 'Audit Renewal Date and Expiry Date Must Be Greater Than Issue Date');
        };
        var onFailDatefor3 = function () {
            popupService.errorsm('ISO', 'Expiry Date Must Be Greater Than  3 months');
        };
        var onFailDatefor6 = function () {
            popupService.errorsm('ISO', 'Expiry Date Must Be Greater Than 6 months');
        };
        vm.func.goToBack = function (Kycid, Id) {
            state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });
        }

        init();
    }

})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('AddNewTrainingController', AddNewTrainingController);

    AddNewTrainingController.$inject = ['$stateParams', '$filter', '$state', 'httpService', 'popupService'];

    function AddNewTrainingController(stateParams, $filter, state, httpService, popupService) {
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {
            vm.data.isFormSubmit = false;
            vm.data.requiredCertificationType = false;
            vm.data.CertificationIssueType = false;
            //  vm.data.requiredCertificationStatus = false;
            vm.data.requiredCertificationValidity = false;

            vm.data.getSingleKycid = stateParams.Kycid;
            vm.data.getPropId = stateParams.Id;

            if (typeof (stateParams.Kycid) != 'undefined' && parseInt(stateParams.Kycid) > 0) {
                httpService.httpCall('api/closureManagement/getSingleKycById?Kycid=' + stateParams.Kycid, 'GET', null)
                .then(function (response) {
                    vm.data.CompanyName = response.Company_name;
                    vm.data.City = response.Company_City;
                    vm.data.Country = response.Company_Country;
                    vm.data.State = response.Company_State;
                    vm.data.assignto = response.Account_Manager;
                    vm.data.Zone = response.Zone;
                    vm.data.Enq_Num = response.Enquiry_Number;
                });
                httpService.httpCall('api/closureManagement/getPropBySingleKycId?Kycid=' + stateParams.Kycid, 'GET', null)
                .then(function (response) {
                    vm.data.BillingCycle = response.validity;
                    vm.data.ImpType = response.type;
                    vm.data.CertiType = response.certification_type;
                });
            }

            vm.data.CertificationType = [
                { value: 'Select' },
                { value: 'Onsite' },
                { value: 'Remote' },
                { value: 'Not Applicable' }
            ];

            //vm.data.CertificationStatus = [
            //    { value: 'Select' },
            //    { value: 'Active' },
            //    { value: 'Inactive' }
            //];

            vm.data.Validity = [
           //     { value: 'Select' },
                { value: '1 Year' },
                { value: '3 Years' }
            ];

            vm.data.CertificateIssueType = [
             //    { value: 'Select' },
                { value: 'Training' }
           //  /   { value: 'Surveillance1' },
              //  { value: 'Surveillance2' },
               // { value: 'Recertification' }
            ];


            vm.data.SelectedCertIssueType = vm.data.CertificateIssueType[0];
            vm.data.selectedCertificationType = vm.data.CertificationType[0];
            //vm.data.selectedCertificationStatus = vm.data.CertificationStatus[0];
            vm.data.selectedCertificationValidity = vm.data.Validity[0];

        }

        //var hideRequiredDateValid = function () {
        //    //   var m= vm.data.ExpiryDate.getFullY
        //    var nosofdays = 0;

        //    vm.data.IssueDateadded = vm.data.IssueDate.setDate(vm.data.IssueDate.getDate() + nosofdays);
        //    vm.data.ExpiryDateadded = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() + nosofdays);

        //    vm.data.IssueDateformate = $filter('date')(vm.data.IssueDateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
        //    vm.data.ExpiryDateformate = $filter('date')(vm.data.ExpiryDateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000


        //    var dateOutIssueDate = new Date(vm.data.IssueDateformate); // it will work if date1 is in ISO format
        //    var dateOutExpiryDate = new Date(vm.data.ExpiryDateformate);

        //    if (dateOutExpiryDate > dateOutIssueDate) {

        //        var timeDiff = Math.abs(dateOutExpiryDate.getTime() - dateOutIssueDate.getTime());
        //        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        //        //alert(diffDays);

        //        if (diffDays < 364) {
        //            onFailDate();
        //            vm.data.ExpiryDate = "";
        //        }

        //    }
        //    else {
        //        onFailDate();
        //        vm.data.ExpiryDate = "";
        //    }


        //}

        vm.func.hideRequiredCertificationType = function () {
            if (vm.data.selectedCertificationType != 'Select') {
                vm.data.requiredCertificationType = false;
            }
            if (vm.data.selectedCertificationType.value != vm.data.ImpType) {
                onFailImpType();
            }
        };

        vm.func.hideRequiredCertIssueType = function () {
            if (vm.data.SelectedCertIssueType != 'Select') {
                vm.data.CertificationIssueType = false;
            }
            if (vm.data.SelectedCertIssueType.value != vm.data.CertiType) {
                onFailIssueType();
            }
        };
        vm.func.hideRequiredStateName = function () {
            if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
                if (vm.data.State != '' || vm.data.State != null) {
                    vm.data.requiredStateName = false;

                }
            }
        };
        //vm.func.valDate = function () {
        //    if
        //}
        //vm.func.hideRequiredCertificationStatus = function () {
        //    if (vm.data.selectedCertificationStatus != 'Select') {
        //        vm.data.requiredCertificationStatus = false;
        //    }
        //};

        vm.func.hideRequiredCertificationValidity = function () {
            if (vm.data.selectedCertificationValidity != 'Select') {
                vm.data.requiredCertificationValidity = false;
            }
            if (vm.data.selectedCertificationValidity.value != vm.data.BillingCycle) {
                onFailValidity();
            }
        };

        function preSaveCertificationDetails() {

            var data = {};
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            var nosofdays = 0;

            vm.data.IssueDateadded = vm.data.IssueDate.setDate(vm.data.IssueDate.getDate() + nosofdays);
          //  vm.data.ExpiryDateadded = vm.data.ExpiryDate.setDate(vm.data.ExpiryDate.getDate() + nosofdays);

            vm.data.IssueDateformate = $filter('date')(vm.data.IssueDateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
           // vm.data.ExpiryDateformate = $filter('date')(vm.data.ExpiryDateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

            vm.data.issueFromdate = vm.data.IssueDateformate;
            vm.data.expiryTodate = vm.data.IssueDateformate;

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            data.Certi_Number = vm.data.CertificationNumber;
            data.Company_Name = vm.data.CompanyName;
            // data.Issue_Date = vm.data.IssueDate;
            // data.Recertification_Date = vm.data.IssueDate;
            //data.Lastupdated_Date = DateTime.Now;
            //  data.Expiry_Date = vm.data.ExpiryDate;

            data.Issue_Date = vm.data.issueFromdate;
            data.Recertification_Date = vm.data.issueFromdate;
            //data.Lastupdated_Date = DateTime.Now;
            data.Expiry_Date = vm.data.expiryTodate;

            data.Certi_Scope = vm.data.Scope;
            data.Certi_Standard = vm.data.Standard;
            data.Certi_Address = vm.data.CertificationAddress;
            data.Certi_Accred = vm.data.UnderAccreditation;
            data.Certi_Body = vm.data.Body;
            data.Country = vm.data.Country;
            data.State = vm.data.State;
            data.City = vm.data.City;
            data.Certi_Type = vm.data.selectedCertificationType.value;
            data.Status = 'Active';//vm.data.selectedCertificationStatus.value
            data.Certi_Validity = vm.data.selectedCertificationValidity.value;
            data.Closure_Kyc_fk = vm.data.getSingleKycid;
            data.Cancel_Date = vm.data.ExpiryDate;
            data.enq_assignto = vm.data.assignto;
            data.Certi_issue_type = "Training";
            data.Zone = vm.data.Zone;
            data.Enquiry_Num_Fk = vm.data.Enq_Num;
            data.Certi_Status = 'Do Not Know';
            return data;
        }

        vm.func.saveCertificationDetails = function (isValid) {
           // hideRequiredDateValid();
            vm.data.isFormSubmit = true;
            //if ((vm.data.selectedCertificationType.value == 'Select') && (vm.data.selectedCertificationValidity.value == 'Select') &&( vm.data.SelectedCertIssueType.value=='Select')) {//&& vm.data.selectedCertificationStatus.value == 'Select' 
            //    vm.data.requiredCertificationType = true;
            //    vm.data.requiredCertificationIssueType = true;
            //   // vm.data.requiredCertificationStatus = true;
            //    vm.data.requiredCertificationValidity = true;
            //    isValid = false;
            //}
            //vm.data.diff = (vm.data.issueFromdate - vm.data.expiryTodate);
            //if(vm.data.diff<1){
            //    vm.data.requiredExpiry = true;
            //    isValid = false;
            //}

            if (vm.data.selectedCertificationType.value == 'Select') {
                vm.data.requiredCertificationType = true;
                isValid = false;
            }
            if (vm.data.SelectedCertIssueType.value == 'Select') {
                vm.data.CertificationIssueType = true;
                isValid = false;
            }
            if (vm.data.selectedCertificationValidity.value == 'Select') {
                vm.data.requiredCertificationValidity = true;
                isValid = false;
            }
            if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
                if (vm.data.State == '' || vm.data.State == null) {
                    vm.data.requiredStateName = true;
                    isValid = false;
                }
            }

            if (isValid == true) {
                var addCertificationDetails = preSaveCertificationDetails();
                if (addCertificationDetails != null) {
                    httpService.httpCall('api/certificationDetails/saveNewCertificationInfo', 'POST', addCertificationDetails)
                    .then(onSuccess, onFail)
                }
            }
        }

        var onSuccess = function () {
            popupService.successsm('ISO', 'Successfully Saved New Certificate !');
            state.go('singleclosurekyc', { Kycid: stateParams.Kycid });
        };

        var onFail = function () {
            popupService.errorsm('ISO', 'Existing Certificate Number!');
        };

        var onFailValidity = function () {
            popupService.errorsm('ISO', 'Miss match of Validity wrt Closure Details.\n\n Please check');
        };
        var onFailIssueType = function () {
            popupService.errorsm('ISO', 'Miss match of Issue Type wrt Closure Details.\n\n Please check');
        };

        var onFailImpType = function () {
            popupService.errorsm('ISO', 'Miss match of Implementation Type wrt Closure Details.\n\n Please check');
        };
        //var onFailDate = function () {
        //    popupService.errorsm('ISO', 'Expiry Date Must Be Greater Than a Year');
        //};
        vm.func.goToBack = function (Kycid, Id) {
            state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });
        }

        init();
    }

})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('ExpiredCertificateController', ExpiredCertificateController)

    ExpiredCertificateController.$inject = ['httpService', '$filter', '$state', '$window'];

    function ExpiredCertificateController(httpService, $filter, $state, $window) {
        var vm = this;

        vm.data = {};
        vm.func = {};


        var init = function () {
            vm.data.afterSearch = false;
            vm.data.totalItems = 0;
            vm.data.itemsPerPage = 10;
            vm.data.Pagination = {
                current: 1
            };


            var date = new Date();

            var firstDay =
                new Date(date.getFullYear(), date.getMonth(), 1);

            var lastDay =
               new Date(date.getFullYear(), date.getMonth() + 1, 0);


            //$('#datepicker').Datepicker({
            //               dateFormat: 'dd-mm-yy'
            //           });

            // httpService.httpCall('api/certificationDetails/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})

            httpService.httpCall('api/closureManagement/suggestforSaleStatus', 'GET', null)
            .then(function (response) {
                vm.data.getSaleStatus = response;
            })
            httpService.httpCall('api/closureManagement/suggestForCertStatus', 'GET', null)
            .then(function (response) {
                vm.data.getCertStatus = response;
            })
            httpService.httpCall('api/certificationDetails/suggestforAgent', 'GET', null)
          .then(function (response) {
              vm.data.getAgentName = response;
          })

            httpService.httpCall('api/certificationDetails/getAllExpiredCertificates', 'GET', null)
                .then(getAllCertificates)

            httpService.httpCall('api/certificationDetails/suggestCompanyname', 'GET', null)
            .then(function (response) {
                vm.data.getAllCompanyNames = response;
            })


            vm.func.dateOptions = function () {
                dateFormat: "dd-MM-yyyy"
            };

            vm.data.valueofdate = new Date(vm.data.valueofdate);



            vm.data.FromDate = $filter('date')(vm.data.valueofdate, "dd/MM/yyyy");
            vm.data.ToDate = $filter('date')(vm.data.ToDate, "dd/MM/yyyy");



            vm.func.searchby = function () {
                var sortData = {};
                //sortData.Zone = vm.data.Zonedata;
                sortData.SalesStatus = vm.data.SaleStatus;
                sortData.CertStatus = vm.data.CertStatus;
                sortData.Agent = vm.data.AgentName;
                sortData.FromDate = vm.data.FromDate;
                sortData.ToDate = vm.data.ToDate;

                httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
                .then(successSearchsorted)
            }
        }


        vm.func.searchby = function () {
            var sortData = {};
            sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }

            //if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
            //    if (vm.data.CompanyState == '' || vm.data.CompanyState == null) {
            //        vm.data.StateName = true;
            //     //   isValid = false;
            //    }

            //}
            //   sortData.FromDate = vm.data.FromDate;
            // sortData.ToDate = vm.data.ToDate;

            httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
               .then(successSearchsorted)

        }
        var successSearchsorted = function (response) {
            vm.data.afterSearch = true;
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        var getAllCertificates = function (response) {
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        vm.func.searchCertificationData = function () {

            
            //var format = /&/;
            //alert('Here');
            //if (format.test(vm.data.CompanyName)) {

            //    alert('Here');

            //    var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

            //    httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + str, 'Get', null)
            //    .then(successSearch)

            //} else {

            //    alert('Here');

            //    httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + vm.data.CompanyName, 'Get', null)
            //    .then(successSearch)

            //}



            httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + vm.data.CompanyName, 'GET', null)
            .then(successsearch)


        }


        var successsearch = function (response) {
            vm.data.afterSearch = true;
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        var getPages = function () {
            vm.data.totalItems = vm.data.getAllCertification.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.getAllCertificationData = vm.data.getAllCertification.slice(start, end);
        };
        //debugger;
        vm.func.getSurvSingleKycDetails = function (Kycid) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('survclosurekyc', { Kycid: Kycid });
            $window.open(url);

        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.SaleStatus = '';
            vm.data.CertStatus = '';
            vm.data.AgentName = '';
            vm.data.FromDate = '';
            vm.data.ToDate = '';

            init();
        }
        init();
    }





})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('CertificateRenewalsController', CertificateRenewalsController)

    CertificateRenewalsController.$inject = ['httpService', '$filter', '$state', '$window'];

    function CertificateRenewalsController(httpService, $filter, $state, $window) {
        var vm = this;

        vm.data = {};
        vm.func = {};


        var init = function () {
            vm.data.afterSearch = false;
            vm.data.totalItems = 0;
            vm.data.itemsPerPage = 10;
            vm.data.Pagination = {
                current: 1
            };


            var date = new Date();

            var firstDay =
                new Date(date.getFullYear(), date.getMonth(), 1);

            var lastDay =
               new Date(date.getFullYear(), date.getMonth() + 1, 0);


            //$('#datepicker').Datepicker({
            //               dateFormat: 'dd-mm-yy'
            //           });

            // httpService.httpCall('api/certificationDetails/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})

            httpService.httpCall('api/closureManagement/suggestforSaleStatus', 'GET', null)
            .then(function (response) {
                vm.data.getSaleStatus = response;
            })
            httpService.httpCall('api/closureManagement/suggestForCertStatus', 'GET', null)
            .then(function (response) {
                vm.data.getCertStatus = response;
            })
            httpService.httpCall('api/certificationDetails/suggestforAgent', 'GET', null)
          .then(function (response) {
              vm.data.getAgentName = response;
          })

            httpService.httpCall('api/certificationDetails/getAllRenewalCertificates', 'GET', null)
                .then(getAllCertificates)

            httpService.httpCall('api/certificationDetails/suggestCompanyname', 'GET', null)
            .then(function (response) {
                vm.data.getAllCompanyNames = response;
            })


            vm.func.dateOptions = function () {
                dateFormat: "dd-MM-yyyy"
            };

            vm.data.valueofdate = new Date(vm.data.valueofdate);



            vm.data.FromDate = $filter('date')(vm.data.valueofdate, "dd/MM/yyyy");
            vm.data.ToDate = $filter('date')(vm.data.ToDate, "dd/MM/yyyy");



            vm.func.searchby = function () {
                var sortData = {};
                //sortData.Zone = vm.data.Zonedata;
                sortData.SalesStatus = vm.data.SaleStatus;
                sortData.CertStatus = vm.data.CertStatus;
                sortData.Agent = vm.data.AgentName;
                sortData.FromDate = vm.data.FromDate;
                sortData.ToDate = vm.data.ToDate;

                httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
                .then(successSearchsorted)
            }
        }


        vm.func.searchby = function () {
            var sortData = {};
            sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }

            //if (vm.data.Country == 'India' || vm.data.Country == 'INDIA') {
            //    if (vm.data.CompanyState == '' || vm.data.CompanyState == null) {
            //        vm.data.StateName = true;
            //     //   isValid = false;
            //    }

            //}
            //   sortData.FromDate = vm.data.FromDate;
            // sortData.ToDate = vm.data.ToDate;

            httpService.httpCall('api/certificationDetails/getCertificationSorted', 'POST', sortData)
               .then(successSearchsorted)

        }
        var successSearchsorted = function (response) {
            vm.data.afterSearch = true;
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        var getAllCertificates = function (response) {
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        vm.func.searchCertificationData = function () {

            
            //var format = /&/;
            //alert('Here');
            //if (format.test(vm.data.CompanyName)) {

            //    alert('Here');

            //    var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

            //    httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + str, 'Get', null)
            //    .then(successSearch)

            //} else {

            //    alert('Here');

            //    httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + vm.data.CompanyName, 'Get', null)
            //    .then(successSearch)

            //}



            httpService.httpCall('api/certificationDetails/searchcertData?Searchkey=' + vm.data.CompanyName, 'GET', null)
            .then(successsearch)


        }


        var successsearch = function (response) {
            vm.data.afterSearch = true;
            vm.data.getAllCertification = response;
            vm.data.getAllCertificationData = angular.copy(vm.data.getAllCertification);
            getPages();
        }

        var getPages = function () {
            vm.data.totalItems = vm.data.getAllCertification.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };

        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.getAllCertificationData = vm.data.getAllCertification.slice(start, end);
        };
        //debugger;
        vm.func.getSurvSingleKycDetails = function (Kycid) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('survclosurekyc', { Kycid: Kycid });
            $window.open(url);

        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.SaleStatus = '';
            vm.data.CertStatus = '';
            vm.data.AgentName = '';
            vm.data.FromDate = '';
            vm.data.ToDate = '';

            init();
        }
        init();
    }





})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('CertificatesSoftCopySentController', CertificatesSoftCopySentController)

    CertificatesSoftCopySentController.$inject = ['httpService', '$filter', '$state', '$window', '$state'];//'popupService'$window

    function CertificatesSoftCopySentController(httpService, $filter, $state, $window, state) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforCertDispatch', 'GET', null)
          .then(function (response) {
              vm.data.CertDispatch = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/getAllSoftCopySent', 'GET', null)
            .then(getAllProposal)

        }
        vm.func.getSingleKycDetails = function (Kycid, Id) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('singleclosurekyc', { Kycid: Kycid, Id: Id });
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getAllProposal = function (response) {
            vm.data.allProposal = response;
            // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);

            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
            vm.func.pageChange();
            getPages();
        }
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}

        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.Dispatch = vm.data.Dispatch;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

          httpService.httpCall('api/proposalMnagement/searchbyCRProjStatus', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName;

              httpService.httpCall('api/proposalMnagement/searchCertResolvedProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

              httpService.httpCall('api/proposalMnagement/searchCertResolvedProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            if (response.length == 0) {

                httpService.httpCall('api/closureManagement/searchClosureKYC?SearchKey=' + vm.data.CompanyName, 'GET', null)
                 .then(successSearchKyc)
            }
            else {

                vm.data.allProposal = response;
                vm.data.allProposalData = angular.copy(vm.data.allProposal);
                getPages();

            }
        }
        var successSearchKyc = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideKycSearch = false;
            vm.data.hideProposalSearch = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();

        }
        vm.func.getSingleKycDetailsByKyc = function (Kycid) {
            //   state.go('singleclosurekyc', { Kycid: Kycid });

            var url = state.href('singleclosurekyc', { Kycid: Kycid });
            $window.open(url);

        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();

(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('CertificatesHardCopySentController', CertificatesHardCopySentController)

    CertificatesHardCopySentController.$inject = ['httpService', '$filter', '$state', '$window', '$state'];//'popupService'$window

    function CertificatesHardCopySentController(httpService, $filter, $state, $window, state) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforCertDispatch', 'GET', null)
          .then(function (response) {
              vm.data.CertDispatch = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function (response) {
                vm.data.getallCompanyName = response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/getAllHardCopySent', 'GET', null)
            .then(getAllProposal)

        }
        vm.func.getSingleKycDetails = function (Kycid, Id) {
            // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('singleclosurekyc', { Kycid: Kycid, Id: Id });
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getAllProposal = function (response) {
            vm.data.allProposal = response;
            // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);

            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
            vm.func.pageChange();
            getPages();
        }
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}

        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.Dispatch = vm.data.Dispatch;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


            // sortData.Fromdate = vm.data.FromDate;
            //    sortData.Todate = vm.data.ToDate;

            httpService.httpCall('api/proposalMnagement/searchbyProjStatus', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            if (response.length == 0) {

                httpService.httpCall('api/closureManagement/searchClosureKYC?SearchKey=' + vm.data.CompanyName, 'GET', null)
                 .then(successSearchKyc)
            }
            else {

                vm.data.allProposal = response;
                vm.data.allProposalData = angular.copy(vm.data.allProposal);
                getPages();

            }
        }
        var successSearchKyc = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideKycSearch = false;
            vm.data.hideProposalSearch = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();

        }
        vm.func.getSingleKycDetailsByKyc = function (Kycid) {
            //   state.go('singleclosurekyc', { Kycid: Kycid });

            var url = state.href('singleclosurekyc', { Kycid: Kycid });
            $window.open(url);

        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('CertificatesDispatchedController', CertificatesDispatchedController)

    CertificatesDispatchedController.$inject = ['httpService', '$filter', '$state', '$window', '$state'];//'popupService'$window

    function CertificatesDispatchedController(httpService, $filter, $state, $window, state) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforCertDispatch', 'GET', null)
          .then(function (response) {
              vm.data.CertDispatch = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function(response){
                vm.data.getallCompanyName=response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/getPendingProposalDetails', 'GET', null)
            .then(getAllProposal)
            
        }
        vm.func.getSingleKycDetails = function (Kycid,Id) {
          // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('singleclosurekyc', { Kycid: Kycid ,Id:Id});
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getAllProposal = function (response) {
            vm.data.allProposal = response;
           // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);
           
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
        ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
            vm.func.pageChange();
            getPages();
        }
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}
       
        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.Dispatch = vm.data.Dispatch;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


           // sortData.Fromdate = vm.data.FromDate;
        //    sortData.Todate = vm.data.ToDate;

            httpService.httpCall('api/proposalMnagement/searchbyProjStatus', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}
       
        vm.func.searchProposalData = function () {

            var format = /&/;

            if (format.test(vm.data.CompanyName)) {

                var str = vm.data.CompanyName.replace(/&/gi, '/A/N/D/');

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + str, 'Get', null)
                .then(successSearch)

            } else {

                httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' + vm.data.CompanyName, 'Get', null)
                .then(successSearch)

            }

        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideProposalSearch = false;
            vm.data.hideKycSearch = true;
            if (response.length == 0) {

                httpService.httpCall('api/closureManagement/searchClosureKYC?SearchKey=' + vm.data.CompanyName, 'GET', null)
                 .then(successSearchKyc)
            }
            else {

            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();

            }
        }
        var successSearchKyc = function (response) {
            vm.data.searchProposal = true;
            vm.data.hideKycSearch = false;
            vm.data.hideProposalSearch = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
                        
        }
        vm.func.getSingleKycDetailsByKyc = function (Kycid) {
         //   state.go('singleclosurekyc', { Kycid: Kycid });

            var url = state.href('singleclosurekyc', { Kycid: Kycid });
            $window.open(url);

        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
    .module('isoappClient')
    .controller('ReCertificatesController', ReCertificatesController)

    ReCertificatesController.$inject = ['httpService', '$filter', '$state', '$window'];//'popupService'$window

    function ReCertificatesController(httpService, $filter, $state, $window) {//, popupService,$window
        var vm = this;

        vm.data = {};
        vm.func = {};

        var init = function () {

            //vm.data.selectMonth = [
            //    { value: 'Select' },
            //    { value: 'January' },
            //    { value: 'February' },
            //    { value: 'March' },
            //    { value: 'April' },
            //    { value: 'May' },
            //    { value: 'June' },
            //    { value: 'July' },
            //    { value: 'August' },
            //    { value: 'September' },
            //    { value: 'October' },
            //    { value: 'November' },
            //    { value: 'December' }
            //];

            //vm.data.selectYear = [
            //{ value: 'Select' },
            //{ value: '2013' },
            //{ value: '2014' },
            //{ value: '2015' },
            //{ value: '2016' },
            //{ value: '2017' },

            //];
            //vm.data.Zonedata = [
            //    { value: 'Select' },
            //    { value: 'BMC' },
            //    { value: 'OMUAE' },
            //    { value: 'Rest of India' },
            //    { value: 'Rest of World' }
            //];

            vm.data.searchProposal = false;
            vm.data.itemsPerPage = 10;
            vm.data.totalItems = 0;
            vm.data.pagination = {
                current: 1
            };

            //vm.data.selectedYear = vm.data.selectYear[0];
            //vm.data.selectedMonth = vm.data.selectMonth[0];

            //vm.data.Zone = vm.data.Zonedata;

            httpService.httpCall('api/proposalMnagement/suggestforAgent', 'GET', null)
            .then(function (response) {
                vm.data.getAgentName = response;
            })

            //httpService.httpCall('api/proposalMnagement/suggestforZone', 'GET', null)
            //.then(function (response) {
            //    vm.data.getZoneData = response;
            //})
            httpService.httpCall('api/proposalMnagement/suggestforCertDispatch', 'GET', null)
          .then(function (response) {
              vm.data.CertDispatch = response;
          })

            httpService.httpCall('api/proposalMnagement/suggestforProposal', 'GET', null)
            .then(function(response){
                vm.data.getallCompanyName=response;
            })


            //httpService.httpCall('api/proposalMnagement/getAllProposalDetails', 'GET', null)
            //.then(getAllProposal)

            httpService.httpCall('api/proposalMnagement/getAllNewRenewalProposalDetails', 'GET', null)
            .then(getAllProposal)
            
        }
        vm.func.getSingleKycDetails = function (Kycid,Id) {
          // var url= $state.go('singleclosurekyc', { Kycid: Kycid, Id: Id });

            var url = $state.href('singleclosurekyc', { Kycid: Kycid ,Id:Id});
            $window.open(url);

        }
        //vm.data.SortBy = [

        //      { id: 'Go Ahead', type: 'Go Ahead' },
        //      { id: 'Hold', type: 'Hold' },
        //      { id: 'Fresh', type: 'Fresh' }
        //];
        var getAllProposal = function (response) {
            vm.data.allProposal = response;
           // vm.data.allProposal = $filter('orderBy')(vm.data.allProposal.ProjectStatus, vm.data.SortBy[0]);
           
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
        ///    vm.data.allProposalData = $filter('orderBy')(response.ProjectStatus, vm.data.SortBy[0]);
            vm.func.pageChange();
            getPages();
        }
        //vm.func.applySort = function () {
        //      vm.data.allProposal = $filter('orderBy')(vm.data.allProposal, vm.data.SortBy[0]);
        //    vm.func.pageChange();
        //    getPages();
        //}
       
        var getPages = function () {
            vm.data.totalItems = vm.data.allProposal.length;
            vm.data.pagination = {
                current: 1
            }
            vm.data.start = vm.data.pagination.current;
            vm.data.end = vm.data.start * vm.data.itemsPerPage;
            if (vm.data.totalItems < vm.data.itemsPerPage) {
                vm.data.end = vm.data.totalItems;
            }
        };


        //vm.func.sortByMonthYear = function () {
        //    var sortdata = {};
        //    sortdata.year = vm.data.selectedYear;
        //    sortdata.month = vm.data.selectedMonth;

        //    httpService.httpCall('api/proposalMnagement/sortByMonthYear', 'POST', null)
        //    .then(successSearch)
        //}


        vm.func.searchby = function () {
            var sortData = {};
            sortData.Dispatch = vm.data.Dispatch;
            //sortData.Zone = vm.data.Zonedata;
            sortData.Agent = vm.data.AgentName;
            var nosofdays = 0;

            //vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
            //vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

            //vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');
            //vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');

            //sortData.Fromdate = vm.data.fromDateformate;
            //sortData.Todate = vm.data.toDateformate;


            if (vm.data.FromDate != null && vm.data.ToDate != null) {
                vm.data.fromdateadded = vm.data.FromDate.setDate(vm.data.FromDate.getDate() + nosofdays);
                vm.data.todateadded = vm.data.ToDate.setDate(vm.data.ToDate.getDate() + nosofdays);

                vm.data.fromDateformate = $filter('date')(vm.data.fromdateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397586600000
                vm.data.toDateformate = $filter('date')(vm.data.todateadded, 'yyyy-MM-dd HH:mm:ss Z');//1397673000000

                sortData.Fromdate = vm.data.fromDateformate;
                sortData.Todate = vm.data.toDateformate;

            }
            else {
                sortData.Fromdate = vm.data.FromDate;
                sortData.Todate = vm.data.ToDate;
            }


           // sortData.Fromdate = vm.data.FromDate;
        //    sortData.Todate = vm.data.ToDate;

            httpService.httpCall('api/proposalMnagement/searchbyProjStatus', 'POST', sortData)
            .then(successSearchsorted)
        }

        var successSearchsorted = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }


        vm.func.pageChange = function () {
            var start = ((vm.data.pagination.current - 1) * vm.data.itemsPerPage)
            , end = start + vm.data.itemsPerPage;

            vm.data.start = start + 1;
            vm.data.end = (vm.data.totalItems > end) ? end : vm.data.totalItems;

            vm.data.allProposalData = vm.data.allProposal.slice(start, end);
        };

        //vm.data.getSingleProposalDetails = function (Id) {
        //    //state.go('singleProposal', { Id: Id });

        //    var url = state.href('singleProposal', { Id: Id });
        //    $window.open(url);
        //}

        //vm.func.addNewProposal = function () {
        //    popupService.addProposal(refresh);
        //}

        vm.func.searchProposalData = function () {
            httpService.httpCall('api/proposalMnagement/searchProposalData?SearchKey=' +vm.data.CompanyName, 'Get', null)
            .then(successSearch)
        }

        var successSearch = function (response) {
            vm.data.searchProposal = true;
            vm.data.allProposal = response;
            vm.data.allProposalData = angular.copy(vm.data.allProposal);
            getPages();
        }

        vm.func.refresh = function () {
            vm.data.CompanyName = '';
            vm.data.Dispatch = '';
            vm.data.AgentName = '';
            vm.data.Fromdate = '';
            vm.data.Todate = '';
            init();
        }

        init();
    }
})();
(function() {
  'use strict';

  angular
    .module('isoappClient')
    .run(runBlock);

  runBlock.$inject = ['$log', '$rootScope', 'localstorageService', '$state', '$location'];

    /** @ngInject */
  function runBlock($log, rootScope, localstorageService, state, $location) {

      $log.debug('runBlock end');

      var UserData = localstorageService.getObject('user');

      if (typeof (UserData) != 'undefined' && UserData != null && !angular.equals(UserData, '{}')) {
          rootScope.UserData = UserData;
          var locationUrl = $location.path().substr(1, $location.path().length - 1);
          if (locationUrl != '') {
              $location.path(locationUrl);
          }
          else {
              state.go('home');
          }
      }
      else {
          state.go('login');
      }

      rootScope.$on('$locationChangeStart', function (e) {
          UserData = localstorageService.getObject('user');
          if (typeof (UserData) == 'undefined' || UserData == null || angular.equals(UserData, '{}')) {
              e.preventDefault();
              state.go('login');
          }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('isoappClient')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider


      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      })
      .state('home', {
        url: '/home',
        templateUrl: 'app/home/home.html',
        controller: 'HomeController',
        controllerAs: 'vm'
      })
      //.state('navbar', {
      //  //  url: '/login',
      //    templateUrl: 'app/components/navbar/navbar.html',

      //    controller: 'NavbrController',
      //   controllerAs: 'vm'
      //})
      .state('searchclosurekyc', {
        url: '/searchclosurekyc',
        templateUrl: 'app/closuremanagement/searchclosurekyc.html',
        controller: 'SearchClosureKycController',
        controllerAs: 'vm'
      })
      .state('addkyc', {
        url: '/addkyc',
        templateUrl: 'app/closuremanagement/addclosurekyc.html',
        controller: 'AddClosureKycController',
        controllerAs: 'vm'
      })
      .state('singleclosurekyc', {
        url: '/singleclosurekyc/:Kycid/:Id',
        templateUrl: 'app/closuremanagement/singlekycdetails.html',
        controller: 'SingleKycDetailsController',
        controllerAs: 'vm'
      })
      .state('survclosurekyc', {
        url: '/survclosurekyc/:Kycid/:certId',
        templateUrl: 'app/certification/survkycdetails.html',
        controller: 'SurvKycDetailsController',
        controllerAs: 'vm'
      })
      .state('addnewcertification', {
        url: '/addnewcertification/:Kycid/:Id',
        templateUrl: 'app/certification/addcertification.html',
        controller: 'AddCertificationController',
        controllerAs: 'vm'
      })
      .state('addnewTrainingcert', {
        url: '/addnewTrainingcert/:Kycid/:Id',
        templateUrl: 'app/certification/addNewTrainingCert.html',
        controller: 'AddNewTrainingController',
        controllerAs: 'vm'
      })
      .state('editClosureKycDetais', {
        url: '/editClosureKycDetais/:Kycid/:Prid',
        templateUrl: 'app/closuremanagement/editclosurekyc.html',
        controller: 'EditClosureKYCDetailsController',
        controllerAs: 'vm'
      })

      //.state('singleProposal', {
      //    url: '/singleProposal/:Id',
      //    templateUrl: 'app/proposalmanagement/singleproposaldetails.html',
      //    controller:''
      //})
      .state('searchEnquiryDetails', {
        url: '/searchEnquiryDetails',
        templateUrl: 'app/enquirymanagement/searchenquiry.html',
        controller: 'SearchEnquiryDetailsController',
        controllerAs: 'vm'
      })
      .state('allProposalDetails', {
        url: '/allProposalDetails',
        templateUrl: 'app/proposalmanagement/allproposal.html',
        controller: 'AllProposalController',
        controllerAs: 'vm'
      })
      .state('NewClosure', {
        url: '/NewClosure',
        templateUrl: 'app/proposalmanagement/NewClosure.html',
        controller: 'NewClosureController',
        controllerAs: 'vm'
      })
      .state('DelayedProjects', {
        url: '/DelayedProjects',
        templateUrl: 'app/proposalmanagement/DelayedProjects.html',
        controller: 'DelayedProjectsController',
        controllerAs: 'vm'
      })
      .state('PaymentHistory', {
        url: '/PaymentHistory',
        templateUrl: 'app/proposalmanagement/PaymentHistory.html',
        controller: 'PaymentHistoryController',
        controllerAs: 'vm'
      })
      .state('TaxInvoiceHistory', {
        url: '/TaxInvoiceHistory',
        templateUrl: 'app/invoice/TaxInvoiceHistory.html',
        controller: 'TaxInvoiceHistoryController',
        controllerAs: 'vm'
      })
      .state('FreshProposalDetail', {
        url: '/FreshProposalDetail',
        templateUrl: 'app/proposalmanagement/Freshproposal.html',
        controller: 'FreshProposalController',
        controllerAs: 'vm'
      })
      .state('InitialPropsalDetail', {
        url: '/InitialPropsalDetail',
        templateUrl: 'app/proposalmanagement/initialproposal.html',
        controller: 'InitialPropsalDetailController',
        controllerAs: 'vm'
      })
      .state('PendingPropsalDetail', {
        url: '/PendingPropsalDetail',
        templateUrl: 'app/proposalmanagement/PendingPayproposal.html',
        controller: 'PendingPropsalDetailController',
        controllerAs: 'vm'
      })
      .state('PayedPropsalDetail', {
        url: '/PayedPropsalDetail',
        templateUrl: 'app/proposalmanagement/Fullpayproposal.html',
        controller: 'PayedPropsalDetailController',
        controllerAs: 'vm'
      })
      .state('ReconciledDetail', {
        url: '/ReconciledDetail',
        templateUrl: 'app/proposalmanagement/Reconciled.html',
        controller: 'ReconciledDetailController',
        controllerAs: 'vm'
      })
      .state('singleProposal', {
        url: '/singleProposal/:Id',
        templateUrl: 'app/proposalmanagement/singleproposaldetails.html',
        controller: 'SingleProposalController',
        controllerAs: 'vm'
      })
      .state('allCertificationDetails', {
        url: '/allCertificationDetails',
        templateUrl: 'app/certification/allCertificationDetails.html',
        controller: 'allCertificationController',
        controllerAs: 'vm'
      })

      .state('TaxInvoice', {
        url: '/TaxInvoice',
        templateUrl: 'app/invoice/TaxInvoice.html',
        controller: 'TaxInvoiceController',
        controllerAs: 'vm'
      })

      .state('issuedCertificateDetails', {
        url: '/issuedCertificateDetails',
        templateUrl: 'app/certification/issuedCertificates.html',
        controller: 'issuedCertificatesController',
        controllerAs: 'vm'
      })

      .state('CertificateRenewals', {
        url: '/CertificateRenewals',
        templateUrl: 'app/certification/CertificateRenewals.html',
        controller: 'CertificateRenewalsController',
        controllerAs: 'vm'
      })

      .state('ExpiredCertificate', {
        url: '/ExpiredCertificate',
        templateUrl: 'app/certification/ExpiredCertificate.html',
        controller: 'ExpiredCertificateController',
        controllerAs: 'vm'
      })

      .state('kycUpdateDetails', {
        url: '/kycUpdateDetails',
        templateUrl: 'app/kycUpdate/kycUpdateDetails.html',
        controller: 'kycUpdateDetailsController',
        controllerAs: 'vm'
      })
      .state('certificatesPending', {
        url: '/certificatesPending',
        templateUrl: 'app/certificatesPending/certificatespending.html',
        controller: 'CertificatesPendingController',
        controllerAs: 'vm'
      })
      .state('agentrequest', {
        url: '/agentrequest',
        templateUrl: 'app/certificatesPending/agentrequest.html',
        controller: 'agentrequestController',
        controllerAs: 'vm'

      })

      .state('certpending', {
        url: '/certpending',
        templateUrl: 'app/certificatesPending/certpending.html',
        controller: 'certpendingController',
        controllerAs: 'vm'
      })

      //.state('certificatesDispatched', {
      //  url: '/certificatesDispatched',
      //  templateUrl: 'app/certificatesDispatched/certificatesdispatched.html',
      //  controller: 'CertificatesDispatchedController',
      //  controllerAs: 'vm'
      //})
      //.state('certificatesSoftCopySent', {
      //  url: '/certificatesSoftCopySent',
      //  templateUrl: 'app/certificatesDispatched/certificatessoftcopysent.html',
      //  controller: 'CertificatesSoftCopySentController',
      //  controllerAs: 'vm'
      //})
      .state('certificatesDispatchedTotal', {
        url: '/certificatesDispatchedTotal',
        templateUrl: 'app/certificatesDispatched/certificatessoftcopysent.html',
        controller: 'CertificatesSoftCopySentController',
        controllerAs: 'vm'
      })
      .state('certificatesHardCopySent', {
        url: '/certificatesHardCopySent',
        templateUrl: 'app/certificatesDispatched/certificateshardcopysent.html',
        controller: 'CertificatesHardCopySentController',
        controllerAs: 'vm'
      })
      .state('recertificates', {
        url: '/recertificates',
        templateUrl: 'app/ReCertification/recertificates.html',
        controller: 'ReCertificatesController',
        controllerAs: 'vm'
      })
      .state('qaChecker', {
        url: '/qaChecker',
        templateUrl: 'app/qaChecker/qachecker.html',
        controller: 'QaCheckerController',
        controllerAs: 'vm'
      })
      .state('qaKycFail', {
        url: '/qaKycFail',
        templateUrl: 'app/qaChecker/qaKycFail.html',
        controller: 'KycFailController',
        controllerAs: 'vm'
      })

      .state('qaKycPass', {
        url: '/qaKycPass',
        templateUrl: 'app/qaChecker/qaKycPass.html',
        controller: 'KycPassController',
        controllerAs: 'vm'
      })
      .state('qaKycApproved', {
        url: '/qaKycApproved',
        templateUrl: 'app/qaChecker/qaKycApproved.html',
        controller: 'KycApprovedController',
        controllerAs: 'vm'
      })
      .state('qaKycRejected', {
        url: '/qaKycRejected',
        templateUrl: 'app/qaChecker/qaKycRejected.html',
        controller: 'KycRejectedController',
        controllerAs: 'vm'
      })

      .state('editKycByQaChecker', {
        url: '/editKycByQaDetails/:Kycid/:Prid',
        templateUrl: 'app/qaChecker/editKycByQaChecker.html',
        controller: 'EditKycByQaCheckerController',
        controllerAs: 'vm'
      })
      .state('searchCertificates', {
        url: '/searchCertificates',
        templateUrl: 'app/certification/searchCertificates.html',
        controller: 'searchCertificateController',
        controllerAs: 'vm'
      })

      .state('qasinglekyc', {
        url: '/qasinglekyc/:Kycid/:Id',
        templateUrl: 'app/qaChecker/qasinglekyc.html',
        controller: 'QaSingleKycController',
        controllerAs: 'vm'
      });


    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function () {
    'use strict';

    angular
      .module('isoappClient')
      .constant('malarkey', malarkey)
      .constant('moment', moment)
     // .value('serviceUrl', 'http://localhost:1279/');             // LOCAL URL
    .value('serviceUrl', 'https://topcertifier.info/iso_newcrm_Api/');  // PRODUCTION URL 15
    //.value('serviceUrl', 'http://52.66.21.137:8086/NEWCRM_API/');  // PRODUCTION URL 52
    //.value('serviceUrl', 'http://13.126.123.241:8086/iso_newcrm_Api/');  // PRODUCTION URL 13



})();

(function() {
  'use strict';

  angular
    .module('isoappClient')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

      // Set options third-party lib
    $locationProvider.html5Mode(true);
  }

})();

angular.module("isoappClient").run(["$templateCache", function($templateCache) {$templateCache.put("app/ReCertification/Message.html","<!DOCTYPE html><html><head><title></title><meta charset=utf-8></head><body><h1>This Website is Down...</h1></body></html>");
$templateCache.put("app/ReCertification/recertificates.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Certificates Renewal</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Dispatch</label><input class=form-control type=text id=Dispatch name=Dispatch autocomplete=off placeholder=\"Search By Cert Dispatch\" ng-model=vm.data.Dispatch uib-typeahead=\"Dispatch as Dispatch for Dispatch in vm.data.CertDispatch | filter:$viewValue | limitTo:10\"><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                        <th class=\"text-left\">Pending Payment</th>\r\n                        <th class=\"text-left\">Remarks</th>\r\n\r\n                       \r\n                    </tr>\r\n                </thead>\r\n                <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                    <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                        <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                        <td class=\"text-left\">{{row.Client}}</td>\r\n                        <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                        <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                        <td class=\"text-center\">{{row.Validity}}</td>\r\n                        <td class=\"text-center\">{{row.Source}}</td>\r\n                        <td class=\"text-center\">{{row.Type}}</td>\r\n                        <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n                      \r\n                    </tr>\r\n                </tbody>\r\n            </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><th class=text-center>Source</th><th class=text-center>Validity</th><th class=text-center>Type</th><th class=text-center>Agent</th><th class=text-center>Cert Dispatch</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.Client}}</td><td class=text-left>{{row.Location}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><td class=text-center>{{row.Source}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.Type}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.ProjectStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certificatesDispatched/certificatesdispatched.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Certificates Pending</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\" required></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Dispatch</label><input class=form-control type=text id=Dispatch name=Dispatch autocomplete=off placeholder=\"Search By Cert Dispatch\" ng-model=vm.data.Dispatch uib-typeahead=\"Dispatch as Dispatch for Dispatch in vm.data.CertDispatch | filter:$viewValue | limitTo:10\"><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive ng-hide=vm.data.hideProposalSearch><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                        <th class=\"text-left\">Pending Payment</th>\r\n                        <th class=\"text-left\">Remarks</th>\r\n\r\n                       \r\n                    </tr>\r\n                </thead>\r\n                <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                    <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                        <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                        <td class=\"text-left\">{{row.Client}}</td>\r\n                        <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                        <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                        <td class=\"text-center\">{{row.Validity}}</td>\r\n                        <td class=\"text-center\">{{row.Source}}</td>\r\n                        <td class=\"text-center\">{{row.Type}}</td>\r\n                        <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n                      \r\n                    </tr>\r\n                </tbody>\r\n            </table>--><!--kyc_id_fk	ClsHistoryDate	Closure_date	Client	sales_agent	source	cb	standards	validity	total_closure	gross_margin	pending_amount	payment_status	project_status--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-center>Soft Copy Date</th><th class=text-center>Closure Date</th><th class=text-center>Agent</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><!-- <th class=\"text-center\">AB</th>\r\n                        <th class=\"text-center\">Source</th>--><th class=text-center>Validity</th><!--<th class=\"text-center\">Type</th>--><th class=text-center>Closure Amount</th><th class=text-center>Pending Amount</th><th class=text-center>Payment Status</th><th class=text-center>Cert Dispatch</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-center>{{row.UpdatedDate|date:\'dd/MM/yyyy\'}}</td><td class=text-center>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Client}}</td><td class=text-left>{{row.Location}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><!--<td class=\"text-center\">{{row.AB}}</td>\r\n                        <td class=\"text-center\">{{row.Source}}</td>--><td class=text-center>{{row.Validity}}</td><!--<td class=\"text-center\">{{row.Type}}</td>--><td class=text-center>{{row.TotalClosure}}</td><td class=text-center>{{row.PendingAmount}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.ProjectStatus}}</td></tr></tbody></table></div><!--<div ng-hide=\"vm.data.hideKycSearch\">\r\n            <p class=\"text-right\">\r\n                KYC Info {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}\r\n            </p>\r\n            <table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4; padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px;\">\r\n                    <tr style=\"color:#4A235A;padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px\" \">\r\n                        <th class=\"text-left\">Client Name</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-left\">Account Manager</th>\r\n                        <th class=\"text-left\">City</th>\r\n                        <th class=\"text-center\">Status</th>\r\n                        <th class=\"text-center\">Last Update</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                    <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.func.getSingleKycDetailsByKyc(row.Kycid)\">--> <!--<td class=\"text-left\">{{row.ClientName}}</td>--><!---ng-if=\"vm.data.NumCert.length<=0\" style=\"color:darkolivegreen\"--><!--<td class=\"text-left\">{{row.Companyname}}</td>\r\n                        <td class=\"text-left\">{{row.AcountManager}}</td>\r\n                        <td class=\"text-left\">{{row.CompanyCity}}</td>\r\n                        <td class=\"text-center\">{{row.Status}}</td>\r\n                        <td class=\"text-center\">{{row.UpdatedDate | date:\'dd/MM/yyyy\'}}</td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n\r\n        </div>--><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certificatesDispatched/certificateshardcopysent.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Certificates Hard Copy Sent</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\" required></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchProposalData()\">Search By</button>--></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Dispatch</label><input class=form-control type=text id=Dispatch name=Dispatch autocomplete=off placeholder=\"Search By Cert Dispatch\" ng-model=vm.data.Dispatch uib-typeahead=\"Dispatch as Dispatch for Dispatch in vm.data.CertDispatch | filter:$viewValue | limitTo:10\"><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive ng-hide=vm.data.hideProposalSearch><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                    <th class=\"text-left\">Pending Payment</th>\r\n                    <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n                </tr>\r\n            </thead>\r\n            <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                    <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                    <td class=\"text-left\">{{row.Client}}</td>\r\n                    <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                    <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                    <td class=\"text-center\">{{row.Validity}}</td>\r\n                    <td class=\"text-center\">{{row.Source}}</td>\r\n                    <td class=\"text-center\">{{row.Type}}</td>\r\n                    <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n                    </tr>\r\n                </tbody>\r\n            </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><th class=text-center>Source</th><th class=text-center>Validity</th><th class=text-center>Type</th><th class=text-center>Agent</th><th class=text-center>Payment Status</th><th class=text-center>Cert Dispatch</th><th class=text-center>Agent Request</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.Client}}</td><td class=text-left>{{row.Location}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><td class=text-center>{{row.Source}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.Type}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.agent_request}}</td></tr></tbody></table></div><!--<div ng-hide=\"vm.data.hideKycSearch\">\r\n            <p class=\"text-right\">\r\n                KYC Info {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}\r\n            </p>\r\n            <table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4; padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px;\">\r\n                    <tr style=\"color:#4A235A;padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px\" \">\r\n                        <th class=\"text-left\">Client Name</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-left\">Account Manager</th>\r\n                        <th class=\"text-left\">City</th>\r\n                        <th class=\"text-center\">Status</th>\r\n                        <th class=\"text-center\">Last Update</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                    <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.func.getSingleKycDetailsByKyc(row.Kycid)\">--> <!--<td class=\"text-left\">{{row.ClientName}}</td>--><!---ng-if=\"vm.data.NumCert.length<=0\" style=\"color:darkolivegreen\"--><!--<td class=\"text-left\">{{row.Companyname}}</td>\r\n                        <td class=\"text-left\">{{row.AcountManager}}</td>\r\n                        <td class=\"text-left\">{{row.CompanyCity}}</td>\r\n                        <td class=\"text-center\">{{row.Status}}</td>\r\n                        <td class=\"text-center\">{{row.UpdatedDate | date:\'dd/MM/yyyy\'}}</td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n\r\n        </div>--><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certificatesDispatched/certificatessoftcopysent.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-4><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:3px></a><h2 style=\"color:cornsilk; text-align:center\">Certs Resolved</h2></div></div><div class=col-md-8><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\" required></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchProposalData()\">Search By</button>--></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Dispatch</label><input class=form-control type=text id=Dispatch name=Dispatch autocomplete=off placeholder=\"Search By Cert Dispatch\" ng-model=vm.data.Dispatch uib-typeahead=\"Dispatch as Dispatch for Dispatch in vm.data.CertDispatch | filter:$viewValue | limitTo:10\"><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>(Dispatch Date) From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive ng-hide=vm.data.hideProposalSearch><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n      <thead style=\"background-color:#76D7C4;\">\r\n          <tr style=\"color:#4A235A;\">\r\n              <th class=\"text-left\">Closure Date</th>\r\n              <th class=\"text-left\">Company Name</th>\r\n              <th class=\"text-center\">Sales Agent</th>\r\n              <th class=\"text-left\">Location</th>\r\n\r\n              <th class=\"text-center\">Validity</th>\r\n              <th class=\"text-center\">Source</th>\r\n              <th class=\"text-center\">Deal Type</th>\r\n              <th class=\"text-left\">Closure Amount</th>\r\n\r\n              <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n          <th class=\"text-left\">Pending Payment</th>\r\n          <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n      </tr>\r\n  </thead>\r\n  <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n      <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n          <td class=\"text-left\">{{row.DispatchDate|date:\'dd/MM/yyyy\'}}</td>\r\n          <td class=\"text-left\">{{row.Client}}</td>\r\n          <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n          <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n          <td class=\"text-center\">{{row.Validity}}</td>\r\n          <td class=\"text-center\">{{row.Source}}</td>\r\n          <td class=\"text-center\">{{row.Type}}</td>\r\n          <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n              <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n              <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n          </tr>\r\n      </tbody>\r\n  </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Soft Copy Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><th class=text-center>Source</th><th class=text-center>Validity</th><th class=text-center>Type</th><th class=text-center>Agent</th><th class=text-center>Payment Status</th><th class=text-center>Certification Status</th><th class=text-center>Agent Request</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.DispatchDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.Client}}</td><td class=text-left>{{row.Location}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><td class=text-center>{{row.Source}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.Type}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.agent_request}}</td></tr></tbody></table></div><!--<div ng-hide=\"vm.data.hideKycSearch\">\r\n            <p class=\"text-right\">\r\n                KYC Info {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}\r\n            </p>\r\n            <table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4; padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px;\">\r\n                    <tr style=\"color:#4A235A;padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px\" \">\r\n                        <th class=\"text-left\">Client Name</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-left\">Account Manager</th>\r\n                        <th class=\"text-left\">City</th>\r\n                        <th class=\"text-center\">Status</th>\r\n                        <th class=\"text-center\">Last Update</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                    <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.func.getSingleKycDetailsByKyc(row.Kycid)\">--> <!--<td class=\"text-left\">{{row.ClientName}}</td>--><!---ng-if=\"vm.data.NumCert.length<=0\" style=\"color:darkolivegreen\"--><!--<td class=\"text-left\">{{row.Companyname}}</td>\r\n                        <td class=\"text-left\">{{row.AcountManager}}</td>\r\n                        <td class=\"text-left\">{{row.CompanyCity}}</td>\r\n                        <td class=\"text-center\">{{row.Status}}</td>\r\n                        <td class=\"text-center\">{{row.UpdatedDate | date:\'dd/MM/yyyy\'}}</td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n\r\n        </div>--><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certification/CertificateRenewals.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Certificate Renewals</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Search By Company/Cert Number</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name/Cert Number\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getAllCompanyNames | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchCertificationData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-href=\"addkyc\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Zone</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>--><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Status</label><input class=form-control type=text id=CertStatus name=CertStatus autocomplete=off placeholder=\"Search By Cert Status\" ng-model=vm.data.CertStatus uib-typeahead=\"Zone as Zone for Zone in vm.data.getCertStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Sale Status</label><input class=form-control type=text id=SaleStatus name=SaleStatus autocomplete=off placeholder=\"Search By Sale Status\" ng-model=vm.data.SaleStatus uib-typeahead=\"Zone as Zone for Zone in vm.data.getSaleStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>(Issue)From Date</label><!--<script  src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--><!--<input class=\"form-control\" type=\"date\" id=\"FromDate\" name=\"FromDate\" autocomplete=\"off\"  ng-model=\"vm.data.FromDate\" />--> <input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><!--<script src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--> <input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a><!--<button type=\"button\" class=\"btn btn-default\"></button>--></div></div></div></form></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.afterSearch == true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right>Clients {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Company Name</th><th class=text-left>Cert Num</th><th class=text-left>ISO Standard</th><th class=text-left>Issue Date</th><th class=text-left>Expiry Date</th><th class=text-center>Validity</th><th class=text-center>Cert Type</th><th class=text-left>CB-AB</th><th class=text-center>Agent</th><!--<th class=\"text-center\">AB</th>--><!--<th class=\"text-center\">Cert Date</th>--><!--<th class=\"text-center\">Type</th>--><!--<th class=\"text-center\">Pending Amount</th>--><th class=text-center>Certification Status</th><!--<th class=\"text-center\">Sale Status</th>--><!--<th class=\"text-center\">Updated Date</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.getAllCertificationData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSurvSingleKycDetails(row.CertificationClosurKycID)><!--<td class=\"text-left\">{{row.CertificationCompanyName}}</td>--><td class=text-left data-toggle=tooltip title={{row.CertificationCompanyName}}>{{row.CertificationCompanyName|limitTo:25}}{{row.CertificationCompanyName.length>25?\'...\':\'\'}}</td><!--<td class=\"text-left\">{{row.City}}</td>--><td class=text-left>{{row.CertificationNumber}}</td><td class=text-left>{{row.CertificationIsoStandard}}</td><td class=text-left>{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td><td class=text-center>{{row.CertificationValidity}}</td><td class=text-center>{{row.CertIssueType}}</td><td class=text-left>{{row.CertificationBody}} - {{row.CertificationUnderAccred}}</td><td class=text-center>{{row.CertAssign}}</td><!--<td class=\"text-center\">{{row.PendingAmount}}</td>--><!-- <td class=\"text-left\" data-toggle=\"tooltip\" title=\"{{row.Remarks}}\">{{row.Remarks|limitTo:35}}{{row.Remarks.length>35?\'...\':\'\'}}</td>--><td class=text-center>{{row.CertificationStatus}}</td><!--<td class=\"text-center\">{{row.CertSaleStatus}}</td>--><!--<td class=\"text-center\">{{row.LastUpdatedDate | date:\'dd/MM/yyyy\'}}</td>--></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certification/ExpiredCertificate.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Expired Certificates</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Search By Company/Cert Number</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name/Cert Number\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getAllCompanyNames | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchCertificationData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-href=\"addkyc\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Zone</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>--><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Status</label><input class=form-control type=text id=CertStatus name=CertStatus autocomplete=off placeholder=\"Search By Cert Status\" ng-model=vm.data.CertStatus uib-typeahead=\"Zone as Zone for Zone in vm.data.getCertStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Sale Status</label><input class=form-control type=text id=SaleStatus name=SaleStatus autocomplete=off placeholder=\"Search By Sale Status\" ng-model=vm.data.SaleStatus uib-typeahead=\"Zone as Zone for Zone in vm.data.getSaleStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>(Issue)From Date</label><!--<script  src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--><!--<input class=\"form-control\" type=\"date\" id=\"FromDate\" name=\"FromDate\" autocomplete=\"off\"  ng-model=\"vm.data.FromDate\" />--> <input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><!--<script src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--> <input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a><!--<button type=\"button\" class=\"btn btn-default\"></button>--></div></div></div></form></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.afterSearch == true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right>Clients {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Company Name</th><th class=text-left>Cert Num</th><th class=text-left>ISO Standard</th><th class=text-left>Issue Date</th><th class=text-left>Expiry Date</th><th class=text-center>Validity</th><th class=text-center>Cert Type</th><th class=text-left>CB-AB</th><th class=text-center>Agent</th><!--<th class=\"text-center\">AB</th>--><!--<th class=\"text-center\">Cert Date</th>--><!--<th class=\"text-center\">Type</th>--><!--<th class=\"text-center\">Pending Amount</th>--><th class=text-center>Certification Status</th><!--<th class=\"text-center\">Sale Status</th>--><!--<th class=\"text-center\">Updated Date</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.getAllCertificationData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSurvSingleKycDetails(row.CertificationClosurKycID)><!--<td class=\"text-left\">{{row.CertificationCompanyName}}</td>--><td class=text-left data-toggle=tooltip title={{row.CertificationCompanyName}}>{{row.CertificationCompanyName|limitTo:25}}{{row.CertificationCompanyName.length>25?\'...\':\'\'}}</td><!--<td class=\"text-left\">{{row.City}}</td>--><td class=text-left>{{row.CertificationNumber}}</td><td class=text-left>{{row.CertificationIsoStandard}}</td><td class=text-left>{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td><td class=text-center>{{row.CertificationValidity}}</td><td class=text-center>{{row.CertIssueType}}</td><td class=text-left>{{row.CertificationBody}} - {{row.CertificationUnderAccred}}</td><td class=text-center>{{row.CertAssign}}</td><!--<td class=\"text-center\">{{row.PendingAmount}}</td>--><!-- <td class=\"text-left\" data-toggle=\"tooltip\" title=\"{{row.Remarks}}\">{{row.Remarks|limitTo:35}}{{row.Remarks.length>35?\'...\':\'\'}}</td>--><td class=text-center>{{row.CertificationStatus}}</td><!--<td class=\"text-center\">{{row.CertSaleStatus}}</td>--><!--<td class=\"text-center\">{{row.LastUpdatedDate | date:\'dd/MM/yyyy\'}}</td>--></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certification/addNewTrainingCert.html","<acme-navbar></acme-navbar><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><!-- form search --><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Add New Training Certificate</h3><br></div></div></form><!-- end form search --></div></div></div><div class=\"body-content clearfix\"><div class=\"bg-color1 block-section line-bottom\"><div class=container><div class=row><div class=\"col-md-8 col-md-offset-2 text-right\"><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> -<label style=color:red>Mandatory Fields</label></div><div class=\"col-md-8 col-md-offset-2\"><!-- form post a job --><form name=addcertificationform novalidate><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcertificationform.CompanyName.$error.required) }\"><label>Candidate Name</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Candidate Name\" id=CompanyName name=CompanyName ng-model=vm.data.CompanyName required></div><div class=row><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.Country.$error.required)}\"><label>Country</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Country Name\" id=Country name=Country ng-model=vm.data.Country required></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':vm.data.requiredStateName}\"><!--(vm.data.isFormSubmit && addcertificationform.State.$error.required)--><label>State</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter State Name\" id=State ng-change=vm.func.hideRequiredStateName() name=State ng-model=vm.data.State></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.City.$error.required)}\"><label>City</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=City name=City ng-model=vm.data.City required></div></div></div><div class=row><div class=col-sm-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.IssueDate.$error.required)}\"><label>Issue Date</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control id=IssueDate placeholder=MM/dd/yyyy name=IssueDate ng-model=vm.data.IssueDate required> <span>MM/dd/yyyy</span></div></div><!--<div class=\"col-sm-4\">\r\n                                <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.ExpiryDate.$error.required)}\">\r\n                                    <label>Expiry Date</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <input type=\"date\" class=\"form-control \" id=\"ExpiryDate\" placeholder=\"MM/dd/yyyy\" name=\"ExpiryDate\" ng-model=\"vm.data.ExpiryDate\" required>--><!--ng-change=\"vm.func.hideRequiredDateValid()\"     ng-change=\"vm.func.hideRequiredDateValid()\"--><!--</div>\r\n                            </div>--><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcertificationform.CertificationNumber.$error.required) }\"><label>Certification Number</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Number\" id=CertificationNumber name=CertificationNumber ng-model=vm.data.CertificationNumber required></div></div><div class=col-md-4><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredCertificationType}\"><label>Implementation Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CertificationType name=CertificationType ng-change=vm.func.hideRequiredCertificationType() ng-model=vm.data.selectedCertificationType ng-options=\"item.value for item in vm.data.CertificationType\"></select></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.Standard.$error.required)}\"><label>Certification Standard</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Standard\" id=Standard name=Standard ng-model=vm.data.Standard required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.Body.$error.required)}\"><label>Certification Body</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control cols=5 rows=5 placeholder=\"Enter Certification Body\" id=Body name=Body ng-model=vm.data.Body required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.UnderAccreditation.$error.required)}\"><label>Under Accreditation</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control cols=5 rows=5 placeholder=\"Enter AB\" id=UnderAccreditation name=UnderAccreditation ng-model=vm.data.UnderAccreditation required></div></div></div><!--<div class=\"row\">\r\n                          \r\n                            <div class=\"col-md-4\">\r\n                                <div class=\"form-group\" ng-class=\"{\'has-error\':vm.data.requiredCertificationValidity}\">\r\n                                    <label>Validity</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <select class=\"form-control \" placeholder=\"Enter Validity\" id=\"Validity\" name=\"Validity\" ng-change=\"vm.func.hideRequiredCertificationValidity()\" ng-model=\"vm.data.selectedCertificationValidity\" ng-options=\"item.value for item in vm.data.Validity\"></select>\r\n                                </div>\r\n                            </div>--><!--<div class=\"col-md-4\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.CertificationStatus.$error.required)}\">\r\n                                <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredCertificationStatus}\">\r\n                                    <label>Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <select class=\"form-control\" id=\"CertificationStatus\" name=\"CertificationStatus\" ng-change=\"vm.func.hideRequiredCertificationStatus()\" ng-model=\"vm.data.selectedCertificationStatus\" ng-options=\"item.value for item in vm.data.CertificationStatus\"></select>\r\n                                </div>\r\n                            </div>--><!--<div class=\"col-md-4\">\r\n                                <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.CertificationIssueType}\">\r\n                                    <label>Issue Type</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <select class=\"form-control\" id=\"CertificationIssueType\" name=\"CertificationIssueType\" ng-change=\"vm.func.hideRequiredCertIssueType()\" ng-model=\"vm.data.SelectedCertIssueType\" ng-options=\"item.value for item in vm.data.CertificateIssueType\"></select>\r\n                                </div>\r\n                            </div>\r\n                        </div>--><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.CertificationAddress.$error.required)}\"><label>Address</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Postal Address\" id=CertificationAddress name=CertificationAddress ng-model=vm.data.CertificationAddress required></textarea></div></div><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.Scope.$error.required)}\"><label>Training In</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Training scope\" id=Scope name=Scope ng-model=vm.data.Scope required></textarea></div></div></div><div class=form-group><button class=\"btn btn-t-primary btn-primary\" ng-click=\"vm.func.goToBack( vm.data.getSingleKycid,vm.data.getPropId)\">Back</button> <button class=\"btn btn-t-primary btn-success\" ng-click=vm.func.saveCertificationDetails(addcertificationform.$valid)>Save</button></div></form><!-- end form post a job --></div></div></div></div></div><!--end body-content --><acme-footer></acme-footer>");
$templateCache.put("app/certification/addcertification.html","<acme-navbar></acme-navbar><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><!-- form search --><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Add New Certificate</h3><br></div></div></form><!-- end form search --></div></div></div><div class=\"body-content clearfix\"><div class=\"bg-color1 block-section line-bottom\"><div class=container><div class=row><div class=\"col-md-8 col-md-offset-2 text-right\"><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> -<label style=color:red>Mandatory Fields</label></div><div class=\"col-md-8 col-md-offset-2\"><!-- form post a job --><form name=addcertificationform novalidate><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcertificationform.CompanyName.$error.required) }\"><label>Company Name</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Company Name\" id=CompanyName name=CompanyName ng-model=vm.data.CompanyName required></div><div class=row><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.Country.$error.required)}\"><label>Country</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Country Name\" id=Country name=Country ng-model=vm.data.Country required></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':vm.data.requiredStateName}\"><!--(vm.data.isFormSubmit && addcertificationform.State.$error.required)--><label>State</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter State Name\" id=State ng-change=vm.func.hideRequiredStateName() name=State ng-model=vm.data.State></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.City.$error.required)}\"><label>City</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=City name=City ng-model=vm.data.City required></div></div></div><div class=row><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.IssueDate.$error.required)}\"><label>Issue Date On Cert</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control id=IssueDate placeholder=MM/dd/yyyy name=IssueDate ng-model=vm.data.IssueDate ng-change=vm.func.datepicker() required></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.ExpiryDate.$error.required)}\"><label>Expiry Date On Cert</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control id=ExpiryDate placeholder=MM/dd/yyyy name=ExpiryDate ng-model=vm.data.AuditRenewalDate required><!--ng-change=\"vm.func.hideRequiredDateValid()\" ng-change=\"vm.func.hideRequiredDateValid()\"--></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':vm.data.requiredCertificationValidity}\"><label>Next Billing Cycle</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control placeholder=\"Enter Validity\" id=Validity name=Validity ng-change=vm.func.hideRequiredCertificationValidity() ng-model=vm.data.selectedCertificationValidity ng-options=\"item.value for item in vm.data.Validity\"></select></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.ExpiryDate.$error.required)}\"><label>Surveillance Audit Date</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control id=AuditRenewalDate placeholder=MM/dd/yyyy name=AuditRenewalDate ng-model=vm.data.ExpiryDate required><!--ng-change=\"vm.func.hideRequiredDateValid()\"     ng-change=\"vm.func.hideRequiredDateValid()\"--></div></div></div><div class=row><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcertificationform.CertificationNumber.$error.required) }\"><label>Certification Number</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Number\" id=CertificationNumber name=CertificationNumber ng-model=vm.data.CertificationNumber required></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.Standard.$error.required)}\"><label>Certification Standard</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Standard\" id=Standard name=Standard ng-model=vm.data.Standard required></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.Body.$error.required)}\"><label>Certification Body</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control cols=5 rows=5 placeholder=\"Enter Certification Body\" id=Body name=Body ng-model=vm.data.Body required></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.UnderAccreditation.$error.required)}\"><label>Accreditation Body</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control cols=5 rows=5 placeholder=\"Enter AB\" id=UnderAccreditation name=UnderAccreditation ng-model=vm.data.UnderAccreditation required></div></div></div><div class=row><div class=col-md-4><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredCertificationType}\"><label>Implementation Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CertificationType name=CertificationType ng-change=vm.func.hideRequiredCertificationType() ng-model=vm.data.selectedCertificationType ng-options=\"item.value for item in vm.data.CertificationType\"></select></div></div><!--<div class=\"col-md-4\">\r\n          <div class=\"form-group\" ng-class=\"{\'has-error\':vm.data.requiredCertificationValidity}\">\r\n              <label>Validity</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n              <select class=\"form-control \" placeholder=\"Enter Validity\" id=\"Validity\" name=\"Validity\" ng-change=\"vm.func.hideRequiredCertificationValidity()\" ng-model=\"vm.data.selectedCertificationValidity\" ng-options=\"item.value for item in vm.data.Validity\"></select>\r\n          </div>\r\n      </div>--><!--<div class=\"col-md-4\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.CertificationStatus.$error.required)}\">\r\n          <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredCertificationStatus}\">\r\n              <label>Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n              <select class=\"form-control\" id=\"CertificationStatus\" name=\"CertificationStatus\" ng-change=\"vm.func.hideRequiredCertificationStatus()\" ng-model=\"vm.data.selectedCertificationStatus\" ng-options=\"item.value for item in vm.data.CertificationStatus\"></select>\r\n          </div>\r\n      </div>--><div class=col-md-4><div class=form-group ng-class=\"{ \'has-error\': vm.data.CertificationIssueType}\"><label>Issue Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CertificationIssueType name=CertificationIssueType ng-change=vm.func.hideRequiredCertIssueType() ng-model=vm.data.SelectedCertIssueType ng-options=\"item.value for item in vm.data.CertificateIssueType\"></select></div></div></div><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.CertificationAddress.$error.required)}\"><label>Address</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Postal Address\" id=CertificationAddress name=CertificationAddress ng-model=vm.data.CertificationAddress required></textarea></div></div><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.Scope.$error.required)}\"><label>Scope</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Scope\" id=Scope name=Scope ng-model=vm.data.Scope required></textarea></div></div></div><div class=form-group><button class=\"btn btn-t-primary btn-primary\" ng-click=\"vm.func.goToBack( vm.data.getSingleKycid,vm.data.getPropId)\">Back</button> <button class=\"btn btn-t-primary btn-success\" ng-click=vm.func.saveCertificationDetails(addcertificationform.$valid)>Save</button></div></form><!-- end form post a job --></div></div></div></div></div><!--end body-content --><acme-footer></acme-footer>");
$templateCache.put("app/certification/allCertificationDetails.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Certificates</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getAllCompanyNames | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchCertificationData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-href=\"addkyc\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Zone</label>\r\n                              \r\n                                <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>--><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Status</label><input class=form-control type=text id=CertStatus name=CertStatus autocomplete=off placeholder=\"Search By Cert Status\" ng-model=vm.data.CertStatus uib-typeahead=\"Zone as Zone for Zone in vm.data.getCertStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Sale Status</label><input class=form-control type=text id=SaleStatus name=SaleStatus autocomplete=off placeholder=\"Search By Sale Status\" ng-model=vm.data.SaleStatus uib-typeahead=\"Zone as Zone for Zone in vm.data.getSaleStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>(Expiry)From Date</label><!--<script  src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--><!--<input class=\"form-control\" type=\"date\" id=\"FromDate\" name=\"FromDate\" autocomplete=\"off\"  ng-model=\"vm.data.FromDate\" />--> <input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><!--<script src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--> <input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a><!--<button type=\"button\" class=\"btn btn-default\"></button>--></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.afterSearch == true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right>Clients {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>Expiry Date</th><th class=text-left>CB</th><!--<th class=\"text-center\">AB</th>--><!--<th class=\"text-center\">Cert Date</th>--><th class=text-center>Validity</th><!--<th class=\"text-center\">Type</th>--><th class=text-center>Assign To</th><th class=text-center>Remarks</th><th class=text-center>Certification Status</th><th class=text-center>Sale Status</th><!--<th class=\"text-center\">Updated Date</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.getAllCertificationData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSurvSingleKycDetails(row.CertificationClosurKycID,row.CertificationId)><!--<td class=\"text-left\">{{row.CertificationCompanyName}}</td>--><td class=text-left data-toggle=tooltip title={{row.CertificationCompanyName}}>{{row.CertificationCompanyName|limitTo:25}}{{row.CertificationCompanyName.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.City}}</td><td class=text-left>{{row.CertificationIsoStandard}}</td><td class=text-left>{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.CertificationBody}}</td><!--<td class=\"text-center\">{{row.CertificationUnderAccred}}</td>--><!--<td class=\"text-center\">{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td>--><td class=text-center>{{row.CertificationValidity}}</td><!--<td class=\"text-center\">{{row.CertificationType}}</td>--><td class=text-center>{{row.CertAssign}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:35}}{{row.Remarks.length>35?\'...\':\'\'}}</td><td class=text-center>{{row.CertificationStatus}}</td><td class=text-center>{{row.CertSaleStatus}}</td><!--<td class=\"text-center\">{{row.LastUpdatedDate | date:\'dd/MM/yyyy\'}}</td>--></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certification/issuedCertificates.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Certificates</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Search By Company/Cert Number</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name/Cert Number\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getAllCompanyNames | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchCertificationData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                  <div class=\"form-group\">\r\n                      <label class=\"hidden-xs\">&nbsp;</label>\r\n                      <a class=\"btn btn-block btn-theme btn-success\" ng-href=\"addkyc\">Add New</a>\r\n                  </div>\r\n              </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><!--<div class=\"col-sm-2 col-xs-12\">\r\n      <div class=\"form-sort-date\">\r\n          <label class=\"color-white\">Zone</label>\r\n\r\n          <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />\r\n      </div>\r\n  </div>--><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Status</label><input class=form-control type=text id=CertStatus name=CertStatus autocomplete=off placeholder=\"Search By Cert Status\" ng-model=vm.data.CertStatus uib-typeahead=\"Zone as Zone for Zone in vm.data.getCertStatus | filter:$viewValue | limitTo:10\"></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n      <div class=\"form-sort-date\">\r\n          <label class=\"color-white\">Sale Status</label>\r\n\r\n          <input class=\"form-control\" type=\"text\" id=\"SaleStatus\" name=\"SaleStatus\"\r\n              autocomplete=\"off\" placeholder=\"Search By Sale Status\"\r\n              ng-model=\"vm.data.SaleStatus\"\r\n              uib-typeahead=\"Zone as Zone for Zone in vm.data.getSaleStatus | filter:$viewValue | limitTo:10\" />\r\n      </div>\r\n  </div>--><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>CB</label><input class=form-control type=text id=CB name=CB autocomplete=off placeholder=\"Search By CB\" ng-model=vm.data.CertBody uib-typeahead=\"Zone as Zone for Zone in vm.data.getCertBody | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>AB</label><input class=form-control type=text id=AB name=AB autocomplete=off placeholder=\"Search By AB\" ng-model=vm.data.AccBody uib-typeahead=\"Zone as Zone for Zone in vm.data.getAccBody | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>Date Filter</label><!--  <input class=\"form-control\" type=\"text\" id=\"QaStatus\" name=\"QaStatus\" autocomplete=\"off\" placeholder=\"Status\" ng-model=\"vm.data.QaStatus\" uib-typeahead=\"QaStatus as QaStatus for QaStatus in vm.data.SuggestedQaStatus | filter:$viewValue | limitTo:10\" />--><select class=form-control id=DateType name=DateType ng-model=vm.data.DateType data-ng-options=\"item.value for item in vm.data.selectDateType\"></select><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><!--<script  src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--><!--<input class=\"form-control\" type=\"date\" id=\"FromDate\" name=\"FromDate\" autocomplete=\"off\"  ng-model=\"vm.data.FromDate\" />--> <input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><!--<script src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--> <input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a><!--<button type=\"button\" class=\"btn btn-default\"></button>--></div></div></div></form></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.afterSearch == true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right>Clients {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Modified date</th><th class=text-left>Company Name</th><th class=text-left>Cert Num</th><th class=text-left>ISO Standard</th><th class=text-left>Issue Date</th><th class=text-left>Expiry Date</th><!--<th class=\"text-center\">Validity</th>--><th class=text-center>Cert Type</th><th class=text-left>CB-AB</th><th class=text-center>Agent</th><!--<th class=\"text-center\">AB</th>--><!--<th class=\"text-center\">Cert Date</th>--><!--<th class=\"text-center\">Type</th>--><!--<th class=\"text-center\">Pending Amount</th>--><th class=text-center>Certification Status</th><!--<th class=\"text-center\">Sale Status</th>--><!--<th class=\"text-center\">Updated Date</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.getAllCertificationData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSurvSingleKycDetails(row.CertificationClosurKycID)><!--<td class=\"text-left\">{{row.CertificationCompanyName}}</td>--><td class=text-left>{{row.LastUpdatedDate | date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.CertificationCompanyName}}>{{row.CertificationCompanyName|limitTo:25}}{{row.CertificationCompanyName.length>25?\'...\':\'\'}}</td><!--<td class=\"text-left\">{{row.City}}</td>--><td class=text-left>{{row.CertificationNumber}}</td><td class=text-left>{{row.CertificationIsoStandard}}</td><td class=text-left>{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td><!--<td class=\"text-center\">{{row.CertificationValidity}}</td>--><td class=text-center>{{row.CertIssueType}}</td><td class=text-left>{{row.CertificationBody}} - {{row.CertificationUnderAccred}}</td><td class=text-center>{{row.CertAssign}}</td><!--<td class=\"text-center\">{{row.PendingAmount}}</td>--><!-- <td class=\"text-left\" data-toggle=\"tooltip\" title=\"{{row.Remarks}}\">{{row.Remarks|limitTo:35}}{{row.Remarks.length>35?\'...\':\'\'}}</td>--><td class=text-center>{{row.CertificationStatus}}</td><!--<td class=\"text-center\">{{row.CertSaleStatus}}</td>--><!--<td class=\"text-center\">{{row.LastUpdatedDate | date:\'dd/MM/yyyy\'}}</td>--></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certification/searchCertificates.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Find Certificates</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Search by Company Name/Certificate Number</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name/Certificate Number\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getAllCompanyNames | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchCertificationData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-href=\"addkyc\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><!--<form class=\"form-sort-date\">\r\n                    <div class=\"row\">--><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Zone</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>--><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Agent</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"Agent\" name=\"Agent\" autocomplete=\"off\" placeholder=\"Search By Agent Name\" ng-model=\"vm.data.AgentName\" uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Cert Status</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"CertStatus\" name=\"CertStatus\" autocomplete=\"off\" placeholder=\"Search By Cert Status\" ng-model=\"vm.data.CertStatus\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getCertStatus | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Sale Status</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"SaleStatus\" name=\"SaleStatus\" autocomplete=\"off\" placeholder=\"Search By Sale Status\" ng-model=\"vm.data.SaleStatus\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getSaleStatus | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">(Expiry)From Date</label>--><!--<script  src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--><!--<input class=\"form-control\" type=\"date\" id=\"FromDate\" name=\"FromDate\" autocomplete=\"off\"  ng-model=\"vm.data.FromDate\" />--><!--<input class=\"form-control \" type=\"date\" id=\"FromDate\" name=\"FromDate\" autocomplete=\"off\" ng-model=\"vm.data.FromDate\" />\r\n\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">To Date</label>--><!--<script src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--><!--<input class=\"form-control\" type=\"date\" id=\"ToDate\" name=\"ToDate\" autocomplete=\"off\" ng-model=\"vm.data.ToDate\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>--><!-- <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.searchby()\">Search</a>--><!--<button type=\"button\" class=\"btn btn-default\"></button>--><!--</div>\r\n                        </div>\r\n                    </div>\r\n                </form>--></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.afterSearch == true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right>Clients {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Cert Number</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>Expiry Date</th><th class=text-left>CB</th><!--<th class=\"text-center\">AB</th>--><!--<th class=\"text-center\">Cert Date</th>--><th class=text-center>Validity</th><!--<th class=\"text-center\">Type</th>--><th class=text-center>Assign To</th><!--<th class=\"text-center\">Remarks</th>--><th class=text-center>Certification Status</th><th class=text-center>Sale Status</th><!--<th class=\"text-center\">Updated Date</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.getAllCertificationData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.viewSearchDetails(row)><!--<td class=\"text-left\">{{row.CertificationCompanyName}}</td>--><td class=text-left>{{row.CertificationNumber}}</td><td class=text-left data-toggle=tooltip title={{row.CertificationCompanyName}}>{{row.CertificationCompanyName|limitTo:25}}{{row.CertificationCompanyName.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.City}}</td><td class=text-left>{{row.CertificationIsoStandard}}</td><td class=text-left>{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.CertificationBody}}</td><!--<td class=\"text-center\">{{row.CertificationUnderAccred}}</td>--><!--<td class=\"text-center\">{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td>--><td class=text-center>{{row.CertificationValidity}}</td><!--<td class=\"text-center\">{{row.CertificationType}}</td>--><td class=text-center>{{row.CertAssign}}</td><!--<td class=\"text-left\" data-toggle=\"tooltip\" title=\"{{row.Remarks}}\">{{row.Remarks|limitTo:35}}{{row.Remarks.length>35?\'...\':\'\'}}</td>--><td class=text-center>{{row.CertificationStatus}}</td><td class=text-center>{{row.CertSaleStatus}}</td><!--<td class=\"text-center\">{{row.LastUpdatedDate | date:\'dd/MM/yyyy\'}}</td>--></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certification/survkycdetails.html","<acme-navbar></acme-navbar><div class=bg-color1><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Details Of Client KYC</h3><br></div></div></form></div></div></div><br><div class=container><a class=alignright ng-href=certificatesPending><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><h3 class=\"no-margin-top color-black alignleft\"><span class=text-info>Company Name</span> - {{vm.data.CompanyName}}</h3></div><div class=container><div class=row><div class=col-md-4><div class=box-list><div class=item><a ng-href=# ng-click=vm.data.editClosureKYCDetails(vm.data.Kycid) class=\"btn btn-theme btn-xs btn-primary alignright\"><span class=\"glyphicon glyphicon-pencil\"></span> Edit</a><h4 class=text-info><u>Company Details</u></h4><p style=color:#8A8989>Company Name - <span class=color-black>{{vm.data.CompanyName}}</span><br>Company Location - <span class=color-black>{{vm.data.CompanyCity}}</span>,<span class=color-black>{{vm.data.CompanyCountry}}</span><br>Nature Of Business - <span class=color-black>{{vm.data.NatureofBusiness}}</span><br>Company Type - <span class=color-black>{{vm.data.CompanyType}}</span><br>Employee Strength - <span class=color-black>{{vm.data.EmployeeStrength}}</span><br>Company URL - <span class=color-black>{{vm.data.URL}}</span><br>Company Landline - <span class=color-black>{{vm.data.Landline}}</span><br><br></p><h4 class=text-info><u>Primary Contact</u></h4><p style=\"color: #8A8989\">Contact Name - <span class=color-black>{{vm.data.ClientName}}</span><br>Client Number - <span class=color-black>{{vm.data.ContactNumber}}</span><br>Client Email - <span class=color-black>{{vm.data.ContactEmail}}</span><br>Client Designation - <span class=color-black>{{vm.data.Designation}}</span><br><br></p><label class=alignright style=color:green ng-if=\"vm.data.noShowDetails == true\" ng-click=vm.func.activenoShowDetails()><u>More Details</u></label><h4 ng-if=\"vm.data.hideDetails == true\" class=text-info><u>Alternate Contact</u></h4><p style=color:#8A8989 ng-if=\"vm.data.hideDetails == true\">Contact Name - <span class=color-black>{{vm.data.AltContactName}}</span><br>Contact Number - <span class=color-black>{{vm.data.AltContactNumber}}</span><br>Contact Email - <span class=color-black>{{vm.data.AltContactEmail}}</span><br>Designation - <span class=color-black>{{vm.data.AltDesignation}}</span><br></p></div></div></div><div class=col-md-8><div class=box-list><div class=item><div class=text-right ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"><!--ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"--><h4 class=\"modal-title text-info alignleft\">Certification Details</h4><span>Certificates {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</span> <a ng-href=# ng-click=vm.data.goAddNewCertificationPage(vm.data.Kycid) style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a><br><br></div><div class=table-responsive ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-left>AB</th><!--<th class=\"text-left\">Issue Date</th>--><th class=text-left>Issue Date</th><th class=text-left>Expiry Date</th><th class=text-left>Validity</th><th class=text-left>Issue Type</th><th class=text-left>Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.certificationDetailsForSingleKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current pagination-id=certificatepagination><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.editCertificationDetails(row)><td>{{row.CertificationIsoStandard}}</td><td>{{row.CertificationBody}}</td><td>{{row.CertificationUnderAccred}}</td><!--<td>{{row.CertificationIssueDate | date:\'dd/MM/yyyy\'}}</td>--><td>{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.CertificationValidity}}</td><td>{{row.CertIssueType}}</td><td>{{row.CertificationStatus}}</td></tr></tbody></table><br></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=certificatepagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.certificationDetailsForSingleKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Certification Details</h4><a ng-href=# ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid, vm.data.Id)\" style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a><br></div><div class=box-list ng-if=\"vm.data.certificationDetailsForSingleKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Certificate !</strong></div></div></div></div><div class=text-right ng-show=\"vm.data.proposalDetailsForSingleKycData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><span>Closures {{vm.data.startofClosure}} to {{vm.data.endofClosure}} of {{vm.data.totalItemsofClosure}}</span><!--<a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a>--><br><br></div><div class=table-responsive ng-show=\"vm.data.proposalDetailsForSingleKycData.length > 0\"><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Validity</th><th class=text-left>Imp Type</th><th class=text-left>Issue Type</th><th class=text-left>Agent</th><!--<th class=\"text-left\">Gross Margin</th>--><th class=text-left>Closure Amount</th><!--<th class=\"text-left\">Surveillance Amount</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.proposalDetailsForSingleKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofClosure current-page=vm.data.paginationofClosure.current pagination-id=proposalpagination><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.viewPropDetails(row.Id)><!--ng-click=\"vm.data.editProposal(row.Id)\"--><td>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td>{{row.Validity}}</td><td>{{row.Type}}</td><td>{{row.certificationType}}</td><td>{{row.SalesAgent}}</td><!--<td>{{row.GrossMargin}}/-</td>--><td>{{row.TotalClosure}}/-</td><!--<td>{{row.SurveillanceCharges}}/-</td>--></tr></tbody></table><br></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofClosure(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=proposalpagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.proposalDetailsForSingleKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><!--<a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a>--><br></div><div class=box-list ng-if=\"vm.data.proposalDetailsForSingleKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Closures !</strong></div></div></div></div><div class=text-right ng-if=\"vm.data.commentDetailsForKycData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Comments</h4><span>Comments {{vm.data.startofComment}} to {{vm.data.endofComment}} of {{vm.data.totalItemsofComment}}</span> <a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=\"vm.func.giveComment(vm.data.Kycid, vm.data.certId)\">Add Comments</a><br><br></div><div class=table-responsive ng-if=\"vm.data.commentDetailsForKycData.length > 0\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Comment By</th><th class=text-left>Date</th><th class=text-left>Comment</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.commentDetailsForKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofComment current-page=vm.data.paginationofComment.current pagination-id=commentpagination><tr style=\"cursor:pointer; color:#4A235A\"><td>{{row.ActivityUser}}</td><td>{{row.ActivityDate | date:\'MM/dd/yyyy\'}}</td><td>{{row.Comment}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofComment(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=commentpagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.commentDetailsForKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Comments</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=\"vm.func.giveComment(vm.data.Kycid, vm.data.certId)\">Add Comments</a><br></div><div class=box-list ng-if=\"vm.data.commentDetailsForKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Comments !</strong></div></div></div></div><!--<div class=\"col-sm-12 col-xs-12 text-center\" style=\"padding-left:0px\" >\r\n                            <div class=\"row\">\r\n                                <div>\r\n                                    <div class=\"col-sm-3\" ng-hide=\"vm.data.hidesoftcopyButton\">\r\n                                        <button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.SoftCopySent(vm.data.Kycid,vm.data.Id)\">Send Soft Copy</button>\r\n                                    </div>\r\n                                    <div class=\"col-sm-3\" ng-hide=\"vm.data.alreadysoftcopyButton\">\r\n                                        <button class=\"btn btn-block btn-theme btn-primary\" disabled>Soft Copy Sent</button>\r\n                                    </div>\r\n                                    <div class=\"col-sm-3\" ng-hide=\"vm.data.hidehardcopyButton\">\r\n                                        <button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.HardCopySent(vm.data.Kycid,vm.data.Id)\">Send Hard Copy</button>\r\n                                    </div>\r\n                                    <div class=\"col-sm-3\" ng-hide=\"vm.data.alreadyhardcopyButton\">\r\n                                        <button class=\"btn btn-block btn-theme btn-primary\" disabled>Hard Copy Sent</button>\r\n                                    </div>--><!--<div class=\"col-sm-3\"  ng-hide=\"vm.data.hideSurvButton\">\r\n                                        <button class=\"btn btn-block btn-theme btn-danger\" ng-click=\"vm.func.SurveillanceFail(vm.data.Kycid,vm.data.Id)\">Surveillance Fail</button>\r\n                                    </div>\r\n                                    <div class=\"col-sm-3\"  ng-hide=\"vm.data.hideSurvButton\">\r\n                                        <button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.SurveillancePass(vm.data.Kycid,vm.data.Id)\">Surveillance Pass</button>\r\n                                    </div>--><!--<div class=\"col-sm-3\"  ng-hide=\"vm.data.hideDispatchButton\">\r\n                                        <button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.CloseandFinish(vm.data.Kycid,vm.data.Id)\">Dispatch & Finish</button>\r\n                                     </div>\r\n                                    <div class=\"col-sm-3\">\r\n                                        <button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.DispatchDetails(vm.data.Kycid,vm.data.Id)\">Dispatch Details</button>\r\n                                    </div>\r\n\r\n                                   \r\n                                </div>\r\n                            </div>--><!-- <button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.CloseandFinish(vm.data.Kycid,vm.data.Id)\">Cert Dispatch & Finish</button>--><!--<a ng-href=\"searchclosurekyc\"><img src=\"../../assets/images/goBack.png\" alt=\"\" style=\"height: 40px; width:130px;\" /></a>--><!--</div>--><!--<div class=\"col-sm-2 col-xs-12\">\r\n                          \r\n                        </div>--></div></div></div></div></div></div><acme-footer></acme-footer><div class=enable-modal ng-hide=vm.data.modalEnable><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n                <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n            </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Are you sure to reject?<br><br>Did you verify details of KYC ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n                <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                    <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                    <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n                </div>\r\n            </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div></div>");
$templateCache.put("app/certificatesPending/agentrequest.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-4><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:3px></a><h2 style=\"color:cornsilk; text-align:center\">Agent Request</h2></div></div><div class=col-md-8><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company (No Criteria)</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\" required></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchProposalData()\">Search By</button>--></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><!--<label class=\"color-white\">Cert Dispatch</label>\r\n                            <input class=\"form-control\" type=\"text\" id=\"Dispatch\" name=\"Dispatch\" autocomplete=\"off\" placeholder=\"Search By Cert Dispatch\" ng-model=\"vm.data.Dispatch\" uib-typeahead=\"Dispatch as Dispatch for Dispatch in vm.data.CertDispatch | filter:$viewValue | limitTo:10\" />--><label class=color-white>Agent Request</label><input class=form-control type=text id=ReqStatus name=ReqStatus autocomplete=off placeholder=\"Request Sts\" ng-model=vm.data.ReqStatus uib-typeahead=\"ReqStatus as ReqStatus for ReqStatus in vm.data.AgentRequest | filter:$viewValue | limitTo:10\"><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>(Request Date) From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive ng-hide=vm.data.hideProposalSearch><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n      <thead style=\"background-color:#76D7C4;\">\r\n          <tr style=\"color:#4A235A;\">\r\n              <th class=\"text-left\">Closure Date</th>\r\n              <th class=\"text-left\">Company Name</th>\r\n              <th class=\"text-center\">Sales Agent</th>\r\n              <th class=\"text-left\">Location</th>\r\n\r\n              <th class=\"text-center\">Validity</th>\r\n              <th class=\"text-center\">Source</th>\r\n              <th class=\"text-center\">Deal Type</th>\r\n              <th class=\"text-left\">Closure Amount</th>\r\n\r\n              <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n          <th class=\"text-left\">Pending Payment</th>\r\n          <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n      </tr>\r\n  </thead>\r\n  <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n      <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n          <td class=\"text-left\">{{row.AgentReqDate|date:\'dd/MM/yyyy\'}}</td>\r\n          <td class=\"text-left\">{{row.Client}}</td>\r\n          <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n          <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n          <td class=\"text-center\">{{row.Validity}}</td>\r\n          <td class=\"text-center\">{{row.Source}}</td>\r\n          <td class=\"text-center\">{{row.Type}}</td>\r\n          <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n              <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n              <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n          </tr>\r\n      </tbody>\r\n  </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Request Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><th class=text-center>Source</th><th class=text-center>Validity</th><th class=text-center>Type</th><th class=text-center>Agent</th><th class=text-center>Payment Status</th><th class=text-center>Cert Dispatch</th><th class=text-center>Agent Request</th><th class=text-center>KYC Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.AgentReqDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.Client}}</td><td class=text-left>{{row.Location}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><td class=text-center>{{row.Source}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.Type}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.agent_request}}</td><td class=text-center>{{row.QaStatus}}</td></tr></tbody></table></div><!--<div ng-hide=\"vm.data.hideKycSearch\">\r\n            <p class=\"text-right\">\r\n                KYC Info {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}\r\n            </p>\r\n            <table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4; padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px;\">\r\n                    <tr style=\"color:#4A235A;padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px\" \">\r\n                        <th class=\"text-left\">Client Name</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-left\">Account Manager</th>\r\n                        <th class=\"text-left\">City</th>\r\n                        <th class=\"text-center\">Status</th>\r\n                        <th class=\"text-center\">Last Update</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                    <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.func.getSingleKycDetailsByKyc(row.Kycid)\">--> <!--<td class=\"text-left\">{{row.ClientName}}</td>--><!---ng-if=\"vm.data.NumCert.length<=0\" style=\"color:darkolivegreen\"--><!--<td class=\"text-left\">{{row.Companyname}}</td>\r\n                        <td class=\"text-left\">{{row.AcountManager}}</td>\r\n                        <td class=\"text-left\">{{row.CompanyCity}}</td>\r\n                        <td class=\"text-center\">{{row.Status}}</td>\r\n                        <td class=\"text-center\">{{row.UpdatedDate | date:\'dd/MM/yyyy\'}}</td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n\r\n        </div>--><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certificatesPending/certificatespending.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-4><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:3px></a><h2 style=\"color:cornsilk; text-align:center\">Certs Pending</h2></div></div><div class=col-md-8><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\" required></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchProposalData()\">Search By</button>--></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Dispatch</label><input class=form-control type=text id=Dispatch name=Dispatch autocomplete=off placeholder=\"Search By Cert Dispatch\" ng-model=vm.data.Dispatch uib-typeahead=\"Dispatch as Dispatch for Dispatch in vm.data.CertDispatch | filter:$viewValue | limitTo:10\"><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>(Closure Date) From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive ng-hide=vm.data.hideProposalSearch><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                        <th class=\"text-left\">Pending Payment</th>\r\n                        <th class=\"text-left\">Remarks</th>\r\n\r\n                       \r\n                    </tr>\r\n                </thead>\r\n                <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                    <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                        <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                        <td class=\"text-left\">{{row.Client}}</td>\r\n                        <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                        <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                        <td class=\"text-center\">{{row.Validity}}</td>\r\n                        <td class=\"text-center\">{{row.Source}}</td>\r\n                        <td class=\"text-center\">{{row.Type}}</td>\r\n                        <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n                      \r\n                    </tr>\r\n                </tbody>\r\n            </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><th class=text-center>Source</th><th class=text-center>Validity</th><th class=text-center>Type</th><th class=text-center>Agent</th><th class=text-center>Payment Status</th><th class=text-center>Cert Dispatch</th><th class=text-center>Agent Request</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.Client}}</td><td class=text-left>{{row.Location}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><td class=text-center>{{row.Source}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.Type}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.agent_request}}</td></tr></tbody></table></div><!--<div ng-hide=\"vm.data.hideKycSearch\">\r\n            <p class=\"text-right\">\r\n                KYC Info {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}\r\n            </p>\r\n            <table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4; padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px;\">\r\n                    <tr style=\"color:#4A235A;padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px\" \">\r\n                        <th class=\"text-left\">Client Name</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-left\">Account Manager</th>\r\n                        <th class=\"text-left\">City</th>\r\n                        <th class=\"text-center\">Status</th>\r\n                        <th class=\"text-center\">Last Update</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                    <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.func.getSingleKycDetailsByKyc(row.Kycid)\">--> <!--<td class=\"text-left\">{{row.ClientName}}</td>--><!---ng-if=\"vm.data.NumCert.length<=0\" style=\"color:darkolivegreen\"--><!--<td class=\"text-left\">{{row.Companyname}}</td>\r\n                        <td class=\"text-left\">{{row.AcountManager}}</td>\r\n                        <td class=\"text-left\">{{row.CompanyCity}}</td>\r\n                        <td class=\"text-center\">{{row.Status}}</td>\r\n                        <td class=\"text-center\">{{row.UpdatedDate | date:\'dd/MM/yyyy\'}}</td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n\r\n        </div>--><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/certificatesPending/certpending.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-4><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:3px></a><h2 style=\"color:cornsilk; text-align:center\">Certs Pending</h2></div></div><div class=col-md-8><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\" autocomplete=off required></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchProposalData()\">Search By</button>--></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                <div class=\"form-group\">\r\n                    <label class=\"hidden-xs\">&nbsp;</label>\r\n                    <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                </div>\r\n            </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Cert Dispatch</label><input class=form-control type=text id=Dispatch name=Dispatch autocomplete=off placeholder=\"Search By Cert Dispatch\" ng-model=vm.data.Dispatch uib-typeahead=\"Dispatch as Dispatch for Dispatch in vm.data.CertDispatch | filter:$viewValue | limitTo:10\"><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>(Full Payment) From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive ng-hide=vm.data.hideProposalSearch><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n          <thead style=\"background-color:#76D7C4;\">\r\n              <tr style=\"color:#4A235A;\">\r\n                  <th class=\"text-left\">Closure Date</th>\r\n                  <th class=\"text-left\">Company Name</th>\r\n                  <th class=\"text-center\">Sales Agent</th>\r\n                  <th class=\"text-left\">Location</th>\r\n\r\n                  <th class=\"text-center\">Validity</th>\r\n                  <th class=\"text-center\">Source</th>\r\n                  <th class=\"text-center\">Deal Type</th>\r\n                  <th class=\"text-left\">Closure Amount</th>\r\n\r\n                  <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n              <th class=\"text-left\">Pending Payment</th>\r\n              <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n          </tr>\r\n      </thead>\r\n      <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n          <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n              <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n              <td class=\"text-left\">{{row.Client}}</td>\r\n              <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n              <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n              td class=\"text-center\">{{row.Validity}}</td>\r\n              <td class=\"text-center\">{{row.Source}}</td>\r\n              <td class=\"text-center\">{{row.Type}}</td>\r\n              <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                  <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                  <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n              </tr>\r\n          </tbody>\r\n      </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Full Payment Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><th class=text-center>Source</th><!--<th class=\"text-center\">Validity</th>--><!--<th class=\"text-center\">Type</th>--><th class=text-center>Agent</th><th class=text-center>Payment Status</th><th class=text-center>Cert Dispatch</th><th class=text-center>Agent Request</th><!--<th class=\"text-center\">Payment Status</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.PaymentExpectedDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.Client}}</td><td class=text-left>{{row.Location}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><td class=text-center>{{row.Source}}</td><!--<td class=\"text-center\">{{row.Validity}}</td>\r\n            <td class=\"text-center\">{{row.Type}}</td>--><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.agent_request}}</td></tr></tbody></table></div><!--<div ng-hide=\"vm.data.hideKycSearch\">\r\n        <p class=\"text-right\">\r\n            KYC Info {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}\r\n        </p>\r\n        <table class=\"table table-hover\">\r\n            <thead style=\"background-color:#76D7C4; padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px;\">\r\n                <tr style=\"color:#4A235A;padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px\" \">\r\n                    <th class=\"text-left\">Client Name</th>\r\n                    <th class=\"text-left\">Company Name</th>\r\n                    <th class=\"text-left\">Account Manager</th>\r\n                    <th class=\"text-left\">City</th>\r\n                    <th class=\"text-center\">Status</th>\r\n                    <th class=\"text-center\">Last Update</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.func.getSingleKycDetailsByKyc(row.Kycid)\">--> <!--<td class=\"text-left\">{{row.ClientName}}</td>--><!---ng-if=\"vm.data.NumCert.length<=0\" style=\"color:darkolivegreen\"--><!--<td class=\"text-left\">{{row.Companyname}}</td>\r\n                    <td class=\"text-left\">{{row.AcountManager}}</td>\r\n                    <td class=\"text-left\">{{row.CompanyCity}}</td>\r\n                    <td class=\"text-center\">{{row.Status}}</td>\r\n                    <td class=\"text-center\">{{row.UpdatedDate | date:\'dd/MM/yyyy\'}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n    </div>--><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/closuremanagement/addclosurekyc.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-4><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a></div></div><div class=col-md-8><!-- form search  --><form name=searchEnquiryDataFrom class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company Name</label><input type=text class=form-control ng-model=vm.data.searchKeyDetails uib-typeahead=\"getdataEnq as getdataEnq for getdataEnq in vm.data.getCompany  | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.search()>Load</button></div></div></div></form><!-- end form search  --></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=\"body-content clearfix\"><div class=\"bg-color1 block-section line-bottom\"><div class=text-center><a ng-href=# ng-click=vm.func.goToBack()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a></div><div class=container><div class=row><div class=\"col-md-8 col-md-offset-2 text-right\"><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> -<label style=color:red>Mandatory Fields</label></div><div class=\"col-md-8 col-md-offset-2\"><!-- form post a job --><form name=addkycform novalidate><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addkycform.CompanyName.$error.required) }\"><label>Company Name</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Company Name\" id=CompanyName name=CompanyName ng-model=vm.data.CompanyName required></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.AgentName.$error.required)}\"><label>Agent Name</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Agent Name\" id=AgentName name=AgentName ng-model=vm.data.AgentName uib-typeahead=\"agent as agent for agent in vm.data.suggestAgentNameData | filter: $viewValue | limitTo: 10\" required></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':vm.data.requiredAssociate}\"><label>Associate</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select type=text class=form-control placeholder=\"Enter Associate\" id=Associate name=Associate ng-change=vm.func.hideRequiredAssociate() ng-model=vm.data.selectedAssociate ng-options=\"item.value for item in vm.data.Associate\" required></select></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.ContactPerson.$error.required)}\"><label>Contact Person</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Full Name\" id=ContactPerson name=ContactPerson ng-model=vm.data.ContactPerson required></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.Designation.$error.required)}\"><label>Designation</label>&nbsp; <img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Designation\" id=Designation name=Designation ng-model=vm.data.Designation required></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.ContactNumber.$error.required)}\"><label>Contact Number</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><div class=form-group><input type=text class=form-control placeholder=\"Enter Phone Number\" id=ContactNumber name=ContactNumber ng-model=vm.data.ContactNumber required></div></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.ContactEmail.$error.required)}\"><label>Email</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><!--<input type=\"email\" class=\"form-control \" placeholder=\"Enter Your Email\" id=\"ContactEmail\" name=\"ContactEmail\" ng-model=\"vm.data.ContactEmail\" ng-pattern=\"vm.data.emailPattern\" required>--> <input type=email class=form-control name=ContactEmail placeholder=\"Enter Email ID\" ng-model=vm.data.ContactEmail ng-maxlength=100 ng-model-options=\"{ updateOn: blur }\" ng-pattern=/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,5}$/ required><div class=error-container ng-show=\"addkycform.ContactEmail.$dirty && addkycform.ContactEmail.$error\"><small class=error ng-show=addkycform.ContactEmail.$error.required>Email ID is required. </small><small class=error ng-show=addkycform.ContactEmail.$error.pattern>Please input a valid email. </small><small class=error ng-show=addkycform.ContactEmail.$error.maxlength>Your email cannot be longer than 100 characters</small></div></div></div></div><p class=text-right><a href=# style=color:green ng-if=\"vm.data.ifWantAddAlternateContact == true\" ng-click=vm.func.activeAddAlternateContact()><u>Add Alternate Contact Details</u></a></p><p class=text-right><a href=# style=\"color:green; color:red\" ng-if=\"vm.data.ifDontWantAddAlternateContact == true\" ng-click=vm.func.deactiveAddAlternateContact()><u>Remove Alternate Contact Details</u></a></p><div ng-if=\"vm.data.addAlternateContact == true\"><div class=row><div class=col-sm-6><div class=form-group><label>Alternate Contact Person</label><input type=text class=form-control placeholder=\"Enter Full Name\" id=AlternateContactPerson name=AlternateContactPerson ng-model=vm.data.AlternateContactPerson></div></div><div class=col-sm-6><div class=form-group><label>Alternate Designation</label><input type=text class=form-control placeholder=\"Enter Alternate Designation\" id=AlternateDesignation name=AlternateDesignation ng-model=vm.data.AlternateDesignation></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label>Alternate Number</label><div class=form-group><input type=text class=form-control placeholder=\"Enter Alternate Number\" id=AlternateNumber name=AlternateNumber ng-model=vm.data.AlternateNumber required></div></div></div><div class=col-sm-6><div class=form-group><label>Alternate Email</label><input type=text class=form-control placeholder=\"Enter Alternate Email\" id=AlternateEmail name=AlternateEmail ng-model=vm.data.AlternateEmail></div></div></div></div><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.Natureofbusiness.$error.required)}\"><label>Nature of business</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Nature of business\" id=Natureofbusiness name=Natureofbusiness ng-model=vm.data.Natureofbusiness required></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.CompanyCountry.$error.required)}\"><label>Country</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Country Name\" id=CompanyCountry name=CompanyCountry ng-model=vm.data.CompanyCountry autocomplete=off uib-typeahead=\"country as country for country in vm.data.suggestCountryData | filter: $viewValue | limitTo: 10\" required></div></div><div class=col-md-3><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.CompanyState.$error.required)}\"--><div class=form-group><label>State</label><input type=text class=form-control placeholder=\"Enter State Name\" id=CompanyState name=CompanyState ng-model=vm.data.CompanyState></div></div><div class=col-md-3 ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.CompanyCity.$error.required)}\"><div class=form-group><label>City</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=CompanyCity name=CompanyCity ng-model=vm.data.CompanyCity required></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredCompanyType}\"><label>Company Type</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CompanyType name=CompanyType ng-change=vm.func.hideRequiredCompanyType() ng-model=vm.data.selectedCompanyType ng-options=\"item.value for item in vm.data.CompanyType\"></select></div></div></div><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.EmployeeStrength.$error.required)}\"><label>Employee Strength</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=number min=0 class=form-control placeholder=Count id=EmployeeStrength name=EmployeeStrength ng-model=vm.data.EmployeeStrength required></div></div><div class=col-md-3><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.Yearsinbusiness.$error.required)}\">--><label>Years in business</label><input type=number min=0 class=form-control placeholder=\"Enter Years in business\" id=Yearsinbusiness name=Yearsinbusiness ng-model=vm.data.Yearsinbusiness></div></div><div class=col-md-3><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.Turnover.$error.required)}\">--><label>Turnover</label><input type=text class=form-control placeholder=\"Enter Turnover\" id=Turnover name=Turnover ng-model=vm.data.Turnover><!--required--></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label>URL/Website</label><input type=text class=form-control placeholder=\"Enter Company URL\" id=URL name=URL ng-model=vm.data.URL></div></div><div class=col-sm-6><div class=form-group><label>Landline</label><div class=form-group><input type=text class=form-control placeholder=\"Enter Landline Number\" id=Landline name=Landline ng-model=vm.data.LandlineNumber></div></div></div></div><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.PostalAddress.$error.required)}\"><label>Postal Address (as per certificate)</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Postal Address\" id=PostalAddress name=PostalAddress ng-model=vm.data.PostalAddress required></textarea></div></div><div class=col-md-6><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addkycform.Locations.$error.required)}\">--><label>Locations</label><!--&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Locations\" id=Locations name=Locations ng-model=vm.data.Locations></textarea></div></div></div><!--<div class=\"form-group\">\r\n                            <label for=\"exampleInputFile\">Attach Company Registration Docs</label>\r\n                            <div class=\"form-group\">\r\n                                <div class=\"input-group\">\r\n                                    <span class=\"input-group-btn\">\r\n                                        <span class=\"btn btn-default btn-theme btn-file no-right-border\">\r\n                                            Your File  <input type=\"file\" id=\"exampleInputFile\">\r\n                                        </span>\r\n                                    </span>\r\n                                    <input type=\"text\" class=\"form-control no-left-border\" readonly>\r\n                                </div>\r\n                                <small>Upload Company Registration Docs . Max. file size: 10 MB.</small>\r\n                            </div> \r\n                        </div>\r\n                        <div class=\"form-group\">\r\n                            <label for=\"exampleInputFile\">Org Chart Doc</label>\r\n                            <div class=\"form-group\">\r\n                                <div class=\"input-group\">\r\n                                    <span class=\"input-group-btn\">\r\n                                        <span class=\"btn btn-default btn-theme btn-file no-right-border\">\r\n                                            Your File  <input type=\"file\" id=\"exampleInputFile\">\r\n                                        </span>\r\n                                    </span>\r\n                                    <input type=\"text\" class=\"form-control no-left-border\" readonly>\r\n                                </div>\r\n                                <small>Upload Company Org Chart Docs . Max. file size: 10 MB.</small>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group\">\r\n                            <label for=\"exampleInputFile\">Attach Photo of premise with board</label>\r\n                            <div class=\"form-group\">\r\n                                <div class=\"input-group\">\r\n                                    <span class=\"input-group-btn\">\r\n                                        <span class=\"btn btn-default btn-theme btn-file no-right-border\">\r\n                                            Your File  <input type=\"file\" id=\"exampleInputFile\">\r\n                                        </span>\r\n                                    </span>\r\n                                    <input type=\"text\" class=\"form-control no-left-border\" readonly>\r\n                                </div>\r\n                                <small>Upload Company Registration Docs . Max. file size: 10 MB.</small>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group\">\r\n                            <label for=\"exampleInputFile\">Other Docs</label>\r\n                            <div class=\"form-group\">\r\n                                <div class=\"input-group\">\r\n                                    <span class=\"input-group-btn\">\r\n                                        <span class=\"btn btn-default btn-theme btn-file no-right-border\">\r\n                                            Your File  <input type=\"file\" id=\"exampleInputFile\">\r\n                                        </span>\r\n                                    </span>\r\n                                    <input type=\"text\" class=\"form-control no-left-border\" readonly>\r\n                                </div>\r\n                                <small>Upload Other Docs . Max. file size: 10 MB.</small>\r\n                            </div>\r\n                        </div>--><div class=form-group><button class=\"btn btn-t-primary btn-primary\" ng-click=vm.func.goToBack()>Back</button> <button class=\"btn btn-t-primary btn-success\" ng-click=vm.func.saveNewKyc(addkycform.$valid)>Save</button></div></form><!-- end form post a job --></div></div></div></div></div><!--end body-content --><acme-footer></acme-footer>");
$templateCache.put("app/closuremanagement/editclosurekyc.html","<acme-navbar></acme-navbar><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><!-- form search --><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Update Client KYC</h3><br></div></div></form><!-- end form search --></div></div></div><div class=\"body-content clearfix\"><div class=\"bg-color1 block-section line-bottom\"><div class=container><div class=row><div class=text-right><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> -<label style=color:red>Mandatory Fields</label></div><div class=\"col-md-8 col-md-offset-2\"><form name=editkycform novalidate><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && editkycform.CompanyName.$error.required) }\"><label>Company Name</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Company Name\" id=CompanyName name=CompanyName ng-model=vm.data.CompanyName required></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': vm.data.requiredAssociate}\"><label>Associate</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select type=text class=form-control placeholder=\"Enter Associate\" id=Associate name=Associate ng-change=vm.func.hideRequiredAssociate() ng-model=vm.data.selectedAssociate ng-options=\"item.value for item in vm.data.Associate\" required></select></div></div></div><!--<div class=\"row\">\r\n                            <div class=\"col-sm-6\">\r\n                                <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.AgentName.$error.required)}\">\r\n                                    <label>Assign To</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <input type=\"text\" class=\"form-control \" placeholder=\"Enter Agent Name\" id=\"AgentName\" name=\"AgentName\" ng-model=\"vm.data.AgentName\" uib-typeahead=\"agent as agent for agent in vm.data.suggestAgentNameData | filter: $viewValue | limitTo: 10\" required />\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"col-sm-6\">\r\n                                <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.firstsaleby.$error.required)}\">\r\n                                    <label>First Sale By</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <input type=\"text\" class=\"form-control \" placeholder=\"Enter First Sale By\" id=\"firstsaleby\" name=\"firstsaleby\"  ng-model=\"vm.data.firstsaleby\"  uib-typeahead=\"agent as agent for agent in vm.data.suggestAgentNameData | filter: $viewValue | limitTo: 10\" required/>\r\n                                </div>\r\n                            </div>\r\n                        </div>--><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.ContactPerson.$error.required)}\"><label>Contact Person</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Full Name\" id=ContactPerson name=ContactPerson ng-model=vm.data.ContactPerson required></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.Designation.$error.required)}\"><label>Designation</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Designation\" id=Designation name=Designation ng-model=vm.data.Designation required></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.ContactNumber.$error.required)}\"><label>Contact Number</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Phone Number\" id=ContactNumber name=ContactNumber ng-model=vm.data.ContactNumber required></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.ContactEmail.$error.required)}\"><label>Email</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><!--<input type=\"email\" class=\"form-control \" placeholder=\"Enter Your Email\" id=\"ContactEmail\" name=\"ContactEmail\" ng-model=\"vm.data.ContactEmail\" required>--> <input type=email class=form-control name=ContactEmail placeholder=\"Enter Email ID\" ng-model=vm.data.ContactEmail ng-maxlength=100 ng-model-options=\"{ updateOn: blur }\" ng-pattern=/^[a-z0-9._-]+@[a-z0-9-]+\\.[a-z0-9.-]{1,50}$/ required><div class=error-container ng-show=\"editkycform.ContactEmail.$dirty && editkycform.ContactEmail.$error\"><small class=error ng-show=editkycform.ContactEmail.$error.required>Update Email ID. </small><small class=error ng-show=editkycform.ContactEmail.$error.pattern>Please input a valid email. </small><small class=error ng-show=editkycform.ContactEmail.$error.maxlength>Your email cannot be longer than 100 characters</small></div></div></div></div><p class=text-right><a href=# style=color:green ng-if=\"vm.data.ifWantAddAlternateContact == true\" ng-click=vm.func.activeAddAlternateContact()><u>Show Alternate Contact Details</u></a></p><p class=text-right><a href=# style=\"color:green; color:red\" ng-if=\"vm.data.ifDontWantAddAlternateContact == true\" ng-click=vm.func.deactiveAddAlternateContact()><u>Hide Alternate Contact Details</u></a></p><div ng-if=\"vm.data.addAlternateContact == true\"><div class=row><div class=col-sm-6><div class=form-group><label>Alternate Contact Person</label><input type=text class=form-control placeholder=\"Enter Full Name\" id=AlternateContactPerson name=AlternateContactPerson ng-model=vm.data.AlternateContactPerson></div></div><div class=col-sm-6><div class=form-group><label>Alternate Designation</label><input type=text class=form-control placeholder=\"Enter Alternate Designation\" id=AlternateDesignation name=AlternateDesignation ng-model=vm.data.AlternateDesignation></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label>Alternate Number</label><input type=text class=form-control placeholder=\"Alternate Phone Number\" id=AlternateNumber name=AlternateNumber ng-model=vm.data.AlternateNumber></div></div><div class=col-sm-6><div class=form-group><label>Alternate Email</label><input type=text class=form-control placeholder=\"Enter Alternate Email\" id=AlternateEmail name=AlternateEmail ng-model=vm.data.AlternateEmail></div></div></div></div><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.Natureofbusiness.$error.required)}\"><label>Nature of business</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Nature of business\" id=Natureofbusiness name=Natureofbusiness ng-model=vm.data.Natureofbusiness required></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.CompanyCountry.$error.required)}\"><label>Company Location</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Country Name\" id=CompanyCountry name=CompanyCountry ng-model=vm.data.CompanyCountry required></div></div><div class=col-md-3 ng-class=\"{\'has-error\':  vm.data.requiredStateName}\"><!--(vm.data.isFormSubmit && addkycform.CompanyState.$error.required)--><div class=form-group><label>State</label><input type=text class=form-control placeholder=\"Enter State Name\" id=CompanyState name=CompanyState ng-change=vm.func.hideRequiredState() ng-model=vm.data.CompanyState></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.CompanyCity.$error.required)}\"><label>City</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=CompanyCity name=CompanyCity ng-model=vm.data.CompanyCity required></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredZoneType}\"><label>Zone</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=ZoneType name=ZoneType ng-change=vm.func.hideRequiredZoneType() ng-model=vm.data.selectedZoneType ng-options=\"item.value for item in vm.data.ZoneType\"></select></div></div></div><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.EmployeeStrength.$error.required)}\"><label>Employee Strength</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=Count id=EmployeeStrength name=EmployeeStrength ng-model=vm.data.EmployeeStrength required></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredCompanyType}\"><label>Company Type</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CompanyType name=CompanyType ng-change=vm.func.hideRequiredCompanyType() ng-model=vm.data.selectedCompanyType ng-options=\"item.value for item in vm.data.ComType\"></select></div></div><!--  <div class=\"col-md-3\">\r\n                                <div class=\"form-group\">\r\n                                    <label>Years in business</label><!--&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--><!--<input type=\"number\" min=\"0\" class=\"form-control \" placeholder=\"Enter Years in business\" id=\"Yearsinbusiness\" name=\"Yearsinbusiness\" ng-model=\"vm.data.Yearsinbusiness\" >\r\n                                </div>--><!--</div>--><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.Turnover.$error.required)}\"><label>Turnover</label><input type=text class=form-control placeholder=\"Enter Turnover\" id=Turnover name=Turnover ng-model=vm.data.Turnover></div></div></div><p class=text-right><a href=# style=color:green ng-if=\"vm.data.ifWantAddMoreCompany == true\" ng-click=vm.func.activeAddMoreCompany()><u>Show More Company Details</u></a></p><p class=text-right><a href=# style=color:red ng-if=\"vm.data.ifDontWantAddMoreCompany == true;\" ng-click=vm.func.deactiveAddMoreCompany()><u>Hide More Company Details</u></a></p><div ng-if=\"vm.data.addMoreCompany == true\" class=row><div class=col-sm-6><div class=form-group><label>URL/Website</label><input type=text class=form-control placeholder=\"Enter Company URL\" id=URL name=URL ng-model=vm.data.URL></div></div><div class=col-sm-6><div class=form-group><label>Landline</label><input type=text class=form-control placeholder=\"Enter Landline Number\" id=LandlineNumber name=LandlineNumber ng-model=vm.data.LandlineNumber>&nbsp;</div></div></div><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.PostalAddress.$error.required)}\"><label>Postal Address (as per certificate)</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Postal Address\" id=PostalAddress name=PostalAddress ng-model=vm.data.PostalAddress required></textarea></div></div><div class=col-md-6><!--<div class=\"form-group\"> ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.Locations.$error.required)}\">\r\n                                    <label>Locations</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--><div class=form-group><label>Location</label><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Locations\" id=Locations name=Locations ng-model=vm.data.Locations></textarea></div></div></div><div class=form-group><!--<button class=\"btn btn-t-primary btn-primary\" ng-click=\"vm.func.goToBack()\">Back</button>--> <button class=\"btn btn-t-primary btn-success\" ng-click=vm.func.updateSingleKycDetails(editkycform.$valid)>Save</button></div></form></div></div></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/closuremanagement/searchclosurekyc.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Client KYC</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchClosureKYCData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-href=\"addkyc\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">zone</label>\r\n                              \r\n                                <input class=\"form-control\" type=\"text\" id=\"zone\" name=\"zone\" autocomplete=\"off\" placeholder=\"search by zone\" ng-model=\"vm.data.zonedata\" uib-typeahead=\"zone as zone for zone in vm.data.getzonedata | filter:$viewvalue | limitto:10\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">agent</label>\r\n                             \r\n                                <input class=\"form-control\" type=\"text\" id=\"agent\" name=\"agent\" autocomplete=\"off\" placeholder=\"search by agent name\" ng-model=\"vm.data.agentname\" uib-typeahead=\"agentname as agentname for agentname in vm.data.getagentname | filter:$viewvalue | limitto:10\" />\r\n                            </div>\r\n                        </div>--><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Zone</label><input class=form-control type=text id=Zone name=Zone autocomplete=off placeholder=\"Search By Zone\" ng-model=vm.data.Zonedata uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=\"form-control input-sm\" type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=\"form-control input-sm\" type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.afterSearch == true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive style=padding:4px><p class=text-right>Clients {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=\"background-color:#76D7C4; padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px\"><tr style=color:#4A235A;padding-bottom:4px;padding-left:4px;padding-right:4px;padding-top:4px><th class=text-left>Client Name</th><th class=text-left>Company Name</th><th class=text-left>Account Manager</th><th class=text-left>City</th><th class=text-center>Status</th><th class=text-center>Last Update</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allClosureManagementData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycid)><td class=text-left>{{row.ClientName}}</td><!---ng-if=\"vm.data.NumCert.length<=0\" style=\"color:darkolivegreen\"--><td class=text-left>{{row.Companyname}}</td><td class=text-left>{{row.AcountManager}}</td><td class=text-left>{{row.CompanyCity}}</td><td class=text-center>{{row.Status}}</td><td class=text-center>{{row.UpdatedDate | date:\'dd/MM/yyyy\'}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/closuremanagement/singlekycdetails.html","<acme-navbar></acme-navbar><div class=bg-color1><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Details Of Client KYC</h3><br></div></div></form></div></div></div><br><div class=container><a class=alignright ng-href=certificatesPending><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><h3 class=\"no-margin-top color-black alignleft\"><span class=text-info>Company Name</span> - {{vm.data.CompanyName}}</h3></div><div class=container><div class=row><div class=col-md-4><div class=box-list><div class=item><a ng-href=# ng-click=vm.data.editClosureKYCDetails(vm.data.Kycid) class=\"btn btn-theme btn-xs btn-primary alignright\"><span class=\"glyphicon glyphicon-pencil\"></span> Edit</a><h4 class=text-info><u>Company Details</u></h4><p style=color:#8A8989>Company Name - <span class=color-black>{{vm.data.CompanyName}}</span><br>Company Location - <span class=color-black>{{vm.data.CompanyCity}}</span>,<span class=color-black>{{vm.data.CompanyCountry}}</span><br>Nature Of Business - <span class=color-black>{{vm.data.NatureofBusiness}}</span><br>Company Type - <span class=color-black>{{vm.data.CompanyType}}</span><br>Employee Strength - <span class=color-black>{{vm.data.EmployeeStrength}}</span><br>Company URL - <span class=color-black>{{vm.data.URL}}</span><br>Company Landline - <span class=color-black>{{vm.data.Landline}}</span><br><br></p><h4 class=text-info><u>Primary Contact</u></h4><p style=\"color: #8A8989\">Contact Name - <span class=color-black>{{vm.data.ClientName}}</span><br>Client Number - <span class=color-black>{{vm.data.ContactNumber}}</span><br>Client Email - <span class=color-black>{{vm.data.ContactEmail}}</span><br>Client Designation - <span class=color-black>{{vm.data.Designation}}</span><br><br></p><label class=alignright style=color:green ng-if=\"vm.data.noShowDetails == true\" ng-click=vm.func.activenoShowDetails()><u>More Details</u></label><h4 ng-if=\"vm.data.hideDetails == true\" class=text-info><u>Alternate Contact</u></h4><p style=color:#8A8989 ng-if=\"vm.data.hideDetails == true\">Contact Name - <span class=color-black>{{vm.data.AltContactName}}</span><br>Contact Number - <span class=color-black>{{vm.data.AltContactNumber}}</span><br>Contact Email - <span class=color-black>{{vm.data.AltContactEmail}}</span><br>Designation - <span class=color-black>{{vm.data.AltDesignation}}</span><br></p></div></div></div><div class=col-md-8><div class=box-list><div class=item><div class=text-right ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"><!--ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"--><h4 class=\"modal-title text-info alignleft\">Certification</h4><span style=padding:10px>Certificates {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</span><!--<a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add Trainig Cert</a>--> <a ng-href=# ng-click=vm.data.goAddNewTrainingCert(vm.data.Kycid) style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\">Add Training Cert</a> <a ng-href=# ng-click=vm.data.goAddNewCertificationPage(vm.data.Kycid) style=\"cursor:pointer; margin-right:10px\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificates</a><br><br></div><div class=table-responsive ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-left>AB</th><!--<th class=\"text-left\">Issue Date</th>--><th class=text-left>Issue Date</th><th class=text-left>Expiry Date</th><th class=text-left>Billing Cycle</th><th class=text-left>Surv Renewal Date</th><th class=text-left>Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.certificationDetailsForSingleKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current pagination-id=certificatepagination><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.editCertificationDetails(row)><td>{{row.CertificationIsoStandard}}</td><td>{{row.CertificationBody}}</td><td>{{row.CertificationUnderAccred}}</td><!--<td>{{row.CertificationIssueDate | date:\'dd/MM/yyyy\'}}</td>--><td>{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.AuditRenewalDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.CertificationValidity}}</td><td>{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.CertificationStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=certificatepagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.certificationDetailsForSingleKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Certification Details</h4><a ng-href=# ng-click=vm.data.goAddNewTrainingCert(vm.data.Kycid) style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\">Add Training Cert</a> <a ng-href=# ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid, vm.data.Id)\" style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a><br></div><div class=box-list ng-if=\"vm.data.certificationDetailsForSingleKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Certificate !</strong></div></div></div></div><br><div class=text-right ng-show=\"vm.data.proposalDetailsForSingleKycData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><span>Closures {{vm.data.startofClosure}} to {{vm.data.endofClosure}} of {{vm.data.totalItemsofClosure}}</span><!--<a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a>--><br><br></div><div class=table-responsive ng-show=\"vm.data.proposalDetailsForSingleKycData.length > 0\"><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Billing Cycle</th><th class=text-left>Payment Status</th><th class=text-left>Issue Type</th><th class=text-left>Agent</th><!--<th class=\"text-left\">Gross Margin</th>--><th class=text-left>Closure Amount</th><!--<th class=\"text-left\">Surveillance Amount</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.proposalDetailsForSingleKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofClosure current-page=vm.data.paginationofClosure.current pagination-id=proposalpagination><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.viewPropDetails(row.Id)><!--ng-click=\"vm.data.editProposal(row.Id)\"--><td>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td>{{row.Validity}}</td><td>{{row.PaymentStatus}}</td><td>{{row.certificationType}}</td><td>{{row.SalesAgent}}</td><!--<td>{{row.GrossMargin}}/-</td>--><td>{{row.TotalClosure}}/-</td><!--<td>{{row.SurveillanceCharges}}/-</td>--></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofClosure(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=proposalpagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.proposalDetailsForSingleKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><!--<a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a>--><br></div><div class=box-list ng-if=\"vm.data.proposalDetailsForSingleKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Closures !</strong></div></div></div></div><br><div class=text-right ng-if=\"vm.data.commentDetailsForKycData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Comments</h4><span style=padding:10px>Comments {{vm.data.startofComment}} to {{vm.data.endofComment}} of {{vm.data.totalItemsofComment}}</span> <a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.func.giveComment(vm.data.Kycid)>Add Comments</a><br><br></div><div class=table-responsive ng-if=\"vm.data.commentDetailsForKycData.length > 0\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Comment By</th><th class=text-left>Date</th><th class=text-left>Comment</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.commentDetailsForKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofComment current-page=vm.data.paginationofComment.current pagination-id=commentpagination><tr style=\"cursor:pointer; color:#4A235A\"><td>{{row.ActivityUser}}</td><td>{{row.ActivityDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.Comment}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofComment(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=commentpagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.commentDetailsForKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Comments</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.func.giveComment(vm.data.Kycid)>Add Comments</a><br></div><div class=box-list ng-if=\"vm.data.commentDetailsForKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Comments !</strong></div></div></div></div><div class=\"col-sm-12 col-xs-12 text-center\" style=padding-left:0px><div class=row><div class=col-sm-3 ng-hide=vm.data.hideAcceptButton><button class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.AcceptRequest(vm.data.Kycid,vm.data.Id)>Accept Request</button></div><div class=col-sm-3 ng-hide=vm.data.alreadyAcceptButton><button class=\"btn btn-block btn-theme btn-success\" disabled>Accept Request</button></div><div class=col-sm-3 ng-hide=vm.data.hidesoftcopyButton><button class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.SoftCopySent(vm.data.Kycid,vm.data.Id)>Soft Copy</button></div><div class=col-sm-3 ng-hide=vm.data.alreadysoftcopyButton><button class=\"btn btn-block btn-theme btn-success\" disabled>Soft Copy</button></div><div class=col-sm-3 ng-hide=vm.data.hidehardcopyButton><button class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.HardCopySent(vm.data.Kycid,vm.data.Id)>Hard Copy</button></div><div class=col-sm-3 ng-hide=vm.data.alreadyhardcopyButton><button class=\"btn btn-block btn-theme btn-success\" disabled>Hard Copy</button></div><!--<div class=\"col-sm-3\"  ng-hide=\"vm.data.hideSurvButton\">\r\n      <button class=\"btn btn-block btn-theme btn-danger\" ng-click=\"vm.func.SurveillanceFail(vm.data.Kycid,vm.data.Id)\">Surveillance Fail</button>\r\n  </div>\r\n  <div class=\"col-sm-3\"  ng-hide=\"vm.data.hideSurvButton\">\r\n      <button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.SurveillancePass(vm.data.Kycid,vm.data.Id)\">Surveillance Pass</button>\r\n  </div>--><div class=col-sm-3 ng-hide=vm.data.hideDispatchButton><button class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.CloseandFinish(vm.data.Kycid,vm.data.Id)>Dispatch</button></div><div class=col-sm-3 ng-hide=vm.data.alreadyDispatch><button class=\"btn btn-block btn-theme btn-success\" disabled>Dispatch</button></div><br><br><div class=col-sm-3 ng-hide=vm.data.hideabort><button class=\"btn btn-block btn-theme btn-danger\" ng-click=vm.func.Abort(vm.data.Kycid,vm.data.Id)>Aborted</button></div><div class=col-sm-3 ng-hide=vm.data.alreadyhideabort><button class=\"btn btn-block btn-theme btn-danger\" disabled>Aborted</button></div><div class=col-sm-3 ng-hide=vm.data.hidenotAapplicable><button class=\"btn btn-block btn-theme btn-info\" ng-click=vm.func.NotApplicable(vm.data.Kycid,vm.data.Id)>N/A</button></div><div class=col-sm-3 ng-hide=vm.data.alreadynotAapplicable><button class=\"btn btn-block btn-theme btn-info\" disabled>N/A</button></div><div class=col-sm-3 ng-hide=vm.data.hideCourier><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.DispatchDetails(vm.data.Kycid,vm.data.Id)>Courier</button></div><div class=col-sm-3 ng-hide=vm.data.alreadyCourier><button class=\"btn btn-block btn-theme btn-primary\" disabled>Courier</button></div><div class=col-sm-3 ng-hide=vm.data.hiderejectButton><button class=\"btn btn-block btn-theme btn-warning\" ng-click=vm.func.RejectRequest(vm.data.Kycid,vm.data.Id)>Reject Request</button></div><div class=col-sm-3 ng-hide=vm.data.alreadyRejectButton><button class=\"btn btn-block btn-theme btn-warning\" disabled>Reject Request</button></div></div><!-- <button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.CloseandFinish(vm.data.Kycid,vm.data.Id)\">Cert Dispatch & Finish</button>--><!--<a ng-href=\"searchclosurekyc\"><img src=\"../../assets/images/goBack.png\" alt=\"\" style=\"height: 40px; width:130px;\" /></a>--></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n\r\n  </div>--><br><br></div></div></div></div></div></div><acme-footer></acme-footer><div class=enable-modal ng-hide=vm.data.modalEnable><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n                <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n            </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Are you sure to reject?<br><br>Did you verify details of KYC ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n                <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                    <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                    <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n                </div>\r\n            </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div></div>");
$templateCache.put("app/enquirymanagement/searchenquiry.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-xs\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Enquiry</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <h1 style=\"color:cornsilk\">Enquiries</h1>\r\n\r\n                            </div>\r\n                        </div>--><div class=\"col-sm-4 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getCompany | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchEnquiryData()>Search</button></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.addNewEnquiry()>Add New</button></div></div></div></form><!-- end form search  --></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.afterSearch == true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right>Enquiries {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-center>Enquiry Date</th><th class=text-left>Name</th><th class=text-left>Company Name</th><!--<th class=\"text-left\">Enquiry Phone</th>\r\n                        <th class=\"text-left\">Enquiry Email</th>--><th class=text-left>City</th><th class=text-center>Enquiry Standard</th><th class=text-center>Lead Source</th><!--<th class=\"text-center\">Edit</th>\r\n                        <th class=\"text-center\">Invalid</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allEnquiryData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=cursor:pointer ng-click=\"\"><td class=text-center ng-click=vm.func.updateEnquiryAssign(row)>{{row.Enquirydate|date:\'medium\'}}</td><td class=text-left ng-click=vm.func.updateEnquiryAssign(row)>{{row.Enquiryname}}</td><td class=text-left ng-click=vm.func.updateEnquiryAssign(row)>{{row.Companyname}}</td><!--<td class=\"text-left\" ng-click=\"vm.func.updateEnquiryAssign(row)\">{{row.Companyname}}</td>--><!--<td class=\"text-left\">{{row.Enquiryphone}}</td>\r\n    <td class=\"text-left\">{{row.Enquiryemail}}</td>--><td class=text-left ng-click=vm.func.updateEnquiryAssign(row)>{{row.Enquirycity}}</td><td class=text-center ng-click=vm.func.updateEnquiryAssign(row)>{{row.EnquiryStandard}}</td><td class=text-center ng-click=vm.func.updateEnquiryAssign(row)>{{row.Enquirytype}}</td><!--<td class=\"text-center\"><button class=\"btn btn-theme btn-xs btn-primary\" ng-click=\"vm.func.updateEnquiryAssign(row)\">Assign</button></td>\r\n                        <td class=\"text-center\"><button class=\"btn btn-theme btn-xs btn-danger btn-primary\" ng-click=\"vm.func.invalidEnquiry(row)\">Invalid</button> </td>--></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/home/home.html","<acme-navbar></acme-navbar><div class=\"body-content clearfix bg-color2\"><div class=\"block-section line-bottom bg-color1\" style=\"padding-top: 60px; padding-bottom: 60px\"><div class=container><div class=\"vc_row wpb_row vc_row-fluid\"><div class=\"wpb_column vc_column_container vc_col-sm-12\"><div class=vc_column-inner><div class=wpb_wrapper><!-- box with icon center --><div class=\"row text-center\"><img src=../../assets/images/ISOCatalyst.png alt=\"\"><div class=white-space-10></div><div class=white-space-10></div><h1 class=link-black>Welcome to TOP Certifier BackOffice application</h1><br><!--<h3>For Hassle Free Consulting and Certification, contact us today.Certifications made Simpler, Faster and Affordable!</h3>--><div class=white-space-10></div><div class=white-space-10></div><div class=white-space-10></div><div class=white-space-10></div><div class=white-space-10></div><div class=white-space-50></div><div class=white-space-10></div><div class=white-space-10></div><div class=white-space-10></div><div class=white-space-30></div><div class=white-space-10></div></div></div></div></div></div></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/invoice/TaxInvoice.html","<acme-navbar></acme-navbar><script src=https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.js referrerpolicy=no-referrer></script><script src=https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js></script><script src=https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.22/pdfmake.min.js></script><header class=main-header><!--<style>\r\n      .bold {\r\n          font-weight: bold;\r\n          color: black;\r\n      }\r\n\r\n      .imgleft {\r\n          float: left;\r\n          margin-left: 33px;\r\n          height: 40px;\r\n      }\r\n\r\n      .imgright {\r\n          float: right;\r\n          margin-right: 33px;\r\n          height: 40px;\r\n      }\r\n\r\n      .table > thead > tr > th,\r\n      .table > tbody > tr > th,\r\n      .table > tfoot > tr > th,\r\n      .table > thead > tr > td,\r\n      .table > tbody > tr > td,\r\n      .table > tfoot > tr > td {\r\n          border: 1px solid black;\r\n          line-height: 1.00;\r\n      }\r\n\r\n    .firstcol {\r\n      background-color: #21618C;\r\n      color: white;\r\n      width: 15%;\r\n    }\r\n\r\n    .secondcol {\r\n      background-color: #D6EAF8;\r\n      color: black;\r\n    }\r\n  </style>--></header><br><br><section class=container><div class=row><div class=col-sm-7><div class=pull-right style=\"margin:0px 0px 10px 10px\"><button class=\"btn btn-danger btn-sm\" id=btndwnld ng-click=vm.func.Download()><strong>Download</strong></button></div><div class=pull-right style=\"margin:0px 0px 10px 10px\"><button class=\"btn btn-danger btn-sm\" id=btndwnld ng-click=vm.func.invoice() ng-hide=vm.data.GenInvBtn><strong>Generate Invoice</strong></button></div></div></div></section><section class=container><div class=row><!-- <div class=\"col-sm-1\"><br><br></div> --><div class=col-sm-12><br><br><div class=\"panel panel-bd\" id=payslip><br><br><br><br><div class=panel-body><div class=imgleft><img src=../../assets/images/invoice-top.png></div><div class=imgright><img src=../../assets/images/invoice-veave.png></div><br><br><br><br><div class=\"form-horizontal col-md-12\" style=\"font-size: 20px\"><div style=\"text-align: center\" class=col-sm-12><h2 style=\"color: black\" class=bold>TAX INVOICE</h2></div><br><table id=dataTables-example class=\"my-table dataTable\"><tbody><tr><td class=\"firstcol bold\">Client Name:</td><td class=\"secondcol1 bold\">{{ vm.data.ClientName }}</td><td class=\"firstcol bold\">Invoice Ref:</td><td class=secondcol>{{ vm.data.InvRefNoStatic }}</td></tr><tr><td class=\"firstcol bold\">Address:</td><td class=secondcol1 style=\"color: black\">{{ vm.data.Address }}</td><td class=\"firstcol bold\">Invoice Date:</td><td class=secondcol style=\"color: black\">{{ vm.data.InvoiceDate|date:\'dd/MM/yyyy\' }}</td></tr><tr><td class=\"firstcol bold\">GSTIN:</td><td class=secondcol1 style=\"color: black\">{{ vm.data.GSTIN }}</td><td class=\"firstcol bold\">PAN Number:</td><td class=secondcol style=\"color: black\">{{ vm.data.StaticPANNumber }}</td></tr><tr><td class=\"firstcol bold\">State:</td><td class=secondcol1 style=\"color: black\">{{ vm.data.State }}</td><td class=\"firstcol bold\">GSTIN:</td><td class=secondcol style=\"color: black\">{{ vm.data.StaticGSTIN }}</td></tr><tr><td class=\"firstcol bold\">Code:</td><td class=secondcol1 style=\"color: black\">{{ vm.data.Code }}</td><td class=\"firstcol bold\">State Code:</td><td class=secondcol style=\"color: black\">{{ vm.data.StaticStateCode }}</td></tr><tr><td class=\"firstcol bold\">Country:</td><td class=secondcol1 style=\"color: black\">{{ vm.data.Country }}</td><td class=\"firstcol bold\">SA Code:</td><td class=secondcol style=\"color: black\">{{ vm.data.StaticSACode }}</td></tr></tbody></table><br><br><table id=dataTables-example class=\"my-table dataTable\"><tbody><tr class=bold style=\"background-color: #21618C;color: white;text-align: center\"><td height=40 style=\"width: 3%\">SL</td><td style=\"width: 37%\">Description</td><td style=\"width: 12%\">Taxable Value</td><td ng-hide=vm.data.ifKarnataka style=\"width: 12%\">CGST (9%)</td><td ng-hide=vm.data.ifKarnataka style=\"width: 12%\">SGST (9%)</td><td ng-hide=vm.data.ifNotKarnataka style=\"width: 12%\">IGST (18%)</td><!--<td style=\"width: 12%;\">TDS (10%)</td>--><td style=\"width: 12%\">Amount (INR)</td></tr><tr style=\"background-color: #D6EAF8; color: black\"><td height=40>1.</td><td>{{ vm.data.DescriptionOne }}</td><td style=\"text-align: end\">{{ vm.data.TaxableValueOne }}</td><td ng-hide=vm.data.ifKarnataka style=\"text-align: end\">{{ vm.data.CGSTOne }}</td><td ng-hide=vm.data.ifKarnataka style=\"text-align: end\">{{ vm.data.SGSTOne }}</td><td ng-hide=vm.data.ifNotKarnataka style=\"text-align: end\">{{ vm.data.IGSTOne }}</td><!--<td style=\"text-align: end;\">{{ vm.data.TDSVal }}</td>--><td style=\"text-align: end\">{{ vm.data.Amount }}</td></tr><tr style=\"color: black\" ng-hide=vm.data.hidesecond><td>2.</td><td>{{ vm.data.DescriptionTwo }}</td><td style=\"text-align: end\">{{ vm.data.TaxableValueTwo }}</td><td ng-hide=vm.data.ifKarnataka style=\"text-align: end\">{{ vm.data.CGSTTwo }}</td><td ng-hide=vm.data.ifKarnataka style=\"text-align: end\">{{ vm.data.SGSTTwo }}</td><td ng-hide=vm.data.ifNotKarnataka style=\"text-align: end\">{{ vm.data.IGSTTwo }}</td><!--<td style=\"text-align: end;\">{{ vm.data.TDSVal }}</td>--><td style=\"text-align: end\">0.00</td><td style=\"text-align: end\">{{ vm.data.AmountTwo }}</td></tr><tr class=bold style=\"background-color: #21618C;color: white\"><td height=40></td><td style=\"text-align: end\">TOTAL</td><td style=\"text-align: end\">{{vm.data.TotalValue}}</td><td ng-hide=vm.data.ifKarnataka style=\"text-align: end\">{{vm.data.TotalCGST}}</td><td ng-hide=vm.data.ifKarnataka style=\"text-align: end\">{{vm.data.TotalSGST}}</td><td ng-hide=vm.data.ifNotKarnataka style=\"text-align: end\">{{ vm.data.TotalIGST }}</td><!--<td style=\"text-align: end;\">{{ vm.data.TDSVal }}</td>--><td style=\"text-align: end\">{{vm.data.TotalClosure}}</td></tr></tbody></table><br><table id=dataTables-example class=\"my-table dataTable\"><tbody><tr><td height=40 class=bold style=\"background-color: #21618C;color: white;width: 200px\">Total in Words</td><td style=\"width: 1050px; background-color: #D6EAF8; color: black\">{{ vm.data.TotalInWords }}</td></tr></tbody></table><!--<h4 class=\"modal-title alignleft bold\" style=\"font-size: 20px;\">Terms of Payment:</h4>\r\n            <br /><br />\r\n            <p contentEditable=\"true\" style=\"color: black;padding-left: 26px;\">\r\n              <img src=\"../../assets/images/dot.png\" width=\"2%\" />\r\n              100% on process initiation\r\n            </p>\r\n            <p style=\"color: black;padding-left: 26px;\">\r\n              <img src=\"../../assets/images/dot.png\" width=\"2%\" />\r\n              Interest of 18% per annum will be\r\n              applicable on\r\n              payments delayed beyond 15 days from the Invoice Date.\r\n            </p>\r\n            <p style=\"color: black;padding-left: 26px;\">\r\n              <img src=\"../../assets/images/dot.png\" width=\"2%\" />\r\n              All charges pertaining to money transfer\r\n              has to be\r\n              exclusively borne by client.--><br><br><!--</p>--><table id=dataTables-example class=\"my-table dataTable\"><tbody class=bold><tr><td height=40 style=\"background-color: #21618C;color: white\">BANK DETAILS</td><td style=\"background-color: #21618C; color: white; width: 1050px\"></td></tr><tr><td height=40 class=firstcol>Account Name<span style=\"float: right\">:</span></td><td style=\"font-weight: 500; background-color: #D6EAF8; width: 90%\">Veave Technologies Pvt. Ltd.</td></tr><tr><td height=40 class=firstcol>Account No <span style=\"float: right\">:</span></td><td style=\"font-weight: 500; background-color: #D6EAF8; width: 90%\">913020024459041</td></tr><tr><td height=40 class=firstcol>IFSC Code <span style=\"float: right\">:</span></td><td style=\"font-weight: 500; background-color: #D6EAF8; width: 90%\">UTIB0000009</td></tr><tr><td height=40 class=firstcol>Bank Name <span style=\"float: right\">:</span></td><td style=\"font-weight: 500; background-color: #D6EAF8; width: 90%\">AXIS BANK LIMITED</td></tr><tr><td height=40 class=firstcol>Branch Code <span style=\"float: right\">:</span></td><td style=\"font-weight: 500; background-color: #D6EAF8; width: 90%\">009</td></tr><tr><td height=40 class=firstcol>Branch Address <span style=\"float: right\">:</span></td><td style=\"font-weight: 500; background-color: #D6EAF8; width: 90%\">No 9, MG Road, Block A, Bangalore (KT), Bengaluru - 560001, Karnataka, INDIA.</td></tr></tbody></table><br><br><div style=text-align:center class=col-md-12><h4 style=color:black class=bold>For Office Use Only</h4></div><div><table id=dataTables-example class=\"my-table dataTable\"><tbody><tr><td height=40 class=\"firstcol bold\" style=\"width: 250px\">Total Project Value:</td><td class=secondcol1 style=\"width: 350px\">{{ vm.data.ProjectValue }}</td><td class=\"firstcol bold\" style=\"width: 250px\">Invoice Sequence:</td><td class=secondcol1 style=\"color: black; width: 350px\">{{ vm.data.InvoiceSequence }}</td></tr></tbody></table></div><br><br><p style=\"color: black\"><b>Document Originality: </b>This document has been issued in electronic format and is controlled as per organization\'s procedures. No manual signatures are required for authentication. To verify the authenticity of this document please email us for confirmation at accounts@veave.in or contact +91-9741391222.</p><br><br><br><br><br><br><br><br><div class=imgleft style=margin-left:0px><div><img src=../../assets/images/invoice-footer.png width=100 height=100></div></div><div class=imgleft style=\"color: black;line-height: 23px\"><p class=bold style=\"font-size: 20px\">Veave Technologies Pvt. Ltd.</p><p style=\"font-size: 18px;margin-bottom: 0px\">107, GokaramRathnam Complex, 3rd Floor, 2nd Main,</p><p style=\"font-size: 18px;margin-bottom: 0px\">7th Block Jayanagar, Bangalore 560082, Karnataka, INDIA</p><p style=\"font-size: 18px;margin-bottom: 0px\">Web: www.veave.in</p></div><br><br><br><br><br><br><br></div></div></div></div></div></section><acme-footer></acme-footer>");
$templateCache.put("app/invoice/TaxInvoiceHistory.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Tax Invoice History</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Client Name</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Client Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-4 col-xs-12\"><div class=form-sort-date><label class=color-white>Invoice Reference</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=Reference name=Reference autocomplete=off placeholder=\"Search By Reference\" ng-model=vm.data.Reference uib-typeahead=\"Reference as Reference for Reference in vm.data.getallInvoiceReference | filter:$viewValue | limitTo:10\"></div></div><!-- <div class=\"col-sm-2 col-xs-12\">\r\n                                    <div class=\"form-sort-date\">\r\n                                        <label class=\"color-white\">Agent</label>\r\n\r\n                                        <input class=\"form-control\" type=\"text\" id=\"Agent\" name=\"Agent\"\r\n                                            autocomplete=\"off\" placeholder=\"Search By Agent Name\"\r\n                                            ng-model=\"vm.data.AgentName\"\r\n                                            uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\" />\r\n                                    </div>\r\n                                </div> --><!-- <div class=\"col-sm-2 col-xs-12\">\r\n                                    <div class=\"form-sort-date\">\r\n                                        <label class=\"color-white\">Bank Type</label>\r\n                                        <input class=\"form-control\" type=\"text\" id=\"BankType\" name=\"BankType\"\r\n                                            autocomplete=\"off\" placeholder=\"Search By Bank Type\"\r\n                                            ng-model=\"vm.data.BankType\"\r\n                                            uib-typeahead=\"BankType as BankType for BankType in vm.data.getBankType | filter:$viewValue | limitTo:10\" />\r\n                                    </div>\r\n                                </div> --><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>Invoice From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>Invoice To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right></p><div class=text-right>Invoice {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</div><p></p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-center>Payment Date</th><!--<th class=\"text-center\">Invoice Date</th>--><th class=text-center>Reference</th><th class=text-center>Client Name</th><th class=text-center>GSTIN</th><th class=text-center>State</th><th class=text-center>Country</th><th class=text-center>Invoice Amount</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\"><td class=text-center>{{row.Invoice_Date|date:\'dd/MM/yyyy\'}}</td><!--<td class=\"text-center\">{{row.Invoice_Date|date:\'dd/MM/yyyy\'}}</td>--><td class=text-center>{{row.Invoice_Ref}}</td><td class=text-left>{{row.Client_Name}}</td><td class=text-center>{{row.Client_GSTIN}}</td><td class=text-center>{{row.Client_State}}</td><td class=text-center>{{row.Client_Country}}</td><td class=text-center>{{row.Total_Amount}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/kycUpdate/kycUpdateDetails.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Update KYC</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=off placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getAllCompanyNames | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchCertificationData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-href=\"addkyc\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row style=\"width: 1100px\"><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Zone</label>\r\n                              \r\n                                <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Size</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"Size\" name=\"Size\" autocomplete=\"off\" placeholder=\"Search By Size\" ng-model=\"vm.data.Size\" uib-typeahead=\"Size as Size for Size in vm.data.getSizeData | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Validity</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"SrchValidity\" name=\"SrchValidity\" autocomplete=\"off\" placeholder=\"Search By Validity\" ng-model=\"vm.data.SrchValidity\" uib-typeahead=\"SrchValidity as SrchValidity for SrchValidity in vm.data.getValidityData | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Email Status</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"SrchStatus\" name=\"SrchStatus\" autocomplete=\"off\" placeholder=\"Search By Status\" ng-model=\"vm.data.SrchStatus\" uib-typeahead=\"SrchStatus as SrchStatus for SrchStatus in vm.data.getStatusData | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Agent</label>\r\n                             \r\n                                <input class=\"form-control\" type=\"text\" id=\"Agent\" name=\"Agent\" autocomplete=\"off\" placeholder=\"Search By Agent Name\" ng-model=\"vm.data.AgentName\" uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>--><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>Missing Contact</label>&nbsp; <input class=color-white type=checkbox ng-model=vm.data.ChkPryCnt value=True><label class=color-white>Missing Certificate Details</label>&nbsp; <input class=color-white type=checkbox ng-model=vm.data.ChkCertDetails value=True><!--<select class=\"form-control \" id=\"PrimaryContact\" name=\"PrimaryContact\"  ng-model=\"vm.data.selectedPrimaryContact\" ng-options=\"item.id for item in vm.data.PrimaryContact\" ></select>--><!-- <input class=\"form-control\" type=\"text\" id=\"PrimaryContact\" name=\"PrimaryContact\" autocomplete=\"off\" placeholder=\"Search for missing PrimaryContact\" ng-model=\"vm.data.PrimaryContact\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><!--<div class=\"col-sm-3 col-xs-12\">\r\n                            <div class=\"form-sort-date\">--><!--<label class=\"color-white\">Missing Cert Details</label>--><!--  <input class=\"color-white\" type=\"checkbox\" ng-model=\"vm.data.ChkCertDetails\"value=\"True\" />--><!-- <select class=\"form-control \" id=\"CertDetails\" name=\"CertDetails\" ng-model=\"vm.data.selectedCertDetails\" ng-options=\"item.id for item in vm.data.CertDetails\"></select>--><!-- <input class=\"form-control\" type=\"text\" id=\"Size\" name=\"CertDetails\" autocomplete=\"off\" placeholder=\"Search for missing CertDetails\" ng-model=\"vm.data.CertDetails\" uib-typeahead=\"Size as Size for Size in vm.data.getSizeData | filter:$viewValue | limitTo:10\" />--><!--</div>\r\n                        </div>--><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Sales Status</label>\r\n                                <select class=\"form-control\"  id=\"SalesStatus\" name=\"SalesStatus\" autocomplete=\"off\" placeholder=\"Search By Sales Status\" ng-model=\"vm.data.selectedSalesStatus\" ng-options=\"item.value for item in vm.data.SalesStatus\" />\r\n                            </div>\r\n                        </div>--><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>Certificate Status</label><input class=form-control type=text id=CertStatus name=CertStatus autocomplete=off placeholder=\"Search By Cert Status\" ng-model=vm.data.CertStatus uib-typeahead=\"CertStatus as CertStatus for CertStatus in vm.data.getCertStatus | filter:$viewValue | limitTo:10\"></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">Agent</label>\r\n\r\n                                <input class=\"form-control\" type=\"text\" id=\"Agent\" name=\"Agent\" autocomplete=\"off\" placeholder=\"Search By Agent Name\" ng-model=\"vm.data.AgentName\" uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\" />\r\n                            </div>\r\n                        </div>--><!--<div class=\"col-sm-3 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">From Date</label>--><!--<script  src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--><!--<input class=\"form-control\" type=\"date\" id=\"FromDate\" name=\"FromDate\" autocomplete=\"off\"  ng-model=\"vm.data.FromDate\" />--><!--<input class=\"form-control \" type=\"date\" id=\"FromDate\" name=\"FromDate\" autocomplete=\"off\"  ng-model=\"vm.data.FromDate\" />\r\n\r\n                            </div>\r\n                        </div>--><!--<div class=\"col-sm-3 col-xs-12\">\r\n                            <div class=\"form-sort-date\">\r\n                                <label class=\"color-white\">To Date</label>--><!--<script src=\"../../../bower_components/bootstrap/js/bootstrap-datepicker.js\"></script>--><!--<input class=\"form-control\" type=\"date\" id=\"ToDate\" name=\"ToDate\" autocomplete=\"off\" ng-model=\"vm.data.ToDate\" />\r\n                            </div>\r\n                        </div>--><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.afterSearch == true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right>Clients {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Company Name</th><th class=text-left>Contact Name</th><th class=text-left>Contact Email</th><th class=text-left>Contact Number</th><th class=text-left>Cert Body</th><th class=text-left>Accred Body</th><th class=text-left>Impl Type</th><th class=text-left>Billing Cycle</th><th class=text-left>Cert Status</th><!--<th class=\"text-left\">Cert Date</th>--><!--<th class=\"text-center\">AB</th>--><!--<th class=\"text-center\">Cert Date</th>--><!--<th class=\"text-center\">Account Value</th>\r\n                        <th class=\"text-center\">Account Size</th>--><!--<th class=\"text-center\">Type</th>--><!--<th class=\"text-center\">Agents</th>\r\n                        <th class=\"text-center\">Last Comments</th>\r\n                        <th class=\"text-center\">Email Status To</th>--><!--<th class=\"text-center\">Certification Status</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.getAllCertificationData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycid)><!--<td class=\"text-left\">{{row.CertificationCompanyName}}</td>--><td class=text-left data-toggle=tooltip title={{row.Companyname}}>{{row.Companyname|limitTo:25}}{{row.Companyname.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ClientName}}</td><td class=text-left>{{row.ContactEmail}}</td><td class=text-left>{{row.ContactNumber}}</td><td class=text-left>{{row.CertBody}}</td><td class=text-left>{{row.AccredBody}}</td><td class=text-left>{{row.ImpType}}</td><!--<td class=\"text-left\">{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td>--><td class=text-left>{{row.BillingCycle}}</td><td class=text-left>{{row.Status}}</td><!--<td class=\"text-center\">{{row.Acc_Value}}</td>--><!--<td class=\"text-center\">{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td>--><!--<td class=\"text-center\">{{row.Acc_Size}}</td>\r\n                        <td class=\"text-center\">{{row.AcountManager}}</td>--><!--<td class=\"text-center\">{{row.CertificationType}}</td>--><!--<td class=\"text-left\" data-toggle=\"tooltip\" title=\"{{row.Remarks}}\">{{row.Remarks|limitTo:35}}{{row.Remarks.length>35?\'...\':\'\'}}</td>--><!--<td class=\"text-center\">{{row.LastUpdatedDate | date:\'dd/MM/yyyy\'}}</td>--><!--<td class=\"text-center\">{{row.EmailStatus}}</td>--><!--<td class=\"text-center\">{{row.CertificationStatus}}</td>--></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/login/login.html","<header class=main-header><div class=hero-header><div class=inner-hero-header><div class=container><div class=\"text-center logo\"><a ng-href=\"\"><img src=../../assets/images/ISOCatalyst.png alt=\"\"></a></div><div class=relative><i class=\"fa fa-globe ic-fade-globe\"></i><!-- form search --><form name=loginform class=form-search-home ng-submit=vm.func.login(loginform.$valid)><div class=row><div class=col-md-12><div class=form-group><label>Username/Email</label><input type=text class=\"form-control input-lg\" ng-model=vm.data.username id=username name=username placeholder=\"Enter Your Username\" required></div><div class=form-group><label>Password</label><input type=password class=\"form-control input-lg\" ng-model=vm.data.password id=password name=password placeholder=\"Enter Your Password\" required></div><div class=form-group><button class=\"btn btn-t-primary btn-lg btn-theme btn-pill btn-block\" type=submit ng-disabled=false style=cursor:pointer>Login</button></div></div></div><div class=text-center><div class=white-space-10></div></div></form><!-- end form search --></div></div></div></div></header><div class=white-space-10></div><div class=white-space-10></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/DelayedProjects.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Delayed Projects</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Payment Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By PaymentStatus\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ID</th><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-center>Sales Agent</th><th class=text-left>Location</th><th class=text-center>Validity</th><th class=text-center>CB</th><th class=text-center>Source</th><!--<th class=\"text-center\">Deal Type</th>--><th class=text-left>Closure Amount</th><th class=text-left>Gross Margin</th><th class=text-left>Payment Recived</th><th class=text-left>Pending Payment</th><th class=text-left>Remarks</th><th class=text-left>Cert Status</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getSingleProposalDetails(row.Id,row.Kycidfk)><!--ng-class=\"\'color\'+vm.data.pendingzero\"--><td class=text-center>{{row.Id}}</td><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Location}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.CB}}</td><td class=text-center>{{row.Source}}</td><td class=text-left>{{row.TotalClosure}}</td><td class=text-left>{{row.GrossMargin}}</td><td class=text-center>{{row.PaymentRecived}}</td><td class=text-left>{{row.PendingAmount}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:25}}{{row.Remarks.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ProjectStatus}}</td><td class=text-left>{{row.PaymentStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/Freshproposal.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Fresh Closures</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Payment Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By PaymentStatus\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ID</th><th class=text-left>Payment Date</th><th class=text-left>Company Name</th><th class=text-center>Sales Agent</th><th class=text-left>Location</th><th class=text-center>Validity</th><th class=text-center>CB</th><th class=text-center>Source</th><!-- <th class=\"text-center\">Deal Type</th> --><th class=text-left>Closure Amount</th><th class=text-left>Gross Margin</th><th class=text-center>Payment Recived</th><th class=text-left>Pending Payment</th><th class=text-left>Remarks</th><th class=text-left>Cert Status</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getSingleProposalDetails(row.Id,row.Kycidfk)><!--ng-class=\"\'color\'+vm.data.pendingzero\"--><td class=text-center>{{row.Id}}</td><td class=text-left>{{row.PaymentDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Location}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.CB}}</td><td class=text-center>{{row.Source}}</td><!-- <td class=\"text-center\">{{row.Type}}</td> --><td class=text-left>{{row.TotalClosure}}</td><td class=text-left>{{row.GrossMargin}}</td><td class=text-center>{{row.PaymentRecived}}</td><td class=text-left>{{row.PendingAmount}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:25}}{{row.Remarks.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ProjectStatus}}</td><td class=text-left>{{row.PaymentStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/Fullpayproposal.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">FullPayment Closures</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Payment Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By PaymentStatus\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ID</th><th class=text-left>Payment Date</th><th class=text-left>Company Name</th><th class=text-center>Sales Agent</th><th class=text-left>Location</th><th class=text-center>Validity</th><th class=text-center>CB</th><th class=text-center>Source</th><!-- <th class=\"text-center\">Deal Type</th> --><th class=text-left>Closure Amount</th><th class=text-left>Gross Margin</th><th class=text-center>Payment Recived</th><th class=text-left>Pending Payment</th><th class=text-left>Remarks</th><th class=text-left>Cert Status</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getSingleProposalDetails(row.Id,row.Kycidfk)><!--ng-class=\"\'color\'+vm.data.pendingzero\"--><td class=text-center>{{row.Id}}</td><td class=text-left>{{row.PaymentDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Location}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.CB}}</td><td class=text-center>{{row.Source}}</td><!-- <td class=\"text-center\">{{row.Type}}</td> --><td class=text-left>{{row.TotalClosure}}</td><td class=text-left>{{row.GrossMargin}}</td><td class=text-center>{{row.PaymentRecived}}</td><td class=text-left>{{row.PendingAmount}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:25}}{{row.Remarks.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ProjectStatus}}</td><td class=text-left>{{row.PaymentStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/MonthlyPaymentHistory.html","<!DOCTYPE html><html><head><meta charset=utf-8><title></title></head><body></body></html>");
$templateCache.put("app/proposalmanagement/NewClosure.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">New Closures</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Payment Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By PaymentStatus\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ID</th><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-center>Sales Agent</th><th class=text-left>Location</th><th class=text-center>Validity</th><th class=text-center>CB</th><th class=text-center>Source</th><!--<th class=\"text-center\">Deal Type</th>--><th class=text-left>Closure Amount</th><th class=text-left>Gross Margin</th><th class=text-left>Payment Recived</th><th class=text-left>Pending Payment</th><th class=text-left>Remarks</th><th class=text-left>Cert Status</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getSingleProposalDetails(row.Id,row.Kycidfk)><!--ng-class=\"\'color\'+vm.data.pendingzero\"--><td class=text-center>{{row.Id}}</td><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Location}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.CB}}</td><td class=text-center>{{row.Source}}</td><td class=text-left>{{row.TotalClosure}}</td><td class=text-left>{{row.GrossMargin}}</td><td class=text-center>{{row.PaymentRecived}}</td><td class=text-left>{{row.PendingAmount}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:25}}{{row.Remarks.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ProjectStatus}}</td><td class=text-left>New</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/PaymentHistory.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Payment History</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Verification Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By Status\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Bank Type</label><input class=form-control type=text id=BankType name=BankType autocomplete=off placeholder=\"Search By Bank Type\" ng-model=vm.data.BankType uib-typeahead=\"BankType as BankType for BankType in vm.data.getBankType | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><p class=text-right></p><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=row><div class=\"col-sm-4 col-xs-12\"><div class=form-sort-date style=\"margin-left: -7px\"><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-success\" ng-click=vm.func.SortByAddedDate()>Sort By Added Date</a></div></div><div class=\"col-sm-6 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-success\" ng-click=vm.func.SortByReceivedDate()>Sort By Received Date</a></div></div></div></div><div class=\"col-sm-6 col-xs-12 text-right\">Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</div></div><!-- <span style=\"float: left;\">\r\n                    <div class=\"form-sort-date\">\r\n                        <label class=\"hidden-xs\">&nbsp;</label>\r\n                        <a class=\"btn btn-success\"\r\n                            ng-click=\"vm.func.searchby()\">Search</a>\r\n                    </div>\r\n                </span> --><p></p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Added Date</th><th class=text-left>Received Date</th><th class=text-left>Company Name</th><th class=text-center>Currency Type</th><th class=text-left>Payment Type</th><th class=text-center>Bank Type</th><th class=text-center>Amount</th><th class=text-center>Added By</th><th class=text-center>Verification Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getPaymentHistory(row.PHID,row.Kyc_id_pk)><td class=text-center>{{row.AddedDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.PaymentDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.CompanyName}}</td><td class=text-center>{{row.CurrencyType}}</td><td class=text-left>{{row.PaymentType}}</td><td class=text-center>{{row.BankType}}</td><td class=text-left>{{row.Amount}}</td><td class=text-center>{{row.AddedBy}}</td><td class=text-center>{{row.VerificationStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/PendingPayproposal.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">PendingPayment Closures</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Payment Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By PaymentStatus\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ID</th><th class=text-left>Payment Date</th><th class=text-left>Company Name</th><th class=text-center>Sales Agent</th><th class=text-left>Location</th><th class=text-center>Validity</th><th class=text-center>CB</th><th class=text-center>Source</th><!-- <th class=\"text-center\">Deal Type</th> --><th class=text-left>Closure Amount</th><th class=text-left>Gross Margin</th><th class=text-center>Pending Recived</th><th class=text-left>Pending Payment</th><th class=text-left>Remarks</th><th class=text-left>Cert Status</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getSingleProposalDetails(row.Id,row.Kycidfk)><!--ng-class=\"\'color\'+vm.data.pendingzero\"--><td class=text-center>{{row.Id}}</td><td class=text-left>{{row.PaymentDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Location}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.CB}}</td><td class=text-center>{{row.Source}}</td><!-- <td class=\"text-center\">{{row.Type}}</td> --><td class=text-left>{{row.TotalClosure}}</td><td class=text-left>{{row.GrossMargin}}</td><td class=text-center>{{row.PaymentRecived}}</td><td class=text-left>{{row.PendingAmount}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:25}}{{row.Remarks.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ProjectStatus}}</td><td class=text-left>{{row.PaymentStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/Reconciled.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Reconciled Closures</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Payment Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By PaymentStatus\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ID</th><th class=text-left>Payment Date</th><th class=text-left>Company Name</th><th class=text-center>Sales Agent</th><th class=text-left>Location</th><th class=text-center>Validity</th><th class=text-center>CB</th><th class=text-center>Source</th><!-- <th class=\"text-center\">Deal Type</th> --><th class=text-left>Closure Amount</th><th class=text-left>Gross Margin</th><th class=text-center>Payment Recived</th><th class=text-left>Pending Payment</th><th class=text-left>Remarks</th><th class=text-left>Cert Status</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getSingleProposalDetails(row.Id,row.Kycidfk)><!--ng-class=\"\'color\'+vm.data.pendingzero\"--><td class=text-center>{{row.Id}}</td><td class=text-left>{{row.PaymentDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Location}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.CB}}</td><td class=text-center>{{row.Source}}</td><!-- <td class=\"text-center\">{{row.Type}}</td> --><td class=text-left>{{row.TotalClosure}}</td><td class=text-left>{{row.GrossMargin}}</td><td class=text-center>{{row.PaymentRecived}}</td><td class=text-left>{{row.PendingAmount}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:25}}{{row.Remarks.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ProjectStatus}}</td><td class=text-left>{{row.PaymentStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/allproposal.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1{\r\n            background-color:burlywood;\r\n        }\r\n          .color0{\r\n            background-color:cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Closures</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Payment Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By PaymentStatus\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ID</th><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-center>Sales Agent</th><th class=text-left>Location</th><th class=text-center>Validity</th><th class=text-center>CB</th><th class=text-center>Source</th><th class=text-center>Deal Type</th><th class=text-left>Closure Amount</th><th class=text-left>Gross Margin</th><th class=text-left>Pending Payment</th><th class=text-left>Remarks</th><th class=text-left>Cert Status</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getSingleProposalDetails(row.Id,row.Kycidfk)><!--ng-class=\"\'color\'+vm.data.pendingzero\"--><td class=text-center>{{row.Id}}</td><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Location}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.CB}}</td><td class=text-center>{{row.Source}}</td><td class=text-center>{{row.Type}}</td><td class=text-left>{{row.TotalClosure}}</td><td class=text-left>{{row.GrossMargin}}</td><td class=text-left>{{row.PendingAmount}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:25}}{{row.Remarks.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ProjectStatus}}</td><td class=text-left>{{row.PaymentStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/demo.html","<acme-navbar></acme-navbar><div class=bg-color1><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Details Of Closure</h3><br></div></div></form></div></div></div><br><div class=container><a class=alignright ng-href=allProposalDetails><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><h3 class=\"no-margin-top color-black alignleft\"><span class=text-info>Client Name</span> - {{vm.data.Client}}</h3></div><div class=container><div class=row><div class=col-md-3><div class=box-list><div class=item><a ng-href=# ng-click=vm.data.editClosureKYCDetails(vm.data.Kycid) class=\"btn btn-theme btn-xs btn-primary alignright\"><span class=\"glyphicon glyphicon-pencil\"></span> Edit</a><h4 class=text-info><u>Company Details</u></h4><p style=color:#4A235A>Company Name - <span class=color-white-mute>{{vm.data.CompanyName}}</span><br>Company Location - <span class=color-white-mute>{{vm.data.CompanyCity}}</span>,<span class=color-white-mute>{{vm.data.CompanyCountry}}</span><br>Nature Of Business - <span class=color-white-mute>{{vm.data.NatureofBusiness}}</span><br>Company Type - <span class=color-white-mute>{{vm.data.CompanyType}}</span><br>Turnover - <span class=color-white-mute>{{vm.data.Turnover}}</span><br>Company URL - <span class=color-white-mute>{{vm.data.URL}}</span><br>Company Landline - <span class=color-white-mute>{{vm.data.Landline}}</span><br><br></p><h4 class=text-info><u>Primary Contact</u></h4><p style=\"color: #4A235A\">Contact Name - <span class=color-white-mute>{{vm.data.ClientName}}</span><br>Client Number - <span class=color-white-mute>{{vm.data.ContactNumber}}</span><br>Client Email - <span class=color-white-mute>{{vm.data.ContactEmail}}</span><br>Client Designation - <span class=color-white-mute>{{vm.data.Designation}}</span><br><br></p><label class=alignright style=color:green ng-if=\"vm.data.noShowDetails == true\" ng-click=vm.func.activenoShowDetails()><u>More Details</u></label><h4 ng-if=\"vm.data.hideDetails == true\" class=text-info><u>Alternate Contact</u></h4><p ng-if=\"vm.data.hideDetails == true\" style=\"color: #4A235A\">Contact Name - <span class=color-white-mute>{{vm.data.AltContactName}}</span><br>Contact Number - <span class=color-white-mute>{{vm.data.AltContactNumber}}</span><br>Contact Email - <span class=color-white-mute>{{vm.data.AltContactEmail}}</span><br>Designation - <span class=color-white-mute>{{vm.data.AltDesignation}}</span><br></p></div></div></div><div class=col-md-8><div class=box-list><div class=item><div class=text-right><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.data.closureReportUpdate()>Update Closure Details</a><br><br></div><div class=table-responsive><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Source</th><th class=text-left>Type</th><th class=text-left>Validity</th><th class=text-left>Sales Agent</th><th class=text-left>Delivery Agent</th><th class=text-left>Project Status</th><th class=text-left>CB</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\"><tr style=cursor:pointer><td>{{vm.data.ClosureDate | date:\'MM/dd/yyyy\'}}</td><td>{{vm.data.Source}}</td><td>{{vm.data.Type}}</td><td>{{vm.data.Validity}}</td><td>{{vm.data.SalesAgent}}</td><td>{{vm.data.DeliveryAgent}}</td><td>{{vm.data.ProjectStatus}}</td><td>{{vm.data.CB}}</td><td>{{vm.data.PaymentStatus}}</td></tr></tbody></table><br></div><div class=text-right><h4 class=\"modal-title text-info alignleft\">Payment Details</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.data.PaymentProposalReportUpdate()>Update Payment Details</a><br><br></div><div class=table-responsive style=\"width: 50%\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Gross Margin :</td><td class=text-center style=\"padding: 3px\">{{vm.data.GrossMargin}}/-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Total Closure :</td><td class=text-center style=\"padding: 3px\">{{vm.data.TotalClosure}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Pending Amount :</td><td class=text-center style=\"padding: 3px\">{{vm.data.PendingAmount}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Actual Expenses :</td><td class=text-center style=\"padding: 3px\">{{vm.data.ActualExpenses}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Payment Recived :</td><td class=text-center style=\"padding: 3px\">{{vm.data.PaymentRecived}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Consultation Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.ConsultationCost}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certification Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.CertificationCost}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Training Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.TrainingCost}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Travel Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.TravelCost}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Other Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.OtherCost}} /-</td></tr></table></div><div class=text-center><a ng-href=allProposalDetails><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a></div></div></div><div class=col-md-5><div class=box-list><div class=item><div class=text-right><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.data.closureReportUpdate()>Update Closure Details</a><br><br></div><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Sales Agent :</td><td class=text-center style=\"padding: 3px\">{{vm.data.SalesAgent}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Sale Type :</td><td class=text-center style=\"padding: 3px\">{{vm.data.Type}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Validity :</td><td class=text-center style=\"padding: 3px\">{{vm.data.Validity}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Standard: :</td><td class=text-center style=\"padding: 3px\">{{vm.data.ActualExpenses}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certification Body :</td><td class=text-center style=\"padding: 3px\">{{vm.data.CB}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Closure Date :</td><td class=text-center style=\"padding: 3px\">{{vm.data.ClosureDate | date:\'dd/MM/yyyy\'}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Sale Source From :</td><td class=text-center style=\"padding: 3px\">{{vm.data.Source}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Delivery Agent :</td><td class=text-center style=\"padding: 3px\">{{vm.data.DeliveryAgent}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Payment Status :</td><td class=text-center style=\"padding: 3px\">{{vm.data.PaymentStatus}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Project Status :</td><td class=text-center style=\"padding: 3px\">{{vm.data.ProjectStatus}}</td></tr></table></div></div></div><div class=col-md-5><div class=item><div class=text-right><h4 class=\"modal-title text-info alignleft\">Payment Details</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.data.PaymentProposalReportUpdate()>Update Payment Details</a><br><br></div><div class=table-responsive style=\"width: 50%\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Gross Margin :</td><td class=text-center style=\"padding: 3px\">{{vm.data.GrossMargin}}/-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Total Closure :</td><td class=text-center style=\"padding: 3px\">{{vm.data.TotalClosure}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Pending Amount :</td><td class=text-center style=\"padding: 3px\">{{vm.data.PendingAmount}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Actual Expenses :</td><td class=text-center style=\"padding: 3px\">{{vm.data.ActualExpenses}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Payment Recived :</td><td class=text-center style=\"padding: 3px\">{{vm.data.PaymentRecived}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Consultation Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.ConsultationCost}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certification Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.CertificationCost}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Training Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.TrainingCost}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Travel Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.TravelCost}} /-</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Other Cost :</td><td class=text-center style=\"padding: 3px\">{{vm.data.OtherCost}} /-</td></tr></table></div></div></div></div></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/initialproposal.html","<acme-navbar></acme-navbar><header class=main-header><style>.color1 {\r\n            background-color: burlywood;\r\n        }\r\n\r\n        .color0 {\r\n            background-color: cornflowerblue;\r\n        }</style><!-- form search area--><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">Initial Closures</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Payment Status</label><!--<input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--> <input class=form-control type=text id=PaymentStatus name=PaymentStatus autocomplete=off placeholder=\"Search By PaymentStatus\" ng-model=vm.data.PayStatus uib-typeahead=\"PaymentStatus as PaymentStatus for PaymentStatus in vm.data.getPaymentStatus | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Closures {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ID</th><th class=text-left>Payment Date</th><th class=text-left>Company Name</th><th class=text-center>Sales Agent</th><th class=text-left>Location</th><th class=text-center>Validity</th><th class=text-center>CB</th><th class=text-center>Source</th><!-- <th class=\"text-center\">Deal Type</th> --><th class=text-left>Closure Amount</th><th class=text-left>Gross Margin</th><th class=text-center>Payment Recived</th><th class=text-left>Pending Payment</th><th class=text-left>Remarks</th><th class=text-left>Cert Status</th><th class=text-left>Payment Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData  | itemsPerPage: vm.data.itemsPerPage \" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.getSingleProposalDetails(row.Id,row.Kycidfk)><!--ng-class=\"\'color\'+vm.data.pendingzero\"--><td class=text-center>{{row.Id}}</td><td class=text-left>{{row.PaymentDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-center>{{row.SalesAgent}}</td><td class=text-left>{{row.Location}}</td><td class=text-center>{{row.Validity}}</td><td class=text-center>{{row.CB}}</td><td class=text-center>{{row.Source}}</td><!-- <td class=\"text-center\">{{row.Type}}</td> --><td class=text-left>{{row.TotalClosure}}</td><td class=text-left>{{row.GrossMargin}}</td><td class=text-center>{{row.PaymentRecived}}</td><td class=text-left>{{row.PendingAmount}}</td><td class=text-left data-toggle=tooltip title={{row.Remarks}}>{{row.Remarks|limitTo:25}}{{row.Remarks.length>25?\'...\':\'\'}}</td><td class=text-left>{{row.ProjectStatus}}</td><td class=text-left>{{row.PaymentStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/singleproposaldetails.html","<acme-navbar></acme-navbar><div class=bg-color1><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Details Of Closure</h3><br></div></div></form></div></div></div><br><div class=container><a class=alignright ng-href=allProposalDetails><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><h3 class=\"no-margin-top color-black alignleft\"><span class=text-info>Client Name</span> - {{vm.data.Client}}</h3></div><div class=container><div class=row><div class=col-md-4><div class=box-list><div class=item><div class=text-right><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.data.closureReportUpdate() ng-hide=vm.data.HideButtons>Update Closure Details</a><br><br></div><div class=table-responsive><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Contact Person :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.ClientName}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Location :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.CompanyCity}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Sales Agent :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.SalesAgent}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Delivery Agent :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.DeliveryAgent}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Sale Type :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.Type}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Validity :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.Validity}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Standard: :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.IsoStandard}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certification Body :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.CB}}-{{vm.data.AB}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Closure Date :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.ClosureDate}}</span></td></tr><!--<tr>\r\n                                        <td class=\"text-left\" style=\"padding: 3px; color:#4A235A\">Sale Source From :</td>\r\n                                        <td class=\"text-center\" style=\"padding: 3px;\"><span class=\"color-black\">{{vm.data.Source}}</span></td>\r\n                                    </tr>--><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Payment Status :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.PaymentStatus}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certification Status :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.ProjectStatus}}</span></td></tr></table></div><!--<a ng-href=\"#\" ng-click=\"vm.data.editClosureKYCDetails(vm.data.kycidfk, vm.data.Prid)\" class=\"btn btn-theme btn-xs btn-primary alignright\"><span class=\"glyphicon glyphicon-pencil\"></span>  Edit  </a>\r\n\r\n                            <h4 class=\"text-info\"><u>Company Details</u></h4>\r\n                            <p style=\"color:#8A8989;\">\r\n                                Company Name - <span class=\"color-black\">{{vm.data.CompanyName}}</span> <br />\r\n                                Company Location - <span class=\"color-black\">{{vm.data.CompanyCity}}</span>,<span class=\"color-black\">{{vm.data.CompanyCountry}}</span> <br />\r\n                                Nature Of Business -  <span class=\"color-black\">{{vm.data.NatureofBusiness}}</span><br />\r\n                                Company Type - <span class=\"color-black\">{{vm.data.CompanyType}}</span> <br />\r\n                                Turnover - <span class=\"color-black\">{{vm.data.Turnover}}</span> <br />\r\n                                Company URL - <span class=\"color-black\">{{vm.data.URL}}</span> <br />\r\n                                Company Landline - <span class=\"color-black\">{{vm.data.Landline}}</span> <br /><br />\r\n                            </p>--><!--<h4 class=\"text-info\"><u>Primary Contact</u></h4>\r\n                            <p style=\"color: #8A8989;\">\r\n                                Contact Name - <span class=\"color-black\">{{vm.data.ClientName}}</span> <br />\r\n                                Client Number - <span class=\"color-black\">{{vm.data.ContactNumber}}</span> <br />\r\n                                Client Email - <span class=\"color-black\">{{vm.data.ContactEmail}}</span><br />\r\n                                Client Designation - <span class=\"color-black\">{{vm.data.Designation}}</span> <br /><br />\r\n                            </p>\r\n                            <label class=\"alignright\" style=\"color:green;\" ng-if=\"vm.data.noShowDetails == true\" ng-click=\"vm.func.activenoShowDetails()\"><u>More Details</u></label>\r\n                            <h4 ng-if=\"vm.data.hideDetails == true\" class=\"text-info\"><u>Alternate Contact</u></h4>\r\n                            <p ng-if=\"vm.data.hideDetails == true\" style=\"color: #8A8989;\">\r\n                                Contact Name - <span class=\"color-black\">{{vm.data.AltContactName}}</span> <br />\r\n                                Contact Number - <span class=\"color-black\">{{vm.data.AltContactNumber}}</span> <br />\r\n                                Contact Email - <span class=\"color-black\">{{vm.data.AltContactEmail}}</span> <br />\r\n                                Designation - <span class=\"color-black\">{{vm.data.AltDesignation}}</span> <br />\r\n                            </p>--></div></div></div><div class=col-md-8><div class=box-list><div class=item><div class=text-center><h4 class=\"modal-title text-info alignleft\">Payment Details</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.data.PaymentProposalReportUpdate() ng-hide=vm.data.HideUpdatePymt>Update Payment Details</a><br><br></div><div class=col-md-6><!--<div class=\"text-right\">\r\n                                    <h4 class=\"modal-title text-info alignleft\"></h4>\r\n\r\n                                    <br /><br />\r\n                                </div>--><div class=table-responsive><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Currency Type:</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.CurrencyType}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Total Closure :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.TotalClosure}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Total Expenses :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.ActualExpenses}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Gross Margin :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.GrossMargin}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Payment Received :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.PaymentRecived}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Payment Pending :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.PendingAmount}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Surveillance Charges :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.Surveillance}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Sale GM :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.SaleGM}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Delivery GM :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.DeliGM}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Last Payment Received Date :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.PaymentExpected}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Full Payment Received Date :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.PaymentExpected}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Cost in Other currency :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.TotalCostinOther}}/-</span></td></tr></table></div></div><div class=col-md-6><!--<div class=\"text-right\">\r\n                                    <h4 class=\"modal-title text-info alignleft\">Payment Details</h4>\r\n                                    <a ng-href=\"#\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=\"vm.data.PaymentProposalReportUpdate()\">Update Payment Details</a>\r\n                                    <br /><br />\r\n                                </div>--><div class=table-responsive><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Tax Amount (GST) :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.TaxAmount}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">TDS :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.tds}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certification Expenses :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.CertificationCost}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Bank Charges :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.BankCharges}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Courier Expenses :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.CourierExpenses}}/-</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Travel Cost :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.TravelCost}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Accomodation Cost :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.Accomodation}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Visa Fees :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.VisaCost}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Per Dm :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.PerDmCost}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Consultant/Auditor :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.ConsultationCost}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Commission :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.Commission}}</span></td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Miscellaneous :</td><td class=text-center style=\"padding: 3px\"><span class=color-black>{{vm.data.OtherCost}}</span></td></tr></table></div></div><div class=remarks><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\" width=768 height=38><tr><td class=text-left style=\"padding: 3px; color:#4A235A\" width=80>Remarks :</td><td class=text-left style=\"padding: 3px\" width=693><span class=color-black>{{vm.data.Remarks}}</span></td></tr></table><!--<a ng-href=\"allProposalDetails\"><img src=\"../../assets/images/goBack.png\" alt=\"\" style=\"height: 40px; width:130px;\" /></a>--></div><br><!-- <div class=\"row\">\r\n                                <br />\r\n                                <br />\r\n                            </div> --><div class=text-right ng-if=\"vm.data.PaymentHistoryForKycData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Payment History</h4><span>Payment History {{vm.data.startofPayHistory}} to {{vm.data.endofPayHistory}} of {{vm.data.totalItemsofPayHistory}} </span><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.func.addpayment() ng-hide=vm.data.HideButtons>Add Payment </a>&nbsp;&nbsp; <a ng-href=# style=\"cursor:pointer;margin-right: 5px\" class=\"btn btn-theme btn-xs btn-primary alignright\" ng-click=vm.func.GenerateInvoive() ng-hide=vm.data.HideInvoice>Generate Invoice</a>&nbsp;&nbsp;<br><br></div><div class=table-responsive ng-if=\"vm.data.PaymentHistoryForKycData.length > 0\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Date</th><th class=text-left>Amount</th><th class=text-left>Currency Type</th><th class=text-left>Payment Type</th><th class=text-left>Bank Type</th><th class=text-left>Added By</th><th class=text-left>Status</th><th ng-hide=vm.data.HideInvoice class=text-left>Invoice</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.PaymentHistoryForKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofPayHistory current-page=vm.data.paginationofPayHistory.current pagination-id=PayHistorypagination><tr style=\"cursor:pointer; color:#4A235A\"><td ng-click=vm.data.getSinglePaymentDetails(row.PHID)>{{ row.PaymentDate | date:\'dd/MM/yyyy\' }}</td><td ng-click=vm.data.getSinglePaymentDetails(row.PHID)>{{row.Amount}}</td><td ng-click=vm.data.getSinglePaymentDetails(row.PHID)>{{row.CurrencyType}}</td><td ng-click=vm.data.getSinglePaymentDetails(row.PHID)>{{row.PaymentType}}</td><td ng-click=vm.data.getSinglePaymentDetails(row.PHID)>{{row.BankType}}</td><td ng-click=vm.data.getSinglePaymentDetails(row.PHID)>{{row.AddedBy}}</td><td ng-click=vm.data.getSinglePaymentDetails(row.PHID)>{{row.VerificationStatus}}</td><td ng-hide=vm.data.HideInvoice style=\"text-align: center\"><input type=checkbox id={{row.PHID}} name=checkbox ng-if=\' row.VerificationStatus == \"Verified\"\'><!--<span ng-if=\'row.InvoiceGenerated == 1 && row.VerificationStatus == \"Verified\"\'>\r\n                                                <Img src=\"../../assets/images/tick-mark-1.png\" alt=\"right-mark\" />\r\n                                            </span>\r\n                                            <span ng-if=\'row.VerificationStatus == \"Not Verified\"\'>\r\n                                                <Img src=\"../../assets/images/cross-mark.png\" alt=\"cross-mark\" style=\"height: 10px; width:13px;\" />\r\n                                            </span>--></td><!-- <td><a ng-href=\"#\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-primary alignright\"\r\n                                            ng-click=\"vm.func.GenerateInvoive(row.PHID)\">Invoice</a></td> --></tr></tbody></table></div><div class=text-right ng-if=\"vm.data.PaymentHistoryForKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Payment History</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.func.addpayment(vm.data.Kycid)>Add Payment</a><br></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofPayHistory(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=PayHistorypagination></dir-pagination-controls></div><!--<div class=\"text-right\">\r\n                            <dir-pagination-controls boundary-links=\"true\"\r\n                                on-page-change=\"vm.func.pageChangeofCommentOne(newPageNumber)\"\r\n                                template-url=\"app/popups/pagination/pagination.html\" pagination-id=\"pagination\">\r\n                            </dir-pagination-controls>\r\n                        </div>--><div class=box-list ng-if=\"vm.data.PaymentHistoryForKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Payment History Found !</strong></div></div></div></div><br><div class=text-right ng-if=\"vm.data.allProposalData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Invoice History</h4><span>Invoice History {{vm.data.startofInvHistory}} to {{vm.data.endofInvHistory}} of {{vm.data.totalItemsofInvHistory}} </span>&nbsp;&nbsp;<br><br></div><div class=table-responsive ng-if=\"vm.data.allProposalData.length > 0\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Invoice Date</th><th class=text-left>Reference</th><th class=text-left>Client Name</th><th class=text-center>GSTIN</th><th class=text-center>State</th><th class=text-center>Country</th><th class=text-left>Invoice Amount</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofInvHistory current-page=vm.data.paginationofInvHistory.current pagination-id=InvHistorypagination><tr style=\"cursor:pointer; color:#4A235A\"><td class=text-center>{{row.Invoice_Date|date:\'dd/MM/yyyy\'}}</td><td class=text-left>{{row.Invoice_Ref}}</td><td class=text-left>{{row.Client_Name}}</td><td class=text-center>{{row.Client_GSTIN}}</td><td class=text-left>{{row.Client_State}}</td><td class=text-center>{{row.Client_Country}}</td><td class=text-left>{{row.Total_Amount}}</td></tr></tbody></table></div><div class=text-right ng-if=\"vm.data.allProposalData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Invoice History</h4></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofInvHistory(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=InvHistorypagination></dir-pagination-controls></div><div class=box-list ng-if=\"vm.data.allProposalData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Invoice History Found !</strong></div></div></div></div><br><div class=text-right ng-if=\"vm.data.commentDetailsForKycData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Comments</h4><span>Comments {{vm.data.startofComment}} to {{vm.data.endofComment}} of {{vm.data.totalItemsofComment}} </span><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.func.giveComment(vm.data.Kycid)>Add Comments</a>&nbsp;&nbsp;<br><br></div><div class=table-responsive ng-if=\"vm.data.commentDetailsForKycData.length > 0\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Comment By</th><th class=text-left>Date</th><th class=text-left>Comment</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.commentDetailsForKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofComment current-page=vm.data.paginationofComment.current pagination-id=commentpagination><tr style=\"cursor:pointer; color:#4A235A\"><td>{{row.ActivityUser}}</td><td>{{row.ActivityDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.Comment}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofComment(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=commentpagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.commentDetailsForKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Comments</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.func.giveComment(vm.data.Kycid)>Add Comments</a><br></div><div class=box-list ng-if=\"vm.data.commentDetailsForKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Comments !</strong></div></div></div></div></div></div></div></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/proposalmanagement/viewPropDetails.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Closure Details Of:&nbsp; <span class=color-black>{{vm.data.Client}}</span></h4></div></div><div class=\"modal-body text-center\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Sales Agent :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.SalesAgent}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Implentation Type :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.Type}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Validity :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.Validity}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Standard: :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.IsoStandard}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certification Body :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.CB}},&nbsp;{{vm.data.AB}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Closure Date :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.ClosureDate}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Sale Source From :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.Source}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Issue Type :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.IssueType}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Audit Type :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.AuditType}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Delivery Agent :</td><td class=text-center style=\"padding: 3px; color:#243125\">{{vm.data.DeliveryAgent}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Payment Status :</td><td class=text-center style=\"padding: 3px;color:#243125\">{{vm.data.PaymentStatus}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certification Status :</td><td class=text-center style=\"padding: 3px;color:#243125\">{{vm.data.ProjectStatus}}</td></tr></table></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button><!--   <button class=\"btn btn-success\" ng-click=\"vm.func.updateEnquiryetails()\">Update</button>--></div></div>");
$templateCache.put("app/qaChecker/editKycByQaChecker.html","<acme-navbar></acme-navbar><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><!-- form search --><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Update Client KYC</h3><br></div></div></form><!-- end form search --></div></div></div><div class=\"body-content clearfix\"><div class=\"bg-color1 block-section line-bottom\"><div class=container><div class=row><div class=text-right><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> -<label style=color:red>Mandatory Fields</label></div><div class=\"col-md-8 col-md-offset-2\"><form name=editkycform novalidate><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && editkycform.CompanyName.$error.required) }\"><label>Company Name</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Company Name\" id=CompanyName name=CompanyName ng-model=vm.data.CompanyName required></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': vm.data.requiredAssociate}\"><label>Associate</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select type=text class=form-control placeholder=\"Enter Associate\" id=Associate name=Associate ng-change=vm.func.hideRequiredAssociate() ng-model=vm.data.selectedAssociate ng-options=\"item.value for item in vm.data.Associate\" required></select></div></div></div><!--<div class=\"row\">\r\n                            <div class=\"col-sm-6\">\r\n                                <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.AgentName.$error.required)}\">\r\n                                    <label>Assign To</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <input type=\"text\" class=\"form-control \" placeholder=\"Enter Agent Name\" id=\"AgentName\" name=\"AgentName\" ng-model=\"vm.data.AgentName\" uib-typeahead=\"agent as agent for agent in vm.data.suggestAgentNameData | filter: $viewValue | limitTo: 10\" required />\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"col-sm-6\">\r\n                                <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.firstsaleby.$error.required)}\">\r\n                                    <label>First Sale By</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <input type=\"text\" class=\"form-control \" placeholder=\"Enter First Sale By\" id=\"firstsaleby\" name=\"firstsaleby\"  ng-model=\"vm.data.firstsaleby\"  uib-typeahead=\"agent as agent for agent in vm.data.suggestAgentNameData | filter: $viewValue | limitTo: 10\" required/>\r\n                                </div>\r\n                            </div>\r\n                        </div>--><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.ContactPerson.$error.required)}\"><label>Contact Person</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Full Name\" id=ContactPerson name=ContactPerson ng-model=vm.data.ContactPerson required></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.Designation.$error.required)}\"><label>Designation</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Designation\" id=Designation name=Designation ng-model=vm.data.Designation required></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.ContactNumber.$error.required)}\"><label>Contact Number</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Phone Number\" id=ContactNumber name=ContactNumber ng-model=vm.data.ContactNumber required></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.ContactEmail.$error.required)}\"><label>Email</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><!--<input type=\"email\" class=\"form-control \" placeholder=\"Enter Your Email\" id=\"ContactEmail\" name=\"ContactEmail\" ng-model=\"vm.data.ContactEmail\" required>--> <input type=email class=form-control name=ContactEmail placeholder=\"Enter Email ID\" ng-model=vm.data.ContactEmail ng-maxlength=100 ng-model-options=\"{ updateOn: blur }\" ng-pattern=/^[a-z0-9._-]+@[a-z0-9-]+\\.[a-z0-9.-]{1,50}$/ required><div class=error-container ng-show=\"editkycform.ContactEmail.$dirty && editkycform.ContactEmail.$error\"><small class=error ng-show=editkycform.ContactEmail.$error.required>Update Email ID. </small><small class=error ng-show=editkycform.ContactEmail.$error.pattern>Please input a valid email. </small><small class=error ng-show=editkycform.ContactEmail.$error.maxlength>Your email cannot be longer than 100 characters</small></div></div></div></div><p class=text-right><a href=# style=color:green ng-if=\"vm.data.ifWantAddAlternateContact == true\" ng-click=vm.func.activeAddAlternateContact()><u>Show Alternate Contact Details</u></a></p><p class=text-right><a href=# style=\"color:green; color:red\" ng-if=\"vm.data.ifDontWantAddAlternateContact == true\" ng-click=vm.func.deactiveAddAlternateContact()><u>Hide Alternate Contact Details</u></a></p><div ng-if=\"vm.data.addAlternateContact == true\"><div class=row><div class=col-sm-6><div class=form-group><label>Alternate Contact Person</label><input type=text class=form-control placeholder=\"Enter Full Name\" id=AlternateContactPerson name=AlternateContactPerson ng-model=vm.data.AlternateContactPerson></div></div><div class=col-sm-6><div class=form-group><label>Alternate Designation</label><input type=text class=form-control placeholder=\"Enter Alternate Designation\" id=AlternateDesignation name=AlternateDesignation ng-model=vm.data.AlternateDesignation></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label>Alternate Number</label><input type=text class=form-control placeholder=\"Alternate Phone Number\" id=AlternateNumber name=AlternateNumber ng-model=vm.data.AlternateNumber></div></div><div class=col-sm-6><div class=form-group><label>Alternate Email</label><input type=text class=form-control placeholder=\"Enter Alternate Email\" id=AlternateEmail name=AlternateEmail ng-model=vm.data.AlternateEmail></div></div></div></div><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.Natureofbusiness.$error.required)}\"><label>Nature of business</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Nature of business\" id=Natureofbusiness name=Natureofbusiness ng-model=vm.data.Natureofbusiness required></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.CompanyCountry.$error.required)}\"><label>Company Location</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Country Name\" id=CompanyCountry name=CompanyCountry ng-model=vm.data.CompanyCountry required></div></div><div class=col-md-3 ng-class=\"{\'has-error\':  vm.data.requiredStateName}\"><!--(vm.data.isFormSubmit && addkycform.CompanyState.$error.required)--><div class=form-group><label>State</label><input type=text class=form-control placeholder=\"Enter State Name\" id=CompanyState name=CompanyState ng-change=vm.func.hideRequiredState() ng-model=vm.data.CompanyState></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.CompanyCity.$error.required)}\"><label>City</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=CompanyCity name=CompanyCity ng-model=vm.data.CompanyCity required></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredZoneType}\"><label>Zone</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=ZoneType name=ZoneType ng-change=vm.func.hideRequiredZoneType() ng-model=vm.data.selectedZoneType ng-options=\"item.value for item in vm.data.ZoneType\"></select></div></div></div><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.EmployeeStrength.$error.required)}\"><label>Employee Strength</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=Count id=EmployeeStrength name=EmployeeStrength ng-model=vm.data.EmployeeStrength required></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredCompanyType}\"><label>Company Type</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CompanyType name=CompanyType ng-change=vm.func.hideRequiredCompanyType() ng-model=vm.data.selectedCompanyType ng-options=\"item.value for item in vm.data.ComType\"></select></div></div><!--  <div class=\"col-md-3\">\r\n                                  <div class=\"form-group\">\r\n                                      <label>Years in business</label><!--&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--><!--<input type=\"number\" min=\"0\" class=\"form-control \" placeholder=\"Enter Years in business\" id=\"Yearsinbusiness\" name=\"Yearsinbusiness\" ng-model=\"vm.data.Yearsinbusiness\" >\r\n                            </div>--><!--</div>--><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.Turnover.$error.required)}\"><label>Turnover</label><input type=text class=form-control placeholder=\"Enter Turnover\" id=Turnover name=Turnover ng-model=vm.data.Turnover></div></div></div><!--<p class=\"text-right\"><a href=\"#\" style=\"color:green;\" ng-if=\"vm.data.ifWantAddMoreCompany == true\" ng-click=\"vm.func.activeAddMoreCompany()\"><u>Show More Company Details</u></a></p>\r\n                        <p class=\"text-right\"><a href=\"#\" style=\"color:red;\" ng-if=\"vm.data.ifDontWantAddMoreCompany == true;\" ng-click=\"vm.func.deactiveAddMoreCompany()\"><u>Hide More Company Details</u></a></p>\r\n                        <div ng-if=\"vm.data.addMoreCompany == true\" class=\"row\">--><div class=row><div class=col-sm-6><div class=form-group><label>URL/Website</label><input type=text class=form-control placeholder=\"Enter Company URL\" id=URL name=URL ng-model=vm.data.URL></div></div><div class=col-sm-6><div class=form-group><label>Landline</label><input type=text class=form-control placeholder=\"Enter Landline Number\" id=LandlineNumber name=LandlineNumber ng-model=vm.data.LandlineNumber>&nbsp;</div></div></div><!--<div class=\"row\">\r\n                            <div class=\"col-md-6\">\r\n                                <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.PostalAddress.$error.required)}\">\r\n                                    <label>Postal Address (as per certificate)</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <textarea class=\"form-control\" cols=\"5\" rows=\"5\" placeholder=\"Enter Postal Address\" id=\"PostalAddress\" name=\"PostalAddress\" ng-model=\"vm.data.PostalAddress\" required></textarea>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"col-md-6\">--><!--<div class=\"form-group\"> ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editkycform.Locations.$error.required)}\">\r\n                                    <label>Locations</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--><!--<div class=\"form-group\">\r\n                                    <label>Location</label>\r\n                                    <textarea class=\"form-control\" cols=\"5\" rows=\"5\" placeholder=\"Enter Locations\" id=\"Locations\" name=\"Locations\" ng-model=\"vm.data.Locations\"></textarea>\r\n                                </div>\r\n                            </div>\r\n                        </div>--><div class=form-group><!--<button class=\"btn btn-t-primary btn-primary\" ng-click=\"vm.func.goToBack()\">Back</button>--> <button class=\"btn btn-t-primary btn-success\" ng-click=vm.func.updateSingleKycDetails(editkycform.$valid)>Save</button></div></form></div></div></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/qaChecker/qaKycApproved.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">KYC Approved</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Status</label><!--  <input class=\"form-control\" type=\"text\" id=\"QaStatus\" name=\"QaStatus\" autocomplete=\"off\" placeholder=\"Status\" ng-model=\"vm.data.QaStatus\" uib-typeahead=\"QaStatus as QaStatus for QaStatus in vm.data.SuggestedQaStatus | filter:$viewValue | limitTo:10\" />--><select class=form-control id=QaStatus name=QaStatus ng-model=vm.data.QaStatus data-ng-options=\"item.value for item in vm.data.selectStatus\"></select><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                    <th class=\"text-left\">Pending Payment</th>\r\n                    <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n                </tr>\r\n            </thead>\r\n            <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                    <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                    <td class=\"text-left\">{{row.Client}}</td>\r\n                    <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                    <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                    <td class=\"text-center\">{{row.Validity}}</td>\r\n                    <td class=\"text-center\">{{row.Source}}</td>\r\n                    <td class=\"text-center\">{{row.Type}}</td>\r\n                    <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n                    </tr>\r\n                </tbody>\r\n            </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><!--<th class=\"text-center\">Source</th>--><th class=text-center>Validity</th><!--<th class=\"text-center\">Type</th>--><th class=text-center>Agent</th><th class=text-center>Cert Status</th><th class=text-center>Payment Status</th><th class=text-center>QA Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-left data-toggle=tooltip title={{row.Location}}>{{row.Location|limitTo:20}}{{row.Location.length>20?\'...\':\'\'}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><!--<td class=\"text-center\">{{row.Source}}</td>--><td class=text-center>{{row.Validity}}</td><!--<td class=\"text-center\">{{row.Type}}</td>--><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.QaStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/qaChecker/qaKycFail.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">KYC Fail</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Status</label><!--  <input class=\"form-control\" type=\"text\" id=\"QaStatus\" name=\"QaStatus\" autocomplete=\"off\" placeholder=\"Status\" ng-model=\"vm.data.QaStatus\" uib-typeahead=\"QaStatus as QaStatus for QaStatus in vm.data.SuggestedQaStatus | filter:$viewValue | limitTo:10\" />--><select class=form-control id=QaStatus name=QaStatus ng-model=vm.data.QaStatus data-ng-options=\"item.value for item in vm.data.selectStatus\"></select><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                    <th class=\"text-left\">Pending Payment</th>\r\n                    <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n                </tr>\r\n            </thead>\r\n            <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                    <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                    <td class=\"text-left\">{{row.Client}}</td>\r\n                    <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                    <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                    <td class=\"text-center\">{{row.Validity}}</td>\r\n                    <td class=\"text-center\">{{row.Source}}</td>\r\n                    <td class=\"text-center\">{{row.Type}}</td>\r\n                    <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n                    </tr>\r\n                </tbody>\r\n            </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><!--<th class=\"text-center\">Source</th>--><th class=text-center>Validity</th><!--<th class=\"text-center\">Type</th>--><th class=text-center>Agent</th><th class=text-center>Cert Status</th><th class=text-center>Payment Status</th><th class=text-center>QA Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-left data-toggle=tooltip title={{row.Location}}>{{row.Location|limitTo:20}}{{row.Location.length>20?\'...\':\'\'}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><!--<td class=\"text-center\">{{row.Source}}</td>--><td class=text-center>{{row.Validity}}</td><!--<td class=\"text-center\">{{row.Type}}</td>--><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.QaStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/qaChecker/qaKycPass.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">KYC Pass</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Status</label><!--  <input class=\"form-control\" type=\"text\" id=\"QaStatus\" name=\"QaStatus\" autocomplete=\"off\" placeholder=\"Status\" ng-model=\"vm.data.QaStatus\" uib-typeahead=\"QaStatus as QaStatus for QaStatus in vm.data.SuggestedQaStatus | filter:$viewValue | limitTo:10\" />--><select class=form-control id=QaStatus name=QaStatus ng-model=vm.data.QaStatus data-ng-options=\"item.value for item in vm.data.selectStatus\"></select><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                    <th class=\"text-left\">Pending Payment</th>\r\n                    <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n                </tr>\r\n            </thead>\r\n            <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                    <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                    <td class=\"text-left\">{{row.Client}}</td>\r\n                    <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                    <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                    <td class=\"text-center\">{{row.Validity}}</td>\r\n                    <td class=\"text-center\">{{row.Source}}</td>\r\n                    <td class=\"text-center\">{{row.Type}}</td>\r\n                    <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n                    </tr>\r\n                </tbody>\r\n            </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><!--<th class=\"text-center\">Source</th>--><th class=text-center>Validity</th><!--<th class=\"text-center\">Type</th>--><th class=text-center>Agent</th><th class=text-center>Cert Status</th><th class=text-center>Payment Status</th><th class=text-center>QA Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-left data-toggle=tooltip title={{row.Location}}>{{row.Location|limitTo:20}}{{row.Location.length>20?\'...\':\'\'}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><!--<td class=\"text-center\">{{row.Source}}</td>--><td class=text-center>{{row.Validity}}</td><!--<td class=\"text-center\">{{row.Type}}</td>--><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.QaStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/qaChecker/qaKycRejected.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">KYC REJECTED</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Status</label><!--  <input class=\"form-control\" type=\"text\" id=\"QaStatus\" name=\"QaStatus\" autocomplete=\"off\" placeholder=\"Status\" ng-model=\"vm.data.QaStatus\" uib-typeahead=\"QaStatus as QaStatus for QaStatus in vm.data.SuggestedQaStatus | filter:$viewValue | limitTo:10\" />--><select class=form-control id=QaStatus name=QaStatus ng-model=vm.data.QaStatus data-ng-options=\"item.value for item in vm.data.selectStatus\"></select><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                    <th class=\"text-left\">Pending Payment</th>\r\n                    <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n                </tr>\r\n            </thead>\r\n            <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                    <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                    <td class=\"text-left\">{{row.Client}}</td>\r\n                    <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                    <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                    <td class=\"text-center\">{{row.Validity}}</td>\r\n                    <td class=\"text-center\">{{row.Source}}</td>\r\n                    <td class=\"text-center\">{{row.Type}}</td>\r\n                    <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n                    </tr>\r\n                </tbody>\r\n            </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><!--<th class=\"text-center\">Source</th>--><th class=text-center>Validity</th><!--<th class=\"text-center\">Type</th>--><th class=text-center>Agent</th><th class=text-center>Cert Status</th><th class=text-center>Payment Status</th><th class=text-center>QA Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-left data-toggle=tooltip title={{row.Location}}>{{row.Location|limitTo:20}}{{row.Location.length>20?\'...\':\'\'}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><!--<td class=\"text-center\">{{row.Source}}</td>--><td class=text-center>{{row.Validity}}</td><!--<td class=\"text-center\">{{row.Type}}</td>--><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.QaStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/qaChecker/qachecker.html","<acme-navbar></acme-navbar><header class=main-header><!-- form search area--><div class=container><div class=row><div class=col-md-3><div class=\"logo text-center-sm inline\"><a href=index.html><img src=../../assets/images/ISOCatalyst.png alt=\"\" style=margin-left:32px></a><h2 style=\"color:cornsilk; text-align:center\">QA Check</h2></div></div><div class=col-md-9><!-- form search  --><form class=form-search-list><div class=row><div class=\"col-sm-6 col-xs-12\"><div class=form-group><label class=color-white>Company</label><input class=form-control type=text id=CompanyName name=CompanyName autocomplete=on placeholder=\"Search By Company Name\" ng-model=vm.data.CompanyName uib-typeahead=\"companyname as companyname for companyname in vm.data.getallCompanyName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-group><label class=hidden-xs>&nbsp;</label><!--<button class=\"btn btn-block btn-theme btn-primary\" ng-click=\"vm.func.searchClosureKYCData()\">Search</button>--> <button class=\"btn btn-block btn-theme btn-primary\" ng-click=vm.func.searchProposalData()>Search</button></div></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"hidden-xs\">&nbsp;</label>\r\n                                <a class=\"btn btn-block btn-theme btn-success\" ng-click=\"vm.func.addNewProposal()\">Add New</a>\r\n                            </div>\r\n                        </div>--></div></form><!-- end form search  --><form class=form-sort-date><div class=row><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Status</label><!--  <input class=\"form-control\" type=\"text\" id=\"QaStatus\" name=\"QaStatus\" autocomplete=\"off\" placeholder=\"Status\" ng-model=\"vm.data.QaStatus\" uib-typeahead=\"QaStatus as QaStatus for QaStatus in vm.data.SuggestedQaStatus | filter:$viewValue | limitTo:10\" />--><select class=form-control id=QaStatus name=QaStatus ng-model=vm.data.QaStatus data-ng-options=\"item.value for item in vm.data.selectStatus\"></select><!--   <input class=\"form-control\" type=\"text\" id=\"Zone\" name=\"Zone\" autocomplete=\"off\" placeholder=\"Search By Zone\" ng-model=\"vm.data.Zonedata\" uib-typeahead=\"Zone as Zone for Zone in vm.data.getZoneData | filter:$viewValue | limitTo:10\" />--></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=color-white>Agent</label><input class=form-control type=text id=Agent name=Agent autocomplete=off placeholder=\"Search By Agent Name\" ng-model=vm.data.AgentName uib-typeahead=\"agentName as agentName for agentName in vm.data.getAgentName | filter:$viewValue | limitTo:10\"></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>From Date</label><input class=form-control type=date id=FromDate name=FromDate autocomplete=off ng-model=vm.data.FromDate></div></div><div class=\"col-sm-3 col-xs-12\"><div class=form-sort-date><label class=color-white>To Date</label><input class=form-control type=date id=ToDate name=ToDate autocomplete=off ng-model=vm.data.ToDate></div></div><div class=\"col-sm-2 col-xs-12\"><div class=form-sort-date><label class=hidden-xs>&nbsp;</label><a class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.searchby()>Search</a></div></div></div></form></div></div></div><!-- end form search area--></header><!-- end main-header --><div class=bg-color1><div class=\"container bg-color1\"><br><div class=text-center ng-show=\"vm.data.searchProposal==true;\"><a ng-href=# ng-click=vm.func.refresh()><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><br><br></div><div class=table-responsive><!--<br />--><p class=text-right>Pending {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</p><!--<!--<!--<table class=\"table table-hover\">\r\n                <thead style=\"background-color:#76D7C4;\">\r\n                    <tr style=\"color:#4A235A;\">\r\n                        <th class=\"text-left\">Closure Date</th>\r\n                        <th class=\"text-left\">Company Name</th>\r\n                        <th class=\"text-center\">Sales Agent</th>\r\n                        <th class=\"text-left\">Location</th>\r\n\r\n                        <th class=\"text-center\">Validity</th>\r\n                        <th class=\"text-center\">Source</th>\r\n                        <th class=\"text-center\">Deal Type</th>\r\n                        <th class=\"text-left\">Closure Amount</th>\r\n\r\n                        <!--<th class=\"text-left\">Payment Received</th>--><!--<th class=\"text-left\">Gross Margin</th>\r\n                    <th class=\"text-left\">Pending Payment</th>\r\n                    <th class=\"text-left\">Remarks</th>\r\n\r\n\r\n                </tr>\r\n            </thead>\r\n            <tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=\"vm.data.totalItems\" current-page=\"vm.data.pagination.current\">\r\n                <tr style=\"cursor:pointer; color:#4A235A;\" ng-click=\"vm.data.getSingleProposalDetails(row.Id)\">\r\n                    <td class=\"text-left\">{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                    <td class=\"text-left\">{{row.Client}}</td>\r\n                    <td class=\"text-center\">{{row.SalesAgent}}</td>\r\n                    <td class=\"text-left\">{{row.Location}}</td>\r\n\r\n                    <td class=\"text-center\">{{row.Validity}}</td>\r\n                    <td class=\"text-center\">{{row.Source}}</td>\r\n                    <td class=\"text-center\">{{row.Type}}</td>\r\n                    <td class=\"text-left\">{{row.TotalClosure}}</td>--><!--<td class=\"text-left\">{{row.PaymentRecived}}</td>--><!--<td class=\"text-left\">{{row.GrossMargin}}</td>\r\n                        <td class=\"text-left\">{{row.PendingAmount}}</td>\r\n                        <td class=\"text-left\">{{row.Remarks}}</td>\r\n\r\n                    </tr>\r\n                </tbody>\r\n            </table>--><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Closure Date</th><th class=text-left>Company Name</th><th class=text-left>City</th><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-center>AB</th><!--<th class=\"text-center\">Source</th>--><th class=text-center>Validity</th><!--<th class=\"text-center\">Type</th>--><th class=text-center>Agent</th><th class=text-center>Cert Status</th><th class=text-center>Payment Status</th><th class=text-center>QA Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.allProposalData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.getSingleKycDetails(row.Kycidfk,row.Id)><td class=text-left>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td class=text-left data-toggle=tooltip title={{row.Client}}>{{row.Client|limitTo:25}}{{row.Client.length>25?\'...\':\'\'}}</td><td class=text-left data-toggle=tooltip title={{row.Location}}>{{row.Location|limitTo:20}}{{row.Location.length>20?\'...\':\'\'}}</td><td class=text-left>{{row.Standards}}</td><td class=text-left>{{row.CB}}</td><td class=text-center>{{row.AB}}</td><!--<td class=\"text-center\">{{row.Source}}</td>--><td class=text-center>{{row.Validity}}</td><!--<td class=\"text-center\">{{row.Type}}</td>--><td class=text-center>{{row.SalesAgent}}</td><td class=text-center>{{row.ProjectStatus}}</td><td class=text-center>{{row.PaymentStatus}}</td><td class=text-center>{{row.QaStatus}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange() template-url=app/popups/pagination/pagination.html></dir-pagination-controls></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/qaChecker/qasinglekyc.html","<acme-navbar></acme-navbar><div class=bg-color1><div class=\"hero-header bg-color4\"><br><br><div class=inner-hero-header><div class=relative><form name=frmSearch class=form-search-home novalidate><div class=row><div class=text-center><img src=../../assets/images/ISOCatalyst.png alt=\"\"></div><div class=container><h3 class=\"text-center color-white\">Details Of Client KYC</h3><br></div></div></form></div></div></div><br><div class=container><a class=alignright ng-href=qaChecker><img src=../../assets/images/goBack.png alt=\"\" style=\"height: 40px; width:130px\"></a><h3 class=\"no-margin-top color-black alignleft\"><span class=text-info>Company Name</span> - {{vm.data.CompanyName}}</h3></div><div class=container><div class=row><div class=col-md-4><div class=box-list><div class=item><a ng-href=# ng-click=vm.data.editClosureKYCDetails(vm.data.Kycid) class=\"btn btn-theme btn-xs btn-primary alignright\"><span class=\"glyphicon glyphicon-pencil\"></span> Edit</a><h4 class=text-info><u>Company Details</u></h4><p style=color:#8A8989>Company Name - <span class=color-black>{{vm.data.CompanyName}}</span><br>Company Location - <span class=color-black>{{vm.data.CompanyCity}}</span>,<span class=color-black>{{vm.data.CompanyCountry}}</span><br>Nature Of Business - <span class=color-black>{{vm.data.NatureofBusiness}}</span><br>Company Type - <span class=color-black>{{vm.data.CompanyType}}</span><br>Employee Strength - <span class=color-black>{{vm.data.EmployeeStrength}}</span><br>Company URL - <span class=color-black>{{vm.data.URL}}</span><br>Company Landline - <span class=color-black>{{vm.data.Landline}}</span><br><br></p><h4 class=text-info><u>Primary Contact</u></h4><p style=\"color: #8A8989\">Contact Name - <span class=color-black>{{vm.data.ClientName}}</span><br>Client Number - <span class=color-black>{{vm.data.ContactNumber}}</span><br>Client Email - <span class=color-black>{{vm.data.ContactEmail}}</span><br>Client Designation - <span class=color-black>{{vm.data.Designation}}</span><br><br></p><label class=alignright style=color:green ng-if=\"vm.data.noShowDetails == true\" ng-click=vm.func.activenoShowDetails()><u>More Details</u></label><h4 ng-if=\"vm.data.hideDetails == true\" class=text-info><u>Alternate Contact</u></h4><p style=color:#8A8989 ng-if=\"vm.data.hideDetails == true\">Contact Name - <span class=color-black>{{vm.data.AltContactName}}</span><br>Contact Number - <span class=color-black>{{vm.data.AltContactNumber}}</span><br>Contact Email - <span class=color-black>{{vm.data.AltContactEmail}}</span><br>Designation - <span class=color-black>{{vm.data.AltDesignation}}</span><br></p></div></div></div><div class=col-md-8><div class=box-list><div class=item><div class=text-right ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"><!--ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"--><h4 class=\"modal-title text-info alignleft\">Certification Details</h4><span>Certificates {{vm.data.start}} to {{vm.data.end}} of {{vm.data.totalItems}}</span><!-- <a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a>--><br><br></div><div class=table-responsive ng-show=\"vm.data.certificationDetailsForSingleKycData.length > 0\"><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>ISO Standard</th><th class=text-left>CB</th><th class=text-left>AB</th><!--<th class=\"text-left\">Issue Date</th>--><th class=text-left>Issue Date</th><th class=text-left>Expiry Date</th><th class=text-left>Validity</th><th class=text-left>Type</th><th class=text-left>Status</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.certificationDetailsForSingleKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItems current-page=vm.data.pagination.current pagination-id=certificatepagination><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.func.editCertificationDetails(row)><td>{{row.CertificationIsoStandard}}</td><td>{{row.CertificationBody}}</td><td>{{row.CertificationUnderAccred}}</td><!--<td>{{row.CertificationIssueDate | date:\'dd/MM/yyyy\'}}</td>--><td>{{row.RecertifiedDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.CertificationExpiryDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.CertificationValidity}}</td><td>{{row.CertificationType}}</td><td>{{row.CertificationStatus}}</td></tr></tbody></table><br></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChange(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=certificatepagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.certificationDetailsForSingleKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Certification Details</h4><!-- <a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a>--><br></div><div class=box-list ng-if=\"vm.data.certificationDetailsForSingleKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Certificate !</strong></div></div></div></div><div class=text-right ng-show=\"vm.data.proposalDetailsForSingleKycData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><span>Closures {{vm.data.startofClosure}} to {{vm.data.endofClosure}} of {{vm.data.totalItemsofClosure}}</span><!--<a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a>--><br><br></div><div class=table-responsive ng-show=\"vm.data.proposalDetailsForSingleKycData.length > 0\"><table class=\"table table-hover\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><!--<th class=\"text-left\">Closure Date</th>\r\n                                        <th class=\"text-left\">Billing Cycle</th>\r\n                                        <th class=\"text-left\">Gross Margin</th>\r\n                                        <th class=\"text-left\">Closure Amount</th>\r\n                                        <th class=\"text-left\">Surveillance Amount</th>--><th class=text-left>Closure Date</th><th class=text-left>Validity</th><th class=text-left>Imp Type</th><th class=text-left>Issue Type</th><th class=text-left>Agent</th><th class=text-left>Gross Margin</th><th class=text-left>Closure Amount</th><!--<th class=\"text-left\">Surveillance Amount</th>--></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.proposalDetailsForSingleKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofClosure current-page=vm.data.paginationofClosure.current pagination-id=proposalpagination><tr style=\"cursor:pointer; color:#4A235A\" ng-click=vm.data.closureReportUpdate(row.Id)><!--ng-click=\"vm.data.editProposal(row.Id)\"--><!--<td>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td>\r\n                                        <td>{{row.Validity}}</td>\r\n                                        <td>{{row.GrossMargin}}/-</td>\r\n                                        <td>{{row.TotalClosure}}/-</td>\r\n                                        <td>{{row.SurveillanceCharges}}/-</td>--><td>{{row.ClosureDate|date:\'dd/MM/yyyy\'}}</td><td>{{row.Validity}}</td><td>{{row.Type}}</td><td>{{row.certificationType}}</td><td>{{row.SalesAgent}}</td><td>{{row.GrossMargin}}/-</td><td>{{row.TotalClosure}}/-</td><!--<td>{{row.SurveillanceCharges}}/-</td>--></tr></tbody></table><br></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofClosure(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=proposalpagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.proposalDetailsForSingleKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Closure Details</h4><!--<a ng-href=\"#\" ng-click=\"vm.data.goAddNewCertificationPage(vm.data.Kycid)\" style=\"cursor:pointer;\" class=\"btn btn-theme btn-xs btn-success alignright\">Add New Certificate</a>--><br></div><div class=box-list ng-if=\"vm.data.proposalDetailsForSingleKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Closures !</strong></div></div></div></div><div class=text-right ng-if=\"vm.data.commentDetailsForKycData.length > 0\"><h4 class=\"modal-title text-info alignleft\">Comments</h4><span>Comments {{vm.data.startofComment}} to {{vm.data.endofComment}} of {{vm.data.totalItemsofComment}}</span> <a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.func.giveComment(vm.data.Kycid)>Add Comments</a><br><br></div><div class=table-responsive ng-if=\"vm.data.commentDetailsForKycData.length > 0\"><table class=\"table table-hover\" style=\"border: 1px solid #6C3483\"><thead style=background-color:#76D7C4><tr style=color:#4A235A><th class=text-left>Comment By</th><th class=text-left>Date</th><th class=text-left>Comment</th></tr></thead><tbody class=\"table table-striped table-hover\" dir-paginate=\"row in vm.data.commentDetailsForKycData | itemsPerPage: vm.data.itemsPerPage\" total-items=vm.data.totalItemsofComment current-page=vm.data.paginationofComment.current pagination-id=commentpagination><tr style=\"cursor:pointer; color:#4A235A\"><td>{{row.ActivityUser}}</td><td>{{row.ActivityDate | date:\'MM/dd/yyyy\'}}</td><td>{{row.Comment}}</td></tr></tbody></table></div><div class=text-right><dir-pagination-controls boundary-links=true on-page-change=vm.func.pageChangeofComment(newPageNumber) template-url=app/popups/pagination/pagination.html pagination-id=commentpagination></dir-pagination-controls></div><div class=text-right ng-if=\"vm.data.commentDetailsForKycData.length <= 0\"><h4 class=\"modal-title text-info alignleft\">Comments</h4><a ng-href=# style=cursor:pointer class=\"btn btn-theme btn-xs btn-success alignright\" ng-click=vm.func.giveComment(vm.data.Kycid)>Add Comments</a><br></div><div class=box-list ng-if=\"vm.data.commentDetailsForKycData.length <= 0\"><div class=row><div class=col-md-12><div class=\"alert alert-danger alert-dismissible fade in\" role=alert><strong>No Comments !</strong></div></div></div></div><div class=\"col-sm-12 col-xs-12 text-left\"><div class=row><div><div class=col-sm-2><button class=\"btn btn-block btn-theme btn-danger btn-primary\" ng-click=vm.func.KycFail(vm.data.Kycid,vm.data.Id)>Kyc Fail</button></div><div class=col-sm-2><button class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.KycPass(vm.data.Kycid,vm.data.Id)>Kyc Pass</button></div><div class=col-sm-3 ng-hide=vm.data.hideProjFailbutton><button class=\"btn btn-block btn-theme btn-danger btn-primary\" ng-click=vm.func.ProjFail(vm.data.Kycid,vm.data.Id)>Kyc Rejected</button></div><div class=col-sm-3 ng-hide=vm.data.hideProjPassbutton><button class=\"btn btn-block btn-theme btn-success\" ng-click=vm.func.ProjPass(vm.data.Kycid,vm.data.Id)>Kyc Approved</button></div></div></div><!--<a ng-href=\"searchclosurekyc\"><img src=\"../../assets/images/goBack.png\" alt=\"\" style=\"height: 40px; width:130px;\" /></a>--></div><!--<div class=\"col-sm-2 col-xs-12\">\r\n\r\n                        </div>--></div></div></div></div></div></div><acme-footer></acme-footer>");
$templateCache.put("app/components/footer/footer.html","<footer class=main-footer><div class=text-center><label>Copyright Veave Technologies &copy; <span id=AppendYear></span></label></div></footer><script>$(\'#AppendYear\').append(new Date().getFullYear());</script>");
$templateCache.put("app/components/navbar/navbar.html","<div class=wrapper><header class=main-header><nav class=\"navbar navbar-default main-navbar hidden-sm hidden-xs\"><div class=container><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-1><ul class=\"nav navbar-nav\"><li ng-class=\"{active: vm.func.activateClass(\'home\')}\"><a ng-href=home style=cursor:pointer><strong>HOME</strong></a></li><!--  <li ng-class=\"{active: vm.func.activateClass(\'searchEnquiryDetails\')}\"><a ng-href=\"searchEnquiryDetails\" style=\"cursor:pointer;\"><strong>NEW ENQUIRIES &nbsp;<span class=\"badge\" style=\"color:white\">{{ vm.data.totalItems}}</span></strong></a></li>--><li ng-hide=vm.data.hideagentrequest ng-class=\"{active: vm.func.activateClass(\'agentrequest\')}\"><a ng-href=agentrequest style=cursor:pointer;padding-left:10px;padding-right:10px><strong>AGENT REQUESTS&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.totalAgentRequests}}</span></strong></a></li><li ng-hide=vm.data.hideCertsPending ng-class=\"{active: vm.func.activateClass(\'certpending\')}\"><a ng-href=certpending style=cursor:pointer;padding-left:10px;padding-right:10px><strong>CERTS PENDING&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.totalCertsPending}}</span></strong></a></li><li ng-hide=vm.data.hideSoftCopySent ng-class=\"{active: vm.func.activateClass(\'certificatesDispatchedTotal\')}\"><a ng-href=certificatesDispatchedTotal style=cursor:pointer;padding-left:10px;padding-right:10px><strong>CERTS RESOLVED&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.Softcopy}}</span></strong></a></li><!--<li ng-hide=\"vm.data.hideHardCopySent\" ng-class=\"{active: vm.func.activateClass(\'certificatesHardCopySent\')}\"><a ng-href=\"certificatesHardCopySent\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>HARD COPY SENT&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.HardCopy}}</span></strong></a></li>--><!--<li ng-hide=\"vm.data.hideDispatched\" ng-class=\"{active: vm.func.activateClass(\'certificatesDispatched\')}\"><a ng-href=\"certificatesDispatched\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>CERTS DISPATCHED&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.PendingRec}}</span></strong></a></li>--><li ng-hide=vm.data.hidePending ng-class=\"{active: vm.func.activateClass(\'certificatesPending\')}\"><a ng-href=certificatesPending style=cursor:pointer;padding-left:10px;padding-right:10px><strong>CERTS PIPELINE&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.totalProp}}</span></strong></a></li><li ng-hide=vm.data.hiderenewal ng-class=\"{active: vm.func.activateClass(\'CertificateRenewals\')}\"><a ng-href=CertificateRenewals style=cursor:pointer;padding-left:10px;padding-right:10px><strong>RENEWALS&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.renewals}}</span></strong></a></li><li ng-hide=vm.data.hideDelayedProjects ng-class=\"{active: vm.func.activateClass(\'DelayedProjects\')}\"><a ng-href=DelayedProjects style=cursor:pointer;padding-left:10px;padding-right:10px><strong>DELAYED PROJECTS&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.DelayedProjects}}</span></strong></a></li><li ng-hide=vm.data.hideExpiredCertificate ng-class=\"{active: vm.func.activateClass(\'ExpiredCertificate\')}\"><a ng-href=ExpiredCertificate style=cursor:pointer;padding-left:10px;padding-right:10px><strong>EXPIRED&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.Expired}}</span></strong></a></li><!-- <li ng-hide=\"vm.data.hiderenewal\" ng-class=\"{active: vm.func.activateClass(\'recertificates\')}\"><a ng-href=\"recertificates\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>CERTIFICATES RENEWAL&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.totalRenewalProp}}</span></strong></a></li> --><!--<li ng-class=\"{active: vm.func.activateClass(\'searchclosurekyc\')}\"><a ng-href=\"searchclosurekyc\" style=\"cursor:pointer;\"><strong>CLIENT&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.totalclients}}</span></strong></a></li>--><!--<li ng-hide=\"vm.data.hideClosureDetails\" ng-class=\"{active: vm.func.activateClass(\'allProposalDetails\')}\"><a ng-href=\"allProposalDetails\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>ACCOUNTS&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.totalFreshProp}}</span></strong></a></li>--><li ng-hide=vm.data.hideNewClo ng-class=\"{active: vm.func.activateClass(\'NewClosure\')}\"><a ng-href=NewClosure style=cursor:pointer;padding-left:10px;padding-right:10px><strong>NEW&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.newclosure}}</span></strong></a></li><li ng-hide=vm.data.hideFresh ng-class=\"{active: vm.func.activateClass(\'FreshProposalDetail\')}\"><a ng-href=FreshProposalDetail style=cursor:pointer;padding-left:10px;padding-right:10px><strong>FRESH&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.totalFreshProp}}</span></strong></a></li><li ng-hide=vm.data.hideInitial ng-class=\"{active: vm.func.activateClass(\'InitialPropsalDetail\')}\"><a ng-href=InitialPropsalDetail style=cursor:pointer;padding-left:10px;padding-right:10px><strong>INITIAL&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.InitialPaymentDetails}}</span></strong></a></li><li ng-hide=vm.data.hidePayPending ng-class=\"{active: vm.func.activateClass(\'PendingPropsalDetail\')}\"><a ng-href=PendingPropsalDetail style=cursor:pointer;padding-left:10px;padding-right:10px><strong>PENDING&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.PendingPaymentDetails}}</span></strong></a></li><li ng-hide=vm.data.hideFullPay ng-class=\"{active: vm.func.activateClass(\'PayedPropsalDetail\')}\"><a ng-href=PayedPropsalDetail style=cursor:pointer;padding-left:10px;padding-right:10px><strong>FULL PAYMENT&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.FullPaymentDetails}}</span></strong></a></li><li ng-hide=vm.data.hideReconciled ng-class=\"{active: vm.func.activateClass(\'ReconciledDetail\')}\"><a ng-href=ReconciledDetail style=cursor:pointer;padding-left:10px;padding-right:10px><strong>RECONCILED&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.ReconciledDetail}}</span></strong></a></li><li ng-hide=vm.data.hidePaymentHistory ng-class=\"{active: vm.func.activateClass(\'PaymentHistory\')}\"><a ng-href=PaymentHistory style=cursor:pointer;padding-left:10px;padding-right:10px><strong>PAY HIST&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.PayHistDetail}}</span></strong></a></li><!--<li ng-hide=\"vm.data.hideMonthPaymentHistory\" ng-class=\"{active: vm.func.activateClass(\'MonthPaymentHistory\')}\"><a ng-href=\"MonthPaymentHistory\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>MONTHLY&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.MonthPayDetails}}</span></strong></a></li>--><li ng-hide=vm.data.hideTaxInvoiceHistory ng-class=\"{active: vm.func.activateClass(\'TaxInvoiceHistory\')}\"><a ng-href=TaxInvoiceHistory style=cursor:pointer;padding-left:10px;padding-right:10px><strong>INV HIST&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.TaxInvoiceHist}}</span></strong></a></li><!-- <li ng-hide=\"vm.data.hidePaymentHistory\" ng-class=\"{active: vm.func.activateClass(\'PaymentHistory\')}\"><a ng-href=\"PaymentHistory\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>RENEWAL&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.PayHistDetail}}</span></strong></a></li> --><li ng-hide=vm.data.hideIssuedCerts ng-class=\"{active: vm.func.activateClass(\'issuedCertificateDetails\')}\"><a ng-href=issuedCertificateDetails style=cursor:pointer;padding-left:10px;padding-right:10px><strong>ISSUED CERTS&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.countofcerts}}</span></strong></a></li><!--<li ng-hide=\"vm.data.hidesearchCertificates\" ng-class=\"{active: vm.func.activateClass(\'searchCertificates\')}\"><a ng-href=\"searchCertificates\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>Find Certificates</strong></a></li>--><li ng-hide=vm.data.hideQaChecker ng-class=\"{active: vm.func.activateClass(\'qaChecker\')}\"><a ng-href=qaChecker style=cursor:pointer;padding-left:10px;padding-right:10px><strong>QA CHECK&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.totalToBeVerified}}</span></strong></a></li><!--<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.totalFreshProp}}</span>--><li ng-hide=vm.data.hideKycFail ng-class=\"{active: vm.func.activateClass(\'qaKycFail\')}\"><a ng-href=qaKycFail style=cursor:pointer;padding-left:10px;padding-right:10px><strong>KYC FAIL&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.KycFailDetail}}</span></strong></a></li><li ng-hide=vm.data.hideKycPass ng-class=\"{active: vm.func.activateClass(\'qaKycPass\')}\"><a ng-href=qaKycPass style=cursor:pointer;padding-left:10px;padding-right:10px><strong>KYC PASS&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.KycPassDetail}}</span></strong></a></li><!--<li ng-hide=\"vm.data.hideKycApproved\" ng-class=\"{active: vm.func.activateClass(\'qaKycApproved\')}\"><a ng-href=\"qaKycApproved\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>KYC APPROVED&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.KycApprovedDetail}}</span></strong></a></li>--><!--<li ng-hide=\"vm.data.hideKycRejected\" ng-class=\"{active: vm.func.activateClass(\'qaKycRejected\')}\"><a ng-href=\"qaKycRejected\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>KYC REJECTED&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.KycRejectedDetail}}</span></strong></a></li>--><!--<li ng-hide=\"vm.data.hideCertification\" ng-class=\"{active: vm.func.activateClass(\'allCertificationDetails\')}\"><a ng-href=\"allCertificationDetails\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>SURVEILLANCE</strong></a></li>--><!--<li  ng-hide =\"vm.data.hideUpdateKyc\" ng-class=\"{active: vm.func.activateClass(\'kycUpdateDetails\')}\"><a ng-href=\"kycUpdateDetails\" style=\"cursor:pointer;padding-left:10px;padding-right:10px\"><strong>UPDATE KYC</strong></a></li>--><!--<li class=\"dropdown\"><a href=\"#\" data-toggle=\"dropdown\" class=\"dropdown-toggle\" style=\"cursor:pointer;\"><strong>Closure Management</strong></a>\r\n      <ul class=\"dropdown-menu\" role=\"menu\">\r\n          <li ng-class=\"{active: vm.func.activateClass(\'searchclosurekyc\')}\"> <a ng-href=\"searchclosurekyc\" style=\"cursor:pointer;\"><strong>Search Closure KYC</strong></a></li>\r\n          <li ng-class=\"{active: vm.func.activateClass(\'searchclosurekyc\')}\"> <a ng-href=\"searchclosurekyc\" style=\"cursor:pointer;\"><strong>Search From Enquiry</strong></a></li>\r\n      </ul>\r\n  </li>--></ul><ul class=\"nav navbar-nav navbar-right\"><li class=link-btn><a ng-click=vm.func.logout()><span class=\"btn btn-theme btn-pill btn-xs btn-line\">Logout</span></a></li></ul></div></div></nav><div class=container><nav class=\"mobile-nav hidden-md hidden-lg\"><ul class=\"nav navbar-nav nav-mobile\"><li class=link-btn><a ng-click=vm.func.logout()><span class=\"btn btn-theme btn-xs btn-line\">Logout</span></a></li></ul><!--<ul class=\"nav navbar-nav nav-mobile\">\r\n                  <p ng-repeat=\"linkname in linksArray.value\" >{{}}</p>\r\n                </ul>--><!--href=\"#\"--> <button ng-click=vm.func.applymobilemenu() class=\"btn-nav-toogle first bars btn btn-theme btn-pill btn-xs btn-line\"><span class=bars></span> Menu</button><div class=mobile-nav-block><h4>Navigation</h4><!--href=\"#\"--> <button ng-click=vm.func.applymobilemenu() class=\"btn-nav-toogle btn btn-theme btn-pill btn-xs btn-line\"><span class=barsclose></span> Close</button><ul class=\"nav navbar-nav\"><li><a ui-sref=home style=cursor:pointer ng-click=vm.func.applymobilemenu()><strong>Home</strong></a></li><!--<li><a ui-sref=\"searchEnquiryDetails\" style=\"cursor:pointer;\" ng-click=\"vm.func.applymobilemenu()\"><strong>New Enquiries &nbsp;<span class=\"badge\" style=\"color:white\">{{ vm.data.totalItems}}</span></strong></a></li>--><li ng-hide=vm.data.hidePending><a ui-sref=certificatesPending style=cursor:pointer ng-click=vm.func.applymobilemenu()><strong>Certificates Pending&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.totalProp}}</span></strong></a></li><!-- <li><a ui-sref=\"searchclosurekyc\" style=\"cursor:pointer;\" ng-click=\"vm.func.applymobilemenu()\"><strong>Client &nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.totalclients}}</span></strong></a></li>--><li ng-hide=vm.data.hideClosureDetails><a ui-sref=allProposalDetails style=cursor:pointer ng-click=vm.func.applymobilemenu()><strong>Accounts&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.totalFreshProp}}</span></strong></a></li><!--    <li><a ui-sref=\"allCertificationDetails\" style=\"cursor:pointer;\" ng-click=\"vm.func.applymobilemenu()\"><strong>Certificates</strong></a></li>--><li ng-hide=vm.data.hideQaChecker><a ui-sref=qaChecker style=cursor:pointer ng-click=vm.func.applymobilemenu()><strong>QA Check&nbsp;<span class=badge style=color:antiquewhite>{{vm.data.totalToBeVerified}}</span></strong></a></li><!--<li ng-class=\"{active: vm.func.activateClass(\'home\')}\"><a ng-href=\"home\" style=\"cursor:pointer;\"><strong>Home</strong></a></li>\r\n                        <li ng-class=\"{active: vm.func.activateClass(\'searchEnquiryDetails\')}\"><a ng-href=\"searchEnquiryDetails\" style=\"cursor:pointer;\"><strong>New Enquiries &nbsp;<span class=\"badge\" style=\"color:white\">{{ vm.data.totalItems}}</span></strong></a></li>\r\n                        <li ng-class=\"{active: vm.func.activateClass(\'searchclosurekyc\')}\"><a ng-href=\"searchclosurekyc\" style=\"cursor:pointer;\"><strong>Client&nbsp;<span class=\"badge\" style=\"color:antiquewhite\">{{vm.data.totalclients}}</span></strong></a></li>\r\n                        <li ng-class=\"{active: vm.func.activateClass(\'allProposalDetails\')}\"> <a ng-href=\"allProposalDetails\" style=\"cursor:pointer;\"><strong>Closure&nbsp;<span class=\"badge\"style=\"color:antiquewhite\">{{vm.data.totalProp}}</span></strong></a></li>\r\n                        <li ng-class=\"{active: vm.func.activateClass(\'allCertificationDetails\')}\"> <a ng-href=\"allCertificationDetails\" style=\"cursor:pointer;\"><strong>Certificates</strong></a></li>--></ul></div></nav></div></header></div>");
$templateCache.put("app/popups/GenerateTaxInvoice/GenerateTaxInvoice.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Tax Invoice Details</h4></div></div><div class=modal-body><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\"><div class=row ng-keyup=vm.func.keyup()><div class=col-md-9><label>Client Name</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Client Name\" id=ClientName name=ClientName ng-model=vm.data.ClientName required></div><div class=col-md-3><label>Invoice Date</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control placeholder=\"Enter Invoice Date\" id=InvoiceDate name=InvoiceDate ng-model=vm.data.InvoiceDate required></div><div class=col-md-4><label>Country</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Country\" id=Country name=Country ng-model=vm.data.Country required></div><div class=col-md-4><label>State</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter State\" id=State name=State ng-model=vm.data.State required></div><div class=col-md-4><label>GSTIN</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text maxlength=15 class=form-control placeholder=\"Enter GSTIN\" id=GSTIN name=GSTIN ng-model=vm.data.GSTIN required ng-keyup=vm.func.ChangeGSTIN() ng-keydown=vm.func.ChangeGSTIN()></div><!--<div class=\"col-md-3\">\r\n      <div class=\"form-group\">\r\n          <label>TDS</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n          <select class=\"form-control \" id=\"TDS\" name=\"TDS\" ng-change=\"vm.func.onchangeTDS()\" ng-model=\"vm.data.selectedTDS\" ng-options=\"item.value for item in vm.data.TDSType\" required></select>\r\n      </div>\r\n  </div>--><div class=col-md-4><label>Total Project Value</label>&nbsp; <img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-top:1px\"> <input type=Number class=form-control placeholder=\"Enter Project Value\" id=TotProjectValue name=TotProjectValue ng-model=vm.data.ProjectValue required></div><div class=col-md-4><label>Invoice Reference No</label>&nbsp; <img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Inv Ref Number\" id=InvRefNoStatic name=InvRefNoStatic ng-model=vm.data.InvRefNoStatic required></div><div class=col-md-4><label>Invoice Sequence</label>&nbsp; <img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Invoice Sequence\" id=InvSequence name=InvSequence ng-model=vm.data.InvSequence required></div><div class=col-md-3><label>Payment Received</label>&nbsp;<!--<img src=\"../../assets/images/star-icon.png\"\r\n    alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=number class=form-control placeholder=\"Enter Payment Received\" id=PaymentReceived name=PaymentReceived ng-model=vm.data.TaxableValueOne required></div><div class=col-md-3><label>GST Amount</label>&nbsp; <img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=Number class=form-control placeholder=\"Enter GST Value\" id=GSTAmount name=GSTAmount ng-model=vm.data.GSTAmount required></div><div class=col-md-3><label>TDS Amount</label>&nbsp; <img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=Number class=form-control placeholder=\"Enter TDS Value\" id=TDSAmount name=TDSAmount ng-model=vm.data.TDSAmount required></div><div class=col-md-3><label>Service Value</label>&nbsp; <img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=Number class=form-control placeholder=\"Enter Taxable Value\" id=TaxableAmount name=TaxableAmount ng-model=vm.data.TaxableAmount required></div><div class=col-md-12><label>Address</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Address\" id=Address name=Address ng-model=vm.data.PostalAddress required></div><div class=col-md-12><label>Description 1</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Description\" id=DescriptionOne name=DescriptionOne ng-model=vm.data.DescriptionOne required></div><!--<div class=\"col-md-9\">\r\n      <label>Description 2</label>\r\n      <input type=\"text\" class=\"form-control \" placeholder=\"Enter Description\" id=\"DescriptionTwo\"\r\n             name=\"DescriptionTwo\" ng-model=\"vm.data.DescriptionTwo\" required />\r\n  </div>\r\n  <div class=\"col-md-3\">\r\n      <label>Taxable Value 2</label>\r\n      <input type=\"text\" class=\"form-control \" placeholder=\"Enter Taxable Value\" id=\"TaxableValueTwo\"\r\n             name=\"TaxableValueTwo\" ng-model=\"vm.data.TaxableValueTwo\" required />--></div></div></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-success\" ng-click=vm.func.generateinvoice();>Generate Invoice</button><!-- <button class=\"btn btn-success\" ng-show=\"ShowVerify\" ng-click=\"vm.func.VerifyPayment()\">Verify</button> --></div>");
$templateCache.put("app/popups/KycUpdate/kycUpdatePopUp.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.ok()><span>&times</span></button><div class=text-left><h3 class=\"modal-title text-info\">Update KYC Info</h3></div></div><div class=modal-body><form name=updateKycForm novalidate><div class=row><div class=col-md-6><table><tr><td><label>Contact Name</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.ContactName.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Contact Name\" id=ContactName name=ContactName ng-model=vm.data.ContactName required></td></tr><tr><td><label>Contact Email</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.contactEmail.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Contact Email\" id=ContactEmail name=ContactEmail ng-model=vm.data.ContactEmail required></td></tr><tr><td><label>Contact Number</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.ContactNumber.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Contact Number\" id=ContactNumber name=ContactNumber ng-model=vm.data.ContactNumber required></td></tr><tr><td><label>Alt Contact Name</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.AltContactName.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Alt Contact Name\" id=AltContactName name=AltContactName ng-model=vm.data.AltContactName required></td></tr><tr><td class=form-group><label>Alt Contact Email</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.AltContactEmail.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Alt Contact Email\" id=AltContactEmail name=AltContactEmail ng-model=vm.data.AltContactEmail required></td></tr><tr><td><label>Alt Contact Number</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.AltContactNumber.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Alt Contact Number\" id=AltContactNumber name=AltContactNumber ng-model=vm.data.AltContactNumber required></td></tr><tr><td><label>Designation</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.Designation.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Designation\" id=Designation name=Designation ng-model=vm.data.Designation required></td></tr></table></div><div class=col-md-6><table><tr><td><label>Company Name</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.Client.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Company Name\" id=Client name=Client ng-model=vm.data.Client required></td></tr><tr><td><label>Employee Strength</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.EmpStrength.$error.required) }\"><input type=text class=form-control placeholder=\"Enter EmpStrength\" id=EmpStrength name=EmpStrength ng-model=vm.data.EmpStrength required></td></tr><tr><td><label>Nature of Business</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.NatureofBusiness.$error.required) }\"><input type=text class=form-control placeholder=\"Enter NatureofBusiness\" id=NatureofBusiness name=NatureofBusiness ng-model=vm.data.NatureofBusiness required></td></tr><tr><td><label>Website URL</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.website.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Website\" id=Website name=Website ng-model=vm.data.Website required></td></tr><tr><td><label>Landline</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.Landline.$error.required) }\"><input type=text class=form-control placeholder=\"Enter Landline\" id=Landline name=Landline ng-model=vm.data.Landline required></td></tr><tr><!--<td>\r\n                                <label>Certificate Validity</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                            </td>\r\n                            <td class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredCompSize}\">\r\n                                <select  class=\"form-control \" ng-change=\"vm.func.hideRequiredCompSize()\" placeholder=\"Enter Company Size\" id=\"CompSize\" name=\"CompSize\" ng-model=\"vm.data.selectedCompSize\" ng-options=\"item.value for item in vm.data.CompSize\" required />\r\n                            </td>--><td><label>Validity</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{ \'has-error\': vm.data.requiredValidity}\"><select class=form-control id=Validity name=Validity ng-change=vm.func.hideRequiredValidity() ng-model=vm.data.selectedValidity ng-options=\"item.value for item in vm.data.Validity\" required></select></td></tr><tr><td><label>Implementation Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></td><td class=form-group ng-class=\"{ \'has-error\': vm.data.requiredType}\"><select class=form-control id=Imptype name=Imptype ng-change=vm.func.hideRequiredType() ng-model=vm.data.selectedClosureType ng-options=\"item.value for item in vm.data.ClosureType\" required></select></td></tr><!--<tr>\r\n                            <td>\r\n                                <label>Validity</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                            </td>\r\n                            <td class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredValidity}\">\r\n                                <select class=\"form-control \" id=\"Validity\" name=\"Validity\" ng-change=\"vm.func.hideRequiredValidity()\" ng-model=\"vm.data.selectedValidity\" ng-options=\"item.value for item in vm.data.Validity\" required></select>\r\n                               \r\n                            </td>\r\n                        </tr>--><!--<tr>\r\n                            <td>\r\n                                <label>Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                            </td>\r\n                            <td class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredStatus}\">\r\n                                <select class=\"form-control \" id=\"Status\"  name=\"Status\" ng-change=\"vm.func.hideRequiredStatus()\" ng-model=\"vm.data.selectedStatus\" ng-options=\"item.value for item in vm.data.Status\" required></select>\r\n        </td>\r\n                        </tr>\r\n                        <tr>\r\n                            <td>\r\n                                <label>Agent</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                            </td>\r\n                            <td class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && updateKycForm.Agent.$error.required) }\">\r\n                                <input type=\"text\" class=\"form-control \" placeholder=\"Enter Agent\" id=\"Agent\" name=\"Agent\" ng-model=\"vm.data.Agent\" autocomplete=\"off\" uib-typeahead=\"Agent as Agent for Agent in vm.data.suggestSalesAgent | filter: $viewValue | limitTo: 10\" required/>\r\n                            </td>\r\n                        </tr>--></table></div></div><!--<div class=\"row\">\r\n                <div class=\"col-md-4\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addproposalform.Client.$error.required) }\">\r\n                        <label>Client</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Company Name\" id=\"Client\" name=\"Client\" ng-model=\"vm.data.Client\" uib-typeahead=\"companyname as companyname for companyname in vm.data.getCompany | filter: $viewValue | limitTo: 15\" required />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.SalesAgent.$error.required)}\">\r\n                        <label>Sales Agent</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Sales Agent\" id=\"SalesAgent\" name=\"SalesAgent\" ng-model=\"vm.data.selectedSalesAgent\" autocomplete=\"off\" uib-typeahead=\"salesagent as salesagent for salesagent in vm.data.suggestSalesAgent | filter: $viewValue | limitTo: 10\" required />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredType}\">\r\n                        <label>Type</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <select class=\"form-control \" id=\"Type\" name=\"Type\" ng-change=\"vm.func.hideRequiredType()\" ng-model=\"vm.data.selectedClosureType\" ng-options=\"item.value for item in vm.data.ClosureType\" required></select>\r\n                    </div>\r\n                </div>\r\n               \r\n                \r\n            </div>--></form></div><div class=modal-footer><!--<button class=\"btn btn-primary\" ng-click=\"vm.func.ok()\">Close</button>--> <button class=\"btn btn-primary\" ng-click=vm.func.updateProposal(updateKycForm.$valid)>Update</button></div></div>");
$templateCache.put("app/popups/addCommentsInAborted/addCommentsInAborted.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Abort Certificate</h4></div></div><div class=modal-body><form name=addcommentsform novalidate><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\"><label>Comments</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea type=text class=form-control placeholder=\"Enter The Reason For Aborting Certificate\" rows=5 id=Comments name=Comments ng-model=vm.data.Comments required></textarea></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-primary\" ng-click=vm.func.saveComment(addcommentsform.$valid)>Save</button></div></div>");
$templateCache.put("app/popups/addCommentsInNAC/addCommentsInNAC.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Certificate - Not Applicable</h4></div></div><div class=modal-body><form name=addcommentsform novalidate><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\"><label>Comments</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea type=text class=form-control placeholder=\"Enter The Reason For Certificate - Not Applicable\" rows=5 id=Comments name=Comments ng-model=vm.data.Comments required></textarea></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-primary\" ng-click=vm.func.saveComment(addcommentsform.$valid)>Save</button></div></div>");
$templateCache.put("app/popups/addCommentsInRejectRequest/addCommentsInRejectRequest.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Reject Request</h4></div></div><!-- <div class=\"col-md-4\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.CertificationStatus.$error.required)}\">\r\n                              <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredCertificationStatus}\">\r\n                                  <label>Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                  <select class=\"form-control\" id=\"CertificationStatus\" name=\"CertificationStatus\" ng-change=\"vm.func.hideRequiredCertificationStatus()\" ng-model=\"vm.data.selectedCertificationStatus\" ng-options=\"item.value for item in vm.data.CertificationStatus\"></select>\r\n                              </div>\r\n                          </div> --><div class=modal-body><form name=addcommentsform novalidate><!--<div ng-hide=\"vm.data.hideStatus\" class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && vm.data.requiredCertificationStatus) }\">\r\n        <label>Sale Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n        <select class=\"form-control\" id=\"CertificationStatus\" name=\"CertificationStatus\" ng-change=\"vm.func.hideRequiredCertificationStatus()\" ng-model=\"vm.data.selectedCertificationStatus\" ng-options=\"item.value for item in vm.data.CertificationStatus\"></select>\r\n      </div>--><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\"><label>Comments</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea type=text class=form-control placeholder=\"Enter the reason for Rejecting Certificate Request\" rows=5 id=Comments name=Comments ng-model=vm.data.Comments required></textarea></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-primary\" ng-click=vm.func.saveComment(addcommentsform.$valid)>Save</button></div></div>");
$templateCache.put("app/popups/addDispatchDetails/addDispatchDetails.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h3 class=\"modal-title text-info\">Add Dispatch Details</h3></div></div><div class=modal-body><form name=dispatchDetailsForm novalidate><div class=row><div class=col-md-12><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && dispatchDetailsForm.CourierService.$error.required) }\"><label>Name of Courier Service</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Courier Service Name\" id=CourierService name=CourierService ng-model=vm.data.CourierService uib-typeahead=\"CourierOffice as CourierOffice for CourierOffice in vm.data.CourierOffice | filter: $viewValue\" required></div></div></div><div class=row><div class=col-md-12><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && dispatchDetailsForm.Location.$error.required)}\"><label>Location</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Location\" id=Location name=Location ng-model=vm.data.Location required></div></div></div><div class=row><div class=col-md-12><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && dispatchDetailsForm.TrackerID.$error.required)}\"><label>Tracker ID</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Tracker ID\" id=TrackerID name=TrackerID ng-model=vm.data.TrackerID required></div></div></div><div class=row><div class=col-md-12><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredRemarks}\"><label>Remarks</label><input type=text class=form-control placeholder=\"Enter Remarks\" id=Remarks name=Remarks ng-model=vm.data.Remarks></div></div></div></form></div><div class=modal-footer><!--   <button class=\"btn btn-primary\" ng-click=\"vm.func.cancel()\">Close</button>--> <button class=\"btn btn-primary\" ng-click=vm.func.savedispatchDetails(dispatchDetailsForm.$valid)>Save</button></div></div>");
$templateCache.put("app/popups/addcommentsforclosure/addcommentsforclosure.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Add Comments</h4></div></div><!-- <div class=\"col-md-4\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addcertificationform.CertificationStatus.$error.required)}\">\r\n                                <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredCertificationStatus}\">\r\n                                    <label>Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                                    <select class=\"form-control\" id=\"CertificationStatus\" name=\"CertificationStatus\" ng-change=\"vm.func.hideRequiredCertificationStatus()\" ng-model=\"vm.data.selectedCertificationStatus\" ng-options=\"item.value for item in vm.data.CertificationStatus\"></select>\r\n                                </div>\r\n                            </div> --><div class=modal-body><form name=addcommentsform novalidate><div ng-hide=vm.data.hideStatus class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && vm.data.requiredCertificationStatus) }\"><label>Sale Status</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CertificationStatus name=CertificationStatus ng-change=vm.func.hideRequiredCertificationStatus() ng-model=vm.data.selectedCertificationStatus ng-options=\"item.value for item in vm.data.CertificationStatus\"></select></div><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\"><label>Comments</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea type=text class=form-control placeholder=\"Enter Comments\" rows=5 id=Comments name=Comments ng-model=vm.data.Comments required></textarea></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-primary\" ng-click=vm.func.saveComment(addcommentsform.$valid)>Save</button></div></div>");
$templateCache.put("app/popups/addenquiry/addnewenquiry.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h3 class=\"modal-title text-info\">Add New Enquiry</h3></div></div><div class=modal-body><form name=addenquiryform novalidate><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addenquiryform.EnquiryName.$error.required) }\"><label>Enquiry Name</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Enquiry Name\" id=EnquiryName name=EnquiryName ng-model=vm.data.EnquiryName required></div></div><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addenquiryform.CompanyName.$error.required) }\"><label>Company Name</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Company Name\" id=CompanyName name=CompanyName ng-model=vm.data.CompanyName required></div></div></div><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addenquiryform.EnquiryPhone.$error.required)}\"><label>Enquiry Phone</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Enquiry Phone Number\" id=EnquiryPhone name=EnquiryPhone ng-model=vm.data.EnquiryPhone required></div></div><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addenquiryform.EnquiryEmail.$error.required)}\"><label>Enquiry Email</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><!--<input type=\"text\" class=\"form-control \" placeholder=\"Enter Email ID\" id=\"EnquiryEmail\" name=\"EnquiryEmail\" ng-model=\"vm.data.EnquiryEmail\" required>--> <input type=email class=form-control name=EnquiryEmail placeholder=\"Enter Email ID\" ng-model=vm.data.EnquiryEmail ng-maxlength=100 ng-model-options=\"{ updateOn: blur }\" ng-pattern=/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,5}$/ required><div class=error-container ng-show=\"addenquiryform.EnquiryEmail.$dirty && addenquiryform.EnquiryEmail.$error\"><small class=error ng-show=addenquiryform.EnquiryEmail.$error.required>Email ID is required. </small><small class=error ng-show=addenquiryform.EnquiryEmail.$error.pattern>Please input a valid email. </small><small class=error ng-show=addenquiryform.EnquiryEmail.$error.maxlength>Your email cannot be longer than 100 characters</small></div></div></div></div><div class=row><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addenquiryform.Country.$error.required)}\"><label>Country</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Country Name\" id=Country name=Country ng-model=vm.data.selectedCompanyname autocomplete=off uib-typeahead=\"country as country for country in vm.data.suggestCountry | filter: $viewValue | limitTo: 10\" required></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addenquiryform.City.$error.required)}\"><label>City</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=City name=City ng-model=vm.data.City required></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addenquiryform.IsoRequired.$error.required)}\"><label>ISO Required</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter ISO Certification Type\" id=IsoRequired name=IsoRequired ng-model=vm.data.selectedIsoRequired uib-typeahead=\"IsoRequired as IsoRequired for IsoRequired in vm.data.suggestIsoRequiredType | filter: $viewValue | limitTo: 15\" required></div></div></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredCompanyType}\"><label>Company Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CompanyType name=CompanyType ng-change=vm.func.hideRequiredCompanyType() ng-model=vm.data.selectedCompanyType ng-options=\"item.value for item in vm.data.CompanyType\"></select></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredLeadType}\"><label>Lead Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=LeadType name=LeadType ng-change=vm.func.hideRequiredLeadType() ng-model=vm.data.selectedLeadType ng-options=\"item.value for item in vm.data.LeadType\"></select></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addenquiryform.CompanySize.$error.required)}\"><label>Company size</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control id=CompanySize name=CompanySize ng-model=vm.data.CompanySize placeholder=\"Enter Company Size\" required></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredEnquirySource}\"><label>Enquiry Source</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=EnquirySource name=EnquirySource ng-change=vm.func.hideRequiredEnquirySource() ng-model=vm.data.selectedEnquirySource ng-options=\"item.value for item in vm.data.EnquirySource\"></select></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-primary\" ng-click=vm.func.saveEnquiryetails(addenquiryform.$valid)>Save</button></div></div>");
$templateCache.put("app/popups/addpaymenthistoryforclosure/addpaymenthistoryforclosure.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 ng-show=addpayment class=\"modal-title text-info\">Add Payment</h4><h4 ng-show=verifypayment class=\"modal-title text-info\">Verify Payment</h4></div></div><div class=modal-body><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\"><div class=row><div class=col-md-4><label>Payment Received</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=number class=form-control placeholder=\"Enter Payment Received\" id=PaymentRecived name=PaymentRecived ng-change=vm.func.changePR() ng-model=vm.data.PaymentRecived required><!--disabled=\"disabled\"--><!--To disable edit payment recieved--></div><div class=col-md-4><label>GST Amount</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=number class=form-control placeholder=\"Enter GST Amount\" id=GSTAmount name=GSTAmount ng-model=vm.data.GSTAmount required></div><div class=col-md-4><label>TDS Amount</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=number class=form-control placeholder=\"Enter TDS Amount\" id=TDSAmount name=TDSAmount ng-change=vm.func.onchangeTDS() ng-model=vm.data.TDSAmount required></div><!--<div class=\"col-md-4\">\r\n    <label>TDS</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px;\" />\r\n    <select class=\"form-control \" id=\"TDS\" name=\"TDS\" ng-change=\"vm.func.onchangeTDS()\" ng-model=\"vm.data.selectedTDS\" ng-options=\"item.value for item in vm.data.TDSType\" required></select>\r\n  </div>--><div class=col-md-4><label>Service Value</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=number class=form-control placeholder=\"Taxable Value\" id=TaxableValue name=TaxableValue ng-model=vm.data.TaxableValue required></div><div class=col-md-4><label>Pending Amount</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=number class=form-control placeholder=\"Enter Pending Amount\" id=PendingAmount name=PendingAmount ng-model=vm.data.PendingAmount required></div><div class=col-md-4><label>Payment Received Date</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control placeholder=\"Enter Payment Recived Date\" id=PaymentRecivedDate name=PaymentRecivedDate ng-model=vm.data.PaymentRecivedDate required></div><div class=col-md-3><label>Currency Type</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CurrencyType name=CurrencyType ng-model=vm.data.selectedcurrencytype ng-options=\"item.value for item in vm.data.currencytype\"></select></div><div class=col-md-3><label>Bank Type</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=BankType name=BankType ng-model=vm.data.selectedBankType ng-options=\"item.value for item in vm.data.BankType\"></select></div><div class=col-md-3><label>Payment Type</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=PaymentType name=PaymentType ng-model=vm.data.selectedPaymentType ng-options=\"item.value for item in vm.data.PaymentType\"></select></div><div class=col-md-3 ng-show=ShowStatus><label>Payment Status</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=PaymentStatus name=PaymentStatus ng-model=vm.data.selectedPaymentStatus ng-options=\"item.value for item in vm.data.PaymentStatus\"></select></div><div class=col-md-12><label>Bank Description</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea type=text class=form-control placeholder=\"Enter Bank Description/ Transaction Reference/ Banking Charges\" id=BankDescription name=BankDescription ng-model=vm.data.BankDescription required></textarea></div><div class=col-md-12><label>Payment Remarks</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea type=text class=form-control placeholder=\"Enter Payment Remarks\" id=PaymentRemarks name=PaymentRemarks ng-model=vm.data.PaymentRemarks required></textarea></div></div></div></div><div class=modal-footer><button class=\"btn btn-success\" ng-show=ShowAdd ng-click=vm.func.addpayment()>Add</button> <button class=\"btn btn-success\" ng-show=ShowVerify ng-click=vm.func.VerifyPayment()>Verify</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-danger\" ng-show=ShowDelete ng-click=vm.func.DeletePayment()>Delete</button> <button class=\"btn btn-warning\" ng-show=ShowReject ng-click=vm.func.RejectPayment()>Reject</button></div></div>");
$templateCache.put("app/popups/certificateupdate/updatecertificate.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.ok()><span>&times</span></button><div class=text-left><h3 class=\"modal-title text-info\"><span>Update Certification Details</span></h3></div></div><div class=modal-body><form name=editcertificateDetailsform novalidate><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && editcertificateDetailsform.CompanyName.$error.required) }\"><label>Company Name</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Company Name\" id=CompanyName name=CompanyName ng-model=vm.data.CompanyName required></div><div class=row><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.Country.$error.required)}\"><label>Country</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Country Name\" id=Country name=Country ng-model=vm.data.Country required></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.State.$error.required)}\"><label>State</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter State Name\" id=State name=State ng-model=vm.data.State></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.City.$error.required)}\"><label>City</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=City name=City ng-model=vm.data.City required></div></div></div><div class=row><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.IssueDate.$error.required)}\"><label>Issue Date on Cert</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control id=IssueDate name=IssueDate placeholder=MM/DD/YYYY ng-model=vm.data.IssueDate required> <small>DD/MM/YYYY</small></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.ExpiryDate.$error.required)}\"><label>Expiry Date on Cert</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control id=ExpiryDate name=ExpiryDate placeholder=MM/DD/YYYY ng-model=vm.data.AuditRenewalDate required><!--ng-change=\"vm.func.hideRequiredDateValid()\"--> <small>DD/MM/YYYY</small></div></div><div class=col-sm-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredCertificationValidity}\"><label>Next Billing Cycle</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control placeholder=\"Enter Validity\" id=Validity name=Validity ng-change=vm.func.hideRequiredCertificationValidity() ng-model=vm.data.selectedCertificationValidity ng-options=\"item.value for item in vm.data.Validity\"></select></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.ExpiryDate.$error.required)}\"><label>Surv Renewal Date</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control id=AuditRenewalDate name=AuditRenewalDate placeholder=MM/DD/YYYY ng-model=vm.data.ExpiryDate required><!--ng-change=\"vm.func.hideRequiredDateValid()\"--> <small>DD/MM/YYYY</small></div></div></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && editcertificateDetailsform.CertificationNumber.$error.required) }\"><label>Certification Number</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Number\" id=CertificationNumber name=CertificationNumber ng-model=vm.data.CertificationNumber></div></div><div class=col-sm-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.Standard.$error.required)}\"><label>Certification Standard</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Standard\" id=Standard name=Standard ng-model=vm.data.Standard required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.Body.$error.required)}\"><label>Certification Body</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Body\" id=Body name=Body ng-model=vm.data.Body required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.UnderAccreditation.$error.required)}\"><label>Accreditation Body</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control cols=5 rows=5 placeholder=\"Enter AB\" id=UnderAccreditation name=UnderAccreditation ng-model=vm.data.UnderAccreditation required></div></div></div><div class=row><div class=col-md-4><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredCertificationType}\"><label>Implementation Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CertificationType name=CertificationType ng-change=vm.func.hideRequiredCertificationType() ng-model=vm.data.selectedCertificationType ng-options=\"item.value for item in vm.data.CertificationType\"></select></div></div><!--<div class=\"col-md-4\">\r\n                    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredCertificationStatus}\">\r\n                        <label>Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <select class=\"form-control\" id=\"CertificationStatus\" name=\"CertificationStatus\" ng-change=\"vm.func.hideRequiredCertificationStatus()\" ng-model=\"vm.data.selectedCertificationStatus\" ng-options=\"item.value for item in vm.data.CertificationStatus\"></select>\r\n                    </div>\r\n                </div>--><div class=col-md-4><div class=form-group ng-class=\"{ \'has-error\': vm.data.CertificationIssueType}\"><label>Issue Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=CertificationIssueType name=CertificationIssueType ng-change=vm.func.hideRequiredCertIssueType() ng-model=vm.data.SelectedCertIssueType ng-options=\"item.value for item in vm.data.CertificateIssueType\"></select></div></div></div><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.CertificationAddress.$error.required)}\"><label>Address</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Postal Address\" id=CertificationAddress name=CertificationAddress ng-model=vm.data.CertificationAddress required></textarea></div></div><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editcertificateDetailsform.Scope.$error.required)}\"><label>Scope</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Scope\" id=Scope name=Scope ng-model=vm.data.Scope required></textarea></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.replace() style=text-align:left>Replace</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-primary\" ng-click=vm.func.updateCertificateDetails(editcertificateDetailsform.$valid)>Update</button></div></div>");
$templateCache.put("app/popups/addproposal/addproposal.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h3 class=\"modal-title text-info\">Add New Closure</h3></div></div><div class=modal-body><form name=addproposalform novalidate><div class=row><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addproposalform.Client.$error.required) }\"><label>Client</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Company Name\" id=Client name=Client autocomplete=off ng-model=vm.data.Client ng-blur=vm.func.loadDataFromClosure(vm.data.Client) uib-typeahead=\"companyname as companyname for companyname in vm.data.getCompany | filter: $viewValue | limitTo: 15\" required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.GrossMargin.$error.required)}\"><label>Gross Margin</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Gross Margin Amount\" id=GrossMargin name=GrossMargin ng-model=vm.data.GrossMargin required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\"><label>Total Closure</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Total Closure Amount\" id=TotalClosure name=TotalClosure ng-model=vm.data.TotalClosure required></div></div></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.SurveillanceCharges.$error.required)}\"><label>Surveillance Charges</label><input type=text class=form-control placeholder=\"Enter Surveillance Charges\" id=SurveillanceCharges name=SurveillanceCharges ng-model=vm.data.SurveillanceCharges></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PaymentRecived.$error.required)}\"><label>Payment Received</label><input type=text class=form-control placeholder=\"Enter Payment Received Amount\" id=PaymentRecived name=PaymentRecived ng-model=vm.data.PaymentRecived></div></div><div class=col-md-3><div class=form-group><label>Payment Expected Date</label><input type=date class=form-control placeholder=\"Enter Payment Expected Date\" id=PaymentExpectedDate name=PaymentExpectedDate ng-model=vm.data.PaymentExpectedDate></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PendingAmount.$error.required)}\"><label>Pending Amount</label><input type=text class=form-control placeholder=\"Enter Pending Amount \" id=PendingAmount name=PendingAmount ng-model=vm.data.PendingAmount></div></div></div><div class=row><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ClosureDate.$error.required)}\"><label>Closure Date</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=date class=form-control placeholder=\"Enter Closure Date\" id=ClosureDate name=ClosureDate ng-model=vm.data.ClosureDate required></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Standards.$error.required)}\"><label>Standards</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter ISO Standards\" id=Standards name=Standards autocomplete=off ng-model=vm.data.selectedIsoStandards required></div></div><!--<div class=\"col-md-4\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Region.$error.required)}\">\r\n                        <label>Region</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Region\" id=\"Region\" name=\"Region\" ng-model=\"vm.data.selectedRegion\" uib-typeahead=\"IsoRequired as IsoRequired for IsoRequired in vm.data.suggestIsoRequiredType | filter: $viewValue | limitTo: 15\" required />\r\n                    </div>\r\n                </div>--><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationBody.$error.required)}\"><label>Certification Body</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Body\" id=CertificationBody name=CertificationBody ng-model=vm.data.CertificationBody required></div></div></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Location.$error.required)}\"><label>Location</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=Location name=Location ng-model=vm.data.Location required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.SalesAgent.$error.required)}\"><label>Sales Agent</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Sales Agent\" id=SalesAgent name=SalesAgent ng-model=vm.data.selectedSalesAgent autocomplete=off uib-typeahead=\"salesagent as salesagent for salesagent in vm.data.suggestSalesAgent | filter: $viewValue | limitTo: 10\" required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.DeliveryAgent.$error.required)}\"><label>Delivery Agent</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Delivery Agent\" id=DeliveryAgent name=DeliveryAgent ng-model=vm.data.selectedDeliveryAgent autocomplete=off uib-typeahead=\"deliveryagent as deliveryagent for deliveryagent in vm.data.suggestDeliveryAgent | filter: $viewValue | limitTo: 10\" required></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredValidity}\"><label>Validity</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=Validity name=Validity ng-change=vm.func.hideRequiredValidity() ng-model=vm.data.selectedValidity ng-options=\"item.value for item in vm.data.Validity\"></select></div></div></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredSource}\"><label>Source</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=Source name=Source ng-change=vm.func.hideRequiredSource() ng-model=vm.data.selectedClosureSource ng-options=\"item.value for item in vm.data.ClosureSource\" required></select></div></div><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredType}\"><label>Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=Type name=Type ng-change=vm.func.hideRequiredType() ng-model=vm.data.selectedClosureType ng-options=\"item.value for item in vm.data.ClosureType\" required></select></div></div><div class=col-md-3><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ActualExpenses.$error.required)}\"--><label>Actual Expenses</label><input type=text class=form-control placeholder=\"Enter Actual Expenses Amount\" id=ActualExpenses name=ActualExpenses ng-model=vm.data.ActualExpenses></div></div><div class=col-md-3><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationCost.$error.required)}\"--><label>Certification Cost</label><input type=text class=form-control placeholder=\"Enter Certification Cost\" id=CertificationCost name=CertificationCost ng-model=vm.data.CertificationCost></div></div><!--<div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredProjectStatus}\">\r\n                        <label>Project Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <select class=\"form-control\" id=\"ClosureProjectStatus\" name=\"ClosureProjectStatus\" ng-change=\"vm.func.hideRequiredProjectStatus()\" ng-model=\"vm.data.selectedClosureProjectStatus\" ng-options=\"item.value for item in vm.data.ClosureProjectStatus\"></select>\r\n                    </div>\r\n                </div>--><!--<div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredPaymentStatus}\">\r\n                        <label>Payment Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <select class=\"form-control\" id=\"ClosurePaymentStatus\" name=\"ClosurePaymentStatus\" ng-change=\"vm.func.hideRequiredPaymentStatus()\" ng-model=\"vm.data.selectedClosurePaymentStatus\" ng-options=\"item.value for item in vm.data.ClosurePaymentStatus\"></select>\r\n                    </div>\r\n                </div>--></div><!--<div class=\"row\">\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ActualExpenses.$error.required)}\">\r\n                        <label>Actual Expenses</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Actual Expenses Amount\" id=\"ActualExpenses\" name=\"ActualExpenses\" ng-model=\"vm.data.ActualExpenses\" />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.SurveillanceCharges.$error.required)}\">\r\n                        <label>Surveillance Charges</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Surveillance Charges\" id=\"SurveillanceCharges\" name=\"SurveillanceCharges\" ng-model=\"vm.data.SurveillanceCharges\" />\r\n                    </div>\r\n                </div>\r\n                \r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PaymentRecived.$error.required)}\">\r\n                        <label>Payment Recived</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Payment Recived Amount\" id=\"PaymentRecived\" name=\"PaymentRecived\" ng-model=\"vm.data.PaymentRecived\" />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ConsultationCost.$error.required)}\">\r\n                        <label>Consultation Cost</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Consultation Cost\" id=\"ConsultationCost\" name=\"ConsultationCost\" ng-model=\"vm.data.ConsultationCost\" />\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationCost.$error.required)}\">\r\n                        <label>Certification Cost</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Certification Cost\" id=\"CertificationCost\" name=\"CertificationCost\" ng-model=\"vm.data.CertificationCost\" />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TrainingCost.$error.required)}\">\r\n                        <label>Training Cost</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Training Cost\" id=\"TrainingCost\" name=\"TrainingCost\" ng-model=\"vm.data.TrainingCost\" />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TravelCost.$error.required)}\">\r\n                        <label>Travel Cost</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Travel Cost\" id=\"TravelCost\" name=\"TravelCost\" ng-model=\"vm.data.TravelCost\" />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.OtherCost.$error.required)}\">\r\n                        <label>Other Cost</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Other Cost\" id=\"OtherCost\" name=\"OtherCost\" ng-model=\"vm.data.OtherCost\" />\r\n                    </div>\r\n                </div>\r\n            </div>--><!--<div class=\"row\">\r\n                <div class=\"col-md-5\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.OtherCostRemarks.$error.required)}\">\r\n                        <label>Other Cost Remarks</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Other Cost Remarks\" id=\"OtherCostRemarks\" name=\"OtherCostRemarks\" ng-model=\"vm.data.OtherCostRemarks\" />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ManDays.$error.required)}\">\r\n                        <label>Man Days</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Man Days\" id=\"ManDays\" name=\"ManDays\" ng-model=\"vm.data.ManDays\" />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CostInOtherCurrency.$error.required)}\">\r\n                        <label>Total Cost In Other Currency</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Cost In Other Currency\" id=\"CostInOtherCurrency\" name=\"CostInOtherCurrency\" ng-model=\"vm.data.CostInOtherCurrency\" />\r\n                    </div>\r\n                </div>\r\n            </div>--><div class=row><!--<div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Remarks.$error.required)}\">\r\n                        <label>Project Team Size</label>\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Team Size\" id=\"TeamSize\" name=\"TeamSize\" ng-model=\"vm.data.TeamSize\" />\r\n                    </div>\r\n                </div>--><div class=col-md-12><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Remarks.$error.required)}\"><label>Remarks</label><input type=text class=form-control placeholder=\"Enter Remarks\" id=Remarks name=Remarks ng-model=vm.data.Remarks></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-primary\" ng-click=vm.func.saveProposal(addproposalform.$valid)>Save</button></div></div>");
$templateCache.put("app/popups/editenquiry/editenquirydetails.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h3 class=\"modal-title text-info\">Update & Assign Enquiry</h3></div></div><div class=modal-body><form name=editenquiryform novalidate><div class=row><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\': (vm.data.isFormSubmit && editenquiryform.CompanyName.$error.required) }\"--><label>Company Name</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter Company Name\" id=CompanyName name=CompanyName ng-model=vm.data.CompanyName></div></div><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\': (vm.data.isFormSubmit && editenquiryform.NatureofBusiness.$error.required) }\"--><label>Nature of Business</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter Nature of Business\" id=NatureofBusiness name=NatureofBusiness ng-model=vm.data.NatureofBusiness></div></div><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editenquiryform.IsoRequired.$error.required)}\"--><label>ISO Required</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter ISO Certification Type\" id=IsoRequired name=IsoRequired ng-model=vm.data.selectedIsoRequired autocomplete=off uib-typeahead=\"IsoRequired as IsoRequired for IsoRequired in vm.data.suggestIsoRequiredType | filter: $viewValue | limitTo: 15\"></div></div></div><div class=row><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\': (vm.data.isFormSubmit && editenquiryform.EnquiryName.$error.required) }\"--><label>Contact Name</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter Enquiry Name\" id=EnquiryName name=EnquiryName ng-model=vm.data.EnquiryName></div></div><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editenquiryform.EnquiryPhone.$error.required)}\"--><label>Contact Phone</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter Enquiry Phone Number\" id=EnquiryPhone name=EnquiryPhone ng-model=vm.data.EnquiryPhone></div></div><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editenquiryform.EnquiryEmail.$error.required)}\"--><label>Contact Email</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--><!--<input type=\"text\" class=\"form-control \" placeholder=\"Enter City Name\" id=\"EnquiryEmail\" name=\"EnquiryEmail\" ng-model=\"vm.data.EnquiryEmail\" required>--> <input type=email class=form-control name=EnquiryEmail placeholder=\"Enter Email ID\" ng-model=vm.data.EnquiryEmail ng-maxlength=100 ng-model-options=\"{ updateOn: blur }\" ng-pattern=/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,5}$/ ><!--<div class=\"error-container\" ng-show=\"editenquiryform.EnquiryEmail.$dirty && editenquiryform.EnquiryEmail.$error\">\r\n                            <small class=\"error\" ng-show=\"editenquiryform.EnquiryEmail.$error.required\">\r\n                                Update Email ID.\r\n                            </small>\r\n                            <small class=\"error\" ng-show=\"editenquiryform.EnquiryEmail.$error.pattern\">\r\n                                Please input a valid email.\r\n                            </small>\r\n                            <small class=\"error\" ng-show=\"editenquiryform.EnquiryEmail.$error.maxlength\">\r\n                                Your email cannot be longer than 100 characters\r\n                            </small>\r\n                        </div>--></div></div></div><div class=row><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editenquiryform.City.$error.required)}\"--><label>City</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter City Name\" id=City name=City ng-model=vm.data.City></div></div><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editenquiryform.Country.$error.required)}\"--><label>Country</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter Country Name\" id=Country name=Country ng-model=vm.data.selectedCountryname autocomplete=off uib-typeahead=\"country as country for country in vm.data.suggestCountry | filter: $viewValue | limitTo: 10\"></div></div><div class=col-md-4><div class=form-group><!--ng-class=\"{\'has-error\': vm.data.requiredLeadSource}\"--><label>Lead Source</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--><select class=form-control id=LeadSource name=LeadSource ng-model=vm.data.LeadSource ng-options=\"item.value for item in vm.data.LeadSourceType\"></select><!--ng-change=\"vm.data.hideRequiredLeadSource()\"--></div></div></div><div class=row><!--<div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredCompanyType}\">\r\n                        <label>Company Type</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <select class=\"form-control\" id=\"CompanyType\" name=\"CompanyType\" ng-change=\"vm.func.hideRequiredCompanyType()\" ng-model=\"vm.data.selectedCompanyType\" ng-options=\"item.value for item in vm.data.CompanyType\"></select>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredLeadType}\">\r\n                        <label>Lead Type</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <select class=\"form-control\" id=\"LeadType\" name=\"LeadType\" ng-change=\"vm.func.hideRequiredLeadType()\" ng-model=\"vm.data.selectedLeadType\" ng-options=\"item.value for item in vm.data.LeadType\"></select>\r\n                    </div>\r\n                </div>--><div class=col-md-12><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editenquiryform.Remarks.$error.required)}\"--><label>Remarks</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control id=Remarks name=Remarks ng-model=vm.data.Remarks placeholder=\"Enter Remarks\"></div></div><!--<div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editenquiryform.Assignto.$error.required)}\">\r\n                        <label>Assign To</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Assign To\" id=\"Assignto\" name=\"Assignto\" ng-model=\"vm.data.selectedAssignto\" uib-typeahead=\"agsign as agsign for agsign in vm.data.suggestAssignTo | filter: $viewValue | limitTo: 10\" required />\r\n                    </div>\r\n                </div>--></div><!--<div class=\"modal-footer\">--><!--<!--<!--<div class=\"row text-right\" style=\"width:1000px ;padding-left:220px\">\r\n                <div class=\"col-md-3\" style=\"padding-top:45px; padding-right:2px\">\r\n                    <p class=\"color-black\"><img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" /><b>Assign To:</b></p>\r\n                </div>\r\n                <div class=\"col-md-4\" style=\"padding-top:35px; padding-left:10px\">\r\n                    <div class=\"form-group\">\r\n                        <!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && editenquiryform.Assignto.$error.required)}\"--><!--<label>Assign To</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" /><br />--><!--<input type=\"text\" class=\"form-control \" placeholder=\"Enter Assign To\" id=\"Assignto\" name=\"Assignto\" ng-model=\"vm.data.selectedAssignto\" uib-typeahead=\"agsign as agsign for agsign in vm.data.suggestAssignTo | filter: $viewValue | limitTo: 10\" required />\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3 text-right\" style=\"padding-top:37px\">\r\n                    <button class=\"btn btn-primary\" ng-click=\"vm.func.updateEnquiryetails\">Update & Assign</button>--><!--(editenquiryform.$valid)--><!--</div>\r\n                </div>--></form><div class=row><form name=submitInvalid><div class=\"col-md-3 col-xs-12\"><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredReason}\"><label>Reason for Invalid</label><select class=form-control id=InvalidReason name=InvalidReason ng-model=vm.data.SelectDumpData ng-options=\"item.value for item in vm.data.ReasonData\"></select></div></div><div class=\"col-md-2 col-xs-12\" style=padding-top:35px><button class=\"btn btn-primary\" ng-click=vm.func.saveEnqInvalidComment(submitInvalid.$valid)>Dump</button></div></form><form name=editenquiryform><div class=col-md-1>&nbsp;</div><div class=\"col-md-3 col-xs-12\"><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredAgent}\"><label>Assign To</label><select class=form-control id=AssignTo name=AssignTo ng-model=vm.data.SelectAgent ng-options=\"item.value for item in vm.data.Agent\"></select></div></div>&nbsp;<div class=\"col-md-2 text-right\" style=padding-top:35px><button class=\"btn btn-primary\" ng-click=vm.func.updateEnquiryetails(editenquiryform.$valid)>Update & Assign</button></div></form></div></div><!--<button class=\"btn btn-primary\" ng-click=\"vm.func.cancel()\">Close</button>--><!--<button class=\"btn btn-primary\" ng-click=\"vm.func.updateEnquiryetails(editenquiryform.$valid)\">Update</button>--><!--</div>--></div>");
$templateCache.put("app/popups/editinvalidEnquiry/editinvalidEnquiry.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dissmiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Reason for Invalid Enquiry</h4></div></div><div class=modal-body><form name=editinvalidenquiryform novalidate><!--<div class=\"row\">\r\n               <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.selectDumpData.$error.required) }\">\r\n                   <label>Dump To</label>\r\n                   <select class=\"form-control\" id=\"dump\" name=\"dump\" ng-model=\"vm.data.selectDumpData\"  ng-options=\"item.name for item in vm.data.DumpData\" ng-change=\"vm.func.SelectDumpData()\"></select>\r\n               </div>\r\n              </div>--><div class=row><div class=form-group><label>Reason</label><select class=form-control id=Reason name=Reason ng-model=vm.data.SelectDumpData ng-options=\"item.value for item in vm.data.ReasonData\" required></select></div></div><div class=row><div class=form-group><label>Comment</label><textarea class=form-control cols=5 rows=5 placeholder=\"Enter Comment\" id=CommentEnquiryInvalid name=CommentEnquiryInvalid ng-model=vm.data.CommentEnquiryInvalid required></textarea></div></div></form><div class=row style=padding-left:150px><button class=\"btn btn-primary\" ng-click=vm.func.saveEnqInvalidComment()>Sumbit</button></div></div></div>");
$templateCache.put("app/popups/errorpopups/errorsmpopup.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.ok()><span>&times;</span></button><div class=text-center><img src=assets/images/ISOCatalyst.png style=\"width:150px; height:50px\" alt=\"\"></div></div><div class=\"modal-body text-danger text-center\"><h5 class=text-danger>{{vm.data.message}}</h5></div><div class=modal-footer><button type=button class=\"btn btn-theme btn-danger\" data-dismiss=modal ng-click=vm.func.ok()>OK</button></div></div>");
$templateCache.put("app/popups/finishClosure/finishClosure.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n            <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n        </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Did you verify details of KYC, Certification and Closures ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n            </div>\r\n        </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div>");
$templateCache.put("app/popups/finishClsDetails/finishClsDetails.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n            <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n        </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Did you verify details of this Closure ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n            </div>\r\n        </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finish()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div>");
$templateCache.put("app/popups/pagination/pagination.html","<ul class=pagination ng-if=\"1 < pages.length || !autoHide\"><li ng-if=boundaryLinks ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=setCurrent(1)>&laquo;</a></li><li ng-if=directionLinks ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" ng-click=setCurrent(pageNumber)>{{ pageNumber }}</a></li><li ng-if=directionLinks ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=boundaryLinks ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=setCurrent(pagination.last)>&raquo;</a></li></ul>");
$templateCache.put("app/popups/pagination/paginationofClosure.html","<ul class=paginationofClosure ng-if=\"1 < pages.length || !autoHide\"><li ng-if=boundaryLinks ng-class=\"{ disabled : paginationofClosure.current == 1 }\"><a href=\"\" ng-click=setCurrent(1)>&laquo;</a></li><li ng-if=directionLinks ng-class=\"{ disabled : paginationofClosure.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(paginationofClosure.current - 1)\">&lsaquo;</a></li><li ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{ active : paginationofClosure.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" ng-click=setCurrent(pageNumber)>{{ pageNumber }}</a></li><li ng-if=directionLinks ng-class=\"{ disabled : paginationofClosure.current == paginationofClosure.last }\"><a href=\"\" ng-click=\"setCurrent(paginationofClosure.current + 1)\">&rsaquo;</a></li><li ng-if=boundaryLinks ng-class=\"{ disabled : paginationofClosure.current == paginationofClosure.last }\"><a href=\"\" ng-click=setCurrent(paginationofClosure.last)>&raquo;</a></li></ul>");
$templateCache.put("app/popups/proposalpaymentupdate/proposalpaymentupdate.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.ok()><span>&times</span></button><div class=text-left><h3 class=\"modal-title text-info\">Update Closure Payment Details</h3></div></div><div class=modal-body><form name=addproposalform novalidate><div class=row><div class=col-md-6><div class=table><table><tr><td><div class=form-group><div class=row><div class=col-md-6><label>GST - Tax</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Tax Amount\" id=TaxAmount name=TaxAmount ng-change=vm.func.calActualExpenses() ng-model=vm.data.TaxAmount required></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Certification Cost</label></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Certification Cost\" id=CertificationCost name=CertificationCost ng-change=vm.func.calActualExpenses() ng-model=vm.data.CertificationCost></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Bank Charges</label></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Bank Charges\" id=BankCharges name=CertificationCost ng-change=vm.func.calActualExpenses() ng-model=vm.data.BankCharges></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Courier Expenses</label></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Courier Expenses\" id=CourierExpenses name=CourierExpenses ng-change=vm.func.calActualExpenses() ng-model=vm.data.CourierExpenses></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Travel Cost</label></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Travel Cost\" id=TravelCost name=TravelCost ng-change=vm.func.calActualExpenses() ng-model=vm.data.TravelCost></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Accommodation Cost</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Accommodation Cost\" id=AccommodationCost name=AccommodationCost ng-change=vm.func.calActualExpenses() ng-model=vm.data.AccommodationCost></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Visa Fees</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Visa Cost\" id=VisaCost name=VisaCost ng-change=vm.func.calActualExpenses() ng-model=vm.data.VisaCost></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Per DM</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Per DM\" id=PerDM name=PerDM ng-change=vm.func.calActualExpenses() ng-model=vm.data.PerDM required></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Auditor/Consultant Fees</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Consultant Fees\" id=ConsultantFee name=ConsultantFee ng-change=vm.func.calActualExpenses() ng-model=vm.data.ConsultantFee required></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Commission</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Commission\" id=Commission name=Commission ng-change=vm.func.calActualExpenses() ng-model=vm.data.Commission required></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Miscellaneous</label></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Miscellaneous Amount\" id=Miscellaneous name=Miscellaneous ng-change=vm.func.calActualExpenses() ng-model=vm.data.OtherCost required></div></div></div></td></tr><!--<tr>\r\n      <td>\r\n          <div class=\"form-group\">\r\n              <div class=\"row\">\r\n                  <div class=\"col-md-6\">\r\n                      <label>Total Actual Expenses</label>\r\n                  </div>\r\n                  <div class=\"col-md-6\">\r\n                      <input type=\"number\" class=\"form-control \" placeholder=\"Enter Actual Expenses\" id=\"ActualExpenses\" name=\"ActualExpenses\" ng-model=\"vm.data.ActualExpenses\" />\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </td>\r\n  </tr>--></table></div></div><div class=col-md-1></div><div class=col-md-5><div class=table><table><tr><td><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\"><div class=row><div class=col-md-6><label>Currency Type</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=text class=form-control placeholder=\"Enter Currency Type\" id=CurrencyType name=CurrencyType ng-model=vm.data.CurrencyType required></div></div></div></td></tr><tr><td><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\"><div class=row><div class=col-md-6><label>Total Closure</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Total Closure Amount\" id=TotalClosure ng-change=vm.func.PendPay() name=TotalClosure ng-model=vm.data.TotalClosure required></div></div></div></td></tr><tr><td><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.GrossMargin.$error.required)}\"><div class=row><div class=col-md-6><label>Total Gross Margin</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Gross Margin Amount\" id=GrossMargin name=GrossMargin ng-model=vm.data.GrossMargin ng-change=vm.func.valGM() required><!--  ng-change=\"vm.func.valReqGrossAndTotal()\"--> <small class=error><span ng-if=vm.data.requiredPaymentStatus1>GM is greater Than Total Closure</span></small></div></div></div></td></tr><tr><td><div class=form-group><div class=row><div class=col-md-6><label>Total Actual Expenses</label></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Actual Expenses\" id=ActualExpenses name=ActualExpenses ng-model=vm.data.ActualExpenses disabled></div></div></div></td></tr><!--<tr>\r\n      <td>\r\n          <div class=\"form-group\"\r\n              ng-class=\"{\'has-error\':(vm.data.isFormSubmit &&  vm.data.requiredsalesGm)}\">\r\n              <div class=\"row\">\r\n                  <div class=\"col-md-6\">\r\n                      <label>% Sale GM</label>&nbsp;<img\r\n                          src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\"\r\n                          style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                  </div>\r\n                  <div class=\"col-md-6\">\r\n                      <input type=\"number\" class=\"form-control \"\r\n                          placeholder=\"Percentage Sale GM Not Found\" id=\"SaleGM\" name=\"SaleGM\"\r\n                          ng-model=\"vm.data.SalePerShare\" ng-change=\"vm.func.valSaleDeli()\"\r\n                          max=\"100\" maxlength=\"3\" />\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </td>\r\n  </tr>\r\n  <tr>\r\n      <td>\r\n          <div class=\"form-group\"\r\n              ng-class=\"{\'has-error\':(vm.data.isFormSubmit &&  vm.data.requiredsalesGm)}\">\r\n              <div class=\"row\">\r\n                  <div class=\"col-md-6\">\r\n                      <label>Sale GM</label>&nbsp;<img src=\"../../assets/images/star-icon.png\"\r\n                          alt=\"Mandatory Fields\"\r\n                          style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                  </div>\r\n                  <div class=\"col-md-6\">\r\n                      <input type=\"number\" class=\"form-control \"\r\n                          placeholder=\"Sale GM Not Found\" id=\"SaleGM\" name=\"SaleGM\"\r\n                          ng-model=\"vm.data.SaleGM\" ng-change=\"vm.func.valSaleShares()\" />\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </td>\r\n  </tr>\r\n  <tr>\r\n      <td>\r\n          <div class=\"form-group\"\r\n              ng-class=\"{\'has-error\':(vm.data.isFormSubmit && vm.data.requiredDelisGM)}\">\r\n              <div class=\"row\">\r\n                  <div class=\"col-md-6\">\r\n                      <label>Delivery GM</label>&nbsp;<img\r\n                          src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\"\r\n                          style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                  </div>\r\n                  <div class=\"col-md-6\">\r\n                      <input type=\"number\" class=\"form-control \"\r\n                          placeholder=\"Deli GM Not Found\" id=\"DeliGM\" name=\"DeliGM\"\r\n                          ng-model=\"vm.data.DeliGM\"\r\n                          ng-change=\"vm.func.valSaleSharesOnDeli()\" />\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </td>\r\n  </tr>--><tr><td><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.tds.$error.required)}\"><div class=row><div class=col-md-6><label>TDS</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter TDS Amount\" id=tds name=tds ng-model=vm.data.tds required></div></div></div></td></tr><tr><td><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PaymentRecived.$error.required)}\"><div class=row><div class=col-md-6><label>Payment Received</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Payment Received Amount\" id=PaymentRecived name=PaymentRecived ng-change=vm.func.PendPay() ng-model=vm.data.PaymentRecived required></div></div></div></td></tr><tr><td><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PendingAmount.$error.required)}\"><div class=row><div class=col-md-6><label>Payment Pending</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=number class=form-control placeholder=\"Enter Pending Amount \" id=PendingAmount name=PendingAmount ng-change=vm.func.FullPaymentPend() ng-model=vm.data.PendingAmount required disabled></div></div></div></td></tr><tr><td><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredPaymentStatus}\"><div class=row><div class=col-md-6><label>Payment Status</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><select class=form-control id=ClosurePaymentStatus name=ClosurePaymentStatus ng-model=vm.data.selectedClosurePaymentStatus ng-change=vm.func.FullPaymentPend() data-ng-options=\"item.value for item in vm.data.ClosurePaymentStatus\"></select><small class=error><span ng-if=vm.data.reqPartPaySts>Certificate has been processed</span></small></div></div></div></td></tr><tr><td><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\"><div class=row><div class=col-md-6><label ng-show=ShowPayRecDate>Full Payment Received Date</label>&nbsp;<img src=../../assets/images/star-icon.png ng-show=ShowPayRecDate alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><input type=date class=form-control id=PaymentExpected name=PaymentExpected ng-model=vm.data.PaymentExpected ng-show=ShowPayRecDate></div></div></div></td></tr><tr><td><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\"><div class=row><div class=col-md-6><label>Remarks</label>&nbsp;<img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"></div><div class=col-md-6><!--<input type=\"text\" class=\"form-control \" placeholder=\"Enter Remarks\" id=\"Remarks\" name=\"Remarks\" ng-model=\"vm.data.Remarks\" />--><textarea type=text class=form-control placeholder=\"Enter Remarks\" id=Remarks name=Remarks ng-model=vm.data.Remarks required>\r\n                                </div>\r\n                              </div>\r\n                            </div>\r\n                          </td>\r\n                        </tr>\r\n\r\n                        <tr>\r\n                          <td>\r\n                            <div class=form-group>\r\n                              <div class=row>\r\n                                <div class=col-md-6>\r\n                                  <!--<input type=\"button\" ng-click=\"vm.func.updateProposalPayementDetails(addproposalform.$valid)\" value=\"Update\"/>-->\r\n                                </div>\r\n                                <div class=col-md-6>\r\n                                  <!--<input type=\"text\" class=\"form-control \" placeholder=\"Enter Remarks\" id=\"Remarks\" name=\"Remarks\" ng-model=\"vm.data.Remarks\" />-->\r\n                                  <!--<textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Remarks\" id=\"Remarks\" name=\"Remarks\" ng-model=\"vm.data.Remarks\" required />-->\r\n                                </div>\r\n                              </div>\r\n                            </div>\r\n                          </td>\r\n                        </tr>\r\n                        <!--<tr>\r\n      <td>\r\n          <button class=\"btn btn-primary\" ng-click=\"vm.func.updateProposalPayementDetails(addproposalform.$valid)\">Update</button>\r\n\r\n      </td>\r\n  </tr>-->\r\n\r\n                      </table>\r\n                    </div>\r\n                    <!--<button class=\"btn btn-primary\" ng-click=\"vm.func.updateProposalPayementDetails(addproposalform.$valid)\">Update</button>-->\r\n\r\n                </div>\r\n\r\n            </div>\r\n        </form>\r\n        <!--<div class=\"row\">\r\n            <button class=\"btn btn-primary\" ng-click=\"vm.func.updateProposalPayementDetails(addproposalform.$valid)\">Update</button>\r\n\r\n\r\n        </div>-->\r\n    </div>\r\n    <div class=modal-footer>\r\n        <button class=\"btn btn-primary\" ng-click=vm.func.FinishClosure() ng-show=ShowRecon style=\"float: left\">Reconcile</button>\r\n\r\n        <button class=\"btn btn-primary\" ng-click=vm.func.ok()>Close</button>\r\n        <button class=\"btn btn-primary\" ng-click=vm.func.updateProposalPayementDetails(addproposalform.$valid) ng-show=ShowUpdate>Update</button>\r\n    </div>\r\n    <!--<button ng-click=\"vm.func.updateProposalPayementDetails(addproposalform.$valid)\">Update</button>-->\r\n</div>\r\n\r\n<!--div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n                <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\">\r\n\r\n                    <label>Total Closure1</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                    <input type=\"number\" class=\"form-control \" placeholder=\"Enter Total Closure Amount\" id=\"TotalClosure\" name=\"TotalClosure\" ng-model=\"vm.data.TotalClosure\" required />\r\n                </div>\r\n\r\n            </div>\r\n            <div class=\"col-md-6\">\r\n                <div class=\"form-group\">\r\n                    <!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationCost.$error.required)}\"-->\r\n<!--<label>Tax1</label>\r\n                <input type=\"number\" class=\"form-control \" placeholder=\"Enter Certification Cost\" id=\"CertificationCost\" name=\"CertificationCost\" ng-change=\"vm.func.calActualExpenses()\" ng-model=\"vm.data.CertificationCost\" />\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"col-md-6\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6\">\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\">\r\n                <label>Total Closure2</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <input type=\"number\" class=\"form-control \" placeholder=\"Enter Total Closure Amount\" id=\"TotalClosure\" name=\"TotalClosure\" ng-model=\"vm.data.TotalClosure\" required />\r\n            </div>\r\n\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n            <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationCost.$error.required)}\"-->\r\n<!--<label>Tax2</label>\r\n            <input type=\"number\" class=\"form-control \" placeholder=\"Enter Certification Cost\" id=\"CertificationCost\" name=\"CertificationCost\" ng-change=\"vm.func.calActualExpenses()\" ng-model=\"vm.data.CertificationCost\" />\r\n        </div>\r\n\r\n    </div>\r\n</div>-->\r\n<!--</div>\r\n\r\n</div>-->\r\n<!--<div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.TotalClosure.$error.required)}\">\r\n            <label>Total Closure</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n            <input type=\"number\" class=\"form-control \" placeholder=\"Enter Total Closure Amount\" id=\"TotalClosure\" name=\"TotalClosure\" ng-model=\"vm.data.TotalClosure\" required />\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-3\">\r\n        <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationCost.$error.required)}\"-->\r\n<!--<label>Tax</label>\r\n    <input type=\"number\" class=\"form-control \" placeholder=\"Enter Certification Cost\" id=\"CertificationCost\" name=\"CertificationCost\" ng-change=\"vm.func.calActualExpenses()\" ng-model=\"vm.data.CertificationCost\" />\r\n</div>-->\r\n<!--<div><span ng-show=\"addproposalform.GrossMargin.$error.maxlength\">Gross Margin should not be larger than the Total Closure</span></div>-->\r\n<!--</div>\r\n<div class=\"col-md-3\">\r\n    <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ConsultationCost.$error.required)}\"-->\r\n<!--<label>Total Expenses</label>\r\n        <input type=\"number\" class=\"form-control \" placeholder=\"Enter Consultation Cost\" id=\"ConsultationCost\" name=\"ConsultationCost\" ng-change=\"vm.func.calActualExpenses()\" ng-model=\"vm.data.ConsultationCost\" />\r\n    </div>\r\n</div>\r\n<div class=\"col-md-3\">\r\n    <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ActualExpenses.$error.required)}\"-->\r\n<!--<label>Gross Margin</label>\r\n            <input type=\"number\" class=\"form-control \" placeholder=\"Enter Actual Expenses Amount\" id=\"ActualExpenses\" name=\"ActualExpenses\" ng-model=\"vm.data.ActualExpenses\" />\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationCost.$error.required)}\"-->\r\n<!--<label>Certification Cost</label>\r\n        <input type=\"number\" class=\"form-control \" placeholder=\"Enter Certification Cost\" id=\"CertificationCost\" name=\"CertificationCost\" ng-change=\"vm.func.calActualExpenses()\" ng-model=\"vm.data.CertificationCost\" />\r\n    </div>\r\n</div>\r\n<div class=\"col-md-3\">\r\n    <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationCost.$error.required)}\"-->\r\n<!--<label>Travel Cost</label>\r\n    <input type=\"number\" class=\"form-control \" placeholder=\"Enter Travel Cost\" id=\"TravelCost\" name=\"TravelCost\" ng-change=\"vm.func.calActualExpenses()\" ng-model=\"vm.data.TravelCost\" />\r\n</div>-->\r\n<!--<div><span ng-show=\"addproposalform.GrossMargin.$error.maxlength\">Gross Margin should not be larger than the Total Closure</span></div>-->\r\n<!--</div>\r\n<div class=\"col-md-3\">\r\n    <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ConsultationCost.$error.required)}\"-->\r\n<!--<label>Accommodation Cost</label>\r\n        <input type=\"number\" class=\"form-control \" placeholder=\"Enter Accommodation Cost\" id=\"AccommodationCost\" name=\"AccommodationCost\" ng-change=\"vm.func.calActualExpenses()\" ng-model=\"vm.data.AccommodationCost\" />\r\n    </div>\r\n</div>\r\n<div class=\"col-md-3\">\r\n    <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ActualExpenses.$error.required)}\"-->\r\n<!--<label>Visa Cost</label>\r\n            <input type=\"number\" class=\"form-control \" placeholder=\"Enter Visa Cost\" id=\"ActualExpenses\" name=\"ActualExpenses\" ng-model=\"vm.data.ActualExpenses\" />\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.GrossMargin.$error.required)}\">\r\n            <label>Gross Margin</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n            <input type=\"number\" class=\"form-control \" placeholder=\"Enter Gross Margin Amount\" id=\"GrossMargin\" name=\"GrossMargin\" ng-model=\"vm.data.GrossMargin\" ng-change=\"vm.func.valGM()\" required />-->\r\n<!--  ng-change=\"vm.func.valReqGrossAndTotal()\"-->\r\n<!--<small class=\"error\"><span ng-if=\"vm.data.requiredPaymentStatus1\">GM is greater Than Total Closure</span></small>\r\n    </div>\r\n\r\n</div>\r\n\r\n<div class=\"col-md-2\">\r\n\r\n    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit &&  vm.data.requiredsalesGm)}\">\r\n        <label>% of Sales GM</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n        <input type=\"number\" class=\"form-control \" placeholder=\"Percentage Sale GM Not Found\" id=\"SaleGM\" name=\"SaleGM\" ng-model=\"vm.data.SalePerShare\" ng-change=\"vm.func.valSaleDeli()\" max=\"100\" maxlength=\"3\"/>\r\n    </div>\r\n</div>\r\n<div class=\"col-md-2\">\r\n    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit &&  vm.data.requiredsalesGm)}\">\r\n        <label>Sales GM</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n        <input type=\"number\" class=\"form-control \" placeholder=\"Sale GM Not Found\" id=\"SaleGM\" name=\"SaleGM\" ng-model=\"vm.data.SaleGM\" ng-change=\"vm.func.valSaleShares()\" />\r\n    </div>\r\n</div>\r\n<div class=\"col-md-2\">\r\n    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && vm.data.requiredDelisGM)}\">\r\n        <label>Delivery GM</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n        <input type=\"number\" class=\"form-control \" placeholder=\"Deli GM Not Found\" id=\"DeliGM\" name=\"DeliGM\" ng-model=\"vm.data.DeliGM\" ng-change=\"vm.func.valSaleSharesOnDeli()\" />\r\n    </div>\r\n</div>\r\n\r\n\r\n<div class=\"col-md-3\">\r\n    <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CostInOtherCurrency.$error.required)}\"-->\r\n<!--<label>Total Cost(Other Currency)</label>\r\n            <input type=\"text\" class=\"form-control \" placeholder=\"Enter Cost In Other Currency\" id=\"CostInOtherCurrency\" name=\"CostInOtherCurrency\" ng-model=\"vm.data.CostInOtherCurrency\" />\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n<div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PaymentRecived.$error.required)}\">\r\n                <label>Payment Received</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <input type=\"number\" class=\"form-control \" placeholder=\"Enter Payment Received Amount\" id=\"PaymentRecived\" name=\"PaymentRecived\" ng-change=\"vm.func.PendPay()\" ng-model=\"vm.data.PaymentRecived\" required />\r\n            </div>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PendingAmount.$error.required)}\">\r\n                <label>Payment Pending</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <input type=\"number\" class=\"form-control \" placeholder=\"Enter Pending Amount \" id=\"PendingAmount\" name=\"PendingAmount\" ng-model=\"vm.data.PendingAmount\" required />\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-md-3\">\r\n            <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PaymentExpected.$error.required)}\"-->\r\n<!--<label>Payment Expected Date</label>-->\r\n<!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />-->\r\n<!--<input type=\"text\" class=\"form-control \" placeholder=\"MM/dd/yyyy\" id=\"PaymentExpected\" name=\"PaymentExpected\" ng-model=\"vm.data.PaymentExpected\" />\r\n        </div>\r\n    </div>\r\n<div class=\"col-md-3\">\r\n    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredPaymentStatus}\">\r\n\r\n        <label>Payment Status</label>   <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n\r\n        <select class=\"form-control\" id=\"ClosurePaymentStatus\" name=\"ClosurePaymentStatus\" ng-model=\"vm.data.selectedClosurePaymentStatus\" data-ng-options=\"item.value for item in vm.data.ClosurePaymentStatus\"></select>\r\n        <small class=\"error\"><span ng-if=\"vm.data.reqPartPaySts\">Certificate has been processed</span></small>-->\r\n<!--ng-change=\"vm.func.hideRequiredPaymentStatus()\"-->\r\n<!--data-ng-change=\"vm.func.updateProjStatus()\"-->\r\n<!--</div>\r\n    </div>\r\n    </div>\r\n\r\n<div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Remarks.$error.required)}\"-->\r\n<!--<label>Remarks</label>\r\n            <input type=\"text\" class=\"form-control \" placeholder=\"Enter Remarks\" id=\"Remarks\" name=\"Remarks\" ng-model=\"vm.data.Remarks\" />\r\n        </div>\r\n    </form>\r\n</div>-->\r\n<!--////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////\r\n\'\r\n\'\r\n\'\r\n\'///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->\r\n<!--<div class=\"col-md-4\">\r\n              <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CostInOtherCurrency.$error.required)}\"-->\r\n<!--<label>Total Cost(Other Currency)</label>\r\n        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Cost In Other Currency\" id=\"CostInOtherCurrency\" name=\"CostInOtherCurrency\" ng-model=\"vm.data.CostInOtherCurrency\" />\r\n    </div>\r\n</div>-->\r\n<!--<div class=\"col-md-4\">\r\n    <div class=\"form-group\">-->\r\n<!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.SurveillanceCharges.$error.required)}\"-->\r\n<!--<label>Surveillance Charges</label>\r\n        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Surveillance Charges\" id=\"SurveillanceCharges\" name=\"SurveillanceCharges\" ng-model=\"vm.data.SurveillanceCharges\" />\r\n    </div>\r\n</div>-->\r\n<!--<div class=\"col-md-4\">\r\n    <div class=\"form-group\"    ng-class=\"{ \'has-error\': vm.data.requiredPaymentStatus}\">\r\n\r\n        <label>Payment Status</label>   <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n\r\n        <select class=\"form-control\" id=\"ClosurePaymentStatus\" name=\"ClosurePaymentStatus\"   ng-model=\"vm.data.selectedClosurePaymentStatus\" data-ng-options=\"item.value for item in vm.data.ClosurePaymentStatus\" ></select>\r\n        <small class=\"error\"><span ng-if=\"vm.data.reqPartPaySts\">Certificate has been processed</span></small>-->\r\n<!--ng-change=\"vm.func.hideRequiredPaymentStatus()\"-->\r\n<!--data-ng-change=\"vm.func.updateProjStatus()\"-->\r\n<!--</div>\r\n</div>-->\r\n<!--<div class=\"col-md-3\">\r\n    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredProjectStatus}\">\r\n        <label>Certificate Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n        <select class=\"form-control\" id=\"ClosureProjectStatus\" name=\"ClosureProjectStatus\" ng-model=\"vm.data.selectedClosureProjectStatus\" data-ng-options=\"item.value for item in vm.data.availableStatus\" ng-change=\"vm.func.hideRequiredProjectStatus()\"></select><!---->\r\n<!--ng-change=\"vm.func.hideRequiredProjectStatus()\"-->\r\n<!--</div>\r\n</div>-->\r\n<!--<div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ManDays.$error.required)}\">\r\n            <label>Man Days</label>\r\n            <input type=\"text\" class=\"form-control \" placeholder=\"Enter Man Days\" id=\"ManDays\" name=\"ManDays\" ng-model=\"vm.data.ManDays\" />\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-9\">\r\n        <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.OtherCostRemarks.$error.required)}\">\r\n            <label>Other Cost Remarks</label>\r\n            <input type=\"text\" class=\"form-control \" placeholder=\"Enter Other Cost Remarks\" id=\"OtherCostRemarks\" name=\"OtherCostRemarks\" ng-model=\"vm.data.OtherCostRemarks\" />\r\n        </div>\r\n    </div>\r\n</div>-->\r\n<!--<div class=\"col-md-3\">\r\n    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PaymentExpected.$error.required)}\">\r\n        <label>Payment Expected Date</label>\r\n        <input type=\"text\" class=\"form-control \" placeholder=\"Payment Expected Date\" id=\"PaymentExpected\" name=\"PaymentExpected\" ng-model=\"vm.data.PaymentExpected|date:\'MM/dd/yyyy\'\" />\r\n    </div>\r\n</div>-->\r\n<!--<div class=\"col-md-3\">\r\n<div class=\"form-group\">\r\n    <!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PaymentExpected.$error.required)}\"-->\r\n<!--<label>Payment Expected Date</label>-->\r\n<!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />-->\r\n<!--<input type=\"text\" class=\"form-control \" placeholder=\"MM/dd/yyyy\" id=\"PaymentExpected\" name=\"PaymentExpected\" ng-model=\"vm.data.PaymentExpected\" />\r\n    </div>\r\n</div>-->\r\n<!--<div class=\"col-md-3\">\r\n    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PaymentRecived.$error.required)}\">\r\n        <label>Payment Received</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n        <input type=\"number\" class=\"form-control \" placeholder=\"Enter Payment Received Amount\" id=\"PaymentRecived\" name=\"PaymentRecived\" ng-change=\"vm.func.PendPay()\" ng-model=\"vm.data.PaymentRecived\" required />\r\n    </div>\r\n\r\n</div>-->\r\n<!--<div class=\"col-md-3\">\r\n\r\n    <div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.PendingAmount.$error.required)}\">\r\n        <label>Payment Pending</label>&nbsp;<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n        <input type=\"number\" class=\"form-control \" placeholder=\"Enter Pending Amount \" id=\"PendingAmount\" name=\"PendingAmount\" ng-model=\"vm.data.PendingAmount\" required />\r\n    </div>\r\n\r\n</div>-->");
$templateCache.put("app/popups/showSearchedCertificates/showSearchedCerts.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Certification Details for : <span class=color-black>{{vm.data.CertiNumber}}</span></h4></div></div><div class=\"modal-body text-center\"><table class=\"table table-hover\" style=\"width: 100%\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certi Number :</td><td class=text-left style=\"padding: 3px\">{{vm.data.CertiNumber}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Company Name :</td><td class=text-left style=\"padding: 3px\">{{vm.data.CompanyName}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">ISO Standard :</td><td class=text-left style=\"padding: 3px\">{{vm.data.ISOStandard}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Issue Date :</td><td class=text-left style=\"padding: 3px\">{{vm.data.IssueDate|date:\'dd/MM/yyyy\'}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Expiry Date :</td><td class=text-left style=\"padding: 3px\">{{vm.data.ExpiryDate|date:\'dd/MM/yyyy\'}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Cert Body :</td><td class=text-left style=\"padding: 3px\">{{vm.data.CertiBody}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Accred Body :</td><td class=text-left style=\"padding: 3px\">{{vm.data.CertiAccred}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certi Scope :</td><td class=text-left style=\"padding: 3px\">{{vm.data.Certi_Scope}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Certi Address :</td><td class=text-left style=\"padding: 3px\">{{vm.data.CertiAddress}}</td></tr></table></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button></div></div>");
$templateCache.put("app/popups/successpopups/successpopup.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.ok()><span>&times;</span></button><div class=text-center><img src=assets/images/ISOCatalyst.png style=\"width:150px; height:50px\" alt=\"\"></div></div><div class=\"modal-body text-info text-center\"><h5 class=text-info>{{vm.data.message}}</h5></div><div class=modal-footer><button class=\"btn btn-info\" ng-click=vm.func.ok()>OK</button></div></div>");
$templateCache.put("app/popups/updateproposal/updateproposalReport.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.ok()><span>&times</span></button><div class=text-left><h3 class=\"modal-title text-info\">Update Closure Report</h3></div></div><div class=modal-body><form name=addproposalform novalidate><div class=row><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addproposalform.Client.$error.required) }\"><label>Client</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Company Name\" id=Client name=Client ng-model=vm.data.Client uib-typeahead=\"companyname as companyname for companyname in vm.data.getCompany | filter: $viewValue | limitTo: 15\" required></div></div><div class=col-md-4><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.SalesAgent.$error.required)}\"><label>Sales Agent</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Sales Agent\" id=SalesAgent name=SalesAgent ng-model=vm.data.selectedSalesAgent autocomplete=off uib-typeahead=\"salesagent as salesagent for salesagent in vm.data.suggestSalesAgent | filter: $viewValue | limitTo: 10\" required></div></div><div class=col-md-4><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredType}\"><label>Type</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=Type name=Type ng-change=vm.func.hideRequiredType() ng-model=vm.data.selectedClosureType ng-options=\"item.value for item in vm.data.ClosureType\" required></select></div></div></div><div class=row><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredValidity}\"><label>Validity</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=Validity name=Validity ng-change=vm.func.hideRequiredValidity() ng-model=vm.data.selectedValidity ng-options=\"item.value for item in vm.data.Validity\" required></select></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Location.$error.required)}\"><label>Location</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter City Name\" id=Location name=Location ng-model=vm.data.Location required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Standards.$error.required)}\"><label>Standards</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter ISO Standards\" id=Standards name=Standards autocomplete=off ng-model=vm.data.selectedIsoStandards uib-typeahead=\"IsoStandards as IsoStandards for IsoStandards in vm.data.suggestIsoStandards | filter: $viewValue | limitTo: 15\" required></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationBody.$error.required)}\"><label>CB-AB</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"> <input type=text class=form-control placeholder=\"Enter Certification Body\" id=CertificationBody name=CertificationBody autocomplete=off ng-model=vm.data.CertificationBody uib-typeahead=\"CBAB as CBAB for CBAB in vm.data.suggestCBAB | filter: $viewValue\" required></div></div></div><div class=row><!--<div class=\"col-md-3\">--><!--<div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationBody.$error.required)}\">\r\n                        <label>CB-AB</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Certification Body\" id=\"CertificationBody\" name=\"CertificationBody\" ng-model=\"vm.data.CertificationBody\" required />\r\n                    </div>--><!--<div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.CertificationBody.$error.required)}\">\r\n                        <label>CB-AB</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <input type=\"text\" class=\"form-control \" placeholder=\"Enter Certification Body\" id=\"CertificationBody\" name=\"CertificationBody\"autocomplete=\"off\" ng-model=\"vm.data.CertificationBody\" uib-typeahead=\"CBAB as CBAB for CBAB in vm.data.suggestCBAB | filter: $viewValue\" required />--><!--<input type=\"text\" class=\"form-control \" placeholder=\"Enter ISO Standards\" id=\"Standards\" name=\"Standards\" autocomplete=\"off\" ng-model=\"vm.data.selectedIsoStandards\" uib-typeahead=\"IsoStandards as IsoStandards for IsoStandards in vm.data.suggestIsoStandards | filter: $viewValue | limitTo: 15\" required />--><!--</div>\r\n                </div>--><div class=col-md-3><div class=form-group ng-class=\"{ \'has-error\': vm.data.requiredSource}\"><label>Source</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><select class=form-control id=Source name=Source ng-change=vm.func.hideRequiredSource() ng-model=vm.data.selectedClosureSource ng-options=\"item.value for item in vm.data.ClosureSource\" required></select></div></div><div class=col-md-3><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.DeliveryAgent.$error.required)}\"--><label>Delivery Agent</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter Delivery Agent\" id=DeliveryAgent name=DeliveryAgent ng-model=vm.data.selectedDeliveryAgent autocomplete=off uib-typeahead=\"deliveryagent as deliveryagent for deliveryagent in vm.data.suggestDeliveryAgent | filter: $viewValue | limitTo: 10\"></div></div><div class=col-md-3><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.DeliveryAgent.$error.required)}\"--><label>Current Sales Agent</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter Current Sales Agent\" id=CurrentAgent name=CurrentAgent ng-model=vm.data.selectedCurrentAgent autocomplete=off uib-typeahead=\"deliveryagent as deliveryagent for deliveryagent in vm.data.suggestDeliveryAgent | filter: $viewValue | limitTo: 10\"></div></div><div class=col-md-3><div class=form-group ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.ClosureDate.$error.required)}\"><label>Closure Date</label><img src=../../assets/images/star-icon.png alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px\"><small>DD/MM/YYYY</small> <input class=form-control type=date id=ClosureDate placeholder=DD/mm/yyyy name=ClosureDate ng-disabled=true ng-model=vm.data.ClosureDate required></div></div><!--<div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredProjectStatus}\">\r\n                        <label>Project Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <select class=\"form-control\" id=\"ClosureProjectStatus\" name=\"ClosureProjectStatus\" ng-change=\"vm.func.hideRequiredProjectStatus()\" ng-model=\"vm.data.selectedClosureProjectStatus\" ng-options=\"item.value for item in vm.data.ClosureProjectStatus\"></select>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <div class=\"form-group\" ng-class=\"{ \'has-error\': vm.data.requiredPaymentStatus}\">\r\n                        <label>Payment Status</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                        <select class=\"form-control\" id=\"ClosurePaymentStatus\" name=\"ClosurePaymentStatus\" ng-change=\"vm.func.hideRequiredPaymentStatus()\" ng-model=\"vm.data.selectedClosurePaymentStatus\" ng-options=\"item.value for item in vm.data.ClosurePaymentStatus\"></select>\r\n                    </div>\r\n                </div>--></div><!--<div class=\"form-group\" ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Region.$error.required)}\">\r\n                <label>Region</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <input type=\"text\" class=\"form-control \" placeholder=\"Enter Region\" id=\"Region\" name=\"Region\" ng-model=\"vm.data.Region\" required />\r\n            </div>--><div class=form-group><!--ng-class=\"{\'has-error\':(vm.data.isFormSubmit && addproposalform.Remarks.$error.required)}\"--><label>Remarks</label><!--<img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />--> <input type=text class=form-control placeholder=\"Enter Remarks\" id=Remarks name=Remarks ng-model=vm.data.Remarks></div></form></div><div class=modal-footer><!--<button class=\"btn btn-primary\" ng-click=\"vm.func.ok()\">Close</button>--> <button class=\"btn btn-primary\" ng-click=vm.func.updateProposal(addproposalform.$valid)>Update</button></div></div>");
$templateCache.put("app/popups/viewenquiry/viewenquiry.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times</span></button><div class=text-left><h4 class=\"modal-title text-info\">Enquiry Details Of : <span class=color-black>{{vm.data.Enquiryname}}</span></h4></div></div><div class=\"modal-body text-center\"><table class=\"table table-hover\" style=\"width: 100%\"><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Company Name :</td><td class=text-left style=\"padding: 3px\">{{vm.data.Companyname}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">ISO Standard :</td><td class=text-left style=\"padding: 3px\">{{vm.data.ISOStandard}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Location :</td><td class=text-left style=\"padding: 3px\">{{vm.data.Country}} , {{vm.data.Enquirycity}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Contact Name :</td><td class=text-left style=\"padding: 3px\">{{vm.data.Enquiryname}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Contact Phone :</td><td class=text-left style=\"padding: 3px\">{{vm.data.Enquiryphone}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Contact Email :</td><td class=text-left style=\"padding: 3px\">{{vm.data.Enquiryemail}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Nature of Business :</td><td class=text-left style=\"padding: 3px\">{{vm.data.NatureofBusiness}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Enquiry Date :</td><td class=text-left style=\"padding: 3px\">{{vm.data.Enq_Date|date:\'dd/MM/yyyy\'}}</td></tr><tr><td class=text-left style=\"padding: 3px; color:#4A235A\">Enquiry Source :</td><td class=text-left style=\"padding: 3px\">{{vm.data.Enquirytype}}</td></tr></table></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.cancel()>Close</button> <button class=\"btn btn-success\" ng-click=vm.func.updateEnquiryetails()>Update</button></div></div>");
$templateCache.put("app/popups/SurveillanceFailPass/SurvPassed/survpassed.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n            <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n        </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Are You Sure To Pass Surveillance?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n            </div>\r\n        </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div>");
$templateCache.put("app/popups/SurveillanceFailPass/SurvFailed/survfailed.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n            <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n        </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Are You Sure To make Surveillance Failed ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n            </div>\r\n        </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div>");
$templateCache.put("app/popups/qaChecker/KycFailed/kycfailed.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n            <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n        </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Are you sure to reject?<br><br>Did you verify details of KYC ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n            </div>\r\n        </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div>");
$templateCache.put("app/popups/qaChecker/KycPassed/kycpassed.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n            <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n        </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Are you sure ?<br><br>Did you verify details of KYC ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n            </div>\r\n        </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div>");
$templateCache.put("app/popups/qaChecker/passIt/passIt.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n            <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n        </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Are you sure<br><br>Did you verify details of KYC ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n            </div>\r\n        </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div>");
$templateCache.put("app/popups/qaChecker/RejectIt/rejectIt.html","<div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.func.cancel()><span>&times </span></button><!--<div class=\"text-left\">\r\n            <h4 class=\"modal-title text-info\">Add Comments</h4>\r\n        </div>--></div><div class=modal-body><h4 class=\"modal-title text-info\">Are you sure to reject<br><br>Did you verify details of KYC ?</h4><!--<form name=\"addcommentsform\" novalidate>\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': (vm.data.isFormSubmit && addcommentsform.Comments.$error.required) }\">\r\n                <label>Comments</label> <img src=\"../../assets/images/star-icon.png\" alt=\"Mandatory Fields\" style=\"height:10px; width:10px; margin-bottom:1px;\" />\r\n                <textarea type=\"text\" class=\"form-control \" placeholder=\"Enter Comments\" rows=\"5\" id=\"Comments\" name=\"Comments\" ng-model=\"vm.data.Comments\" required></textarea>\r\n            </div>\r\n        </form>--></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=vm.func.finishIt()>Yes</button> <button class=\"btn btn-primary\" ng-click=vm.func.cancel()>No</button></div></div>");}]);